var _marked = /*#__PURE__*/_regeneratorRuntime().mark(bo),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(yo),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(At),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(Sn);
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t9, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t9, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n33 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n33 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n33++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import { global as re, EmitterMixin as N, CKEditorError as f, compareArrays as F, toMap as pe, ObservableMixin as U, count as Zt, isIterable as le, toArray as ae, EventInfo as Rt, Collection as Lt, uid as Fs, spliceArray as en, logWarning as W, DomEmitterMixin as Ds, isValidAttributeName as Bs, first as Wt, isText as E, indexOf as Ee, getAncestors as Vs, isComment as Le, env as M, scrollViewportToShowTarget as $s, isInsideSurrogatePair as Wn, isInsideCombinedSymbol as qn, remove as tn, insertAt as zn, diff as gt, fastDiff as Ls, keyCodes as de, isArrowKeyCode as Ws, priorities as pt, isInsideEmojiSequence as qs, isNode as ot, getCode as zs } from "../../../../../@ckeditor_ckeditor5-utils@45.2.1/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { clone as Un } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/object/clone.js";
import { isEqual as nn } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/predicate/isEqual.js";
import { isObject as at } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isObject.js";
import { unset as Us } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/unset.js";
import { get as lt } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/get.js";
import { isPlainObject as Tt } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isPlainObject.js";
import { assignIn as Js } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/assignIn.js";
import { merge as Jn } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/merge.js";
import { set as js } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/set.js";
import { cloneDeep as ce } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/cloneDeep.js";
import { isEqualWith as Gs } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isEqualWith.js";
import { debounce as Mt } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/debounce.js"; /**
                                                                                                                            * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                            * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                            */
var Ne = new WeakMap();
var sn = !1;
function al(_ref) {
  var s = _ref.view,
    e = _ref.element,
    t = _ref.text,
    _ref$isDirectHost = _ref.isDirectHost,
    n = _ref$isDirectHost === void 0 ? !0 : _ref$isDirectHost,
    _ref$keepOnFocus = _ref.keepOnFocus,
    r = _ref$keepOnFocus === void 0 ? !1 : _ref$keepOnFocus;
  var i = s.document;
  Ne.has(i) || (Ne.set(i, new Map()), i.registerPostFixer(function (a) {
    return _t(Ne.get(i), a);
  }), i.on("change:isComposing", function () {
    s.change(function (a) {
      return _t(Ne.get(i), a);
    });
  }, {
    priority: "high"
  })), e.is("editableElement") && e.on("change:placeholder", function (a, l, c) {
    return o(c);
  }), e.placeholder ? o(e.placeholder) : t && o(t), t && Zs();
  function o(a) {
    var l = {
      text: a,
      isDirectHost: n,
      keepOnFocus: r,
      hostElement: n ? e : null
    };
    Ne.get(i).set(e, l), s.change(function (c) {
      return _t([[e, l]], c);
    });
  }
}
function Hs(s, e) {
  return e.hasClass("ck-placeholder") ? !1 : (s.addClass("ck-placeholder", e), !0);
}
function Ks(s, e) {
  return e.hasClass("ck-placeholder") ? (s.removeClass("ck-placeholder", e), !0) : !1;
}
function Xs(s, e) {
  if (!s.isAttached() || Ys(s)) return !1;
  var t = s.document,
    r = t.selection.anchor;
  return t.isComposing && r && r.parent === s ? !1 : e || !t.isFocused ? !0 : !!r && r.parent !== s;
}
function Ys(s) {
  var _iterator = _createForOfIteratorHelper(s.getChildren()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var e = _step.value;
      if (!e.is("uiElement")) return !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return !1;
}
function _t(s, e) {
  var t = [];
  var n = !1;
  var _iterator2 = _createForOfIteratorHelper(s),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref2 = _step2.value;
      var _ref3 = _slicedToArray(_ref2, 2);
      var r = _ref3[0];
      var i = _ref3[1];
      i.isDirectHost && (t.push(r), rn(e, r, i) && (n = !0));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(s),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref4 = _step3.value;
      var _ref5 = _slicedToArray(_ref4, 2);
      var _r2 = _ref5[0];
      var _i2 = _ref5[1];
      if (_i2.isDirectHost) continue;
      var o = Qs(_r2);
      o && (t.includes(o) || (_i2.hostElement = o, rn(e, _r2, _i2) && (n = !0)));
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return n;
}
function rn(s, e, t) {
  var n = t.text,
    r = t.isDirectHost,
    i = t.hostElement;
  var o = !1;
  return i.getAttribute("data-placeholder") !== n && (s.setAttribute("data-placeholder", n, i), o = !0), (r || e.childCount == 1) && Xs(i, t.keepOnFocus) ? Hs(s, i) && (o = !0) : Ks(s, i) && (o = !0), o;
}
function Qs(s) {
  if (s.childCount) {
    var e = s.getChild(0);
    if (e.is("element") && !e.is("uiElement") && !e.is("attributeElement")) return e;
  }
  return null;
}
function Zs() {
  sn || W("enableplaceholder-deprecated-text-option"), sn = !0;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var we = /*#__PURE__*/function () {
    function we() {
      _classCallCheck(this, we);
    }
    return _createClass(we, [{
      key: "is",
      value: function is() {
        throw new Error("is() method is abstract");
      }
    }]);
  }(),
  be = /*#__PURE__*/function (_N) {
    function be(e) {
      var _this;
      _classCallCheck(this, be);
      _this = _callSuper(this, be), _defineProperty(_assertThisInitialized(_this), "document", void 0), _defineProperty(_assertThisInitialized(_this), "parent", void 0), _this.document = e, _this.parent = null;
      return _this;
    }
    _inherits(be, _N);
    return _createClass(be, [{
      key: "index",
      get: function get() {
        var e;
        if (!this.parent) return null;
        if ((e = this.parent.getChildIndex(this)) == -1) throw new f("view-node-not-found-in-parent", this);
        return e;
      }
    }, {
      key: "nextSibling",
      get: function get() {
        var e = this.index;
        return e !== null && this.parent.getChild(e + 1) || null;
      }
    }, {
      key: "previousSibling",
      get: function get() {
        var e = this.index;
        return e !== null && this.parent.getChild(e - 1) || null;
      }
    }, {
      key: "root",
      get: function get() {
        var e = this;
        for (; e.parent;) e = e.parent;
        return e;
      }
    }, {
      key: "isAttached",
      value: function isAttached() {
        return this.root.is("rootElement");
      }
    }, {
      key: "getPath",
      value: function getPath() {
        var e = [];
        var t = this;
        for (; t.parent;) e.unshift(t.index), t = t.parent;
        return e;
      }
    }, {
      key: "getAncestors",
      value: function getAncestors() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = [];
        var n = e.includeSelf ? this : this.parent;
        for (; n;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return t;
      }
    }, {
      key: "getCommonAncestor",
      value: function getCommonAncestor(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = this.getAncestors(t),
          r = e.getAncestors(t);
        var i = 0;
        for (; n[i] == r[i] && n[i];) i++;
        return i === 0 ? null : n[i - 1];
      }
    }, {
      key: "isBefore",
      value: function isBefore(e) {
        if (this == e || this.root !== e.root) return !1;
        var t = this.getPath(),
          n = e.getPath(),
          r = F(t, n);
        switch (r) {
          case "prefix":
            return !0;
          case "extension":
            return !1;
          default:
            return t[r] < n[r];
        }
      }
    }, {
      key: "isAfter",
      value: function isAfter(e) {
        return this == e || this.root !== e.root ? !1 : !this.isBefore(e);
      }
    }, {
      key: "_remove",
      value: function _remove() {
        this.parent._removeChildren(this.index);
      }
    }, {
      key: "_fireChange",
      value: function _fireChange(e, t, n) {
        this.fire("change:".concat(e), t, n), this.parent && this.parent._fireChange(e, t, n);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var e = Un(this);
        return delete e.parent, e;
      }
    }]);
  }(N(we));
be.prototype.is = function (s) {
  return s === "node" || s === "view:node";
};
var x = /*#__PURE__*/function (_be) {
  function xt(e, t) {
    var _this2;
    _classCallCheck(this, xt);
    _this2 = _callSuper(this, xt, [e]), _defineProperty(_assertThisInitialized(_this2), "_textData", void 0), _this2._textData = t;
    return _this2;
  }
  _inherits(xt, _be);
  return _createClass(xt, [{
    key: "data",
    get: function get() {
      return this._textData;
    }
  }, {
    key: "_data",
    get: function get() {
      return this.data;
    },
    set: function set(e) {
      this._fireChange("text", this), this._textData = e;
    }
  }, {
    key: "isSimilar",
    value: function isSimilar(e) {
      return e instanceof xt ? this === e || this.data === e.data : !1;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      return new xt(this.document, this.data);
    }
  }]);
}(be);
x.prototype.is = function (s) {
  return s === "$text" || s === "view:$text" || s === "text" || s === "view:text" || s === "node" || s === "view:node";
};
var Q = /*#__PURE__*/function (_we) {
  function Q(e, t, n) {
    var _this3;
    _classCallCheck(this, Q);
    if (_this3 = _callSuper(this, Q), _defineProperty(_assertThisInitialized(_this3), "textNode", void 0), _defineProperty(_assertThisInitialized(_this3), "data", void 0), _defineProperty(_assertThisInitialized(_this3), "offsetInText", void 0), _this3.textNode = e, t < 0 || t > e.data.length) throw new f("view-textproxy-wrong-offsetintext", _assertThisInitialized(_this3));
    if (n < 0 || t + n > e.data.length) throw new f("view-textproxy-wrong-length", _assertThisInitialized(_this3));
    _this3.data = e.data.substring(t, t + n), _this3.offsetInText = t;
    return _assertThisInitialized(_this3);
  }
  _inherits(Q, _we);
  return _createClass(Q, [{
    key: "offsetSize",
    get: function get() {
      return this.data.length;
    }
  }, {
    key: "isPartial",
    get: function get() {
      return this.data.length !== this.textNode.data.length;
    }
  }, {
    key: "parent",
    get: function get() {
      return this.textNode.parent;
    }
  }, {
    key: "root",
    get: function get() {
      return this.textNode.root;
    }
  }, {
    key: "document",
    get: function get() {
      return this.textNode.document;
    }
  }, {
    key: "getAncestors",
    value: function getAncestors() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = [];
      var n = e.includeSelf ? this.textNode : this.parent;
      for (; n !== null;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
      return t;
    }
  }]);
}(we);
Q.prototype.is = function (s) {
  return s === "$textProxy" || s === "view:$textProxy" || s === "textProxy" || s === "view:textProxy";
};
var ct = /*#__PURE__*/function () {
  function ct() {
    _classCallCheck(this, ct);
    _defineProperty(this, "_consumables", new Map());
  }
  return _createClass(ct, [{
    key: "add",
    value: function add(e, t) {
      var n;
      if (e.is("$text") || e.is("documentFragment")) {
        this._consumables.set(e, !0);
        return;
      }
      this._consumables.has(e) ? n = this._consumables.get(e) : (n = new er(e), this._consumables.set(e, n)), n.add(t ? Ve(t) : e._getConsumables());
    }
  }, {
    key: "test",
    value: function test(e, t) {
      var n = this._consumables.get(e);
      return n === void 0 ? null : e.is("$text") || e.is("documentFragment") ? n : n.test(Ve(t));
    }
  }, {
    key: "consume",
    value: function consume(e, t) {
      if (e.is("$text") || e.is("documentFragment")) return this.test(e, t) ? (this._consumables.set(e, !1), !0) : !1;
      var n = this._consumables.get(e);
      return n === void 0 ? !1 : n.consume(Ve(t));
    }
  }, {
    key: "revert",
    value: function revert(e, t) {
      var n = this._consumables.get(e);
      n !== void 0 && (e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !0) : n.revert(Ve(t)));
    }
  }], [{
    key: "createFrom",
    value: function createFrom(e, t) {
      if (t || (t = new ct()), e.is("$text")) t.add(e);else if (e.is("element") || e.is("documentFragment")) {
        t.add(e);
        var _iterator4 = _createForOfIteratorHelper(e.getChildren()),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var n = _step4.value;
            ct.createFrom(n, t);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      return t;
    }
  }]);
}();
var er = /*#__PURE__*/function () {
  function er(e) {
    _classCallCheck(this, er);
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "_canConsumeName", null);
    _defineProperty(this, "_attributes", new Map());
    this.element = e;
  }
  return _createClass(er, [{
    key: "add",
    value: function add(e) {
      e.name && (this._canConsumeName = !0);
      var _iterator5 = _createForOfIteratorHelper(e.attributes),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ref6 = _step5.value;
          var _ref7 = _slicedToArray(_ref6, 2);
          var t = _ref7[0];
          var n = _ref7[1];
          if (n) {
            var r = this._attributes.get(t);
            (!r || typeof r == "boolean") && (r = new Map(), this._attributes.set(t, r)), r.set(n, !0);
          } else {
            if (t == "style" || t == "class") throw new f("viewconsumable-invalid-attribute", this);
            this._attributes.set(t, !0);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "test",
    value: function test(e) {
      if (e.name && !this._canConsumeName) return this._canConsumeName;
      var _iterator6 = _createForOfIteratorHelper(e.attributes),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref8 = _step6.value;
          var _ref9 = _slicedToArray(_ref8, 2);
          var t = _ref9[0];
          var n = _ref9[1];
          var r = this._attributes.get(t);
          if (r === void 0) return null;
          if (r === !1) return !1;
          if (r !== !0) {
            if (n) {
              var i = r.get(n);
              if (i === void 0) return null;
              if (!i) return !1;
            } else {
              var _iterator7 = _createForOfIteratorHelper(r.values()),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _i3 = _step7.value;
                  if (!_i3) return !1;
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return !0;
    }
  }, {
    key: "consume",
    value: function consume(e) {
      if (!this.test(e)) return !1;
      e.name && (this._canConsumeName = !1);
      var _iterator8 = _createForOfIteratorHelper(e.attributes),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _ref0 = _step8.value;
          var _ref1 = _slicedToArray(_ref0, 2);
          var t = _ref1[0];
          var n = _ref1[1];
          var r = this._attributes.get(t);
          if (typeof r == "boolean") {
            var _iterator9 = _createForOfIteratorHelper(this.element._getConsumables(t, n).attributes),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _ref10 = _step9.value;
                var _ref11 = _slicedToArray(_ref10, 1);
                var i = _ref11[0];
                this._attributes.set(i, !1);
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          } else if (n) {
            var _iterator0 = _createForOfIteratorHelper(this.element._getConsumables(t, n).attributes),
              _step0;
            try {
              for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                var _ref12 = _step0.value;
                var _ref13 = _slicedToArray(_ref12, 2);
                var _i4 = _ref13[1];
                r.set(_i4, !1);
              }
            } catch (err) {
              _iterator0.e(err);
            } finally {
              _iterator0.f();
            }
          } else {
            var _iterator1 = _createForOfIteratorHelper(r.keys()),
              _step1;
            try {
              for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
                var _i5 = _step1.value;
                r.set(_i5, !1);
              }
            } catch (err) {
              _iterator1.e(err);
            } finally {
              _iterator1.f();
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return !0;
    }
  }, {
    key: "revert",
    value: function revert(e) {
      e.name && (this._canConsumeName = !0);
      var _iterator10 = _createForOfIteratorHelper(e.attributes),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _ref14 = _step10.value;
          var _ref15 = _slicedToArray(_ref14, 2);
          var t = _ref15[0];
          var n = _ref15[1];
          var r = this._attributes.get(t);
          if (r === !1) {
            this._attributes.set(t, !0);
            continue;
          }
          if (!(r === void 0 || r === !0)) if (n) r.get(n) === !1 && r.set(n, !0);else {
            var _iterator11 = _createForOfIteratorHelper(r.keys()),
              _step11;
            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var i = _step11.value;
                r.set(i, !0);
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }]);
}();
function Ve(s) {
  var e = [];
  return "attributes" in s && s.attributes && wt(e, s.attributes), "classes" in s && s.classes && wt(e, s.classes, "class"), "styles" in s && s.styles && wt(e, s.styles, "style"), {
    name: s.name || !1,
    attributes: e
  };
}
function wt(s, e, t) {
  if (typeof e == "string") {
    s.push(t ? [t, e] : [e]);
    return;
  }
  var _iterator12 = _createForOfIteratorHelper(e),
    _step12;
  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var n = _step12.value;
      Array.isArray(n) ? s.push(n) : s.push(t ? [t, n] : [n]);
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
}
var je = /*#__PURE__*/function () {
  function je() {
    _classCallCheck(this, je);
    _defineProperty(this, "_patterns", []);
    this.add.apply(this, arguments);
  }
  return _createClass(je, [{
    key: "add",
    value: function add() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      for (var _i6 = 0, _e2 = e; _i6 < _e2.length; _i6++) {
        var t = _e2[_i6];
        (typeof t == "string" || t instanceof RegExp) && (t = {
          name: t
        }), this._patterns.push(t);
      }
    }
  }, {
    key: "match",
    value: function match() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }
      for (var _i7 = 0, _e3 = e; _i7 < _e3.length; _i7++) {
        var t = _e3[_i7];
        var _iterator13 = _createForOfIteratorHelper(this._patterns),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var n = _step13.value;
            var r = this._isElementMatching(t, n);
            if (r) return {
              element: t,
              pattern: n,
              match: r
            };
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }
      return null;
    }
  }, {
    key: "matchAll",
    value: function matchAll() {
      var t = [];
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }
      for (var _i8 = 0, _e4 = e; _i8 < _e4.length; _i8++) {
        var n = _e4[_i8];
        var _iterator14 = _createForOfIteratorHelper(this._patterns),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var r = _step14.value;
            var i = this._isElementMatching(n, r);
            i && t.push({
              element: n,
              pattern: r,
              match: i
            });
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      }
      return t.length > 0 ? t : null;
    }
  }, {
    key: "getElementName",
    value: function getElementName() {
      if (this._patterns.length !== 1) return null;
      var e = this._patterns[0],
        t = e.name;
      return typeof e != "function" && t && !(t instanceof RegExp) ? t : null;
    }
  }, {
    key: "_isElementMatching",
    value: function _isElementMatching(e, t) {
      if (typeof t == "function") {
        var i = t(e);
        return !i || _typeof(i) != "object" ? i : Ve(i);
      }
      var n = {};
      if (t.name && (n.name = tr(t.name, e.name), !n.name)) return null;
      var r = [];
      return t.attributes && !nr(t.attributes, e, r) || t.classes && !sr(t.classes, e, r) || t.styles && !rr(t.styles, e, r) ? null : (r.length && (n.attributes = r), n);
    }
  }]);
}();
function ht(s, e) {
  return s === !0 || s === e || s instanceof RegExp && !!String(e).match(s);
}
function tr(s, e) {
  return s instanceof RegExp ? !!e.match(s) : s === e;
}
function qt(s, e) {
  if (Array.isArray(s)) return s.map(function (n) {
    return _typeof(n) != "object" || n instanceof RegExp ? e ? [e, n, !0] : [n, !0] : ((n.key === void 0 || n.value === void 0) && W("matcher-pattern-missing-key-or-value", n), e ? [e, n.key, n.value] : [n.key, n.value]);
  });
  if (_typeof(s) != "object" || s instanceof RegExp) return [e ? [e, s, !0] : [s, !0]];
  var t = [];
  for (var n in s) Object.prototype.hasOwnProperty.call(s, n) && t.push(e ? [e, n, s[n]] : [n, s[n]]);
  return t;
}
function nr(s, e, t) {
  var n;
  return _typeof(s) == "object" && !(s instanceof RegExp) && !Array.isArray(s) ? (s.style !== void 0 && W("matcher-pattern-deprecated-attributes-style-key", s), s.class !== void 0 && W("matcher-pattern-deprecated-attributes-class-key", s)) : n = ["class", "style"], e._collectAttributesMatch(qt(s), t, n);
}
function sr(s, e, t) {
  return e._collectAttributesMatch(qt(s, "class"), t);
}
function rr(s, e, t) {
  return e._collectAttributesMatch(qt(s, "style"), t);
}
var We = /*#__PURE__*/function () {
  function We(e) {
    _classCallCheck(this, We);
    _defineProperty(this, "_styles", void 0);
    _defineProperty(this, "_cachedStyleNames", null);
    _defineProperty(this, "_cachedExpandedStyleNames", null);
    _defineProperty(this, "_styleProcessor", void 0);
    this._styles = {}, this._styleProcessor = e;
  }
  return _createClass(We, [{
    key: "isEmpty",
    get: function get() {
      return !Object.entries(this._styles).length;
    }
  }, {
    key: "size",
    get: function get() {
      return this.isEmpty ? 0 : this.getStyleNames().length;
    }
  }, {
    key: "setTo",
    value: function setTo(e) {
      this.clear();
      var t = ir(e);
      var _iterator15 = _createForOfIteratorHelper(t),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _ref16 = _step15.value;
          var _ref17 = _slicedToArray(_ref16, 2);
          var n = _ref17[0];
          var r = _ref17[1];
          this._styleProcessor.toNormalizedForm(n, r, this._styles);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return this;
    }
  }, {
    key: "has",
    value: function has(e) {
      if (this.isEmpty) return !1;
      var n = this._styleProcessor.getReducedForm(e, this._styles).find(function (_ref18) {
        var _ref19 = _slicedToArray(_ref18, 1),
          r = _ref19[0];
        return r === e;
      });
      return Array.isArray(n);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      if (this._cachedStyleNames = null, this._cachedExpandedStyleNames = null, at(e)) for (var _i9 = 0, _Object$entries = Object.entries(e); _i9 < _Object$entries.length; _i9++) {
        var _ref20 = _Object$entries[_i9];
        var _ref21 = _slicedToArray(_ref20, 2);
        var n = _ref21[0];
        var r = _ref21[1];
        this._styleProcessor.toNormalizedForm(n, r, this._styles);
      } else this._styleProcessor.toNormalizedForm(e, t, this._styles);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var _iterator16 = _createForOfIteratorHelper(ae(e)),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var t = _step16.value;
          this._cachedStyleNames = null, this._cachedExpandedStyleNames = null;
          var n = Nt(t);
          Us(this._styles, n), delete this._styles[t], this._cleanEmptyObjectsOnPath(n);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }
  }, {
    key: "getNormalized",
    value: function getNormalized(e) {
      return this._styleProcessor.getNormalized(e, this._styles);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.isEmpty ? "" : this.getStylesEntries().map(function (e) {
        return e.join(":");
      }).sort().join(";") + ";";
    }
  }, {
    key: "getAsString",
    value: function getAsString(e) {
      if (this.isEmpty) return;
      if (this._styles[e] && !at(this._styles[e])) return this._styles[e];
      var n = this._styleProcessor.getReducedForm(e, this._styles).find(function (_ref22) {
        var _ref23 = _slicedToArray(_ref22, 1),
          r = _ref23[0];
        return r === e;
      });
      if (Array.isArray(n)) return n[1];
    }
  }, {
    key: "getStyleNames",
    value: function getStyleNames() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this.isEmpty ? [] : e ? (this._cachedExpandedStyleNames || (this._cachedExpandedStyleNames = this._styleProcessor.getStyleNames(this._styles)), this._cachedExpandedStyleNames) : (this._cachedStyleNames || (this._cachedStyleNames = this.getStylesEntries().map(function (_ref24) {
        var _ref25 = _slicedToArray(_ref24, 1),
          t = _ref25[0];
        return t;
      })), this._cachedStyleNames);
    }
  }, {
    key: "keys",
    value: function keys() {
      return this.getStyleNames();
    }
  }, {
    key: "clear",
    value: function clear() {
      this._styles = {}, this._cachedStyleNames = null, this._cachedExpandedStyleNames = null;
    }
  }, {
    key: "isSimilar",
    value: function isSimilar(e) {
      if (this.size !== e.size) return !1;
      var _iterator17 = _createForOfIteratorHelper(this.getStyleNames()),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var t = _step17.value;
          if (!e.has(t) || e.getAsString(t) !== this.getAsString(t)) return !1;
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      return !0;
    }
  }, {
    key: "getStylesEntries",
    value: function getStylesEntries() {
      var e = [],
        t = Object.keys(this._styles);
      for (var _i0 = 0, _t2 = t; _i0 < _t2.length; _i0++) {
        var n = _t2[_i0];
        e.push.apply(e, _toConsumableArray(this._styleProcessor.getReducedForm(n, this._styles)));
      }
      return e;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      var e = new this.constructor(this._styleProcessor);
      return e.set(this.getNormalized()), e;
    }
  }, {
    key: "_getTokensMatch",
    value: function _getTokensMatch(e, t) {
      var n = [];
      var _iterator18 = _createForOfIteratorHelper(this.getStyleNames(!0)),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var r = _step18.value;
          if (ht(e, r)) {
            if (t === !0) {
              n.push(r);
              continue;
            }
            var i = this.getAsString(r);
            ht(t, i) && n.push(r);
          }
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      return n.length ? n : void 0;
    }
  }, {
    key: "_getConsumables",
    value: function _getConsumables(e) {
      var t = [];
      if (e) {
        t.push(e);
        var _iterator19 = _createForOfIteratorHelper(this._styleProcessor.getRelatedStyles(e)),
          _step19;
        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var n = _step19.value;
            t.push(n);
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
      } else {
        var _iterator20 = _createForOfIteratorHelper(this.getStyleNames()),
          _step20;
        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var _n2 = _step20.value;
            var _iterator21 = _createForOfIteratorHelper(this._styleProcessor.getRelatedStyles(_n2)),
              _step21;
            try {
              for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                var r = _step21.value;
                t.push(r);
              }
            } catch (err) {
              _iterator21.e(err);
            } finally {
              _iterator21.f();
            }
            t.push(_n2);
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
      }
      return t;
    }
  }, {
    key: "_canMergeFrom",
    value: function _canMergeFrom(e) {
      var _iterator22 = _createForOfIteratorHelper(e.getStyleNames()),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var t = _step22.value;
          if (this.has(t) && this.getAsString(t) !== e.getAsString(t)) return !1;
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      return !0;
    }
  }, {
    key: "_mergeFrom",
    value: function _mergeFrom(e) {
      var _iterator23 = _createForOfIteratorHelper(e.getStyleNames()),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var t = _step23.value;
          this.has(t) || this.set(t, e.getAsString(t));
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }
  }, {
    key: "_isMatching",
    value: function _isMatching(e) {
      var _iterator24 = _createForOfIteratorHelper(e.getStyleNames()),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var t = _step24.value;
          if (!this.has(t) || this.getAsString(t) !== e.getAsString(t)) return !1;
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      return !0;
    }
  }, {
    key: "_cleanEmptyObjectsOnPath",
    value: function _cleanEmptyObjectsOnPath(e) {
      var t = e.split(".");
      if (!(t.length > 1)) return;
      var r = t.splice(0, t.length - 1).join("."),
        i = lt(this._styles, r);
      if (!i) return;
      !Object.keys(i).length && this.remove(r);
    }
  }]);
}();
var ul = /*#__PURE__*/function () {
  function ul() {
    _classCallCheck(this, ul);
    _defineProperty(this, "_normalizers", void 0);
    _defineProperty(this, "_extractors", void 0);
    _defineProperty(this, "_reducers", void 0);
    _defineProperty(this, "_consumables", void 0);
    this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
  }
  return _createClass(ul, [{
    key: "toNormalizedForm",
    value: function toNormalizedForm(e, t, n) {
      if (at(t)) {
        bt(n, Nt(e), t);
        return;
      }
      if (this._normalizers.has(e)) {
        var r = this._normalizers.get(e),
          _r3 = r(t),
          i = _r3.path,
          o = _r3.value;
        bt(n, i, o);
      } else bt(n, e, t);
    }
  }, {
    key: "getNormalized",
    value: function getNormalized(e, t) {
      if (!e) return Jn({}, t);
      if (t[e] !== void 0) return t[e];
      if (this._extractors.has(e)) {
        var n = this._extractors.get(e);
        if (typeof n == "string") return lt(t, n);
        var r = n(e, t);
        if (r) return r;
      }
      return lt(t, Nt(e));
    }
  }, {
    key: "getReducedForm",
    value: function getReducedForm(e, t) {
      var n = this.getNormalized(e, t);
      return n === void 0 ? [] : this._reducers.has(e) ? this._reducers.get(e)(n) : [[e, n]];
    }
  }, {
    key: "getStyleNames",
    value: function getStyleNames(e) {
      var t = new Set();
      var _iterator25 = _createForOfIteratorHelper(this._consumables.keys()),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _n3 = _step25.value;
          var r = this.getNormalized(_n3, e);
          r && (_typeof(r) != "object" || Object.keys(r).length) && t.add(_n3);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      for (var _i1 = 0, _Object$keys = Object.keys(e); _i1 < _Object$keys.length; _i1++) {
        var n = _Object$keys[_i1];
        t.add(n);
      }
      return Array.from(t);
    }
  }, {
    key: "getRelatedStyles",
    value: function getRelatedStyles(e) {
      return this._consumables.get(e) || [];
    }
  }, {
    key: "setNormalizer",
    value: function setNormalizer(e, t) {
      this._normalizers.set(e, t);
    }
  }, {
    key: "setExtractor",
    value: function setExtractor(e, t) {
      this._extractors.set(e, t);
    }
  }, {
    key: "setReducer",
    value: function setReducer(e, t) {
      this._reducers.set(e, t);
    }
  }, {
    key: "setStyleRelation",
    value: function setStyleRelation(e, t) {
      this._mapStyleNames(e, t);
      var _iterator26 = _createForOfIteratorHelper(t),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var n = _step26.value;
          this._mapStyleNames(n, [e]);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }
  }, {
    key: "_mapStyleNames",
    value: function _mapStyleNames(e, t) {
      var _this$_consumables$ge;
      this._consumables.has(e) || this._consumables.set(e, []), (_this$_consumables$ge = this._consumables.get(e)).push.apply(_this$_consumables$ge, _toConsumableArray(t));
    }
  }]);
}();
function ir(s) {
  var e = null,
    t = 0,
    n = 0,
    r = null;
  var i = new Map();
  if (s === "") return i;
  s.charAt(s.length - 1) != ";" && (s = s + ";");
  for (var o = 0; o < s.length; o++) {
    var a = s.charAt(o);
    if (e === null) switch (a) {
      case ":":
        r || (r = s.substr(t, o - t), n = o + 1);
        break;
      case '"':
      case "'":
        e = a;
        break;
      case ";":
        {
          var l = s.substr(n, o - n);
          r && i.set(r.trim(), l.trim()), r = null, t = o + 1;
          break;
        }
    } else a === e && (e = null);
  }
  return i;
}
function Nt(s) {
  return s.replace("-", ".");
}
function bt(s, e, t) {
  var n = t;
  at(t) && (n = Jn({}, lt(s, e), t)), js(s, e, n);
}
var yt = /*#__PURE__*/function () {
  function yt() {
    _classCallCheck(this, yt);
    _defineProperty(this, "_set", new Set());
  }
  return _createClass(yt, [{
    key: "isEmpty",
    get: function get() {
      return this._set.size == 0;
    }
  }, {
    key: "size",
    get: function get() {
      return this._set.size;
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._set.has(e);
    }
  }, {
    key: "keys",
    value: function keys() {
      return Array.from(this._set.keys());
    }
  }, {
    key: "setTo",
    value: function setTo(e) {
      this.clear();
      var _iterator27 = _createForOfIteratorHelper(e.split(/\s+/)),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var t = _step27.value;
          t && this._set.add(t);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      return this;
    }
  }, {
    key: "set",
    value: function set(e) {
      var _iterator28 = _createForOfIteratorHelper(ae(e)),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var t = _step28.value;
          t && this._set.add(t);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var _iterator29 = _createForOfIteratorHelper(ae(e)),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var t = _step29.value;
          this._set.delete(t);
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this._set.clear();
    }
  }, {
    key: "toString",
    value: function toString() {
      return Array.from(this._set).join(" ");
    }
  }, {
    key: "isSimilar",
    value: function isSimilar(e) {
      if (this.size !== e.size) return !1;
      var _iterator30 = _createForOfIteratorHelper(this.keys()),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var t = _step30.value;
          if (!e.has(t)) return !1;
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      return !0;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      var e = new this.constructor();
      return e._set = new Set(this._set), e;
    }
  }, {
    key: "_getTokensMatch",
    value: function _getTokensMatch(e) {
      var t = [];
      if (e === !0) {
        var _iterator31 = _createForOfIteratorHelper(this._set.keys()),
          _step31;
        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var n = _step31.value;
            t.push(n);
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }
        return t;
      }
      if (typeof e == "string") {
        var _iterator32 = _createForOfIteratorHelper(e.split(/\s+/)),
          _step32;
        try {
          for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
            var _n4 = _step32.value;
            if (this._set.has(_n4)) t.push(_n4);else return;
          }
        } catch (err) {
          _iterator32.e(err);
        } finally {
          _iterator32.f();
        }
        return t;
      }
      var _iterator33 = _createForOfIteratorHelper(this._set.keys()),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var _n5 = _step33.value;
          _n5.match(e) && t.push(_n5);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      return t.length ? t : void 0;
    }
  }, {
    key: "_getConsumables",
    value: function _getConsumables(e) {
      return e ? [e] : this.keys();
    }
  }, {
    key: "_canMergeFrom",
    value: function _canMergeFrom() {
      return !0;
    }
  }, {
    key: "_mergeFrom",
    value: function _mergeFrom(e) {
      var _iterator34 = _createForOfIteratorHelper(e._set.keys()),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var t = _step34.value;
          this._set.has(t) || this._set.add(t);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    }
  }, {
    key: "_isMatching",
    value: function _isMatching(e) {
      var _iterator35 = _createForOfIteratorHelper(e._set.keys()),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var t = _step35.value;
          if (!this._set.has(t)) return !1;
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      return !0;
    }
  }]);
}();
var te = /*#__PURE__*/function (_be2) {
  function jn(e, t, n, r) {
    var _this4;
    _classCallCheck(this, jn);
    _this4 = _callSuper(this, jn, [e]), _defineProperty(_assertThisInitialized(_this4), "name", void 0), _defineProperty(_assertThisInitialized(_this4), "_unsafeAttributesToRender", []), _defineProperty(_assertThisInitialized(_this4), "_attrs", void 0), _defineProperty(_assertThisInitialized(_this4), "_children", void 0), _defineProperty(_assertThisInitialized(_this4), "_customProperties", new Map()), _this4.name = t, _this4._attrs = _this4._parseAttributes(n), _this4._children = [], r && _this4._insertChild(0, r);
    return _this4;
  }
  _inherits(jn, _be2);
  return _createClass(jn, [{
    key: "_classes",
    get: function get() {
      return this._attrs.get("class");
    }
  }, {
    key: "_styles",
    get: function get() {
      return this._attrs.get("style");
    }
  }, {
    key: "childCount",
    get: function get() {
      return this._children.length;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this._children.length === 0;
    }
  }, {
    key: "getChild",
    value: function getChild(e) {
      return this._children[e];
    }
  }, {
    key: "getChildIndex",
    value: function getChildIndex(e) {
      return this._children.indexOf(e);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children[Symbol.iterator]();
    }
  }, {
    key: "getAttributeKeys",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
      var _iterator36, _step36, e;
      return _regeneratorRuntime().wrap(function getAttributeKeys$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = this._classes;
            if (!_context.t0) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return "class";
          case 4:
            _context.t1 = this._styles;
            if (!_context.t1) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return "style";
          case 8:
            _iterator36 = _createForOfIteratorHelper(this._attrs.keys());
            _context.prev = 9;
            _iterator36.s();
          case 11:
            if ((_step36 = _iterator36.n()).done) {
              _context.next = 19;
              break;
            }
            e = _step36.value;
            _context.t2 = e != "class" && e != "style";
            if (!_context.t2) {
              _context.next = 17;
              break;
            }
            _context.next = 17;
            return e;
          case 17:
            _context.next = 11;
            break;
          case 19:
            _context.next = 24;
            break;
          case 21:
            _context.prev = 21;
            _context.t3 = _context["catch"](9);
            _iterator36.e(_context.t3);
          case 24:
            _context.prev = 24;
            _iterator36.f();
            return _context.finish(24);
          case 27:
          case "end":
            return _context.stop();
        }
      }, getAttributeKeys, this, [[9, 21, 24, 27]]);
    })
  }, {
    key: "getAttributes",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributes() {
      var _iterator37, _step37, _ref26, _ref27, e, t;
      return _regeneratorRuntime().wrap(function getAttributes$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _iterator37 = _createForOfIteratorHelper(this._attrs.entries());
            _context2.prev = 1;
            _iterator37.s();
          case 3:
            if ((_step37 = _iterator37.n()).done) {
              _context2.next = 12;
              break;
            }
            _ref26 = _step37.value;
            _ref27 = _slicedToArray(_ref26, 2);
            e = _ref27[0];
            t = _ref27[1];
            _context2.next = 10;
            return [e, String(t)];
          case 10:
            _context2.next = 3;
            break;
          case 12:
            _context2.next = 17;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            _iterator37.e(_context2.t0);
          case 17:
            _context2.prev = 17;
            _iterator37.f();
            return _context2.finish(17);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, getAttributes, this, [[1, 14, 17, 20]]);
    })
  }, {
    key: "getAttribute",
    value: function getAttribute(e) {
      return this._attrs.has(e) ? String(this._attrs.get(e)) : void 0;
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(e, t) {
      return this._attrs.has(e) ? t !== void 0 ? Pe(this.name, e) || Oe(this.name, e) ? this._attrs.get(e).has(t) : this._attrs.get(e) === t : !0 : !1;
    }
  }, {
    key: "isSimilar",
    value: function isSimilar(e) {
      if (!(e instanceof jn)) return !1;
      if (this === e) return !0;
      if (this.name != e.name || this._attrs.size !== e._attrs.size) return !1;
      var _iterator38 = _createForOfIteratorHelper(this._attrs),
        _step38;
      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var _ref28 = _step38.value;
          var _ref29 = _slicedToArray(_ref28, 2);
          var t = _ref29[0];
          var n = _ref29[1];
          var r = e._attrs.get(t);
          if (r === void 0) return !1;
          if (typeof n == "string" || typeof r == "string") {
            if (r !== n) return !1;
          } else if (!n.isSimilar(r)) return !1;
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
      return !0;
    }
  }, {
    key: "hasClass",
    value: function hasClass() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }
      for (var _i10 = 0, _e5 = e; _i10 < _e5.length; _i10++) {
        var t = _e5[_i10];
        if (!this._classes || !this._classes.has(t)) return !1;
      }
      return !0;
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var e = this._classes ? this._classes.keys() : [],
        t = e[Symbol.iterator]();
      return Object.assign(e, {
        next: t.next.bind(t)
      });
    }
  }, {
    key: "getStyle",
    value: function getStyle(e) {
      return this._styles && this._styles.getAsString(e);
    }
  }, {
    key: "getNormalizedStyle",
    value: function getNormalizedStyle(e) {
      return this._styles && this._styles.getNormalized(e);
    }
  }, {
    key: "getStyleNames",
    value: function getStyleNames(e) {
      return this._styles ? this._styles.getStyleNames(e) : [];
    }
  }, {
    key: "hasStyle",
    value: function hasStyle() {
      for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        e[_key5] = arguments[_key5];
      }
      for (var _i11 = 0, _e6 = e; _i11 < _e6.length; _i11++) {
        var t = _e6[_i11];
        if (!this._styles || !this._styles.has(t)) return !1;
      }
      return !0;
    }
  }, {
    key: "findAncestor",
    value: function findAncestor() {
      for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        e[_key6] = arguments[_key6];
      }
      var t = _construct(je, e);
      var n = this.parent;
      for (; n && !n.is("documentFragment");) {
        if (t.match(n)) return n;
        n = n.parent;
      }
      return null;
    }
  }, {
    key: "getCustomProperty",
    value: function getCustomProperty(e) {
      return this._customProperties.get(e);
    }
  }, {
    key: "getCustomProperties",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getCustomProperties() {
      return _regeneratorRuntime().wrap(function getCustomProperties$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.delegateYield(this._customProperties.entries(), "t0", 1);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, getCustomProperties, this);
    })
  }, {
    key: "getIdentity",
    value: function getIdentity() {
      var e = this._classes ? this._classes.keys().sort().join(",") : "",
        t = this._styles && String(this._styles),
        n = Array.from(this._attrs).filter(function (_ref30) {
          var _ref31 = _slicedToArray(_ref30, 1),
            r = _ref31[0];
          return r != "style" && r != "class";
        }).map(function (r) {
          return "".concat(r[0], "=\"").concat(r[1], "\"");
        }).sort().join(" ");
      return this.name + (e == "" ? "" : " class=\"".concat(e, "\"")) + (t ? " style=\"".concat(t, "\"") : "") + (n == "" ? "" : " ".concat(n));
    }
  }, {
    key: "shouldRenderUnsafeAttribute",
    value: function shouldRenderUnsafeAttribute(e) {
      return this._unsafeAttributesToRender.includes(e);
    }
  }, {
    key: "_clone",
    value: function _clone() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = [];
      if (e) {
        var _iterator39 = _createForOfIteratorHelper(this.getChildren()),
          _step39;
        try {
          for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
            var r = _step39.value;
            t.push(r._clone(e));
          }
        } catch (err) {
          _iterator39.e(err);
        } finally {
          _iterator39.f();
        }
      }
      var n = new this.constructor(this.document, this.name, this._attrs, t);
      return n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n._unsafeAttributesToRender = this._unsafeAttributesToRender, n;
    }
  }, {
    key: "_appendChild",
    value: function _appendChild(e) {
      return this._insertChild(this.childCount, e);
    }
  }, {
    key: "_insertChild",
    value: function _insertChild(e, t) {
      this._fireChange("children", this, {
        index: e
      });
      var n = 0;
      var r = or(this.document, t);
      var _iterator40 = _createForOfIteratorHelper(r),
        _step40;
      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var i = _step40.value;
          i.parent !== null && i._remove(), i.parent = this, i.document = this.document, this._children.splice(e, 0, i), e++, n++;
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
      return n;
    }
  }, {
    key: "_removeChildren",
    value: function _removeChildren(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this._fireChange("children", this, {
        index: e
      });
      for (var n = e; n < e + t; n++) this._children[n].parent = null;
      return this._children.splice(e, t);
    }
  }, {
    key: "_setAttribute",
    value: function _setAttribute(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      if (this._fireChange("attributes", this), Pe(this.name, e) || Oe(this.name, e)) {
        var r = this._attrs.get(e);
        r || (r = Pe(this.name, e) ? new We(this.document.stylesProcessor) : new yt(), this._attrs.set(e, r)), n ? r.setTo(String(t)) : Pe(this.name, e) ? Array.isArray(t) ? r.set(t[0], t[1]) : r.set(t) : r.set(typeof t == "string" ? t.split(/\s+/) : t);
      } else this._attrs.set(e, String(t));
    }
  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(e, t) {
      if (this._fireChange("attributes", this), t !== void 0 && (Pe(this.name, e) || Oe(this.name, e))) {
        var n = this._attrs.get(e);
        return n ? (Oe(this.name, e) && typeof t == "string" && (t = t.split(/\s+/)), n.remove(t), n.isEmpty ? this._attrs.delete(e) : !1) : !1;
      }
      return this._attrs.delete(e);
    }
  }, {
    key: "_addClass",
    value: function _addClass(e) {
      this._setAttribute("class", e, !1);
    }
  }, {
    key: "_removeClass",
    value: function _removeClass(e) {
      this._removeAttribute("class", e);
    }
  }, {
    key: "_setStyle",
    value: function _setStyle(e, t) {
      typeof e != "string" ? this._setAttribute("style", e, !1) : this._setAttribute("style", [e, t], !1);
    }
  }, {
    key: "_removeStyle",
    value: function _removeStyle(e) {
      this._removeAttribute("style", e);
    }
  }, {
    key: "_collectAttributesMatch",
    value: function _collectAttributesMatch(e, t, n) {
      var _iterator41 = _createForOfIteratorHelper(e),
        _step41;
      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var _ref32 = _step41.value;
          var _ref33 = _slicedToArray(_ref32, 3);
          var r = _ref33[0];
          var i = _ref33[1];
          var o = _ref33[2];
          var a = !1,
            l = !1;
          var _iterator42 = _createForOfIteratorHelper(this._attrs),
            _step42;
          try {
            for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
              var _ref34 = _step42.value;
              var _ref35 = _slicedToArray(_ref34, 2);
              var c = _ref35[0];
              var h = _ref35[1];
              if (!(n && n.includes(c) || !ht(r, c))) if (a = !0, typeof h == "string") {
                if (ht(i, h)) t.push([c]), l = !0;else if (!(r instanceof RegExp)) return !1;
              } else {
                var d = h._getTokensMatch(i, o || !0);
                if (d) {
                  l = !0;
                  var _iterator43 = _createForOfIteratorHelper(d),
                    _step43;
                  try {
                    for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                      var p = _step43.value;
                      t.push([c, p]);
                    }
                  } catch (err) {
                    _iterator43.e(err);
                  } finally {
                    _iterator43.f();
                  }
                } else if (!(r instanceof RegExp)) return !1;
              }
            }
          } catch (err) {
            _iterator42.e(err);
          } finally {
            _iterator42.f();
          }
          if (!a || !l) return !1;
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
      return !0;
    }
  }, {
    key: "_getConsumables",
    value: function _getConsumables(e, t) {
      var n = [];
      if (e) {
        var r = this._attrs.get(e);
        if (r !== void 0) if (typeof r == "string") n.push([e]);else {
          var _iterator44 = _createForOfIteratorHelper(r._getConsumables(t)),
            _step44;
          try {
            for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
              var i = _step44.value;
              n.push([e, i]);
            }
          } catch (err) {
            _iterator44.e(err);
          } finally {
            _iterator44.f();
          }
        }
      } else {
        var _iterator45 = _createForOfIteratorHelper(this._attrs),
          _step45;
        try {
          for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
            var _ref36 = _step45.value;
            var _ref37 = _slicedToArray(_ref36, 2);
            var _r4 = _ref37[0];
            var _i12 = _ref37[1];
            if (typeof _i12 == "string") n.push([_r4]);else {
              var _iterator46 = _createForOfIteratorHelper(_i12._getConsumables()),
                _step46;
              try {
                for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                  var o = _step46.value;
                  n.push([_r4, o]);
                }
              } catch (err) {
                _iterator46.e(err);
              } finally {
                _iterator46.f();
              }
            }
          }
        } catch (err) {
          _iterator45.e(err);
        } finally {
          _iterator45.f();
        }
      }
      return {
        name: !e,
        attributes: n
      };
    }
  }, {
    key: "_canMergeAttributesFrom",
    value: function _canMergeAttributesFrom(e) {
      if (this.name != e.name) return !1;
      var _iterator47 = _createForOfIteratorHelper(e._attrs),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var _ref38 = _step47.value;
          var _ref39 = _slicedToArray(_ref38, 2);
          var t = _ref39[0];
          var n = _ref39[1];
          var r = this._attrs.get(t);
          if (r !== void 0) {
            if (typeof r == "string" || typeof n == "string") {
              if (r !== n) return !1;
            } else if (!r._canMergeFrom(n)) return !1;
          }
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
      return !0;
    }
  }, {
    key: "_mergeAttributesFrom",
    value: function _mergeAttributesFrom(e) {
      this._fireChange("attributes", this);
      var _iterator48 = _createForOfIteratorHelper(e._attrs),
        _step48;
      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var _ref40 = _step48.value;
          var _ref41 = _slicedToArray(_ref40, 2);
          var t = _ref41[0];
          var n = _ref41[1];
          var r = this._attrs.get(t);
          r === void 0 || typeof r == "string" || typeof n == "string" ? this._setAttribute(t, n) : r._mergeFrom(n);
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
    }
  }, {
    key: "_canSubtractAttributesOf",
    value: function _canSubtractAttributesOf(e) {
      if (this.name != e.name) return !1;
      var _iterator49 = _createForOfIteratorHelper(e._attrs),
        _step49;
      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var _ref42 = _step49.value;
          var _ref43 = _slicedToArray(_ref42, 2);
          var t = _ref43[0];
          var n = _ref43[1];
          var r = this._attrs.get(t);
          if (r === void 0) return !1;
          if (typeof r == "string" || typeof n == "string") {
            if (r !== n) return !1;
          } else if (!r._isMatching(n)) return !1;
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
      return !0;
    }
  }, {
    key: "_subtractAttributesOf",
    value: function _subtractAttributesOf(e) {
      this._fireChange("attributes", this);
      var _iterator50 = _createForOfIteratorHelper(e._attrs),
        _step50;
      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var _ref44 = _step50.value;
          var _ref45 = _slicedToArray(_ref44, 2);
          var t = _ref45[0];
          var n = _ref45[1];
          var r = this._attrs.get(t);
          typeof r == "string" || typeof n == "string" ? this._attrs.delete(t) : (r.remove(n.keys()), r.isEmpty && this._attrs.delete(t));
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
    }
  }, {
    key: "_setCustomProperty",
    value: function _setCustomProperty(e, t) {
      this._customProperties.set(e, t);
    }
  }, {
    key: "_removeCustomProperty",
    value: function _removeCustomProperty(e) {
      return this._customProperties.delete(e);
    }
  }, {
    key: "_parseAttributes",
    value: function _parseAttributes(e) {
      var t = pe(e);
      var _iterator51 = _createForOfIteratorHelper(t),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var _ref46 = _step51.value;
          var _ref47 = _slicedToArray(_ref46, 2);
          var n = _ref47[0];
          var r = _ref47[1];
          if (r === null) t.delete(n);else if (Pe(this.name, n)) {
            var i = r instanceof We ? r._clone() : new We(this.document.stylesProcessor).setTo(String(r));
            t.set(n, i);
          } else if (Oe(this.name, n)) {
            var _i13 = r instanceof yt ? r._clone() : new yt().setTo(String(r));
            t.set(n, _i13);
          } else typeof r != "string" && t.set(n, String(r));
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
      return t;
    }
  }]);
}(be);
te.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "element" || s === "view:element") : s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
function or(s, e) {
  if (typeof e == "string") return [new x(s, e)];
  le(e) || (e = [e]);
  var t = [];
  var _iterator52 = _createForOfIteratorHelper(e),
    _step52;
  try {
    for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
      var n = _step52.value;
      typeof n == "string" ? t.push(new x(s, n)) : n instanceof Q ? t.push(new x(s, n.data)) : t.push(n);
    }
  } catch (err) {
    _iterator52.e(err);
  } finally {
    _iterator52.f();
  }
  return t;
}
function Oe(s, e) {
  return e == "class" || s == "a" && e == "rel";
}
function Pe(s, e) {
  return e == "style";
}
var Ge = /*#__PURE__*/function (_te) {
  function Ge(e, t, n, r) {
    var _this5;
    _classCallCheck(this, Ge);
    _this5 = _callSuper(this, Ge, [e, t, n, r]), _this5.getFillerOffset = ar;
    return _this5;
  }
  _inherits(Ge, _te);
  return _createClass(Ge);
}(te);
Ge.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "containerElement" || s === "view:containerElement" || s === "element" || s === "view:element") : s === "containerElement" || s === "view:containerElement" || s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
function ar() {
  var s = _toConsumableArray(this.getChildren()),
    e = s[this.childCount - 1];
  if (e && e.is("element", "br")) return this.childCount;
  var _iterator53 = _createForOfIteratorHelper(s),
    _step53;
  try {
    for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
      var t = _step53.value;
      if (!t.is("uiElement")) return null;
    }
  } catch (err) {
    _iterator53.e(err);
  } finally {
    _iterator53.f();
  }
  return this.childCount;
}
var dt = /*#__PURE__*/function (_U) {
  function dt(e, t, n, r) {
    var _this6;
    _classCallCheck(this, dt);
    _this6 = _callSuper(this, dt, [e, t, n, r]), _this6.set("isReadOnly", !1), _this6.set("isFocused", !1), _this6.set("placeholder", void 0), _this6.bind("isReadOnly").to(e), _this6.bind("isFocused").to(e, "isFocused", function (i) {
      return i && e.selection.editableElement == _assertThisInitialized(_this6);
    }), _this6.listenTo(e.selection, "change", function () {
      _this6.isFocused = e.isFocused && e.selection.editableElement == _assertThisInitialized(_this6);
    });
    return _this6;
  }
  _inherits(dt, _U);
  return _createClass(dt, [{
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
  }]);
}(U(Ge));
dt.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "editableElement" || s === "view:editableElement" || s === "containerElement" || s === "view:containerElement" || s === "element" || s === "view:element") : s === "editableElement" || s === "view:editableElement" || s === "containerElement" || s === "view:containerElement" || s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
var on = Symbol("rootName");
var Gn = /*#__PURE__*/function (_dt) {
  function Gn(e, t) {
    var _this7;
    _classCallCheck(this, Gn);
    _this7 = _callSuper(this, Gn, [e, t]), _this7.rootName = "main";
    return _this7;
  }
  _inherits(Gn, _dt);
  return _createClass(Gn, [{
    key: "rootName",
    get: function get() {
      return this.getCustomProperty(on);
    },
    set: function set(e) {
      this._setCustomProperty(on, e);
    }
  }, {
    key: "_name",
    set: function set(e) {
      this.name = e;
    }
  }]);
}(dt);
Gn.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "rootElement" || s === "view:rootElement" || s === "editableElement" || s === "view:editableElement" || s === "containerElement" || s === "view:containerElement" || s === "element" || s === "view:element") : s === "rootElement" || s === "view:rootElement" || s === "editableElement" || s === "view:editableElement" || s === "containerElement" || s === "view:containerElement" || s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
var me = /*#__PURE__*/function () {
    function me() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, me);
      _defineProperty(this, "direction", void 0);
      _defineProperty(this, "boundaries", void 0);
      _defineProperty(this, "singleCharacters", void 0);
      _defineProperty(this, "shallow", void 0);
      _defineProperty(this, "ignoreElementEnd", void 0);
      _defineProperty(this, "_position", void 0);
      _defineProperty(this, "_boundaryStartParent", void 0);
      _defineProperty(this, "_boundaryEndParent", void 0);
      if (!e.boundaries && !e.startPosition) throw new f("view-tree-walker-no-start-position", null);
      if (e.direction && e.direction != "forward" && e.direction != "backward") throw new f("view-tree-walker-unknown-direction", e.startPosition, {
        direction: e.direction
      });
      this.boundaries = e.boundaries || null, e.startPosition ? this._position = g._createAt(e.startPosition) : this._position = g._createAt(e.boundaries[e.direction == "backward" ? "end" : "start"]), this.direction = e.direction || "forward", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
    }
    return _createClass(me, [{
      key: Symbol.iterator,
      value: function value() {
        return this;
      }
    }, {
      key: "position",
      get: function get() {
        return this._position;
      }
    }, {
      key: "skip",
      value: function skip(e) {
        var t, n;
        do n = this.position, t = this.next(); while (!t.done && e(t.value));
        t.done || (this._position = n);
      }
    }, {
      key: "jumpTo",
      value: function jumpTo(e) {
        this._boundaryStartParent && e.isBefore(this.boundaries.start) ? e = this.boundaries.start : this._boundaryEndParent && e.isAfter(this.boundaries.end) && (e = this.boundaries.end), this._position = e.clone();
      }
    }, {
      key: "next",
      value: function next() {
        return this.direction == "forward" ? this._next() : this._previous();
      }
    }, {
      key: "_next",
      value: function _next() {
        var e = this.position.clone();
        var t = this.position,
          n = e.parent;
        if (n.parent === null && e.offset === n.childCount) return {
          done: !0,
          value: void 0
        };
        if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
          done: !0,
          value: void 0
        };
        var r;
        if (n && n.is("view:$text")) {
          if (e.isAtEnd) return this._position = g._createAfter(n), this._next();
          r = n.data[e.offset];
        } else r = n.getChild(e.offset);
        if (typeof r == "string") {
          var i;
          this.singleCharacters ? i = 1 : i = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - e.offset;
          var o = new Q(n, e.offset, i);
          return e.offset += i, this._position = e, this._formatReturnValue("text", o, t, e, i);
        }
        if (r && r.is("view:element")) {
          if (!this.shallow) e = new g(r, 0);else {
            if (this.boundaries && this.boundaries.end.isBefore(e)) return {
              done: !0,
              value: void 0
            };
            e.offset++;
          }
          return this._position = e, this._formatReturnValue("elementStart", r, t, e, 1);
        }
        if (r && r.is("view:$text")) {
          if (this.singleCharacters) return e = new g(r, 0), this._position = e, this._next();
          var _i14 = r.data.length,
            _o2;
          return r == this._boundaryEndParent ? (_i14 = this.boundaries.end.offset, _o2 = new Q(r, 0, _i14), e = g._createAfter(_o2)) : (_o2 = new Q(r, 0, r.data.length), e.offset++), this._position = e, this._formatReturnValue("text", _o2, t, e, _i14);
        }
        return e = g._createAfter(n), this._position = e, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, t, e);
      }
    }, {
      key: "_previous",
      value: function _previous() {
        var e = this.position.clone();
        var t = this.position,
          n = e.parent;
        if (n.parent === null && e.offset === 0) return {
          done: !0,
          value: void 0
        };
        if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
          done: !0,
          value: void 0
        };
        var r;
        if (n.is("view:$text")) {
          if (e.isAtStart) return this._position = g._createBefore(n), this._previous();
          r = n.data[e.offset - 1];
        } else r = n.getChild(e.offset - 1);
        if (typeof r == "string") {
          var i;
          if (this.singleCharacters) i = 1;else {
            var a = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
            i = e.offset - a;
          }
          e.offset -= i;
          var o = new Q(n, e.offset, i);
          return this._position = e, this._formatReturnValue("text", o, t, e, i);
        }
        if (r && r.is("view:element")) return this.shallow ? (e.offset--, this._position = e, this._formatReturnValue("elementStart", r, t, e, 1)) : (e = new g(r, r.childCount), this._position = e, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", r, t, e));
        if (r && r.is("view:$text")) {
          if (this.singleCharacters) return e = new g(r, r.data.length), this._position = e, this._previous();
          var _i15 = r.data.length,
            _o3;
          if (r == this._boundaryStartParent) {
            var _a2 = this.boundaries.start.offset;
            _o3 = new Q(r, _a2, r.data.length - _a2), _i15 = _o3.data.length, e = g._createBefore(_o3);
          } else _o3 = new Q(r, 0, r.data.length), e.offset--;
          return this._position = e, this._formatReturnValue("text", _o3, t, e, _i15);
        }
        return e = g._createBefore(n), this._position = e, this._formatReturnValue("elementStart", n, t, e, 1);
      }
    }, {
      key: "_formatReturnValue",
      value: function _formatReturnValue(e, t, n, r, i) {
        return t.is("view:$textProxy") && (t.offsetInText + t.data.length == t.textNode.data.length && (this.direction == "forward" && !(this.boundaries && this.boundaries.end.isEqual(this.position)) ? (r = g._createAfter(t.textNode), this._position = r) : n = g._createAfter(t.textNode)), t.offsetInText === 0 && (this.direction == "backward" && !(this.boundaries && this.boundaries.start.isEqual(this.position)) ? (r = g._createBefore(t.textNode), this._position = r) : n = g._createBefore(t.textNode))), {
          done: !1,
          value: {
            type: e,
            item: t,
            previousPosition: n,
            nextPosition: r,
            length: i
          }
        };
      }
    }]);
  }(),
  g = /*#__PURE__*/function (_we2) {
    function Y(e, t) {
      var _this8;
      _classCallCheck(this, Y);
      _this8 = _callSuper(this, Y), _defineProperty(_assertThisInitialized(_this8), "parent", void 0), _defineProperty(_assertThisInitialized(_this8), "offset", void 0), _this8.parent = e, _this8.offset = t;
      return _this8;
    }
    _inherits(Y, _we2);
    return _createClass(Y, [{
      key: "nodeAfter",
      get: function get() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
      }
    }, {
      key: "nodeBefore",
      get: function get() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
      }
    }, {
      key: "isAtStart",
      get: function get() {
        return this.offset === 0;
      }
    }, {
      key: "isAtEnd",
      get: function get() {
        var e = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
        return this.offset === e;
      }
    }, {
      key: "root",
      get: function get() {
        return this.parent.root;
      }
    }, {
      key: "editableElement",
      get: function get() {
        var e = this.parent;
        for (; !(e instanceof dt);) if (e.parent) e = e.parent;else return null;
        return e;
      }
    }, {
      key: "getShiftedBy",
      value: function getShiftedBy(e) {
        var t = Y._createAt(this),
          n = t.offset + e;
        return t.offset = n < 0 ? 0 : n, t;
      }
    }, {
      key: "getLastMatchingPosition",
      value: function getLastMatchingPosition(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        t.startPosition = this;
        var n = new me(t);
        return n.skip(e), n.position;
      }
    }, {
      key: "getAncestors",
      value: function getAncestors() {
        return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
          includeSelf: !0
        });
      }
    }, {
      key: "getCommonAncestor",
      value: function getCommonAncestor(e) {
        var t = this.getAncestors(),
          n = e.getAncestors();
        var r = 0;
        for (; t[r] == n[r] && t[r];) r++;
        return r === 0 ? null : t[r - 1];
      }
    }, {
      key: "isEqual",
      value: function isEqual(e) {
        return this.parent == e.parent && this.offset == e.offset;
      }
    }, {
      key: "isBefore",
      value: function isBefore(e) {
        return this.compareWith(e) == "before";
      }
    }, {
      key: "isAfter",
      value: function isAfter(e) {
        return this.compareWith(e) == "after";
      }
    }, {
      key: "compareWith",
      value: function compareWith(e) {
        if (this.root !== e.root) return "different";
        if (this.isEqual(e)) return "same";
        var t = this.parent.is("node") ? this.parent.getPath() : [],
          n = e.parent.is("node") ? e.parent.getPath() : [];
        t.push(this.offset), n.push(e.offset);
        var r = F(t, n);
        switch (r) {
          case "prefix":
            return "before";
          case "extension":
            return "after";
          default:
            return t[r] < n[r] ? "before" : "after";
        }
      }
    }, {
      key: "getWalker",
      value: function getWalker() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return e.startPosition = this, new me(e);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new Y(this.parent, this.offset);
      }
    }], [{
      key: "_createAt",
      value: function _createAt(e, t) {
        if (e instanceof Y) return new this(e.parent, e.offset);
        {
          var n = e;
          if (t == "end") t = n.is("$text") ? n.data.length : n.childCount;else {
            if (t == "before") return this._createBefore(n);
            if (t == "after") return this._createAfter(n);
            if (t !== 0 && !t) throw new f("view-createpositionat-offset-required", n);
          }
          return new Y(n, t);
        }
      }
    }, {
      key: "_createAfter",
      value: function _createAfter(e) {
        if (e.is("$textProxy")) return new Y(e.textNode, e.offsetInText + e.data.length);
        if (!e.parent) throw new f("view-position-after-root", e, {
          root: e
        });
        return new Y(e.parent, e.index + 1);
      }
    }, {
      key: "_createBefore",
      value: function _createBefore(e) {
        if (e.is("$textProxy")) return new Y(e.textNode, e.offsetInText);
        if (!e.parent) throw new f("view-position-before-root", e, {
          root: e
        });
        return new Y(e.parent, e.index);
      }
    }]);
  }(we);
g.prototype.is = function (s) {
  return s === "position" || s === "view:position";
};
var w = /*#__PURE__*/function (_we3) {
  function se(e) {
    var _this9;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, se);
    _this9 = _callSuper(this, se), _defineProperty(_assertThisInitialized(_this9), "start", void 0), _defineProperty(_assertThisInitialized(_this9), "end", void 0), _this9.start = e.clone(), _this9.end = t ? t.clone() : e.clone();
    return _this9;
  }
  _inherits(se, _we3);
  return _createClass(se, [{
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      return _regeneratorRuntime().wrap(function value$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.delegateYield(new me({
              boundaries: this,
              ignoreElementEnd: !0
            }), "t0", 1);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, value, this);
    })
  }, {
    key: "isCollapsed",
    get: function get() {
      return this.start.isEqual(this.end);
    }
  }, {
    key: "isFlat",
    get: function get() {
      return this.start.parent === this.end.parent;
    }
  }, {
    key: "root",
    get: function get() {
      return this.start.root;
    }
  }, {
    key: "getEnlarged",
    value: function getEnlarged() {
      var e = this.start.getLastMatchingPosition(et, {
          direction: "backward"
        }),
        t = this.end.getLastMatchingPosition(et);
      return e.parent.is("$text") && e.isAtStart && (e = g._createBefore(e.parent)), t.parent.is("$text") && t.isAtEnd && (t = g._createAfter(t.parent)), new se(e, t);
    }
  }, {
    key: "getTrimmed",
    value: function getTrimmed() {
      var e = this.start.getLastMatchingPosition(et);
      if (e.isAfter(this.end) || e.isEqual(this.end)) return new se(e, e);
      var t = this.end.getLastMatchingPosition(et, {
        direction: "backward"
      });
      var n = e.nodeAfter,
        r = t.nodeBefore;
      return n && n.is("$text") && (e = new g(n, 0)), r && r.is("$text") && (t = new g(r, r.data.length)), new se(e, t);
    }
  }, {
    key: "isEqual",
    value: function isEqual(e) {
      return this == e || this.start.isEqual(e.start) && this.end.isEqual(e.end);
    }
  }, {
    key: "containsPosition",
    value: function containsPosition(e) {
      return e.isAfter(this.start) && e.isBefore(this.end);
    }
  }, {
    key: "containsRange",
    value: function containsRange(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      e.isCollapsed && (t = !1);
      var n = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
        r = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
      return n && r;
    }
  }, {
    key: "getDifference",
    value: function getDifference(e) {
      var t = [];
      return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new se(this.start, e.start)), this.containsPosition(e.end) && t.push(new se(e.end, this.end))) : t.push(this.clone()), t;
    }
  }, {
    key: "getIntersection",
    value: function getIntersection(e) {
      if (this.isIntersecting(e)) {
        var t = this.start,
          n = this.end;
        return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new se(t, n);
      }
      return null;
    }
  }, {
    key: "getWalker",
    value: function getWalker() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return e.boundaries = this, new me(e);
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor() {
      return this.start.getCommonAncestor(this.end);
    }
  }, {
    key: "getContainedElement",
    value: function getContainedElement() {
      if (this.isCollapsed) return null;
      var e = this.start.nodeAfter,
        t = this.end.nodeBefore;
      return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (e = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (t = this.end.parent.previousSibling), e && e.is("element") && e === t ? e : null;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new se(this.start, this.end);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this0 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var t, _iterator54, _step54, n;
        return _regeneratorRuntime().wrap(function _callee$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              e.boundaries = _this0, e.ignoreElementEnd = !0;
              t = new me(e);
              _iterator54 = _createForOfIteratorHelper(t);
              _context5.prev = 3;
              _iterator54.s();
            case 5:
              if ((_step54 = _iterator54.n()).done) {
                _context5.next = 11;
                break;
              }
              n = _step54.value;
              _context5.next = 9;
              return n.item;
            case 9:
              _context5.next = 5;
              break;
            case 11:
              _context5.next = 16;
              break;
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](3);
              _iterator54.e(_context5.t0);
            case 16:
              _context5.prev = 16;
              _iterator54.f();
              return _context5.finish(16);
            case 19:
            case "end":
              return _context5.stop();
          }
        }, _callee, null, [[3, 13, 16, 19]]);
      })();
    }
  }, {
    key: "getPositions",
    value: function getPositions() {
      var _this1 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var t, _iterator55, _step55, n;
        return _regeneratorRuntime().wrap(function _callee2$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              e.boundaries = _this1;
              t = new me(e);
              _context6.next = 4;
              return t.position;
            case 4:
              _iterator55 = _createForOfIteratorHelper(t);
              _context6.prev = 5;
              _iterator55.s();
            case 7:
              if ((_step55 = _iterator55.n()).done) {
                _context6.next = 13;
                break;
              }
              n = _step55.value;
              _context6.next = 11;
              return n.nextPosition;
            case 11:
              _context6.next = 7;
              break;
            case 13:
              _context6.next = 18;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](5);
              _iterator55.e(_context6.t0);
            case 18:
              _context6.prev = 18;
              _iterator55.f();
              return _context6.finish(18);
            case 21:
            case "end":
              return _context6.stop();
          }
        }, _callee2, null, [[5, 15, 18, 21]]);
      })();
    }
  }, {
    key: "isIntersecting",
    value: function isIntersecting(e) {
      return this.start.isBefore(e.end) && this.end.isAfter(e.start);
    }
  }], [{
    key: "_createFromParentsAndOffsets",
    value: function _createFromParentsAndOffsets(e, t, n, r) {
      return new this(new g(e, t), new g(n, r));
    }
  }, {
    key: "_createFromPositionAndShift",
    value: function _createFromPositionAndShift(e, t) {
      var n = e,
        r = e.getShiftedBy(t);
      return t > 0 ? new this(n, r) : new this(r, n);
    }
  }, {
    key: "_createIn",
    value: function _createIn(e) {
      return this._createFromParentsAndOffsets(e, 0, e, e.childCount);
    }
  }, {
    key: "_createOn",
    value: function _createOn(e) {
      var t = e.is("$textProxy") ? e.offsetSize : 1;
      return this._createFromPositionAndShift(g._createBefore(e), t);
    }
  }]);
}(we);
w.prototype.is = function (s) {
  return s === "range" || s === "view:range";
};
function et(s) {
  return !!(s.item.is("attributeElement") || s.item.is("uiElement"));
}
var Z = /*#__PURE__*/function (_N2) {
  function Hn() {
    var _this11;
    var _this10;
    _classCallCheck(this, Hn);
    _this10 = _callSuper(this, Hn), _defineProperty(_assertThisInitialized(_this10), "_ranges", void 0), _defineProperty(_assertThisInitialized(_this10), "_lastRangeBackward", void 0), _defineProperty(_assertThisInitialized(_this10), "_isFake", void 0), _defineProperty(_assertThisInitialized(_this10), "_fakeSelectionLabel", void 0), _this10._ranges = [], _this10._lastRangeBackward = !1, _this10._isFake = !1, _this10._fakeSelectionLabel = "", arguments.length && (_this11 = _this10).setTo.apply(_this11, arguments);
    return _this10;
  }
  _inherits(Hn, _N2);
  return _createClass(Hn, [{
    key: "isFake",
    get: function get() {
      return this._isFake;
    }
  }, {
    key: "fakeSelectionLabel",
    get: function get() {
      return this._fakeSelectionLabel;
    }
  }, {
    key: "anchor",
    get: function get() {
      if (!this._ranges.length) return null;
      var e = this._ranges[this._ranges.length - 1];
      return (this._lastRangeBackward ? e.end : e.start).clone();
    }
  }, {
    key: "focus",
    get: function get() {
      if (!this._ranges.length) return null;
      var e = this._ranges[this._ranges.length - 1];
      return (this._lastRangeBackward ? e.start : e.end).clone();
    }
  }, {
    key: "isCollapsed",
    get: function get() {
      return this.rangeCount === 1 && this._ranges[0].isCollapsed;
    }
  }, {
    key: "rangeCount",
    get: function get() {
      return this._ranges.length;
    }
  }, {
    key: "isBackward",
    get: function get() {
      return !this.isCollapsed && this._lastRangeBackward;
    }
  }, {
    key: "editableElement",
    get: function get() {
      return this.anchor ? this.anchor.editableElement : null;
    }
  }, {
    key: "getRanges",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
      var _iterator56, _step56, e;
      return _regeneratorRuntime().wrap(function getRanges$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _iterator56 = _createForOfIteratorHelper(this._ranges);
            _context7.prev = 1;
            _iterator56.s();
          case 3:
            if ((_step56 = _iterator56.n()).done) {
              _context7.next = 9;
              break;
            }
            e = _step56.value;
            _context7.next = 7;
            return e.clone();
          case 7:
            _context7.next = 3;
            break;
          case 9:
            _context7.next = 14;
            break;
          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7["catch"](1);
            _iterator56.e(_context7.t0);
          case 14:
            _context7.prev = 14;
            _iterator56.f();
            return _context7.finish(14);
          case 17:
          case "end":
            return _context7.stop();
        }
      }, getRanges, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "getFirstRange",
    value: function getFirstRange() {
      var e = null;
      var _iterator57 = _createForOfIteratorHelper(this._ranges),
        _step57;
      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var t = _step57.value;
          (!e || t.start.isBefore(e.start)) && (e = t);
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
      return e ? e.clone() : null;
    }
  }, {
    key: "getLastRange",
    value: function getLastRange() {
      var e = null;
      var _iterator58 = _createForOfIteratorHelper(this._ranges),
        _step58;
      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var t = _step58.value;
          (!e || t.end.isAfter(e.end)) && (e = t);
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
      return e ? e.clone() : null;
    }
  }, {
    key: "getFirstPosition",
    value: function getFirstPosition() {
      var e = this.getFirstRange();
      return e ? e.start.clone() : null;
    }
  }, {
    key: "getLastPosition",
    value: function getLastPosition() {
      var e = this.getLastRange();
      return e ? e.end.clone() : null;
    }
  }, {
    key: "isEqual",
    value: function isEqual(e) {
      if (this.isFake != e.isFake || this.isFake && this.fakeSelectionLabel != e.fakeSelectionLabel || this.rangeCount != e.rangeCount) return !1;
      if (this.rangeCount === 0) return !0;
      if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
      var _iterator59 = _createForOfIteratorHelper(this._ranges),
        _step59;
      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var t = _step59.value;
          var n = !1;
          var _iterator60 = _createForOfIteratorHelper(e._ranges),
            _step60;
          try {
            for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
              var r = _step60.value;
              if (t.isEqual(r)) {
                n = !0;
                break;
              }
            }
          } catch (err) {
            _iterator60.e(err);
          } finally {
            _iterator60.f();
          }
          if (!n) return !1;
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
      return !0;
    }
  }, {
    key: "isSimilar",
    value: function isSimilar(e) {
      if (this.isBackward != e.isBackward) return !1;
      var t = Zt(this.getRanges()),
        n = Zt(e.getRanges());
      if (t != n) return !1;
      if (t == 0) return !0;
      var _iterator61 = _createForOfIteratorHelper(this.getRanges()),
        _step61;
      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var r = _step61.value;
          r = r.getTrimmed();
          var i = !1;
          var _iterator62 = _createForOfIteratorHelper(e.getRanges()),
            _step62;
          try {
            for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
              var o = _step62.value;
              if (o = o.getTrimmed(), r.start.isEqual(o.start) && r.end.isEqual(o.end)) {
                i = !0;
                break;
              }
            }
          } catch (err) {
            _iterator62.e(err);
          } finally {
            _iterator62.f();
          }
          if (!i) return !1;
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
      return !0;
    }
  }, {
    key: "getSelectedElement",
    value: function getSelectedElement() {
      return this.rangeCount !== 1 ? null : this.getFirstRange().getContainedElement();
    }
  }, {
    key: "setTo",
    value: function setTo() {
      for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        e[_key7] = arguments[_key7];
      }
      var t = e[0],
        n = e[1],
        r = e[2];
      if (_typeof(n) == "object" && (r = n, n = void 0), t === null) this._setRanges([]), this._setFakeOptions(r);else if (t instanceof Hn || t instanceof zt) this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({
        fake: t.isFake,
        label: t.fakeSelectionLabel
      });else if (t instanceof w) this._setRanges([t], r && r.backward), this._setFakeOptions(r);else if (t instanceof g) this._setRanges([new w(t)]), this._setFakeOptions(r);else if (t instanceof be) {
        var i = !!r && !!r.backward;
        var o;
        if (n === void 0) throw new f("view-selection-setto-required-second-parameter", this);
        n == "in" ? o = w._createIn(t) : n == "on" ? o = w._createOn(t) : o = new w(g._createAt(t, n)), this._setRanges([o], i), this._setFakeOptions(r);
      } else if (le(t)) this._setRanges(t, r && r.backward), this._setFakeOptions(r);else throw new f("view-selection-setto-not-selectable", this);
      this.fire("change");
    }
  }, {
    key: "setFocus",
    value: function setFocus(e, t) {
      if (this.anchor === null) throw new f("view-selection-setfocus-no-ranges", this);
      var n = g._createAt(e, t);
      if (n.compareWith(this.focus) == "same") return;
      var r = this.anchor;
      this._ranges.pop(), n.compareWith(r) == "before" ? this._addRange(new w(n, r), !0) : this._addRange(new w(r, n)), this.fire("change");
    }
  }, {
    key: "_setRanges",
    value: function _setRanges(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      e = Array.from(e), this._ranges = [];
      var _iterator63 = _createForOfIteratorHelper(e),
        _step63;
      try {
        for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
          var n = _step63.value;
          this._addRange(n);
        }
      } catch (err) {
        _iterator63.e(err);
      } finally {
        _iterator63.f();
      }
      this._lastRangeBackward = !!t;
    }
  }, {
    key: "_setFakeOptions",
    value: function _setFakeOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._isFake = !!e.fake, this._fakeSelectionLabel = e.fake && e.label || "";
    }
  }, {
    key: "_addRange",
    value: function _addRange(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (!(e instanceof w)) throw new f("view-selection-add-range-not-range", this);
      this._pushRange(e), this._lastRangeBackward = !!t;
    }
  }, {
    key: "_pushRange",
    value: function _pushRange(e) {
      var _iterator64 = _createForOfIteratorHelper(this._ranges),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var t = _step64.value;
          if (e.isIntersecting(t)) throw new f("view-selection-range-intersects", this, {
            addedRange: e,
            intersectingRange: t
          });
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
      this._ranges.push(new w(e.start, e.end));
    }
  }]);
}(N(we));
Z.prototype.is = function (s) {
  return s === "selection" || s === "view:selection";
};
var zt = /*#__PURE__*/function (_N3) {
  function zt() {
    var _this12$_selection;
    var _this12;
    _classCallCheck(this, zt);
    _this12 = _callSuper(this, zt), _defineProperty(_assertThisInitialized(_this12), "_selection", void 0), _this12._selection = new Z(), _this12._selection.delegate("change").to(_assertThisInitialized(_this12)), arguments.length && (_this12$_selection = _this12._selection).setTo.apply(_this12$_selection, arguments);
    return _this12;
  }
  _inherits(zt, _N3);
  return _createClass(zt, [{
    key: "isFake",
    get: function get() {
      return this._selection.isFake;
    }
  }, {
    key: "fakeSelectionLabel",
    get: function get() {
      return this._selection.fakeSelectionLabel;
    }
  }, {
    key: "anchor",
    get: function get() {
      return this._selection.anchor;
    }
  }, {
    key: "focus",
    get: function get() {
      return this._selection.focus;
    }
  }, {
    key: "isCollapsed",
    get: function get() {
      return this._selection.isCollapsed;
    }
  }, {
    key: "rangeCount",
    get: function get() {
      return this._selection.rangeCount;
    }
  }, {
    key: "isBackward",
    get: function get() {
      return this._selection.isBackward;
    }
  }, {
    key: "editableElement",
    get: function get() {
      return this._selection.editableElement;
    }
  }, {
    key: "_ranges",
    get: function get() {
      return this._selection._ranges;
    }
  }, {
    key: "getRanges",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
      return _regeneratorRuntime().wrap(function getRanges$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.delegateYield(this._selection.getRanges(), "t0", 1);
          case 1:
          case "end":
            return _context8.stop();
        }
      }, getRanges, this);
    })
  }, {
    key: "getFirstRange",
    value: function getFirstRange() {
      return this._selection.getFirstRange();
    }
  }, {
    key: "getLastRange",
    value: function getLastRange() {
      return this._selection.getLastRange();
    }
  }, {
    key: "getFirstPosition",
    value: function getFirstPosition() {
      return this._selection.getFirstPosition();
    }
  }, {
    key: "getLastPosition",
    value: function getLastPosition() {
      return this._selection.getLastPosition();
    }
  }, {
    key: "getSelectedElement",
    value: function getSelectedElement() {
      return this._selection.getSelectedElement();
    }
  }, {
    key: "isEqual",
    value: function isEqual(e) {
      return this._selection.isEqual(e);
    }
  }, {
    key: "isSimilar",
    value: function isSimilar(e) {
      return this._selection.isSimilar(e);
    }
  }, {
    key: "_setTo",
    value: function _setTo() {
      var _this$_selection;
      (_this$_selection = this._selection).setTo.apply(_this$_selection, arguments);
    }
  }, {
    key: "_setFocus",
    value: function _setFocus(e, t) {
      this._selection.setFocus(e, t);
    }
  }]);
}(N(we));
zt.prototype.is = function (s) {
  return s === "selection" || s == "documentSelection" || s == "view:selection" || s == "view:documentSelection";
};
var Ut = /*#__PURE__*/function (_Rt) {
  function Ut(e, t, n) {
    var _this13;
    _classCallCheck(this, Ut);
    _this13 = _callSuper(this, Ut, [e, t]), _defineProperty(_assertThisInitialized(_this13), "startRange", void 0), _defineProperty(_assertThisInitialized(_this13), "_eventPhase", void 0), _defineProperty(_assertThisInitialized(_this13), "_currentTarget", void 0), _this13.startRange = n, _this13._eventPhase = "none", _this13._currentTarget = null;
    return _this13;
  }
  _inherits(Ut, _Rt);
  return _createClass(Ut, [{
    key: "eventPhase",
    get: function get() {
      return this._eventPhase;
    }
  }, {
    key: "currentTarget",
    get: function get() {
      return this._currentTarget;
    }
  }]);
}(Rt);
var vt = Symbol("bubbling contexts");
function Ot(s) {
  var e = /*#__PURE__*/function (_s2) {
    function e() {
      _classCallCheck(this, e);
      return _callSuper(this, e, arguments);
    }
    _inherits(e, _s2);
    return _createClass(e, [{
      key: "fire",
      value: function fire(n) {
        try {
          var i = n instanceof Rt ? n : new Rt(this, n),
            o = Pt(this);
          if (!o.size) return;
          for (var _len8 = arguments.length, r = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
            r[_key8 - 1] = arguments[_key8];
          }
          if (Ie(i, "capturing", this), Ce.apply(void 0, [o, "$capture", i].concat(r))) return i.return;
          var a = i.startRange || this.selection.getFirstRange(),
            l = a ? a.getContainedElement() : null,
            c = l ? !!Kn(o, l) : !1;
          var h = l || lr(a);
          if (Ie(i, "atTarget", h), !c) {
            if (Ce.apply(void 0, [o, "$text", i].concat(r))) return i.return;
            Ie(i, "bubbling", h);
          }
          for (; h;) {
            if (h.is("rootElement")) {
              if (Ce.apply(void 0, [o, "$root", i].concat(r))) return i.return;
            } else if (h.is("element") && Ce.apply(void 0, [o, h.name, i].concat(r))) return i.return;
            if (Ce.apply(void 0, [o, h, i].concat(r))) return i.return;
            h = h.parent, Ie(i, "bubbling", h);
          }
          return Ie(i, "bubbling", this), Ce.apply(void 0, [o, "$document", i].concat(r)), i.return;
        } catch (i) {
          /* istanbul ignore next -- @preserve */f.rethrowUnexpectedError(i, this);
        }
      }
    }, {
      key: "_addEventListener",
      value: function _addEventListener(n, r, i) {
        var o = ae(i.context || "$document"),
          a = Pt(this);
        var _iterator65 = _createForOfIteratorHelper(o),
          _step65;
        try {
          for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
            var l = _step65.value;
            var c = a.get(l);
            c || (c = new (N())(), a.set(l, c)), this.listenTo(c, n, r, i);
          }
        } catch (err) {
          _iterator65.e(err);
        } finally {
          _iterator65.f();
        }
      }
    }, {
      key: "_removeEventListener",
      value: function _removeEventListener(n, r) {
        var i = Pt(this);
        var _iterator66 = _createForOfIteratorHelper(i.values()),
          _step66;
        try {
          for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
            var o = _step66.value;
            this.stopListening(o, n, r);
          }
        } catch (err) {
          _iterator66.e(err);
        } finally {
          _iterator66.f();
        }
      }
    }]);
  }(s);
  return e;
}
{
  var s = Ot(Object);
  ["fire", "_addEventListener", "_removeEventListener"].forEach(function (e) {
    Ot[e] = s.prototype[e];
  });
}
function Ie(s, e, t) {
  s instanceof Ut && (s._eventPhase = e, s._currentTarget = t);
}
function Ce(s, e, t) {
  var r = typeof e == "string" ? s.get(e) : Kn(s, e);
  for (var _len9 = arguments.length, n = new Array(_len9 > 3 ? _len9 - 3 : 0), _key9 = 3; _key9 < _len9; _key9++) {
    n[_key9 - 3] = arguments[_key9];
  }
  return r ? (r.fire.apply(r, [t].concat(n)), t.stop.called) : !1;
}
function Kn(s, e) {
  var _iterator67 = _createForOfIteratorHelper(s),
    _step67;
  try {
    for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
      var _ref48 = _step67.value;
      var _ref49 = _slicedToArray(_ref48, 2);
      var t = _ref49[0];
      var n = _ref49[1];
      if (typeof t == "function" && t(e)) return n;
    }
  } catch (err) {
    _iterator67.e(err);
  } finally {
    _iterator67.f();
  }
  return null;
}
function Pt(s) {
  return s[vt] || (s[vt] = new Map()), s[vt];
}
function lr(s) {
  if (!s) return null;
  var e = s.start.parent,
    t = s.end.parent,
    n = e.getPath(),
    r = t.getPath();
  return n.length > r.length ? e : t;
}
var Xn = /*#__PURE__*/function (_Ot) {
  function Xn(e) {
    var _this14;
    _classCallCheck(this, Xn);
    _this14 = _callSuper(this, Xn), _defineProperty(_assertThisInitialized(_this14), "selection", void 0), _defineProperty(_assertThisInitialized(_this14), "roots", void 0), _defineProperty(_assertThisInitialized(_this14), "stylesProcessor", void 0), _defineProperty(_assertThisInitialized(_this14), "_postFixers", new Set()), _this14.selection = new zt(), _this14.roots = new Lt({
      idProperty: "rootName"
    }), _this14.stylesProcessor = e, _this14.set("isReadOnly", !1), _this14.set("isFocused", !1), _this14.set("isSelecting", !1), _this14.set("isComposing", !1);
    return _this14;
  }
  _inherits(Xn, _Ot);
  return _createClass(Xn, [{
    key: "getRoot",
    value: function getRoot() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
      return this.roots.get(e);
    }
  }, {
    key: "registerPostFixer",
    value: function registerPostFixer(e) {
      this._postFixers.add(e);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.roots.forEach(function (e) {
        return e.destroy();
      }), this.stopListening();
    }
  }, {
    key: "_callPostFixers",
    value: function _callPostFixers(e) {
      var t = !1;
      do {
        var _iterator68 = _createForOfIteratorHelper(this._postFixers),
          _step68;
        try {
          for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
            var n = _step68.value;
            if (t = n(e), t) break;
          }
        } catch (err) {
          _iterator68.e(err);
        } finally {
          _iterator68.f();
        }
      } while (t);
    }
  }]);
}(Ot(U()));
var an = 10;
var Me = /*#__PURE__*/function (_te2) {
  function Me(e, t, n, r) {
    var _this15;
    _classCallCheck(this, Me);
    _this15 = _callSuper(this, Me, [e, t, n, r]), _defineProperty(_assertThisInitialized(_this15), "_priority", an), _defineProperty(_assertThisInitialized(_this15), "_id", null), _defineProperty(_assertThisInitialized(_this15), "_clonesGroup", null), _this15.getFillerOffset = cr;
    return _this15;
  }
  _inherits(Me, _te2);
  return _createClass(Me, [{
    key: "priority",
    get: function get() {
      return this._priority;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "getElementsWithSameId",
    value: function getElementsWithSameId() {
      if (this.id === null) throw new f("attribute-element-get-elements-with-same-id-no-id", this);
      return new Set(this._clonesGroup);
    }
  }, {
    key: "isSimilar",
    value: function isSimilar(e) {
      return this.id !== null || e.id !== null ? this.id === e.id : _superPropGet(Me, "isSimilar", this, 3)([e]) && this.priority == e.priority;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = _superPropGet(Me, "_clone", this, 3)([e]);
      return t._priority = this._priority, t._id = this._id, t;
    }
  }, {
    key: "_canMergeAttributesFrom",
    value: function _canMergeAttributesFrom(e) {
      return this.id !== null || e.id !== null || this.priority !== e.priority ? !1 : _superPropGet(Me, "_canMergeAttributesFrom", this, 3)([e]);
    }
  }, {
    key: "_canSubtractAttributesOf",
    value: function _canSubtractAttributesOf(e) {
      return this.id !== null || e.id !== null || this.priority !== e.priority ? !1 : _superPropGet(Me, "_canSubtractAttributesOf", this, 3)([e]);
    }
  }]);
}(te);
_defineProperty(Me, "DEFAULT_PRIORITY", an);
Me.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "attributeElement" || s === "view:attributeElement" || s === "element" || s === "view:element") : s === "attributeElement" || s === "view:attributeElement" || s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
function cr() {
  if (Ct(this)) return null;
  var s = this.parent;
  for (; s && s.is("attributeElement");) {
    if (Ct(s) > 1) return null;
    s = s.parent;
  }
  return !s || Ct(s) > 1 ? null : this.childCount;
}
function Ct(s) {
  return Array.from(s.getChildren()).filter(function (e) {
    return !e.is("uiElement");
  }).length;
}
var Jt = /*#__PURE__*/function (_te3) {
  function Jt(e, t, n, r) {
    var _this16;
    _classCallCheck(this, Jt);
    _this16 = _callSuper(this, Jt, [e, t, n, r]), _this16.getFillerOffset = hr;
    return _this16;
  }
  _inherits(Jt, _te3);
  return _createClass(Jt, [{
    key: "_insertChild",
    value: function _insertChild(e, t) {
      if (t && (t instanceof be || Array.from(t).length > 0)) throw new f("view-emptyelement-cannot-add", [this, t]);
      return 0;
    }
  }]);
}(te);
Jt.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "emptyElement" || s === "view:emptyElement" || s === "element" || s === "view:element") : s === "emptyElement" || s === "view:emptyElement" || s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
function hr() {
  return null;
}
var mt = /*#__PURE__*/function (_te4) {
  function mt(e, t, n, r) {
    var _this17;
    _classCallCheck(this, mt);
    _this17 = _callSuper(this, mt, [e, t, n, r]), _this17.getFillerOffset = fr;
    return _this17;
  }
  _inherits(mt, _te4);
  return _createClass(mt, [{
    key: "_insertChild",
    value: function _insertChild(e, t) {
      if (t && (t instanceof be || Array.from(t).length > 0)) throw new f("view-uielement-cannot-add", [this, t]);
      return 0;
    }
  }, {
    key: "render",
    value: function render(e, t) {
      return this.toDomElement(e);
    }
  }, {
    key: "toDomElement",
    value: function toDomElement(e) {
      var t = e.createElement(this.name);
      var _iterator69 = _createForOfIteratorHelper(this.getAttributeKeys()),
        _step69;
      try {
        for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
          var n = _step69.value;
          t.setAttribute(n, this.getAttribute(n));
        }
      } catch (err) {
        _iterator69.e(err);
      } finally {
        _iterator69.f();
      }
      return t;
    }
  }]);
}(te);
mt.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "uiElement" || s === "view:uiElement" || s === "element" || s === "view:element") : s === "uiElement" || s === "view:uiElement" || s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
function ur(s) {
  s.document.on("arrowKey", function (e, t) {
    return dr(e, t, s.domConverter);
  }, {
    priority: "low"
  });
}
function fr() {
  return null;
}
function dr(s, e, t) {
  if (e.keyCode == de.arrowright) {
    var n = e.domTarget.ownerDocument.defaultView.getSelection(),
      r = n.rangeCount == 1 && n.getRangeAt(0).collapsed;
    if (r || e.shiftKey) {
      var i = n.focusNode,
        o = n.focusOffset,
        a = t.domPositionToView(i, o);
      if (a === null) return;
      var l = !1;
      var c = a.getLastMatchingPosition(function (h) {
        return h.item.is("uiElement") && (l = !0), !!(h.item.is("uiElement") || h.item.is("attributeElement"));
      });
      if (l) {
        var h = t.viewPositionToDom(c);
        r ? n.collapse(h.parent, h.offset) : n.extend(h.parent, h.offset);
      }
    }
  }
}
var jt = /*#__PURE__*/function (_te5) {
  function jt(e, t, n, r) {
    var _this18;
    _classCallCheck(this, jt);
    _this18 = _callSuper(this, jt, [e, t, n, r]), _this18.getFillerOffset = mr;
    return _this18;
  }
  _inherits(jt, _te5);
  return _createClass(jt, [{
    key: "_insertChild",
    value: function _insertChild(e, t) {
      if (t && (t instanceof be || Array.from(t).length > 0)) throw new f("view-rawelement-cannot-add", [this, t]);
      return 0;
    }
  }, {
    key: "render",
    value: function render(e, t) {}
  }]);
}(te);
jt.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "rawElement" || s === "view:rawElement" || s === "element" || s === "view:element") : s === "rawElement" || s === "view:rawElement" || s === this.name || s === "view:" + this.name || s === "element" || s === "view:element" || s === "node" || s === "view:node";
};
function mr() {
  return null;
}
var ge = /*#__PURE__*/function (_N4) {
  function ge(e, t) {
    var _this19;
    _classCallCheck(this, ge);
    _this19 = _callSuper(this, ge), _defineProperty(_assertThisInitialized(_this19), "document", void 0), _defineProperty(_assertThisInitialized(_this19), "_children", []), _defineProperty(_assertThisInitialized(_this19), "_customProperties", new Map()), _this19.document = e, t && _this19._insertChild(0, t);
    return _this19;
  }
  _inherits(ge, _N4);
  return _createClass(ge, [{
    key: Symbol.iterator,
    value: function value() {
      return this._children[Symbol.iterator]();
    }
  }, {
    key: "childCount",
    get: function get() {
      return this._children.length;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.childCount === 0;
    }
  }, {
    key: "root",
    get: function get() {
      return this;
    }
  }, {
    key: "parent",
    get: function get() {
      return null;
    }
  }, {
    key: "name",
    get: function get() {}
  }, {
    key: "getFillerOffset",
    get: function get() {}
  }, {
    key: "getCustomProperty",
    value: function getCustomProperty(e) {
      return this._customProperties.get(e);
    }
  }, {
    key: "getCustomProperties",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getCustomProperties() {
      return _regeneratorRuntime().wrap(function getCustomProperties$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.delegateYield(this._customProperties.entries(), "t0", 1);
          case 1:
          case "end":
            return _context9.stop();
        }
      }, getCustomProperties, this);
    })
  }, {
    key: "_appendChild",
    value: function _appendChild(e) {
      return this._insertChild(this.childCount, e);
    }
  }, {
    key: "getChild",
    value: function getChild(e) {
      return this._children[e];
    }
  }, {
    key: "getChildIndex",
    value: function getChildIndex(e) {
      return this._children.indexOf(e);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children[Symbol.iterator]();
    }
  }, {
    key: "_insertChild",
    value: function _insertChild(e, t) {
      this._fireChange("children", this, {
        index: e
      });
      var n = 0;
      var r = gr(this.document, t);
      var _iterator70 = _createForOfIteratorHelper(r),
        _step70;
      try {
        for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
          var i = _step70.value;
          i.parent !== null && i._remove(), i.parent = this, this._children.splice(e, 0, i), e++, n++;
        }
      } catch (err) {
        _iterator70.e(err);
      } finally {
        _iterator70.f();
      }
      return n;
    }
  }, {
    key: "_removeChildren",
    value: function _removeChildren(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this._fireChange("children", this, {
        index: e
      });
      for (var n = e; n < e + t; n++) this._children[n].parent = null;
      return this._children.splice(e, t);
    }
  }, {
    key: "_fireChange",
    value: function _fireChange(e, t, n) {
      this.fire("change:".concat(e), t, n);
    }
  }, {
    key: "_setCustomProperty",
    value: function _setCustomProperty(e, t) {
      this._customProperties.set(e, t);
    }
  }, {
    key: "_removeCustomProperty",
    value: function _removeCustomProperty(e) {
      return this._customProperties.delete(e);
    }
  }]);
}(N(we));
ge.prototype.is = function (s) {
  return s === "documentFragment" || s === "view:documentFragment";
};
function gr(s, e) {
  return typeof e == "string" ? [new x(s, e)] : (le(e) || (e = [e]), Array.from(e).map(function (t) {
    return typeof t == "string" ? new x(s, t) : t instanceof Q ? new x(s, t.data) : t;
  }));
}
var Yn = /*#__PURE__*/function () {
  function Yn(e) {
    _classCallCheck(this, Yn);
    _defineProperty(this, "document", void 0);
    _defineProperty(this, "_cloneGroups", new Map());
    _defineProperty(this, "_slotFactory", null);
    this.document = e;
  }
  return _createClass(Yn, [{
    key: "setSelection",
    value: function setSelection() {
      var _this$document$select;
      (_this$document$select = this.document.selection)._setTo.apply(_this$document$select, arguments);
    }
  }, {
    key: "setSelectionFocus",
    value: function setSelectionFocus(e, t) {
      this.document.selection._setFocus(e, t);
    }
  }, {
    key: "createDocumentFragment",
    value: function createDocumentFragment(e) {
      return new ge(this.document, e);
    }
  }, {
    key: "createText",
    value: function createText(e) {
      return new x(this.document, e);
    }
  }, {
    key: "createAttributeElement",
    value: function createAttributeElement(e, t) {
      var _r$_unsafeAttributesT;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var r = new Me(this.document, e, t);
      return typeof n.priority == "number" && (r._priority = n.priority), n.id && (r._id = n.id), n.renderUnsafeAttributes && (_r$_unsafeAttributesT = r._unsafeAttributesToRender).push.apply(_r$_unsafeAttributesT, _toConsumableArray(n.renderUnsafeAttributes)), r;
    }
  }, {
    key: "createContainerElement",
    value: function createContainerElement(e, t) {
      var _o$_unsafeAttributesT;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var i = null;
      Tt(n) ? r = n : i = n;
      var o = new Ge(this.document, e, t, i);
      return r.renderUnsafeAttributes && (_o$_unsafeAttributesT = o._unsafeAttributesToRender).push.apply(_o$_unsafeAttributesT, _toConsumableArray(r.renderUnsafeAttributes)), o;
    }
  }, {
    key: "createEditableElement",
    value: function createEditableElement(e, t) {
      var _r$_unsafeAttributesT2;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var r = new dt(this.document, e, t);
      return n.renderUnsafeAttributes && (_r$_unsafeAttributesT2 = r._unsafeAttributesToRender).push.apply(_r$_unsafeAttributesT2, _toConsumableArray(n.renderUnsafeAttributes)), r;
    }
  }, {
    key: "createEmptyElement",
    value: function createEmptyElement(e, t) {
      var _r$_unsafeAttributesT3;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var r = new Jt(this.document, e, t);
      return n.renderUnsafeAttributes && (_r$_unsafeAttributesT3 = r._unsafeAttributesToRender).push.apply(_r$_unsafeAttributesT3, _toConsumableArray(n.renderUnsafeAttributes)), r;
    }
  }, {
    key: "createUIElement",
    value: function createUIElement(e, t, n) {
      var r = new mt(this.document, e, t);
      return n && (r.render = n), r;
    }
  }, {
    key: "createRawElement",
    value: function createRawElement(e, t, n) {
      var _i$_unsafeAttributesT;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var i = new jt(this.document, e, t);
      return n && (i.render = n), r.renderUnsafeAttributes && (_i$_unsafeAttributesT = i._unsafeAttributesToRender).push.apply(_i$_unsafeAttributesT, _toConsumableArray(r.renderUnsafeAttributes)), i;
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(e, t, n, r) {
      r !== void 0 ? r._setAttribute(e, t, n) : n._setAttribute(e, t);
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(e, t, n) {
      n !== void 0 ? n._removeAttribute(e, t) : t._removeAttribute(e);
    }
  }, {
    key: "addClass",
    value: function addClass(e, t) {
      t._addClass(e);
    }
  }, {
    key: "removeClass",
    value: function removeClass(e, t) {
      t._removeClass(e);
    }
  }, {
    key: "setStyle",
    value: function setStyle(e, t, n) {
      Tt(e) && n === void 0 ? t._setStyle(e) : n._setStyle(e, t);
    }
  }, {
    key: "removeStyle",
    value: function removeStyle(e, t) {
      t._removeStyle(e);
    }
  }, {
    key: "setCustomProperty",
    value: function setCustomProperty(e, t, n) {
      n._setCustomProperty(e, t);
    }
  }, {
    key: "removeCustomProperty",
    value: function removeCustomProperty(e, t) {
      return t._removeCustomProperty(e);
    }
  }, {
    key: "breakAttributes",
    value: function breakAttributes(e) {
      return e instanceof g ? this._breakAttributes(e) : this._breakAttributesRange(e);
    }
  }, {
    key: "breakContainer",
    value: function breakContainer(e) {
      var t = e.parent;
      if (!t.is("containerElement")) throw new f("view-writer-break-non-container-element", this.document);
      if (!t.parent) throw new f("view-writer-break-root", this.document);
      if (e.isAtStart) return g._createBefore(t);
      if (!e.isAtEnd) {
        var n = t._clone(!1);
        this.insert(g._createAfter(t), n);
        var r = new w(e, g._createAt(t, "end")),
          i = new g(n, 0);
        this.move(r, i);
      }
      return g._createAfter(t);
    }
  }, {
    key: "mergeAttributes",
    value: function mergeAttributes(e) {
      var t = e.offset,
        n = e.parent;
      if (n.is("$text")) return e;
      if (n.is("attributeElement") && n.childCount === 0) {
        var o = n.parent,
          a = n.index;
        return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new g(o, a));
      }
      var r = n.getChild(t - 1),
        i = n.getChild(t);
      if (!r || !i) return e;
      if (r.is("$text") && i.is("$text")) return cn(r, i);
      if (r.is("attributeElement") && i.is("attributeElement") && r.isSimilar(i)) {
        var _o4 = r.childCount;
        return r._appendChild(i.getChildren()), i._remove(), this._removeFromClonedElementsGroup(i), this.mergeAttributes(new g(r, _o4));
      }
      return e;
    }
  }, {
    key: "mergeContainers",
    value: function mergeContainers(e) {
      var t = e.nodeBefore,
        n = e.nodeAfter;
      if (!t || !n || !t.is("containerElement") || !n.is("containerElement")) throw new f("view-writer-merge-containers-invalid-position", this.document);
      var r = t.getChild(t.childCount - 1),
        i = r instanceof x ? g._createAt(r, "end") : g._createAt(t, "end");
      return this.move(w._createIn(n), g._createAt(t, "end")), this.remove(w._createOn(n)), i;
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      t = le(t) ? _toConsumableArray(t) : [t], Qn(t, this.document);
      var n = t.reduce(function (o, a) {
        var l = o[o.length - 1],
          c = !a.is("uiElement");
        return !l || l.breakAttributes != c ? o.push({
          breakAttributes: c,
          nodes: [a]
        }) : l.nodes.push(a), o;
      }, []);
      var r = null,
        i = e;
      var _iterator71 = _createForOfIteratorHelper(n),
        _step71;
      try {
        for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
          var _ref50 = _step71.value;
          var o = _ref50.nodes;
          var a = _ref50.breakAttributes;
          var l = this._insertNodes(i, o, a);
          r || (r = l.start), i = l.end;
        }
      } catch (err) {
        _iterator71.e(err);
      } finally {
        _iterator71.f();
      }
      return r ? new w(r, i) : new w(e);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = e instanceof w ? e : w._createOn(e);
      if (Fe(t, this.document), t.isCollapsed) return new ge(this.document);
      var _this$_breakAttribute = this._breakAttributesRange(t, !0),
        n = _this$_breakAttribute.start,
        r = _this$_breakAttribute.end,
        i = n.parent,
        o = r.offset - n.offset,
        a = i._removeChildren(n.offset, o);
      var _iterator72 = _createForOfIteratorHelper(a),
        _step72;
      try {
        for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
          var c = _step72.value;
          this._removeFromClonedElementsGroup(c);
        }
      } catch (err) {
        _iterator72.e(err);
      } finally {
        _iterator72.f();
      }
      var l = this.mergeAttributes(n);
      return t.start = l, t.end = l.clone(), new ge(this.document, a);
    }
  }, {
    key: "clear",
    value: function clear(e, t) {
      Fe(e, this.document);
      var n = e.getWalker({
        direction: "backward",
        ignoreElementEnd: !0
      });
      var _iterator73 = _createForOfIteratorHelper(n),
        _step73;
      try {
        for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
          var r = _step73.value;
          var i = r.item;
          var o = void 0;
          if (i.is("element") && t.isSimilar(i)) o = w._createOn(i);else if (!r.nextPosition.isAfter(e.start) && i.is("$textProxy")) {
            var a = i.getAncestors().find(function (l) {
              return l.is("element") && t.isSimilar(l);
            });
            a && (o = w._createIn(a));
          }
          o && (o.end.isAfter(e.end) && (o.end = e.end), o.start.isBefore(e.start) && (o.start = e.start), this.remove(o));
        }
      } catch (err) {
        _iterator73.e(err);
      } finally {
        _iterator73.f();
      }
    }
  }, {
    key: "move",
    value: function move(e, t) {
      var n;
      if (t.isAfter(e.end)) {
        t = this._breakAttributes(t, !0);
        var r = t.parent,
          i = r.childCount;
        e = this._breakAttributesRange(e, !0), n = this.remove(e), t.offset += r.childCount - i;
      } else n = this.remove(e);
      return this.insert(t, n);
    }
  }, {
    key: "wrap",
    value: function wrap(e, t) {
      if (!(t instanceof Me)) throw new f("view-writer-wrap-invalid-attribute", this.document);
      if (Fe(e, this.document), e.isCollapsed) {
        var n = e.start;
        n.parent.is("element") && !pr(n.parent) && (n = n.getLastMatchingPosition(function (i) {
          return i.item.is("uiElement");
        })), n = this._wrapPosition(n, t);
        var r = this.document.selection;
        return r.isCollapsed && r.getFirstPosition().isEqual(e.start) && this.setSelection(n), new w(n);
      } else return this._wrapRange(e, t);
    }
  }, {
    key: "unwrap",
    value: function unwrap(e, t) {
      if (!(t instanceof Me)) throw new f("view-writer-unwrap-invalid-attribute", this.document);
      if (Fe(e, this.document), e.isCollapsed) return e;
      var _this$_breakAttribute2 = this._breakAttributesRange(e, !0),
        n = _this$_breakAttribute2.start,
        r = _this$_breakAttribute2.end,
        i = n.parent,
        o = this._unwrapChildren(i, n.offset, r.offset, t),
        a = this.mergeAttributes(o.start);
      a.isEqual(o.start) || o.end.offset--;
      var l = this.mergeAttributes(o.end);
      return new w(a, l);
    }
  }, {
    key: "rename",
    value: function rename(e, t) {
      var n = new Ge(this.document, e, t.getAttributes());
      return this.insert(g._createAfter(t), n), this.move(w._createIn(t), g._createAt(n, 0)), this.remove(w._createOn(t)), n;
    }
  }, {
    key: "clearClonedElementsGroup",
    value: function clearClonedElementsGroup(e) {
      this._cloneGroups.delete(e);
    }
  }, {
    key: "createPositionAt",
    value: function createPositionAt(e, t) {
      return g._createAt(e, t);
    }
  }, {
    key: "createPositionAfter",
    value: function createPositionAfter(e) {
      return g._createAfter(e);
    }
  }, {
    key: "createPositionBefore",
    value: function createPositionBefore(e) {
      return g._createBefore(e);
    }
  }, {
    key: "createRange",
    value: function createRange(e, t) {
      return new w(e, t);
    }
  }, {
    key: "createRangeOn",
    value: function createRangeOn(e) {
      return w._createOn(e);
    }
  }, {
    key: "createRangeIn",
    value: function createRangeIn(e) {
      return w._createIn(e);
    }
  }, {
    key: "createSelection",
    value: function createSelection() {
      for (var _len0 = arguments.length, e = new Array(_len0), _key0 = 0; _key0 < _len0; _key0++) {
        e[_key0] = arguments[_key0];
      }
      return _construct(Z, e);
    }
  }, {
    key: "createSlot",
    value: function createSlot() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "children";
      if (!this._slotFactory) throw new f("view-writer-invalid-create-slot-context", this.document);
      return this._slotFactory(this, e);
    }
  }, {
    key: "_registerSlotFactory",
    value: function _registerSlotFactory(e) {
      this._slotFactory = e;
    }
  }, {
    key: "_clearSlotFactory",
    value: function _clearSlotFactory() {
      this._slotFactory = null;
    }
  }, {
    key: "_insertNodes",
    value: function _insertNodes(e, t, n) {
      var r;
      if (n ? r = It(e) : r = e.parent.is("$text") ? e.parent.parent : e.parent, !r) throw new f("view-writer-invalid-position-container", this.document);
      var i;
      n ? i = this._breakAttributes(e, !0) : i = e.parent.is("$text") ? kt(e) : e;
      var o = r._insertChild(i.offset, t);
      var _iterator74 = _createForOfIteratorHelper(t),
        _step74;
      try {
        for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
          var h = _step74.value;
          this._addToClonedElementsGroup(h);
        }
      } catch (err) {
        _iterator74.e(err);
      } finally {
        _iterator74.f();
      }
      var a = i.getShiftedBy(o),
        l = this.mergeAttributes(i);
      l.isEqual(i) || a.offset--;
      var c = this.mergeAttributes(a);
      return new w(l, c);
    }
  }, {
    key: "_wrapChildren",
    value: function _wrapChildren(e, t, n, r) {
      var i = t;
      var o = [];
      for (; i < n;) {
        var l = e.getChild(i),
          c = l.is("$text"),
          h = l.is("attributeElement");
        if (h && l._canMergeAttributesFrom(r)) l._mergeAttributesFrom(r), o.push(new g(e, i));else if (c || !h || _r(r, l)) {
          var d = r._clone();
          l._remove(), d._appendChild(l), e._insertChild(i, d), this._addToClonedElementsGroup(d), o.push(new g(e, i));
        } else this._wrapChildren(l, 0, l.childCount, r);
        i++;
      }
      var a = 0;
      for (var _i16 = 0, _o5 = o; _i16 < _o5.length; _i16++) {
        var _l2 = _o5[_i16];
        if (_l2.offset -= a, _l2.offset == t) continue;
        this.mergeAttributes(_l2).isEqual(_l2) || (a++, n--);
      }
      return w._createFromParentsAndOffsets(e, t, e, n);
    }
  }, {
    key: "_unwrapChildren",
    value: function _unwrapChildren(e, t, n, r) {
      var i = t;
      var o = [];
      for (; i < n;) {
        var l = e.getChild(i);
        if (!l.is("attributeElement")) {
          i++;
          continue;
        }
        if (l.isSimilar(r)) {
          var c = l.getChildren(),
            h = l.childCount;
          l._remove(), e._insertChild(i, c), this._removeFromClonedElementsGroup(l), o.push(new g(e, i), new g(e, i + h)), i += h, n += h - 1;
          continue;
        }
        if (l._canSubtractAttributesOf(r)) {
          l._subtractAttributesOf(r), o.push(new g(e, i), new g(e, i + 1)), i++;
          continue;
        }
        this._unwrapChildren(l, 0, l.childCount, r), i++;
      }
      var a = 0;
      for (var _i17 = 0, _o6 = o; _i17 < _o6.length; _i17++) {
        var _l3 = _o6[_i17];
        if (_l3.offset -= a, _l3.offset == t || _l3.offset == n) continue;
        this.mergeAttributes(_l3).isEqual(_l3) || (a++, n--);
      }
      return w._createFromParentsAndOffsets(e, t, e, n);
    }
  }, {
    key: "_wrapRange",
    value: function _wrapRange(e, t) {
      var _this$_breakAttribute3 = this._breakAttributesRange(e, !0),
        n = _this$_breakAttribute3.start,
        r = _this$_breakAttribute3.end,
        i = n.parent,
        o = this._wrapChildren(i, n.offset, r.offset, t),
        a = this.mergeAttributes(o.start);
      a.isEqual(o.start) || o.end.offset--;
      var l = this.mergeAttributes(o.end);
      return new w(a, l);
    }
  }, {
    key: "_wrapPosition",
    value: function _wrapPosition(e, t) {
      if (t.isSimilar(e.parent)) return ln(e.clone());
      e.parent.is("$text") && (e = kt(e));
      var n = this.createAttributeElement("_wrapPosition-fake-element");
      n._priority = Number.POSITIVE_INFINITY, n.isSimilar = function () {
        return !1;
      }, e.parent._insertChild(e.offset, n);
      var r = new w(e, e.getShiftedBy(1));
      this.wrap(r, t);
      var i = new g(n.parent, n.index);
      n._remove();
      var o = i.nodeBefore,
        a = i.nodeAfter;
      return o && o.is("view:$text") && a && a.is("view:$text") ? cn(o, a) : ln(i);
    }
  }, {
    key: "_breakAttributesRange",
    value: function _breakAttributesRange(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = e.start,
        r = e.end;
      if (Fe(e, this.document), e.isCollapsed) {
        var l = this._breakAttributes(e.start, t);
        return new w(l, l);
      }
      var i = this._breakAttributes(r, t),
        o = i.parent.childCount,
        a = this._breakAttributes(n, t);
      return i.offset += i.parent.childCount - o, new w(a, i);
    }
  }, {
    key: "_breakAttributes",
    value: function _breakAttributes(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = e.offset,
        r = e.parent;
      if (e.parent.is("emptyElement")) throw new f("view-writer-cannot-break-empty-element", this.document);
      if (e.parent.is("uiElement")) throw new f("view-writer-cannot-break-ui-element", this.document);
      if (e.parent.is("rawElement")) throw new f("view-writer-cannot-break-raw-element", this.document);
      if (!t && r.is("$text") && Ft(r.parent) || Ft(r)) return e.clone();
      if (r.is("$text")) return this._breakAttributes(kt(e), t);
      var i = r.childCount;
      if (n == i) {
        var o = new g(r.parent, r.index + 1);
        return this._breakAttributes(o, t);
      } else if (n === 0) {
        var _o7 = new g(r.parent, r.index);
        return this._breakAttributes(_o7, t);
      } else {
        var _o8 = r.index + 1,
          a = r._clone();
        r.parent._insertChild(_o8, a), this._addToClonedElementsGroup(a);
        var l = r.childCount - n,
          c = r._removeChildren(n, l);
        a._appendChild(c);
        var h = new g(r.parent, _o8);
        return this._breakAttributes(h, t);
      }
    }
  }, {
    key: "_addToClonedElementsGroup",
    value: function _addToClonedElementsGroup(e) {
      if (!e.root.is("rootElement")) return;
      if (e.is("element")) {
        var _iterator75 = _createForOfIteratorHelper(e.getChildren()),
          _step75;
        try {
          for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
            var r = _step75.value;
            this._addToClonedElementsGroup(r);
          }
        } catch (err) {
          _iterator75.e(err);
        } finally {
          _iterator75.f();
        }
      }
      var t = e.id;
      if (!t) return;
      var n = this._cloneGroups.get(t);
      n || (n = new Set(), this._cloneGroups.set(t, n)), n.add(e), e._clonesGroup = n;
    }
  }, {
    key: "_removeFromClonedElementsGroup",
    value: function _removeFromClonedElementsGroup(e) {
      if (e.is("element")) {
        var _iterator76 = _createForOfIteratorHelper(e.getChildren()),
          _step76;
        try {
          for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
            var r = _step76.value;
            this._removeFromClonedElementsGroup(r);
          }
        } catch (err) {
          _iterator76.e(err);
        } finally {
          _iterator76.f();
        }
      }
      var t = e.id;
      if (!t) return;
      var n = this._cloneGroups.get(t);
      n && n.delete(e);
    }
  }]);
}();
function pr(s) {
  return Array.from(s.getChildren()).some(function (e) {
    return !e.is("uiElement");
  });
}
function It(s) {
  var e = s.parent;
  for (; !Ft(e);) {
    if (!e) return;
    e = e.parent;
  }
  return e;
}
function _r(s, e) {
  return s.priority < e.priority ? !0 : s.priority > e.priority ? !1 : s.getIdentity() < e.getIdentity();
}
function ln(s) {
  var e = s.nodeBefore;
  if (e && e.is("$text")) return new g(e, e.data.length);
  var t = s.nodeAfter;
  return t && t.is("$text") ? new g(t, 0) : s;
}
function kt(s) {
  if (s.offset == s.parent.data.length) return new g(s.parent.parent, s.parent.index + 1);
  if (s.offset === 0) return new g(s.parent.parent, s.parent.index);
  var e = s.parent.data.slice(s.offset);
  return s.parent._data = s.parent.data.slice(0, s.offset), s.parent.parent._insertChild(s.parent.index + 1, new x(s.root.document, e)), new g(s.parent.parent, s.parent.index + 1);
}
function cn(s, e) {
  var t = s.data.length;
  return s._data += e.data, e._remove(), new g(s, t);
}
var wr = [x, Me, Ge, Jt, jt, mt];
function Qn(s, e) {
  var _iterator77 = _createForOfIteratorHelper(s),
    _step77;
  try {
    var _loop = function _loop() {
      var t = _step77.value;
      if (!wr.some(function (n) {
        return t instanceof n;
      })) throw new f("view-writer-insert-invalid-node-type", e);
      t.is("$text") || Qn(t.getChildren(), e);
    };
    for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator77.e(err);
  } finally {
    _iterator77.f();
  }
}
function Ft(s) {
  return s && (s.is("containerElement") || s.is("documentFragment"));
}
function Fe(s, e) {
  var t = It(s.start),
    n = It(s.end);
  if (!t || !n || t !== n) throw new f("view-writer-invalid-range-container", e);
}
var Zn = function Zn(s) {
    return s.createTextNode(" ");
  },
  es = function es(s) {
    var e = s.createElement("span");
    return e.dataset.ckeFiller = "true", e.innerText = " ", e;
  },
  ts = function ts(s) {
    var e = s.createElement("br");
    return e.dataset.ckeFiller = "true", e;
  },
  L = 7,
  He = "⁠".repeat(L);
function D(s) {
  return typeof s == "string" ? s.substr(0, L) === He : E(s) && s.data.substr(0, L) === He;
}
function Re(s) {
  return s.data.length == L && D(s);
}
function hn(s) {
  var e = typeof s == "string" ? s : s.data;
  return D(s) ? e.slice(L) : e;
}
function br(s) {
  s.document.on("arrowKey", yr, {
    priority: "low"
  });
}
function yr(s, e) {
  if (e.keyCode == de.arrowleft) {
    var t = e.domTarget.ownerDocument.defaultView.getSelection();
    if (t.rangeCount == 1 && t.getRangeAt(0).collapsed) {
      var n = t.getRangeAt(0).startContainer,
        r = t.getRangeAt(0).startOffset;
      D(n) && r <= L && t.collapse(n, 0);
    }
  }
}
var vr = /*#__PURE__*/function (_U2) {
  function vr(e, t) {
    var _this20;
    _classCallCheck(this, vr);
    _this20 = _callSuper(this, vr), _defineProperty(_assertThisInitialized(_this20), "domDocuments", new Set()), _defineProperty(_assertThisInitialized(_this20), "domConverter", void 0), _defineProperty(_assertThisInitialized(_this20), "markedAttributes", new Set()), _defineProperty(_assertThisInitialized(_this20), "markedChildren", new Set()), _defineProperty(_assertThisInitialized(_this20), "markedTexts", new Set()), _defineProperty(_assertThisInitialized(_this20), "selection", void 0), _defineProperty(_assertThisInitialized(_this20), "_inlineFiller", null), _defineProperty(_assertThisInitialized(_this20), "_fakeSelectionContainer", null), _this20.domConverter = e, _this20.selection = t, _this20.set("isFocused", !1), _this20.set("isSelecting", !1), _this20.set("isComposing", !1), M.isBlink && !M.isAndroid && _this20.on("change:isSelecting", function () {
      _this20.isSelecting || _this20.render();
    });
    return _this20;
  }
  _inherits(vr, _U2);
  return _createClass(vr, [{
    key: "markToSync",
    value: function markToSync(e, t) {
      if (e === "text") this.domConverter.mapViewToDom(t.parent) && this.markedTexts.add(t);else {
        if (!this.domConverter.mapViewToDom(t)) return;
        if (e === "attributes") this.markedAttributes.add(t);else if (e === "children") this.markedChildren.add(t);else throw new f("view-renderer-unknown-type", this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isComposing && !M.isAndroid) return;
      var e = null;
      var t = M.isBlink && !M.isAndroid ? !this.isSelecting : !0;
      var _iterator78 = _createForOfIteratorHelper(this.markedChildren),
        _step78;
      try {
        for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
          var _n6 = _step78.value;
          this._updateChildrenMappings(_n6);
        }
      } catch (err) {
        _iterator78.e(err);
      } finally {
        _iterator78.f();
      }
      t ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? e = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (e = this.selection.getFirstPosition(), this.markedChildren.add(e.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (e = this.domConverter.domPositionToView(this._inlineFiller), e && e.parent.is("$text") && (e = g._createBefore(e.parent)));
      var _iterator79 = _createForOfIteratorHelper(this.markedAttributes),
        _step79;
      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var _n7 = _step79.value;
          this._updateAttrs(_n7);
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
      var _iterator80 = _createForOfIteratorHelper(this.markedChildren),
        _step80;
      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var _n8 = _step80.value;
          this._updateChildren(_n8, {
            inlineFillerPosition: e
          });
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
      var _iterator81 = _createForOfIteratorHelper(this.markedTexts),
        _step81;
      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var _n9 = _step81.value;
          !this.markedChildren.has(_n9.parent) && this.domConverter.mapViewToDom(_n9.parent) && this._updateText(_n9, {
            inlineFillerPosition: e
          });
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
      if (t) if (e) {
        var n = this.domConverter.viewPositionToDom(e),
          r = n.parent.ownerDocument;
        D(n.parent) ? this._inlineFiller = n.parent : this._inlineFiller = un(r, n.parent, n.offset);
      } else this._inlineFiller = null;
      this._updateFocus(), this._updateSelection(), this.domConverter._clearTemporaryCustomProperties(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
    }
  }, {
    key: "_updateChildrenMappings",
    value: function _updateChildrenMappings(e) {
      var t = this.domConverter.mapViewToDom(e);
      if (!t) return;
      var n = Array.from(t.childNodes),
        r = Array.from(this.domConverter.viewChildrenToDom(e, {
          withChildren: !1
        })),
        i = this._diffNodeLists(n, r),
        o = this._findUpdateActions(i, n, r, Cr);
      if (o.indexOf("update") !== -1) {
        var a = {
          equal: 0,
          insert: 0,
          delete: 0
        };
        var _iterator82 = _createForOfIteratorHelper(o),
          _step82;
        try {
          for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
            var l = _step82.value;
            if (l === "update") {
              var c = a.equal + a.insert,
                h = a.equal + a.delete,
                d = e.getChild(c);
              d && !d.is("uiElement") && !d.is("rawElement") && this._updateElementMappings(d, n[h]), tn(r[c]), a.equal++;
            } else a[l]++;
          }
        } catch (err) {
          _iterator82.e(err);
        } finally {
          _iterator82.f();
        }
      }
    }
  }, {
    key: "_updateElementMappings",
    value: function _updateElementMappings(e, t) {
      this.domConverter.unbindDomElement(t), this.domConverter.bindElements(t, e), this.markedChildren.add(e), this.markedAttributes.add(e);
    }
  }, {
    key: "_getInlineFillerPosition",
    value: function _getInlineFillerPosition() {
      var e = this.selection.getFirstPosition();
      return e.parent.is("$text") ? g._createBefore(e.parent) : e;
    }
  }, {
    key: "_isSelectionInInlineFiller",
    value: function _isSelectionInInlineFiller() {
      if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) return !1;
      var e = this.selection.getFirstPosition(),
        t = this.domConverter.viewPositionToDom(e);
      return !!(t && E(t.parent) && D(t.parent));
    }
  }, {
    key: "_removeInlineFiller",
    value: function _removeInlineFiller() {
      var e = this._inlineFiller;
      if (!D(e)) throw new f("view-renderer-filler-was-lost", this);
      Re(e) ? e.remove() : e.data = e.data.substr(L), this._inlineFiller = null;
    }
  }, {
    key: "_needsInlineFillerAtSelection",
    value: function _needsInlineFillerAtSelection() {
      if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) return !1;
      var e = this.selection.getFirstPosition(),
        t = e.parent,
        n = e.offset;
      if (!this.domConverter.mapViewToDom(t.root) || !t.is("element") || !Pr(t)) return !1;
      var r = e.nodeBefore,
        i = e.nodeAfter;
      return !(r instanceof x || i instanceof x || n === t.getFillerOffset() && (!r || !r.is("element", "br")) || M.isAndroid && (r || i));
    }
  }, {
    key: "_updateText",
    value: function _updateText(e, t) {
      var n = this.domConverter.findCorrespondingDomText(e);
      var i = this.domConverter.viewToDom(e).data;
      var o = t.inlineFillerPosition;
      o && o.parent == e.parent && o.offset == e.index && (i = He + i), this._updateTextNode(n, i);
    }
  }, {
    key: "_updateAttrs",
    value: function _updateAttrs(e) {
      var t = this.domConverter.mapViewToDom(e);
      if (t) {
        for (var _i18 = 0, _Array$from = Array.from(t.attributes); _i18 < _Array$from.length; _i18++) {
          var n = _Array$from[_i18];
          var r = n.name;
          e.hasAttribute(r) || this.domConverter.removeDomElementAttribute(t, r);
        }
        var _iterator83 = _createForOfIteratorHelper(e.getAttributeKeys()),
          _step83;
        try {
          for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
            var _n0 = _step83.value;
            this.domConverter.setDomElementAttribute(t, _n0, e.getAttribute(_n0), e);
          }
        } catch (err) {
          _iterator83.e(err);
        } finally {
          _iterator83.f();
        }
      }
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren(e, t) {
      var n = this.domConverter.mapViewToDom(e);
      if (!n) return;
      if (M.isAndroid) {
        var d = null;
        for (var _i19 = 0, _Array$from2 = Array.from(n.childNodes); _i19 < _Array$from2.length; _i19++) {
          var p = _Array$from2[_i19];
          if (d && E(d) && E(p)) {
            n.normalize();
            break;
          }
          d = p;
        }
      }
      var r = t.inlineFillerPosition,
        i = n.childNodes,
        o = Array.from(this.domConverter.viewChildrenToDom(e, {
          bind: !0
        }));
      r && r.parent === e && un(n.ownerDocument, o, r.offset);
      var a = this._diffNodeLists(i, o),
        l = this._findUpdateActions(a, i, o, kr);
      var c = 0;
      var h = new Set();
      var _iterator84 = _createForOfIteratorHelper(l),
        _step84;
      try {
        for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
          var _d = _step84.value;
          _d === "delete" ? (h.add(i[c]), tn(i[c])) : (_d === "equal" || _d === "update") && c++;
        }
      } catch (err) {
        _iterator84.e(err);
      } finally {
        _iterator84.f();
      }
      c = 0;
      var _iterator85 = _createForOfIteratorHelper(l),
        _step85;
      try {
        for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
          var _d2 = _step85.value;
          _d2 === "insert" ? (zn(n, c, o[c]), c++) : _d2 === "update" ? (this._updateTextNode(i[c], o[c].data), c++) : _d2 === "equal" && (this._markDescendantTextToSync(this.domConverter.domToView(o[c])), c++);
        }
      } catch (err) {
        _iterator85.e(err);
      } finally {
        _iterator85.f();
      }
      var _iterator86 = _createForOfIteratorHelper(h),
        _step86;
      try {
        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
          var _d3 = _step86.value;
          _d3.parentNode || this.domConverter.unbindDomElement(_d3);
        }
      } catch (err) {
        _iterator86.e(err);
      } finally {
        _iterator86.f();
      }
    }
  }, {
    key: "_diffNodeLists",
    value: function _diffNodeLists(e, t) {
      return e = Er(e, this._fakeSelectionContainer), gt(e, t, Ar.bind(null, this.domConverter));
    }
  }, {
    key: "_findUpdateActions",
    value: function _findUpdateActions(e, t, n, r) {
      if (e.indexOf("insert") === -1 || e.indexOf("delete") === -1) return e;
      var i = [],
        o = [],
        a = [];
      var l = {
        equal: 0,
        insert: 0,
        delete: 0
      };
      var _iterator87 = _createForOfIteratorHelper(e),
        _step87;
      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var c = _step87.value;
          c === "insert" ? a.push(n[l.equal + l.insert]) : c === "delete" ? o.push(t[l.equal + l.delete]) : (i = i.concat(gt(o, a, r).map(function (h) {
            return h === "equal" ? "update" : h;
          })), i.push("equal"), o = [], a = []), l[c]++;
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
      return i.concat(gt(o, a, r).map(function (c) {
        return c === "equal" ? "update" : c;
      }));
    }
  }, {
    key: "_updateTextNode",
    value: function _updateTextNode(e, t) {
      var n = e.data;
      n != t && (M.isAndroid && this.isComposing && n.replace(/\u00A0/g, " ") == t.replace(/\u00A0/g, " ") || this._updateTextNodeInternal(e, t));
    }
  }, {
    key: "_updateTextNodeInternal",
    value: function _updateTextNodeInternal(e, t) {
      var n = Ls(e.data, t);
      var _iterator88 = _createForOfIteratorHelper(n),
        _step88;
      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var r = _step88.value;
          r.type === "insert" ? e.insertData(r.index, r.values.join("")) : e.deleteData(r.index, r.howMany);
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
    }
  }, {
    key: "_markDescendantTextToSync",
    value: function _markDescendantTextToSync(e) {
      if (e) {
        if (e.is("$text")) this.markedTexts.add(e);else if (e.is("element")) {
          var _iterator89 = _createForOfIteratorHelper(e.getChildren()),
            _step89;
          try {
            for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
              var t = _step89.value;
              this._markDescendantTextToSync(t);
            }
          } catch (err) {
            _iterator89.e(err);
          } finally {
            _iterator89.f();
          }
        }
      }
    }
  }, {
    key: "_updateSelection",
    value: function _updateSelection() {
      if (M.isBlink && !M.isAndroid && this.isSelecting && !this.markedChildren.size) return;
      if (this.selection.rangeCount === 0) {
        this._removeDomSelection(), this._removeFakeSelection();
        return;
      }
      var e = this.domConverter.mapViewToDom(this.selection.editableElement);
      if (!this.isFocused || !e) {
        !this.selection.isFake && this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected && this._removeFakeSelection();
        return;
      }
      this.selection.isFake ? this._updateFakeSelection(e) : this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected ? (this._removeFakeSelection(), this._updateDomSelection(e)) : this.isComposing && M.isAndroid || this._updateDomSelection(e);
    }
  }, {
    key: "_updateFakeSelection",
    value: function _updateFakeSelection(e) {
      var t = e.ownerDocument;
      this._fakeSelectionContainer || (this._fakeSelectionContainer = Rr(t));
      var n = this._fakeSelectionContainer;
      if (this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(e)) return;
      (!n.parentElement || n.parentElement != e) && e.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
      var r = t.getSelection(),
        i = t.createRange();
      r.removeAllRanges(), i.selectNodeContents(n), r.addRange(i);
    }
  }, {
    key: "_updateDomSelection",
    value: function _updateDomSelection(e) {
      var t = e.ownerDocument.defaultView.getSelection();
      if (!this._domSelectionNeedsUpdate(t)) return;
      var n = this.domConverter.viewPositionToDom(this.selection.anchor),
        r = this.domConverter.viewPositionToDom(this.selection.focus);
      t.setBaseAndExtent(n.parent, n.offset, r.parent, r.offset), M.isGecko && Sr(r, t);
    }
  }, {
    key: "_domSelectionNeedsUpdate",
    value: function _domSelectionNeedsUpdate(e) {
      if (!this.domConverter.isDomSelectionCorrect(e)) return !0;
      var t = e && this.domConverter.domSelectionToView(e);
      return !(t && this.selection.isEqual(t) || !this.selection.isCollapsed && this.selection.isSimilar(t));
    }
  }, {
    key: "_fakeSelectionNeedsUpdate",
    value: function _fakeSelectionNeedsUpdate(e) {
      var t = this._fakeSelectionContainer,
        n = e.ownerDocument.getSelection();
      return !t || t.parentElement !== e || n.anchorNode !== t && !t.contains(n.anchorNode) ? !0 : t.textContent !== this.selection.fakeSelectionLabel;
    }
  }, {
    key: "_removeDomSelection",
    value: function _removeDomSelection() {
      var _iterator90 = _createForOfIteratorHelper(this.domDocuments),
        _step90;
      try {
        for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
          var e = _step90.value;
          var t = e.getSelection();
          if (t.rangeCount) {
            var n = e.activeElement,
              r = this.domConverter.mapDomToView(n);
            n && r && t.removeAllRanges();
          }
        }
      } catch (err) {
        _iterator90.e(err);
      } finally {
        _iterator90.f();
      }
    }
  }, {
    key: "_removeFakeSelection",
    value: function _removeFakeSelection() {
      var e = this._fakeSelectionContainer;
      e && e.remove();
    }
  }, {
    key: "_updateFocus",
    value: function _updateFocus() {
      if (this.isFocused) {
        var e = this.selection.editableElement;
        e && this.domConverter.focus(e);
      }
    }
  }]);
}(U());
function Pr(s) {
  if (s.getAttribute("contenteditable") == "false") return !1;
  var e = s.findAncestor(function (t) {
    return t.hasAttribute("contenteditable");
  });
  return !e || e.getAttribute("contenteditable") == "true";
}
function un(s, e, t) {
  var n = e instanceof Array ? e : e.childNodes,
    r = n[t];
  if (E(r)) return r.data = He + r.data, r;
  {
    var i = s.createTextNode(He);
    return Array.isArray(e) ? n.splice(t, 0, i) : zn(e, t, i), i;
  }
}
function Cr(s, e) {
  return ot(s) && ot(e) && !E(s) && !E(e) && !Le(s) && !Le(e) && s.tagName.toLowerCase() === e.tagName.toLowerCase();
}
function kr(s, e) {
  return ot(s) && ot(e) && E(s) && E(e);
}
function Ar(s, e, t) {
  return e === t ? !0 : E(e) && E(t) ? e.data === t.data : !!(s.isBlockFiller(e) && s.isBlockFiller(t));
}
function Sr(s, e) {
  var t = s.parent,
    n = s.offset;
  if (E(t) && Re(t) && (n = Ee(t) + 1, t = t.parentNode), t.nodeType != Node.ELEMENT_NODE || n != t.childNodes.length - 1) return;
  var r = t.childNodes[n];
  r && r.tagName == "BR" && e.addRange(e.getRangeAt(0));
}
function Er(s, e) {
  var t = Array.from(s);
  return t.length == 0 || !e || t[t.length - 1] == e && t.pop(), t;
}
function Rr(s) {
  var e = s.createElement("div");
  return e.className = "ck-fake-selection-container", Object.assign(e.style, {
    position: "fixed",
    top: 0,
    left: "-9999px",
    width: "42px"
  }), e.textContent = " ", e;
}
var Tr = ts(re.document),
  Mr = Zn(re.document),
  xr = es(re.document),
  tt = "data-ck-unsafe-attribute-",
  fn = "data-ck-unsafe-element";
var ns = /*#__PURE__*/function () {
  function ns(e) {
    var _ref51 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref51.blockFillerMode,
      _ref51$renderingMode = _ref51.renderingMode,
      n = _ref51$renderingMode === void 0 ? "editing" : _ref51$renderingMode;
    _classCallCheck(this, ns);
    _defineProperty(this, "document", void 0);
    _defineProperty(this, "renderingMode", void 0);
    _defineProperty(this, "blockFillerMode", void 0);
    _defineProperty(this, "preElements", void 0);
    _defineProperty(this, "blockElements", void 0);
    _defineProperty(this, "inlineObjectElements", void 0);
    _defineProperty(this, "unsafeElements", void 0);
    _defineProperty(this, "_domDocument", void 0);
    _defineProperty(this, "_domToViewMapping", new WeakMap());
    _defineProperty(this, "_viewToDomMapping", new WeakMap());
    _defineProperty(this, "_fakeSelectionMapping", new WeakMap());
    _defineProperty(this, "_rawContentElementMatcher", new je());
    _defineProperty(this, "_inlineObjectElementMatcher", new je());
    _defineProperty(this, "_elementsWithTemporaryCustomProperties", new Set());
    this.document = e, this.renderingMode = n, this.blockFillerMode = t || (n === "editing" ? "br" : "nbsp"), this.preElements = ["pre", "textarea"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this.unsafeElements = ["script", "style"], this._domDocument = this.renderingMode === "editing" ? re.document : re.document.implementation.createHTMLDocument("");
  }
  return _createClass(ns, [{
    key: "domDocument",
    get: function get() {
      return this._domDocument;
    }
  }, {
    key: "bindFakeSelection",
    value: function bindFakeSelection(e, t) {
      this._fakeSelectionMapping.set(e, new Z(t));
    }
  }, {
    key: "fakeSelectionToView",
    value: function fakeSelectionToView(e) {
      return this._fakeSelectionMapping.get(e);
    }
  }, {
    key: "bindElements",
    value: function bindElements(e, t) {
      this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
    }
  }, {
    key: "unbindDomElement",
    value: function unbindDomElement(e) {
      var t = this._domToViewMapping.get(e);
      if (t) {
        this._domToViewMapping.delete(e), this._viewToDomMapping.delete(t);
        var _iterator91 = _createForOfIteratorHelper(e.children),
          _step91;
        try {
          for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
            var n = _step91.value;
            this.unbindDomElement(n);
          }
        } catch (err) {
          _iterator91.e(err);
        } finally {
          _iterator91.f();
        }
      }
    }
  }, {
    key: "bindDocumentFragments",
    value: function bindDocumentFragments(e, t) {
      this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
    }
  }, {
    key: "shouldRenderAttribute",
    value: function shouldRenderAttribute(e, t, n) {
      return this.renderingMode === "data" ? !0 : (e = e.toLowerCase(), e.startsWith("on") || e === "srcdoc" && t.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i) ? !1 : n === "img" && (e === "src" || e === "srcset") || n === "source" && e === "srcset" ? !0 : !t.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
    }
  }, {
    key: "setContentOf",
    value: function setContentOf(e, t) {
      if (this.renderingMode === "data") {
        e.innerHTML = t;
        return;
      }
      var n = new DOMParser().parseFromString(t, "text/html"),
        r = n.createDocumentFragment(),
        i = n.body.childNodes;
      for (; i.length > 0;) r.appendChild(i[0]);
      var o = n.createTreeWalker(r, NodeFilter.SHOW_ELEMENT),
        a = [];
      var l;
      for (; l = o.nextNode();) a.push(l);
      for (var _i20 = 0, _a3 = a; _i20 < _a3.length; _i20++) {
        var c = _a3[_i20];
        var _iterator92 = _createForOfIteratorHelper(c.getAttributeNames()),
          _step92;
        try {
          for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
            var d = _step92.value;
            this.setDomElementAttribute(c, d, c.getAttribute(d));
          }
        } catch (err) {
          _iterator92.e(err);
        } finally {
          _iterator92.f();
        }
        var h = c.tagName.toLowerCase();
        this._shouldRenameElement(h) && (pn(h), c.replaceWith(this._createReplacementDomElement(h, c)));
      }
      for (; e.firstChild;) e.firstChild.remove();
      e.append(r);
    }
  }, {
    key: "viewToDom",
    value: function viewToDom(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (e.is("$text")) {
        var n = this._processDataFromViewText(e);
        return this._domDocument.createTextNode(n);
      } else {
        var _n1 = e;
        if (this.mapViewToDom(_n1)) if (_n1.getCustomProperty("editingPipeline:doNotReuseOnce")) this._elementsWithTemporaryCustomProperties.add(_n1);else return this.mapViewToDom(_n1);
        var r;
        if (_n1.is("documentFragment")) r = this._domDocument.createDocumentFragment(), t.bind && this.bindDocumentFragments(r, _n1);else {
          if (_n1.is("uiElement")) return _n1.name === "$comment" ? r = this._domDocument.createComment(_n1.getCustomProperty("$rawContent")) : r = _n1.render(this._domDocument, this), t.bind && this.bindElements(r, _n1), r;
          this._shouldRenameElement(_n1.name) ? (pn(_n1.name), r = this._createReplacementDomElement(_n1.name)) : _n1.hasAttribute("xmlns") ? r = this._domDocument.createElementNS(_n1.getAttribute("xmlns"), _n1.name) : r = this._domDocument.createElement(_n1.name), _n1.is("rawElement") && _n1.render(r, this), t.bind && this.bindElements(r, _n1);
          var _iterator93 = _createForOfIteratorHelper(_n1.getAttributeKeys()),
            _step93;
          try {
            for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
              var i = _step93.value;
              this.setDomElementAttribute(r, i, _n1.getAttribute(i), _n1);
            }
          } catch (err) {
            _iterator93.e(err);
          } finally {
            _iterator93.f();
          }
        }
        if (t.withChildren !== !1) {
          var _iterator94 = _createForOfIteratorHelper(this.viewChildrenToDom(_n1, t)),
            _step94;
          try {
            for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
              var _i21 = _step94.value;
              r instanceof HTMLTemplateElement ? r.content.appendChild(_i21) : r.appendChild(_i21);
            }
          } catch (err) {
            _iterator94.e(err);
          } finally {
            _iterator94.f();
          }
        }
        return r;
      }
    }
  }, {
    key: "setDomElementAttribute",
    value: function setDomElementAttribute(e, t, n, r) {
      var i = this.shouldRenderAttribute(t, n, e.tagName.toLowerCase()) || r && r.shouldRenderUnsafeAttribute(t);
      if (i || W("domconverter-unsafe-attribute-detected", {
        domElement: e,
        key: t,
        value: n
      }), !Bs(t)) {
        W("domconverter-invalid-attribute-detected", {
          domElement: e,
          key: t,
          value: n
        });
        return;
      }
      e.hasAttribute(t) && !i ? e.removeAttribute(t) : e.hasAttribute(tt + t) && i && e.removeAttribute(tt + t), e.setAttribute(i ? t : tt + t, n);
    }
  }, {
    key: "removeDomElementAttribute",
    value: function removeDomElementAttribute(e, t) {
      t != fn && (e.removeAttribute(t), e.removeAttribute(tt + t));
    }
  }, {
    key: "viewChildrenToDom",
    value: function viewChildrenToDom(e) {
      var _this21 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var n, r, _iterator95, _step95, i, o, a;
        return _regeneratorRuntime().wrap(function _callee3$(_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              n = e.getFillerOffset && e.getFillerOffset();
              r = 0;
              _iterator95 = _createForOfIteratorHelper(e.getChildren());
              _context0.prev = 3;
              _iterator95.s();
            case 5:
              if ((_step95 = _iterator95.n()).done) {
                _context0.next = 28;
                break;
              }
              i = _step95.value;
              _context0.t0 = n === r;
              if (!_context0.t0) {
                _context0.next = 11;
                break;
              }
              _context0.next = 11;
              return _this21._getBlockFiller();
            case 11:
              o = i.is("element") && !!i.getCustomProperty("dataPipeline:transparentRendering") && !Wt(i.getAttributes());
              if (!(o && _this21.renderingMode == "data")) {
                _context0.next = 22;
                break;
              }
              if (!i.is("rawElement")) {
                _context0.next = 19;
                break;
              }
              a = _this21._domDocument.createElement(i.name);
              i.render(a, _this21);
              return _context0.delegateYield(_toConsumableArray(a.childNodes), "t1", 17);
            case 17:
              _context0.next = 20;
              break;
            case 19:
              return _context0.delegateYield(_this21.viewChildrenToDom(i, t), "t2", 20);
            case 20:
              _context0.next = 25;
              break;
            case 22:
              o && W("domconverter-transparent-rendering-unsupported-in-editing-pipeline", {
                viewElement: i
              });
              _context0.next = 25;
              return _this21.viewToDom(i, t);
            case 25:
              r++;
            case 26:
              _context0.next = 5;
              break;
            case 28:
              _context0.next = 33;
              break;
            case 30:
              _context0.prev = 30;
              _context0.t3 = _context0["catch"](3);
              _iterator95.e(_context0.t3);
            case 33:
              _context0.prev = 33;
              _iterator95.f();
              return _context0.finish(33);
            case 36:
              _context0.t4 = n === r;
              if (!_context0.t4) {
                _context0.next = 40;
                break;
              }
              _context0.next = 40;
              return _this21._getBlockFiller();
            case 40:
            case "end":
              return _context0.stop();
          }
        }, _callee3, null, [[3, 30, 33, 36]]);
      })();
    }
  }, {
    key: "viewRangeToDom",
    value: function viewRangeToDom(e) {
      var t = this.viewPositionToDom(e.start),
        n = this.viewPositionToDom(e.end),
        r = this._domDocument.createRange();
      return r.setStart(t.parent, t.offset), r.setEnd(n.parent, n.offset), r;
    }
  }, {
    key: "viewPositionToDom",
    value: function viewPositionToDom(e) {
      var t = e.parent;
      if (t.is("$text")) {
        var n = this.findCorrespondingDomText(t);
        if (!n) return null;
        var r = e.offset;
        return D(n) && (r += L), n.data && r > n.data.length && (r = n.data.length), {
          parent: n,
          offset: r
        };
      } else {
        var _n10, _r5, i;
        if (e.offset === 0) {
          if (_n10 = this.mapViewToDom(t), !_n10) return null;
          i = _n10.childNodes[0];
        } else {
          var a = e.nodeBefore;
          if (_r5 = a.is("$text") ? this.findCorrespondingDomText(a) : this.mapViewToDom(a), !_r5) return null;
          _n10 = _r5.parentNode, i = _r5.nextSibling;
        }
        if (E(i) && D(i)) return {
          parent: i,
          offset: L
        };
        var o = _r5 ? Ee(_r5) + 1 : 0;
        return {
          parent: _n10,
          offset: o
        };
      }
    }
  }, {
    key: "domToView",
    value: function domToView(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = [],
        r = this._domToView(e, t, n),
        i = r.next().value;
      return !i || (r.next(), this._processDomInlineNodes(null, n, t), this.blockFillerMode == "br" && mn(i)) || i.is("$text") && i.data.length == 0 ? null : i;
    }
  }, {
    key: "domChildrenToView",
    value: function domChildrenToView(e) {
      var _this22 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var r, i, o, a, l;
        return _regeneratorRuntime().wrap(function _callee4$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              r = [];
              e instanceof HTMLTemplateElement ? r = _toConsumableArray(e.content.childNodes) : r = _toConsumableArray(e.childNodes);
              i = 0;
            case 3:
              if (!(i < r.length)) {
                _context1.next = 16;
                break;
              }
              o = r[i], a = _this22._domToView(o, t, n), l = a.next().value;
              _context1.t0 = l !== null;
              if (!_context1.t0) {
                _context1.next = 13;
                break;
              }
              _this22._isBlockViewElement(l) && _this22._processDomInlineNodes(e, n, t);
              _context1.t1 = _this22.blockFillerMode == "br" && mn(l);
              if (_context1.t1) {
                _context1.next = 12;
                break;
              }
              _context1.next = 12;
              return l;
            case 12:
              a.next();
            case 13:
              i++;
              _context1.next = 3;
              break;
            case 16:
              _this22._processDomInlineNodes(e, n, t);
            case 17:
            case "end":
              return _context1.stop();
          }
        }, _callee4);
      })();
    }
  }, {
    key: "domSelectionToView",
    value: function domSelectionToView(e) {
      if (Dr(e)) return new Z([]);
      if (e.rangeCount === 1) {
        var r = e.getRangeAt(0).startContainer;
        E(r) && (r = r.parentNode);
        var i = this.fakeSelectionToView(r);
        if (i) return i;
      }
      var t = this.isDomSelectionBackward(e),
        n = [];
      for (var _r6 = 0; _r6 < e.rangeCount; _r6++) {
        var _i22 = e.getRangeAt(_r6),
          o = this.domRangeToView(_i22);
        o && n.push(o);
      }
      return new Z(n, {
        backward: t
      });
    }
  }, {
    key: "domRangeToView",
    value: function domRangeToView(e) {
      var t = this.domPositionToView(e.startContainer, e.startOffset),
        n = this.domPositionToView(e.endContainer, e.endOffset);
      return t && n ? new w(t, n) : null;
    }
  }, {
    key: "domPositionToView",
    value: function domPositionToView(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (this.isBlockFiller(e)) return this.domPositionToView(e.parentNode, Ee(e));
      var n = this.mapDomToView(e);
      if (n && (n.is("uiElement") || n.is("rawElement"))) return g._createBefore(n);
      if (E(e)) {
        if (Re(e)) return this.domPositionToView(e.parentNode, Ee(e));
        var r = this.findCorrespondingViewText(e);
        var i = t;
        return r ? (D(e) && (i -= L, i = i < 0 ? 0 : i), new g(r, i)) : null;
      } else {
        if (t === 0) {
          var _r7 = this.mapDomToView(e);
          if (_r7) return new g(_r7, 0);
        } else {
          var _r8 = e.childNodes[t - 1];
          if (E(_r8) && Re(_r8) || _r8 && this.isBlockFiller(_r8)) return this.domPositionToView(_r8.parentNode, Ee(_r8));
          var _i23 = E(_r8) ? this.findCorrespondingViewText(_r8) : this.mapDomToView(_r8);
          if (_i23 && _i23.parent) return new g(_i23.parent, _i23.index + 1);
        }
        return null;
      }
    }
  }, {
    key: "mapDomToView",
    value: function mapDomToView(e) {
      return this.getHostViewElement(e) || this._domToViewMapping.get(e);
    }
  }, {
    key: "findCorrespondingViewText",
    value: function findCorrespondingViewText(e) {
      if (Re(e)) return null;
      var t = this.getHostViewElement(e);
      if (t) return t;
      var n = e.previousSibling;
      if (n) {
        if (!this.isElement(n)) return null;
        var r = this.mapDomToView(n);
        if (r) {
          var i = r.nextSibling;
          return i instanceof x ? i : null;
        }
      } else {
        var _r9 = this.mapDomToView(e.parentNode);
        if (_r9) {
          var _i24 = _r9.getChild(0);
          return _i24 instanceof x ? _i24 : null;
        }
      }
      return null;
    }
  }, {
    key: "mapViewToDom",
    value: function mapViewToDom(e) {
      return this._viewToDomMapping.get(e);
    }
  }, {
    key: "findCorrespondingDomText",
    value: function findCorrespondingDomText(e) {
      var t = e.previousSibling;
      return t && this.mapViewToDom(t) ? this.mapViewToDom(t).nextSibling : !t && e.parent && this.mapViewToDom(e.parent) ? this.mapViewToDom(e.parent).childNodes[0] : null;
    }
  }, {
    key: "focus",
    value: function focus(e) {
      var t = this.mapViewToDom(e);
      if (!t || t.ownerDocument.activeElement === t) return;
      var _re$window = re.window,
        n = _re$window.scrollX,
        r = _re$window.scrollY,
        i = [];
      dn(t, function (o) {
        var a = o.scrollLeft,
          l = o.scrollTop;
        i.push([a, l]);
      }), t.focus(), dn(t, function (o) {
        var _i$shift = i.shift(),
          _i$shift2 = _slicedToArray(_i$shift, 2),
          a = _i$shift2[0],
          l = _i$shift2[1];
        o.scrollLeft = a, o.scrollTop = l;
      }), re.window.scrollTo(n, r);
    }
  }, {
    key: "_clearDomSelection",
    value: function _clearDomSelection() {
      var e = this.mapViewToDom(this.document.selection.editableElement);
      if (!e) return;
      var t = e.ownerDocument.defaultView.getSelection(),
        n = this.domSelectionToView(t);
      n && n.rangeCount > 0 && t.removeAllRanges();
    }
  }, {
    key: "isElement",
    value: function isElement(e) {
      return e && e.nodeType == Node.ELEMENT_NODE;
    }
  }, {
    key: "isDocumentFragment",
    value: function isDocumentFragment(e) {
      return e && e.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
    }
  }, {
    key: "isBlockFiller",
    value: function isBlockFiller(e) {
      return this.blockFillerMode == "br" ? e.isEqualNode(Tr) : gn(e, this.blockElements) ? !0 : e.isEqualNode(xr) || Or(e, this.blockElements);
    }
  }, {
    key: "isDomSelectionBackward",
    value: function isDomSelectionBackward(e) {
      if (e.isCollapsed) return !1;
      var t = this._domDocument.createRange();
      try {
        t.setStart(e.anchorNode, e.anchorOffset), t.setEnd(e.focusNode, e.focusOffset);
      } catch (_unused) {
        return !1;
      }
      var n = t.collapsed;
      return t.detach(), n;
    }
  }, {
    key: "getHostViewElement",
    value: function getHostViewElement(e) {
      var t = Vs(e);
      for (t.pop(); t.length;) {
        var n = t.pop(),
          r = this._domToViewMapping.get(n);
        if (r && (r.is("uiElement") || r.is("rawElement"))) return r;
      }
      return null;
    }
  }, {
    key: "isDomSelectionCorrect",
    value: function isDomSelectionCorrect(e) {
      return this._isDomSelectionPositionCorrect(e.anchorNode, e.anchorOffset) && this._isDomSelectionPositionCorrect(e.focusNode, e.focusOffset);
    }
  }, {
    key: "registerRawContentMatcher",
    value: function registerRawContentMatcher(e) {
      this._rawContentElementMatcher.add(e);
    }
  }, {
    key: "registerInlineObjectMatcher",
    value: function registerInlineObjectMatcher(e) {
      this._inlineObjectElementMatcher.add(e);
    }
  }, {
    key: "_clearTemporaryCustomProperties",
    value: function _clearTemporaryCustomProperties() {
      var _iterator96 = _createForOfIteratorHelper(this._elementsWithTemporaryCustomProperties),
        _step96;
      try {
        for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
          var e = _step96.value;
          e._removeCustomProperty("editingPipeline:doNotReuseOnce");
        }
      } catch (err) {
        _iterator96.e(err);
      } finally {
        _iterator96.f();
      }
      this._elementsWithTemporaryCustomProperties.clear();
    }
  }, {
    key: "_getBlockFiller",
    value: function _getBlockFiller() {
      switch (this.blockFillerMode) {
        case "nbsp":
          return Zn(this._domDocument);
        case "markedNbsp":
          return es(this._domDocument);
        case "br":
          return ts(this._domDocument);
      }
    }
  }, {
    key: "_isDomSelectionPositionCorrect",
    value: function _isDomSelectionPositionCorrect(e, t) {
      if (E(e) && D(e) && t < L || this.isElement(e) && D(e.childNodes[t])) return !1;
      var n = this.mapDomToView(e);
      return !(n && (n.is("uiElement") || n.is("rawElement")));
    }
  }, {
    key: "_domToView",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function _domToView(e, t, n) {
      var r, i, o, _i25, a, l, c, _o9, _iterator97, _step97, _a4, _iterator98, _step98, _a5;
      return _regeneratorRuntime().wrap(function _domToView$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (!(this.blockFillerMode != "br" && gn(e, this.blockElements))) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return", null);
          case 2:
            r = this.getHostViewElement(e);
            if (!r) {
              _context10.next = 5;
              break;
            }
            return _context10.abrupt("return", r);
          case 5:
            if (!(Le(e) && t.skipComments)) {
              _context10.next = 7;
              break;
            }
            return _context10.abrupt("return", null);
          case 7:
            if (!E(e)) {
              _context10.next = 17;
              break;
            }
            if (!Re(e)) {
              _context10.next = 10;
              break;
            }
            return _context10.abrupt("return", null);
          case 10:
            i = e.data;
            if (!(i === "")) {
              _context10.next = 13;
              break;
            }
            return _context10.abrupt("return", null);
          case 13:
            o = new x(this.document, i);
            return _context10.abrupt("return", (n.push(o), o));
          case 17:
            _i25 = this.mapDomToView(e);
            if (!_i25) {
              _context10.next = 20;
              break;
            }
            return _context10.abrupt("return", (this._isInlineObjectElement(_i25) && n.push(_i25), _i25));
          case 20:
            if (!this.isDocumentFragment(e)) {
              _context10.next = 24;
              break;
            }
            _i25 = new ge(this.document), t.bind && this.bindDocumentFragments(e, _i25);
            _context10.next = 31;
            break;
          case 24:
            _i25 = this._createViewElement(e, t), t.bind && this.bindElements(e, _i25);
            a = e.attributes;
            if (a) for (l = a.length, c = 0; c < l; c++) _i25._setAttribute(a[c].name, a[c].value);
            if (!this._isViewElementWithRawContent(_i25, t)) {
              _context10.next = 29;
              break;
            }
            return _context10.abrupt("return", (_i25._setCustomProperty("$rawContent", e.innerHTML), this._isBlockViewElement(_i25) || n.push(_i25), _i25));
          case 29:
            if (!Le(e)) {
              _context10.next = 31;
              break;
            }
            return _context10.abrupt("return", (_i25._setCustomProperty("$rawContent", e.data), _i25));
          case 31:
            _context10.next = 33;
            return _i25;
          case 33:
            _o9 = [];
            if (t.withChildren !== !1) {
              _iterator97 = _createForOfIteratorHelper(this.domChildrenToView(e, t, _o9));
              try {
                for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
                  _a4 = _step97.value;
                  _i25._appendChild(_a4);
                }
              } catch (err) {
                _iterator97.e(err);
              } finally {
                _iterator97.f();
              }
            }
            if (this._isInlineObjectElement(_i25)) n.push(_i25), this._processDomInlineNodes(null, _o9, t);else {
              _iterator98 = _createForOfIteratorHelper(_o9);
              try {
                for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
                  _a5 = _step98.value;
                  n.push(_a5);
                }
              } catch (err) {
                _iterator98.e(err);
              } finally {
                _iterator98.f();
              }
            }
          case 36:
          case "end":
            return _context10.stop();
        }
      }, _domToView, this);
    })
  }, {
    key: "_processDomInlineNodes",
    value: function _processDomInlineNodes(e, t, n) {
      if (!t.length || e && !this.isDocumentFragment(e) && !this._isBlockDomElement(e)) return;
      var r = !1;
      for (var i = 0; i < t.length; i++) {
        var o = t[i];
        if (!o.is("$text")) {
          r = !1;
          continue;
        }
        var a = void 0,
          l = !1;
        if (this._isPreFormatted(o)) a = hn(o.data);else {
          a = o.data.replace(/[ \n\t\r]{1,}/g, " "), l = /[^\S\u00A0]/.test(a.charAt(a.length - 1));
          var c = i > 0 ? t[i - 1] : null,
            h = i + 1 < t.length ? t[i + 1] : null,
            d = !c || c.is("element") && c.name == "br" || r,
            p = h ? !1 : !D(o.data);
          n.withChildren !== !1 && (d && (a = a.replace(/^ /, "")), p && (a = a.replace(/ $/, ""))), a = hn(a), this.blockFillerMode != "br" && o.parent && (Fr(o.parent, a) ? (a = "", o.parent.parent && (o.parent.parent._setCustomProperty("$hasBlockFiller", !0), o.parent._remove())) : Ir(o.parent, a, this.blockElements) && (a = "", o.parent._setCustomProperty("$hasBlockFiller", !0))), a = a.replace(/ \u00A0/g, "  ");
          var _ = h && h.is("element") && h.name != "br",
            y = h && h.is("$text") && h.data.charAt(0) == " ";
          (/[ \u00A0]\u00A0$/.test(a) || !h || _ || y) && (a = a.replace(/\u00A0$/, " ")), (d || c && c.is("element") && c.name != "br") && (a = a.replace(/^\u00A0/, " "));
        }
        a.length == 0 && o.parent ? (o._remove(), t.splice(i, 1), i--) : (o._data = a, r = l);
      }
      t.length = 0;
    }
  }, {
    key: "_processDataFromViewText",
    value: function _processDataFromViewText(e) {
      var t = e.data;
      if (this._isPreFormatted(e)) return t;
      if (t.charAt(0) == " ") {
        var n = this._getTouchingInlineViewNode(e, !1);
        (n && n.is("$textProxy") && this._nodeEndsWithSpace(n) || !n) && (t = " " + t.substr(1));
      }
      if (t.charAt(t.length - 1) == " ") {
        var _n11 = this._getTouchingInlineViewNode(e, !0),
          r = _n11 && _n11.is("$textProxy") && _n11.data.charAt(0) == " ";
        (t.charAt(t.length - 2) == " " || !_n11 || r) && (t = t.substr(0, t.length - 1) + " ");
      }
      return t.replace(/ {2}/g, "  ");
    }
  }, {
    key: "_nodeEndsWithSpace",
    value: function _nodeEndsWithSpace(e) {
      if (this._isPreFormatted(e)) return !1;
      var t = this._processDataFromViewText(e);
      return t.charAt(t.length - 1) == " ";
    }
  }, {
    key: "_isPreFormatted",
    value: function _isPreFormatted(e) {
      if (Nr(e, this.preElements)) return !0;
      var _iterator99 = _createForOfIteratorHelper(e.getAncestors({
          parentFirst: !0
        })),
        _step99;
      try {
        for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
          var t = _step99.value;
          if (!(!t.is("element") || !t.hasStyle("white-space") || t.getStyle("white-space") === "inherit")) return ["pre", "pre-wrap", "break-spaces"].includes(t.getStyle("white-space"));
        }
      } catch (err) {
        _iterator99.e(err);
      } finally {
        _iterator99.f();
      }
      return !1;
    }
  }, {
    key: "_getTouchingInlineViewNode",
    value: function _getTouchingInlineViewNode(e, t) {
      var n = new me({
        startPosition: t ? g._createAfter(e) : g._createBefore(e),
        direction: t ? "forward" : "backward"
      });
      var _iterator100 = _createForOfIteratorHelper(n),
        _step100;
      try {
        for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
          var _ref52 = _step100.value;
          var r = _ref52.item;
          if (r.is("$textProxy")) return r;
          if (r.is("element") && r.getCustomProperty("dataPipeline:transparentRendering")) continue;
          if (r.is("element", "br")) return null;
          if (this._isInlineObjectElement(r)) return r;
          if (r.is("containerElement")) return null;
        }
      } catch (err) {
        _iterator100.e(err);
      } finally {
        _iterator100.f();
      }
      return null;
    }
  }, {
    key: "_isBlockDomElement",
    value: function _isBlockDomElement(e) {
      return this.isElement(e) && this.blockElements.includes(e.tagName.toLowerCase());
    }
  }, {
    key: "_isBlockViewElement",
    value: function _isBlockViewElement(e) {
      return e.is("element") && this.blockElements.includes(e.name);
    }
  }, {
    key: "_isInlineObjectElement",
    value: function _isInlineObjectElement(e) {
      return e.is("element") ? e.name == "br" || this.inlineObjectElements.includes(e.name) || !!this._inlineObjectElementMatcher.match(e) : !1;
    }
  }, {
    key: "_createViewElement",
    value: function _createViewElement(e, t) {
      if (Le(e)) return new mt(this.document, "$comment");
      var n = t.keepOriginalCase ? e.tagName : e.tagName.toLowerCase();
      return new te(this.document, n);
    }
  }, {
    key: "_isViewElementWithRawContent",
    value: function _isViewElementWithRawContent(e, t) {
      return t.withChildren !== !1 && e.is("element") && !!this._rawContentElementMatcher.match(e);
    }
  }, {
    key: "_shouldRenameElement",
    value: function _shouldRenameElement(e) {
      var t = e.toLowerCase();
      return this.renderingMode === "editing" && this.unsafeElements.includes(t);
    }
  }, {
    key: "_createReplacementDomElement",
    value: function _createReplacementDomElement(e, t) {
      var n = this._domDocument.createElement("span");
      if (n.setAttribute(fn, e), t) {
        for (; t.firstChild;) n.appendChild(t.firstChild);
        var _iterator101 = _createForOfIteratorHelper(t.getAttributeNames()),
          _step101;
        try {
          for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
            var r = _step101.value;
            n.setAttribute(r, t.getAttribute(r));
          }
        } catch (err) {
          _iterator101.e(err);
        } finally {
          _iterator101.f();
        }
      }
      return n;
    }
  }]);
}();
function Nr(s, e) {
  return s.getAncestors().some(function (t) {
    return t.is("element") && e.includes(t.name);
  });
}
function dn(s, e) {
  var t = s;
  for (; t;) e(t), t = t.parentElement;
}
function Or(s, e) {
  return s.isEqualNode(Mr) && ss(s, e) && s.parentNode.childNodes.length === 1;
}
function ss(s, e) {
  var t = s.parentNode;
  return !!t && !!t.tagName && e.includes(t.tagName.toLowerCase());
}
function Ir(s, e, t) {
  return e == " " && s && s.is("element") && s.childCount == 1 && t.includes(s.name);
}
function Fr(s, e) {
  return e == " " && s && s.is("element", "span") && s.childCount == 1 && s.hasAttribute("data-cke-filler");
}
function mn(s) {
  return s.is("element", "br") && s.hasAttribute("data-cke-filler");
}
function gn(s, e) {
  return s.tagName === "BR" && ss(s, e) && s.parentNode.childNodes.length === 1;
}
function pn(s) {
  s === "script" && W("domconverter-unsafe-script-element-detected"), s === "style" && W("domconverter-unsafe-style-element-detected");
}
function Dr(s) {
  if (!M.isGecko || !s.rangeCount) return !1;
  var e = s.getRangeAt(0).startContainer;
  try {
    Object.prototype.toString.call(e);
  } catch (_unused2) {
    return !0;
  }
  return !1;
}
var xe = /*#__PURE__*/function (_Ds) {
  function xe(e) {
    var _this23;
    _classCallCheck(this, xe);
    _this23 = _callSuper(this, xe), _defineProperty(_assertThisInitialized(_this23), "view", void 0), _defineProperty(_assertThisInitialized(_this23), "document", void 0), _defineProperty(_assertThisInitialized(_this23), "_isEnabled", !1), _this23.view = e, _this23.document = e.document;
    return _this23;
  }
  _inherits(xe, _Ds);
  return _createClass(xe, [{
    key: "isEnabled",
    get: function get() {
      return this._isEnabled;
    }
  }, {
    key: "enable",
    value: function enable() {
      this._isEnabled = !0;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._isEnabled = !1;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.disable(), this.stopListening();
    }
  }, {
    key: "checkShouldIgnoreEventFromTarget",
    value: function checkShouldIgnoreEventFromTarget(e) {
      return e && e.nodeType === 3 && (e = e.parentNode), !e || e.nodeType !== 1 ? !1 : e.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
    }
  }]);
}(Ds());
var Br = /*#__PURE__*/function () {
  function Br(e, t, n) {
    _classCallCheck(this, Br);
    _defineProperty(this, "view", void 0);
    _defineProperty(this, "document", void 0);
    _defineProperty(this, "domEvent", void 0);
    _defineProperty(this, "domTarget", void 0);
    this.view = e, this.document = e.document, this.domEvent = t, this.domTarget = t.target, Js(this, n);
  }
  return _createClass(Br, [{
    key: "target",
    get: function get() {
      return this.view.domConverter.mapDomToView(this.domTarget);
    }
  }, {
    key: "preventDefault",
    value: function preventDefault() {
      this.domEvent.preventDefault();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.domEvent.stopPropagation();
    }
  }]);
}();
var ye = /*#__PURE__*/function (_xe2) {
  function ye() {
    var _this24;
    _classCallCheck(this, ye);
    for (var _len1 = arguments.length, args = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++) {
      args[_key1] = arguments[_key1];
    }
    _this24 = _callSuper(this, ye, [].concat(args));
    _defineProperty(_this24, "useCapture", !1);
    _defineProperty(_this24, "usePassive", !1);
    return _this24;
  }
  _inherits(ye, _xe2);
  return _createClass(ye, [{
    key: "observe",
    value: function observe(e) {
      var _this25 = this;
      (typeof this.domEventType == "string" ? [this.domEventType] : this.domEventType).forEach(function (n) {
        _this25.listenTo(e, n, function (r, i) {
          _this25.isEnabled && !_this25.checkShouldIgnoreEventFromTarget(i.target) && _this25.onDomEvent(i);
        }, {
          useCapture: _this25.useCapture,
          usePassive: _this25.usePassive
        });
      });
    }
  }, {
    key: "stopObserving",
    value: function stopObserving(e) {
      this.stopListening(e);
    }
  }, {
    key: "fire",
    value: function fire(e, t, n) {
      this.isEnabled && this.document.fire(e, new Br(this.view, t, n));
    }
  }]);
}(xe);
var Vr = /*#__PURE__*/function (_ye2) {
  function Vr() {
    var _this26;
    _classCallCheck(this, Vr);
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }
    _this26 = _callSuper(this, Vr, [].concat(args));
    _defineProperty(_this26, "domEventType", ["keydown", "keyup"]);
    return _this26;
  }
  _inherits(Vr, _ye2);
  return _createClass(Vr, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      var t = {
        keyCode: e.keyCode,
        altKey: e.altKey,
        ctrlKey: e.ctrlKey,
        shiftKey: e.shiftKey,
        metaKey: e.metaKey,
        get keystroke() {
          return zs(this);
        }
      };
      this.fire(e.type, e, t);
    }
  }]);
}(ye);
var $r = /*#__PURE__*/function (_xe3) {
  function $r(e) {
    var _this27;
    _classCallCheck(this, $r);
    _this27 = _callSuper(this, $r, [e]), _defineProperty(_assertThisInitialized(_this27), "_fireSelectionChangeDoneDebounced", void 0), _this27._fireSelectionChangeDoneDebounced = Mt(function (t) {
      _this27.document.fire("selectionChangeDone", t);
    }, 200);
    return _this27;
  }
  _inherits($r, _xe3);
  return _createClass($r, [{
    key: "observe",
    value: function observe() {
      var _this28 = this;
      var e = this.document;
      e.on("arrowKey", function (t, n) {
        e.selection.isFake && _this28.isEnabled && n.preventDefault();
      }, {
        context: "$capture"
      }), e.on("arrowKey", function (t, n) {
        e.selection.isFake && _this28.isEnabled && _this28._handleSelectionMove(n.keyCode);
      }, {
        priority: "lowest"
      });
    }
  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet($r, "destroy", this, 3)([]), this._fireSelectionChangeDoneDebounced.cancel();
    }
  }, {
    key: "_handleSelectionMove",
    value: function _handleSelectionMove(e) {
      var t = this.document.selection,
        n = new Z(t.getRanges(), {
          backward: t.isBackward,
          fake: !1
        });
      (e == de.arrowleft || e == de.arrowup) && n.setTo(n.getFirstPosition()), (e == de.arrowright || e == de.arrowdown) && n.setTo(n.getLastPosition());
      var r = {
        oldSelection: t,
        newSelection: n,
        domSelection: null
      };
      this.document.fire("selectionChange", r), this._fireSelectionChangeDoneDebounced(r);
    }
  }]);
}(xe);
var rs = /*#__PURE__*/function (_xe4) {
  function rs(e) {
    var _this29;
    _classCallCheck(this, rs);
    _this29 = _callSuper(this, rs, [e]), _defineProperty(_assertThisInitialized(_this29), "domConverter", void 0), _defineProperty(_assertThisInitialized(_this29), "_config", void 0), _defineProperty(_assertThisInitialized(_this29), "_domElements", void 0), _defineProperty(_assertThisInitialized(_this29), "_mutationObserver", void 0), _this29._config = {
      childList: !0,
      characterData: !0,
      subtree: !0
    }, _this29.domConverter = e.domConverter, _this29._domElements = new Set(), _this29._mutationObserver = new window.MutationObserver(_this29._onMutations.bind(_assertThisInitialized(_this29)));
    return _this29;
  }
  _inherits(rs, _xe4);
  return _createClass(rs, [{
    key: "flush",
    value: function flush() {
      this._onMutations(this._mutationObserver.takeRecords());
    }
  }, {
    key: "observe",
    value: function observe(e) {
      this._domElements.add(e), this.isEnabled && this._mutationObserver.observe(e, this._config);
    }
  }, {
    key: "stopObserving",
    value: function stopObserving(e) {
      if (this._domElements.delete(e), this.isEnabled) {
        this._mutationObserver.disconnect();
        var _iterator102 = _createForOfIteratorHelper(this._domElements),
          _step102;
        try {
          for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
            var t = _step102.value;
            this._mutationObserver.observe(t, this._config);
          }
        } catch (err) {
          _iterator102.e(err);
        } finally {
          _iterator102.f();
        }
      }
    }
  }, {
    key: "enable",
    value: function enable() {
      _superPropGet(rs, "enable", this, 3)([]);
      var _iterator103 = _createForOfIteratorHelper(this._domElements),
        _step103;
      try {
        for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
          var e = _step103.value;
          this._mutationObserver.observe(e, this._config);
        }
      } catch (err) {
        _iterator103.e(err);
      } finally {
        _iterator103.f();
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      _superPropGet(rs, "disable", this, 3)([]), this._mutationObserver.disconnect();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(rs, "destroy", this, 3)([]), this._mutationObserver.disconnect();
    }
  }, {
    key: "_onMutations",
    value: function _onMutations(e) {
      if (e.length === 0) return;
      var t = this.domConverter,
        n = new Set(),
        r = new Set();
      var _iterator104 = _createForOfIteratorHelper(e),
        _step104;
      try {
        for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
          var o = _step104.value;
          var a = t.mapDomToView(o.target);
          a && (a.is("uiElement") || a.is("rawElement") || o.type === "childList" && !this._isBogusBrMutation(o) && r.add(a));
        }
      } catch (err) {
        _iterator104.e(err);
      } finally {
        _iterator104.f();
      }
      var _iterator105 = _createForOfIteratorHelper(e),
        _step105;
      try {
        for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
          var _o0 = _step105.value;
          var _a6 = t.mapDomToView(_o0.target);
          if (!(_a6 && (_a6.is("uiElement") || _a6.is("rawElement"))) && _o0.type === "characterData") {
            var l = t.findCorrespondingViewText(_o0.target);
            l && !r.has(l.parent) ? n.add(l) : !l && D(_o0.target) && r.add(t.mapDomToView(_o0.target.parentNode));
          }
        }
      } catch (err) {
        _iterator105.e(err);
      } finally {
        _iterator105.f();
      }
      var i = [];
      var _iterator106 = _createForOfIteratorHelper(n),
        _step106;
      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var _o1 = _step106.value;
          i.push({
            type: "text",
            node: _o1
          });
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
      var _iterator107 = _createForOfIteratorHelper(r),
        _step107;
      try {
        for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
          var _o10 = _step107.value;
          var _a7 = t.mapViewToDom(_o10),
            _l4 = Array.from(_o10.getChildren()),
            c = Array.from(t.domChildrenToView(_a7, {
              withChildren: !1
            }));
          Gs(_l4, c, Lr) || i.push({
            type: "children",
            node: _o10
          });
        }
      } catch (err) {
        _iterator107.e(err);
      } finally {
        _iterator107.f();
      }
      i.length && this.document.fire("mutations", {
        mutations: i
      });
    }
  }, {
    key: "_isBogusBrMutation",
    value: function _isBogusBrMutation(e) {
      var t = null;
      return e.nextSibling === null && e.removedNodes.length === 0 && e.addedNodes.length == 1 && (t = this.domConverter.domToView(e.addedNodes[0], {
        withChildren: !1
      })), t && t.is("element", "br");
    }
  }]);
}(xe);
function Lr(s, e) {
  if (!Array.isArray(s)) return s === e ? !0 : s.is("$text") && e.is("$text") ? s.data === e.data : !1;
}
var Dt = /*#__PURE__*/function (_ye3) {
  function Dt(e) {
    var _this30;
    _classCallCheck(this, Dt);
    _this30 = _callSuper(this, Dt, [e]), _defineProperty(_assertThisInitialized(_this30), "_renderTimeoutId", null), _defineProperty(_assertThisInitialized(_this30), "_isFocusChanging", !1), _defineProperty(_assertThisInitialized(_this30), "domEventType", ["focus", "blur"]), _this30.useCapture = !0;
    var t = _this30.document;
    t.on("focus", function () {
      return _this30._handleFocus();
    }), t.on("blur", function (n, r) {
      return _this30._handleBlur(r);
    }), t.on("beforeinput", function () {
      t.isFocused || _this30._handleFocus();
    }, {
      priority: "highest"
    });
    return _this30;
  }
  _inherits(Dt, _ye3);
  return _createClass(Dt, [{
    key: "flush",
    value: function flush() {
      this._isFocusChanging && (this._isFocusChanging = !1, this.document.isFocused = !0);
    }
  }, {
    key: "onDomEvent",
    value: function onDomEvent(e) {
      this.fire(e.type, e);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._clearTimeout(), _superPropGet(Dt, "destroy", this, 3)([]);
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      var _this31 = this;
      this._clearTimeout(), this._isFocusChanging = !0, this._renderTimeoutId = setTimeout(function () {
        _this31._renderTimeoutId = null, _this31.flush(), _this31.view.change(function () {});
      }, 50);
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur(e) {
      var t = this.document.selection.editableElement;
      (t === null || t === e.target) && (this.document.isFocused = !1, this._isFocusChanging = !1, this.view.change(function () {}));
    }
  }, {
    key: "_clearTimeout",
    value: function _clearTimeout() {
      this._renderTimeoutId && (clearTimeout(this._renderTimeoutId), this._renderTimeoutId = null);
    }
  }]);
}(ye);
var Wr = /*#__PURE__*/function (_xe5) {
  function Wr(e) {
    var _this32;
    _classCallCheck(this, Wr);
    _this32 = _callSuper(this, Wr, [e]), _defineProperty(_assertThisInitialized(_this32), "mutationObserver", void 0), _defineProperty(_assertThisInitialized(_this32), "focusObserver", void 0), _defineProperty(_assertThisInitialized(_this32), "selection", void 0), _defineProperty(_assertThisInitialized(_this32), "domConverter", void 0), _defineProperty(_assertThisInitialized(_this32), "_documents", new WeakSet()), _defineProperty(_assertThisInitialized(_this32), "_fireSelectionChangeDoneDebounced", void 0), _defineProperty(_assertThisInitialized(_this32), "_clearInfiniteLoopInterval", void 0), _defineProperty(_assertThisInitialized(_this32), "_documentIsSelectingInactivityTimeoutDebounced", void 0), _defineProperty(_assertThisInitialized(_this32), "_loopbackCounter", 0), _defineProperty(_assertThisInitialized(_this32), "_pendingSelectionChange", new Set()), _this32.mutationObserver = e.getObserver(rs), _this32.focusObserver = e.getObserver(Dt), _this32.selection = _this32.document.selection, _this32.domConverter = e.domConverter, _this32._fireSelectionChangeDoneDebounced = Mt(function (t) {
      _this32.document.fire("selectionChangeDone", t);
    }, 200), _this32._clearInfiniteLoopInterval = setInterval(function () {
      return _this32._clearInfiniteLoop();
    }, 1e3), _this32._documentIsSelectingInactivityTimeoutDebounced = Mt(function () {
      return _this32.document.isSelecting = !1;
    }, 5e3), _this32.view.document.on("change:isFocused", function (t, n, r) {
      if (r && _this32._pendingSelectionChange.size) {
        for (var _i26 = 0, _Array$from3 = Array.from(_this32._pendingSelectionChange); _i26 < _Array$from3.length; _i26++) {
          var i = _Array$from3[_i26];
          _this32._handleSelectionChange(i);
        }
        _this32._pendingSelectionChange.clear();
      }
    });
    return _this32;
  }
  _inherits(Wr, _xe5);
  return _createClass(Wr, [{
    key: "observe",
    value: function observe(e) {
      var _this33 = this;
      var t = e.ownerDocument,
        n = function n() {
          _this33.document.isSelecting = !0, _this33._documentIsSelectingInactivityTimeoutDebounced();
        },
        r = function r() {
          _this33.document.isSelecting && (_this33._handleSelectionChange(t), _this33.document.isSelecting = !1, _this33._documentIsSelectingInactivityTimeoutDebounced.cancel());
        };
      this.listenTo(e, "selectstart", n, {
        priority: "highest"
      }), this.listenTo(e, "keydown", r, {
        priority: "highest",
        useCapture: !0
      }), this.listenTo(e, "keyup", r, {
        priority: "highest",
        useCapture: !0
      }), !this._documents.has(t) && (this.listenTo(t, "mouseup", r, {
        priority: "highest",
        useCapture: !0
      }), this.listenTo(t, "selectionchange", function () {
        _this33.document.isComposing && !M.isAndroid || (_this33._handleSelectionChange(t), _this33._documentIsSelectingInactivityTimeoutDebounced());
      }), this.listenTo(this.view.document, "compositionstart", function () {
        _this33._handleSelectionChange(t);
      }, {
        priority: "lowest"
      }), this._documents.add(t));
    }
  }, {
    key: "stopObserving",
    value: function stopObserving(e) {
      this.stopListening(e);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Wr, "destroy", this, 3)([]), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
    }
  }, {
    key: "_reportInfiniteLoop",
    value: function _reportInfiniteLoop() {}
  }, {
    key: "_handleSelectionChange",
    value: function _handleSelectionChange(e) {
      if (!this.isEnabled) return;
      var t = e.defaultView.getSelection();
      if (this.checkShouldIgnoreEventFromTarget(t.anchorNode)) return;
      this.mutationObserver.flush();
      var n = this.domConverter.domSelectionToView(t);
      if (n.rangeCount == 0) {
        this.view.hasDomSelection = !1;
        return;
      }
      if (this.view.hasDomSelection = !0, this.focusObserver.flush(), !this.view.document.isFocused && !this.view.document.isReadOnly) {
        this._pendingSelectionChange.add(e);
        return;
      }
      if (this._pendingSelectionChange.delete(e), !(this.selection.isEqual(n) && this.domConverter.isDomSelectionCorrect(t))) {
        if (++this._loopbackCounter > 60) {
          this._reportInfiniteLoop();
          return;
        }
        if (this.selection.isSimilar(n)) this.view.forceRender();else {
          var r = {
            oldSelection: this.selection,
            newSelection: n,
            domSelection: t
          };
          this.document.fire("selectionChange", r), this._fireSelectionChangeDoneDebounced(r);
        }
      }
    }
  }, {
    key: "_clearInfiniteLoop",
    value: function _clearInfiniteLoop() {
      this._loopbackCounter = 0;
    }
  }]);
}(xe);
var qr = /*#__PURE__*/function (_ye4) {
  function qr(e) {
    var _this34;
    _classCallCheck(this, qr);
    _this34 = _callSuper(this, qr, [e]);
    _defineProperty(_this34, "domEventType", ["compositionstart", "compositionupdate", "compositionend"]);
    var t = _this34.document;
    t.on("compositionstart", function () {
      t.isComposing = !0;
    }), t.on("compositionend", function () {
      t.isComposing = !1;
    });
    return _this34;
  }
  _inherits(qr, _ye4);
  return _createClass(qr, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      this.fire(e.type, e, {
        data: e.data
      });
    }
  }]);
}(ye);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
var zr = /*#__PURE__*/function () {
  function zr(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, zr);
    _defineProperty(this, "_files", void 0);
    _defineProperty(this, "_native", void 0);
    this._files = t.cacheFiles ? _n(e) : null, this._native = e;
  }
  return _createClass(zr, [{
    key: "files",
    get: function get() {
      return this._files || (this._files = _n(this._native)), this._files;
    }
  }, {
    key: "types",
    get: function get() {
      return this._native.types;
    }
  }, {
    key: "getData",
    value: function getData(e) {
      return this._native.getData(e);
    }
  }, {
    key: "setData",
    value: function setData(e, t) {
      this._native.setData(e, t);
    }
  }, {
    key: "effectAllowed",
    get: function get() {
      return this._native.effectAllowed;
    },
    set: function set(e) {
      this._native.effectAllowed = e;
    }
  }, {
    key: "dropEffect",
    get: function get() {
      return this._native.dropEffect;
    },
    set: function set(e) {
      this._native.dropEffect = e;
    }
  }, {
    key: "setDragImage",
    value: function setDragImage(e, t, n) {
      this._native.setDragImage(e, t, n);
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this._native.dropEffect == "none" || !!this._native.mozUserCancelled;
    }
  }]);
}();
function _n(s) {
  var e = Array.from(s.files || []),
    t = Array.from(s.items || []);
  return e.length ? e : t.filter(function (n) {
    return n.kind === "file";
  }).map(function (n) {
    return n.getAsFile();
  });
}
var Ur = /*#__PURE__*/function (_ye5) {
  function Ur() {
    var _this35;
    _classCallCheck(this, Ur);
    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }
    _this35 = _callSuper(this, Ur, [].concat(args));
    _defineProperty(_this35, "domEventType", "beforeinput");
    return _this35;
  }
  _inherits(Ur, _ye5);
  return _createClass(Ur, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      var t = e.getTargetRanges(),
        n = this.view,
        r = n.document;
      var i = null,
        o = null,
        a = [];
      if (e.dataTransfer && (i = new zr(e.dataTransfer)), e.data !== null ? o = e.data : i && (o = i.getData("text/plain")), r.selection.isFake) a = Array.from(r.selection.getRanges()), e.preventDefault();else if (t.length) a = t.map(function (l) {
        var c = n.domConverter.domPositionToView(l.startContainer, l.startOffset);
        var h = n.domConverter.domPositionToView(l.endContainer, l.endOffset);
        if (c && D(l.startContainer) && l.startOffset < L) {
          e.preventDefault();
          var d = L - l.startOffset;
          c = c.getLastMatchingPosition(function (p) {
            return !!(p.item.is("attributeElement") || p.item.is("uiElement") || p.item.is("$textProxy") && d--);
          }, {
            direction: "backward",
            singleCharacters: !0
          });
        }
        if (Jr(l.endContainer, l.endOffset) && e.preventDefault(), c) return n.createRange(c, h);
        if (h) return n.createRange(h);
      }).filter(function (l) {
        return !!l;
      });else if (M.isAndroid) {
        var l = e.target.ownerDocument.defaultView.getSelection();
        a = Array.from(n.domConverter.domSelectionToView(l).getRanges());
      }
      if (M.isAndroid && e.inputType == "insertCompositionText" && o && o.endsWith("\n")) {
        this.fire(e.type, e, {
          inputType: "insertParagraph",
          targetRanges: [n.createRange(a[0].end)]
        });
        return;
      }
      if (["insertText", "insertReplacementText"].includes(e.inputType) && o && o.includes("\n")) {
        var _l5 = o.split(/\n{1,2}/g);
        var c = a;
        e.preventDefault();
        for (var h = 0; h < _l5.length; h++) {
          var d = _l5[h];
          d != "" && (this.fire(e.type, e, {
            data: d,
            dataTransfer: i,
            targetRanges: c,
            inputType: e.inputType,
            isComposing: e.isComposing
          }), c = [r.selection.getFirstRange()]), h + 1 < _l5.length && (this.fire(e.type, e, {
            inputType: "insertParagraph",
            targetRanges: c
          }), c = [r.selection.getFirstRange()]);
        }
        return;
      }
      this.fire(e.type, e, {
        data: o,
        dataTransfer: i,
        targetRanges: a,
        inputType: e.inputType,
        isComposing: e.isComposing
      });
    }
  }]);
}(ye);
function Jr(s, e) {
  for (; s.parentNode;) {
    if (E(s)) {
      if (e != s.data.length) return !1;
    } else if (e != s.childNodes.length) return !1;
    if (e = Ee(s) + 1, s = s.parentNode, e < s.childNodes.length && D(s.childNodes[e])) return !0;
  }
  return !1;
}
var jr = /*#__PURE__*/function (_xe6) {
  function jr(e) {
    var _this36;
    _classCallCheck(this, jr);
    _this36 = _callSuper(this, jr, [e]), _this36.document.on("keydown", function (t, n) {
      if (_this36.isEnabled && Ws(n.keyCode)) {
        var r = new Ut(_this36.document, "arrowKey", _this36.document.selection.getFirstRange());
        _this36.document.fire(r, n), r.stop.called && t.stop();
      }
    });
    return _this36;
  }
  _inherits(jr, _xe6);
  return _createClass(jr, [{
    key: "observe",
    value: function observe() {}
  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }]);
}(xe);
var Gr = /*#__PURE__*/function (_xe7) {
  function Gr(e) {
    var _this37;
    _classCallCheck(this, Gr);
    _this37 = _callSuper(this, Gr, [e]);
    var t = _this37.document;
    t.on("keydown", function (n, r) {
      if (!_this37.isEnabled || r.keyCode != de.tab || r.ctrlKey) return;
      var i = new Ut(t, "tab", t.selection.getFirstRange());
      t.fire(i, r), i.stop.called && n.stop();
    });
    return _this37;
  }
  _inherits(Gr, _xe7);
  return _createClass(Gr, [{
    key: "observe",
    value: function observe() {}
  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }]);
}(xe);
var Hr = /*#__PURE__*/function (_U3) {
  function Hr(e) {
    var _this38;
    _classCallCheck(this, Hr);
    _this38 = _callSuper(this, Hr), _defineProperty(_assertThisInitialized(_this38), "document", void 0), _defineProperty(_assertThisInitialized(_this38), "domConverter", void 0), _defineProperty(_assertThisInitialized(_this38), "domRoots", new Map()), _defineProperty(_assertThisInitialized(_this38), "_renderer", void 0), _defineProperty(_assertThisInitialized(_this38), "_initialDomRootAttributes", new WeakMap()), _defineProperty(_assertThisInitialized(_this38), "_observers", new Map()), _defineProperty(_assertThisInitialized(_this38), "_writer", void 0), _defineProperty(_assertThisInitialized(_this38), "_ongoingChange", !1), _defineProperty(_assertThisInitialized(_this38), "_postFixersInProgress", !1), _defineProperty(_assertThisInitialized(_this38), "_renderingDisabled", !1), _defineProperty(_assertThisInitialized(_this38), "_hasChangedSinceTheLastRendering", !1), _this38.document = new Xn(e), _this38.domConverter = new ns(_this38.document), _this38.set("isRenderingInProgress", !1), _this38.set("hasDomSelection", !1), _this38._renderer = new vr(_this38.domConverter, _this38.document.selection), _this38._renderer.bind("isFocused", "isSelecting", "isComposing").to(_this38.document, "isFocused", "isSelecting", "isComposing"), _this38._writer = new Yn(_this38.document), _this38.addObserver(rs), _this38.addObserver(Dt), _this38.addObserver(Wr), _this38.addObserver(Vr), _this38.addObserver($r), _this38.addObserver(qr), _this38.addObserver(jr), _this38.addObserver(Ur), _this38.addObserver(Gr), br(_assertThisInitialized(_this38)), ur(_assertThisInitialized(_this38)), _this38.on("render", function () {
      _this38._render(), _this38.document.fire("layoutChanged"), _this38._hasChangedSinceTheLastRendering = !1;
    }), _this38.listenTo(_this38.document.selection, "change", function () {
      _this38._hasChangedSinceTheLastRendering = !0;
    }), _this38.listenTo(_this38.document, "change:isFocused", function () {
      _this38._hasChangedSinceTheLastRendering = !0;
    }), M.isiOS && _this38.listenTo(_this38.document, "blur", function (t, n) {
      _this38.domConverter.mapDomToView(n.domEvent.relatedTarget) || _this38.domConverter._clearDomSelection();
    }), _this38.listenTo(_this38.document, "mutations", function (t, _ref53) {
      var n = _ref53.mutations;
      n.forEach(function (r) {
        return _this38._renderer.markToSync(r.type, r.node);
      });
    }, {
      priority: "low"
    }), _this38.listenTo(_this38.document, "mutations", function () {
      _this38.forceRender();
    }, {
      priority: "lowest"
    });
    return _this38;
  }
  _inherits(Hr, _U3);
  return _createClass(Hr, [{
    key: "attachDomRoot",
    value: function attachDomRoot(e) {
      var _this39 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
      var n = this.document.getRoot(t);
      n._name = e.tagName.toLowerCase();
      var r = {};
      for (var _i27 = 0, _Array$from4 = Array.from(e.attributes); _i27 < _Array$from4.length; _i27++) {
        var _ref54 = _Array$from4[_i27];
        var o = _ref54.name;
        var a = _ref54.value;
        r[o] = a, o === "class" ? this._writer.addClass(a.split(" "), n) : n.hasAttribute(o) || this._writer.setAttribute(o, a, n);
      }
      this._initialDomRootAttributes.set(e, r);
      var i = function i() {
        _this39._writer.setAttribute("contenteditable", (!n.isReadOnly).toString(), n), n.isReadOnly ? _this39._writer.addClass("ck-read-only", n) : _this39._writer.removeClass("ck-read-only", n);
      };
      i(), this.domRoots.set(t, e), this.domConverter.bindElements(e, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(e.ownerDocument), n.on("change:children", function (o, a) {
        return _this39._renderer.markToSync("children", a);
      }), n.on("change:attributes", function (o, a) {
        return _this39._renderer.markToSync("attributes", a);
      }), n.on("change:text", function (o, a) {
        return _this39._renderer.markToSync("text", a);
      }), n.on("change:isReadOnly", function () {
        return _this39.change(i);
      }), n.on("change", function () {
        _this39._hasChangedSinceTheLastRendering = !0;
      });
      var _iterator108 = _createForOfIteratorHelper(this._observers.values()),
        _step108;
      try {
        for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
          var _o11 = _step108.value;
          _o11.observe(e, t);
        }
      } catch (err) {
        _iterator108.e(err);
      } finally {
        _iterator108.f();
      }
    }
  }, {
    key: "detachDomRoot",
    value: function detachDomRoot(e) {
      var t = this.domRoots.get(e);
      Array.from(t.attributes).forEach(function (_ref55) {
        var r = _ref55.name;
        return t.removeAttribute(r);
      });
      var n = this._initialDomRootAttributes.get(t);
      for (var r in n) t.setAttribute(r, n[r]);
      this.domRoots.delete(e), this.domConverter.unbindDomElement(t);
      var _iterator109 = _createForOfIteratorHelper(this._observers.values()),
        _step109;
      try {
        for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
          var _r0 = _step109.value;
          _r0.stopObserving(t);
        }
      } catch (err) {
        _iterator109.e(err);
      } finally {
        _iterator109.f();
      }
    }
  }, {
    key: "getDomRoot",
    value: function getDomRoot() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
      return this.domRoots.get(e);
    }
  }, {
    key: "addObserver",
    value: function addObserver(e) {
      var t = this._observers.get(e);
      if (t) return t;
      t = new e(this), this._observers.set(e, t);
      var _iterator110 = _createForOfIteratorHelper(this.domRoots),
        _step110;
      try {
        for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
          var _ref56 = _step110.value;
          var _ref57 = _slicedToArray(_ref56, 2);
          var n = _ref57[0];
          var r = _ref57[1];
          t.observe(r, n);
        }
      } catch (err) {
        _iterator110.e(err);
      } finally {
        _iterator110.f();
      }
      return t.enable(), t;
    }
  }, {
    key: "getObserver",
    value: function getObserver(e) {
      return this._observers.get(e);
    }
  }, {
    key: "disableObservers",
    value: function disableObservers() {
      var _iterator111 = _createForOfIteratorHelper(this._observers.values()),
        _step111;
      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var e = _step111.value;
          e.disable();
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
    }
  }, {
    key: "enableObservers",
    value: function enableObservers() {
      var _iterator112 = _createForOfIteratorHelper(this._observers.values()),
        _step112;
      try {
        for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
          var e = _step112.value;
          e.enable();
        }
      } catch (err) {
        _iterator112.e(err);
      } finally {
        _iterator112.f();
      }
    }
  }, {
    key: "scrollToTheSelection",
    value: function scrollToTheSelection() {
      var _ref58 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        e = _ref58.alignToTop,
        t = _ref58.forceScroll,
        _ref58$viewportOffset = _ref58.viewportOffset,
        n = _ref58$viewportOffset === void 0 ? 20 : _ref58$viewportOffset,
        _ref58$ancestorOffset = _ref58.ancestorOffset,
        r = _ref58$ancestorOffset === void 0 ? 20 : _ref58$ancestorOffset;
      var i = this.document.selection.getFirstRange();
      if (!i) return;
      var o = ce({
        alignToTop: e,
        forceScroll: t,
        viewportOffset: n,
        ancestorOffset: r
      });
      typeof n == "number" && (n = {
        top: n,
        bottom: n,
        left: n,
        right: n
      });
      var a = {
        target: this.domConverter.viewRangeToDom(i),
        viewportOffset: n,
        ancestorOffset: r,
        alignToTop: e,
        forceScroll: t
      };
      this.fire("scrollToTheSelection", a, o), $s(a);
    }
  }, {
    key: "focus",
    value: function focus() {
      if (!this.document.isFocused) {
        var e = this.document.selection.editableElement;
        e && (this.domConverter.focus(e), this.forceRender());
      }
    }
  }, {
    key: "change",
    value: function change(e) {
      if (this.isRenderingInProgress || this._postFixersInProgress) throw new f("cannot-change-view-tree", this);
      try {
        if (this._ongoingChange) return e(this._writer);
        this._ongoingChange = !0;
        var t = e(this._writer);
        return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), t;
      } catch (t) {
        /* istanbul ignore next -- @preserve */f.rethrowUnexpectedError(t, this);
      }
    }
  }, {
    key: "forceRender",
    value: function forceRender() {
      this._hasChangedSinceTheLastRendering = !0, this.getObserver(Dt).flush(), this.change(function () {});
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator113 = _createForOfIteratorHelper(this._observers.values()),
        _step113;
      try {
        for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
          var e = _step113.value;
          e.destroy();
        }
      } catch (err) {
        _iterator113.e(err);
      } finally {
        _iterator113.f();
      }
      this.document.destroy(), this.stopListening();
    }
  }, {
    key: "createPositionAt",
    value: function createPositionAt(e, t) {
      return g._createAt(e, t);
    }
  }, {
    key: "createPositionAfter",
    value: function createPositionAfter(e) {
      return g._createAfter(e);
    }
  }, {
    key: "createPositionBefore",
    value: function createPositionBefore(e) {
      return g._createBefore(e);
    }
  }, {
    key: "createRange",
    value: function createRange(e, t) {
      return new w(e, t);
    }
  }, {
    key: "createRangeOn",
    value: function createRangeOn(e) {
      return w._createOn(e);
    }
  }, {
    key: "createRangeIn",
    value: function createRangeIn(e) {
      return w._createIn(e);
    }
  }, {
    key: "createSelection",
    value: function createSelection() {
      for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        e[_key12] = arguments[_key12];
      }
      return _construct(Z, e);
    }
  }, {
    key: "_disableRendering",
    value: function _disableRendering(e) {
      this._renderingDisabled = e, e == !1 && this.change(function () {});
    }
  }, {
    key: "_render",
    value: function _render() {
      this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
    }
  }]);
}(U());
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
var he = /*#__PURE__*/function () {
  function he() {
    _classCallCheck(this, he);
  }
  return _createClass(he, [{
    key: "is",
    value: function is() {
      throw new Error("is() method is abstract");
    }
  }]);
}();
var j = /*#__PURE__*/function (_he) {
  function j(e, t, n) {
    var _this40;
    _classCallCheck(this, j);
    if (_this40 = _callSuper(this, j), _defineProperty(_assertThisInitialized(_this40), "textNode", void 0), _defineProperty(_assertThisInitialized(_this40), "data", void 0), _defineProperty(_assertThisInitialized(_this40), "offsetInText", void 0), _this40.textNode = e, t < 0 || t > e.offsetSize) throw new f("model-textproxy-wrong-offsetintext", _assertThisInitialized(_this40));
    if (n < 0 || t + n > e.offsetSize) throw new f("model-textproxy-wrong-length", _assertThisInitialized(_this40));
    _this40.data = e.data.substring(t, t + n), _this40.offsetInText = t;
    return _assertThisInitialized(_this40);
  }
  _inherits(j, _he);
  return _createClass(j, [{
    key: "startOffset",
    get: function get() {
      return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null;
    }
  }, {
    key: "offsetSize",
    get: function get() {
      return this.data.length;
    }
  }, {
    key: "endOffset",
    get: function get() {
      return this.startOffset !== null ? this.startOffset + this.offsetSize : null;
    }
  }, {
    key: "isPartial",
    get: function get() {
      return this.offsetSize !== this.textNode.offsetSize;
    }
  }, {
    key: "parent",
    get: function get() {
      return this.textNode.parent;
    }
  }, {
    key: "root",
    get: function get() {
      return this.textNode.root;
    }
  }, {
    key: "getPath",
    value: function getPath() {
      var e = this.textNode.getPath();
      return e.length > 0 && (e[e.length - 1] += this.offsetInText), e;
    }
  }, {
    key: "getAncestors",
    value: function getAncestors() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = [];
      var n = e.includeSelf ? this : this.parent;
      for (; n;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
      return t;
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(e) {
      return this.textNode.hasAttribute(e);
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(e) {
      return this.textNode.getAttribute(e);
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this.textNode.getAttributes();
    }
  }, {
    key: "getAttributeKeys",
    value: function getAttributeKeys() {
      return this.textNode.getAttributeKeys();
    }
  }]);
}(he);
j.prototype.is = function (s) {
  return s === "$textProxy" || s === "model:$textProxy" || s === "textProxy" || s === "model:textProxy";
};
var ie = /*#__PURE__*/function () {
  function ie(e) {
    _classCallCheck(this, ie);
    _defineProperty(this, "direction", void 0);
    _defineProperty(this, "boundaries", void 0);
    _defineProperty(this, "singleCharacters", void 0);
    _defineProperty(this, "shallow", void 0);
    _defineProperty(this, "ignoreElementEnd", void 0);
    _defineProperty(this, "_position", void 0);
    _defineProperty(this, "_boundaryStartParent", void 0);
    _defineProperty(this, "_boundaryEndParent", void 0);
    _defineProperty(this, "_visitedParent", void 0);
    if (!e || !e.boundaries && !e.startPosition) throw new f("model-tree-walker-no-start-position", null);
    var t = e.direction || "forward";
    if (t != "forward" && t != "backward") throw new f("model-tree-walker-unknown-direction", e, {
      direction: t
    });
    this.direction = t, this.boundaries = e.boundaries || null, e.startPosition ? this._position = e.startPosition.clone() : this._position = m._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
  }
  return _createClass(ie, [{
    key: Symbol.iterator,
    value: function value() {
      return this;
    }
  }, {
    key: "position",
    get: function get() {
      return this._position;
    }
  }, {
    key: "skip",
    value: function skip(e) {
      var t, n, r, i;
      do {
        var _this$next;
        r = this.position, i = this._visitedParent, _this$next = this.next(), t = _this$next.done, n = _this$next.value, _this$next;
      } while (!t && e(n));
      t || (this._position = r, this._visitedParent = i);
    }
  }, {
    key: "jumpTo",
    value: function jumpTo(e) {
      this._boundaryStartParent && e.isBefore(this.boundaries.start) ? e = this.boundaries.start : this._boundaryEndParent && e.isAfter(this.boundaries.end) && (e = this.boundaries.end), this._position = e.clone(), this._visitedParent = e.parent;
    }
  }, {
    key: "next",
    value: function next() {
      return this.direction == "forward" ? this._next() : this._previous();
    }
  }, {
    key: "_next",
    value: function _next() {
      var e = this.position,
        t = this.position.clone(),
        n = this._visitedParent;
      if (n.parent === null && t.offset === n.maxOffset) return {
        done: !0,
        value: void 0
      };
      if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
        done: !0,
        value: void 0
      };
      var r = qe(t, n),
        i = r || is(t, n, r);
      if (i && i.is("model:element")) {
        if (!this.shallow) t.path.push(0), this._visitedParent = i;else {
          if (this.boundaries && this.boundaries.end.isBefore(t)) return {
            done: !0,
            value: void 0
          };
          t.offset++;
        }
        return this._position = t, fe("elementStart", i, e, t, 1);
      }
      if (i && i.is("model:$text")) {
        var o;
        if (this.singleCharacters) o = 1;else {
          var c = i.endOffset;
          this._boundaryEndParent == n && this.boundaries.end.offset < c && (c = this.boundaries.end.offset), o = c - t.offset;
        }
        var a = t.offset - i.startOffset,
          l = new j(i, a, o);
        return t.offset += o, this._position = t, fe("text", l, e, t, o);
      }
      return t.path.pop(), t.offset++, this._position = t, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : fe("elementEnd", n, e, t);
    }
  }, {
    key: "_previous",
    value: function _previous() {
      var e = this.position,
        t = this.position.clone(),
        n = this._visitedParent;
      if (n.parent === null && t.offset === 0) return {
        done: !0,
        value: void 0
      };
      if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
        done: !0,
        value: void 0
      };
      var r = t.parent,
        i = qe(t, r),
        o = i || os(t, r, i);
      if (o && o.is("model:element")) return t.offset--, this.shallow ? (this._position = t, fe("elementStart", o, e, t, 1)) : (t.path.push(o.maxOffset), this._position = t, this._visitedParent = o, this.ignoreElementEnd ? this._previous() : fe("elementEnd", o, e, t));
      if (o && o.is("model:$text")) {
        var a;
        if (this.singleCharacters) a = 1;else {
          var h = o.startOffset;
          this._boundaryStartParent == n && this.boundaries.start.offset > h && (h = this.boundaries.start.offset), a = t.offset - h;
        }
        var l = t.offset - o.startOffset,
          c = new j(o, l - a, a);
        return t.offset -= a, this._position = t, fe("text", c, e, t, a);
      }
      return t.path.pop(), this._position = t, this._visitedParent = n.parent, fe("elementStart", n, e, t, 1);
    }
  }]);
}();
function fe(s, e, t, n, r) {
  return {
    done: !1,
    value: {
      type: s,
      item: e,
      previousPosition: t,
      nextPosition: n,
      length: r
    }
  };
}
var m = /*#__PURE__*/function (_he2) {
  function m(e, t) {
    var _this41;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
    _classCallCheck(this, m);
    if (_this41 = _callSuper(this, m), _defineProperty(_assertThisInitialized(_this41), "root", void 0), _defineProperty(_assertThisInitialized(_this41), "path", void 0), _defineProperty(_assertThisInitialized(_this41), "stickiness", void 0), !e.is("element") && !e.is("documentFragment")) throw new f("model-position-root-invalid", e);
    if (!Array.isArray(t) || t.length === 0) throw new f("model-position-path-incorrect-format", e, {
      path: t
    });
    e.is("rootElement") ? t = t.slice() : (t = [].concat(_toConsumableArray(e.getPath()), _toConsumableArray(t)), e = e.root), _this41.root = e, _this41.path = t, _this41.stickiness = n;
    return _assertThisInitialized(_this41);
  }
  _inherits(m, _he2);
  return _createClass(m, [{
    key: "offset",
    get: function get() {
      return this.path[this.path.length - 1];
    },
    set: function set(e) {
      this.path[this.path.length - 1] = e;
    }
  }, {
    key: "parent",
    get: function get() {
      var e = this.root;
      for (var t = 0; t < this.path.length - 1; t++) if (e = e.getChildAtOffset(this.path[t]), !e) throw new f("model-position-path-incorrect", this, {
        position: this
      });
      if (e.is("$text")) throw new f("model-position-path-incorrect", this, {
        position: this
      });
      return e;
    }
  }, {
    key: "index",
    get: function get() {
      return this.parent.offsetToIndex(this.offset);
    }
  }, {
    key: "textNode",
    get: function get() {
      return qe(this, this.parent);
    }
  }, {
    key: "nodeAfter",
    get: function get() {
      var e = this.parent;
      return is(this, e, qe(this, e));
    }
  }, {
    key: "nodeBefore",
    get: function get() {
      var e = this.parent;
      return os(this, e, qe(this, e));
    }
  }, {
    key: "isAtStart",
    get: function get() {
      return this.offset === 0;
    }
  }, {
    key: "isAtEnd",
    get: function get() {
      return this.offset == this.parent.maxOffset;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (this.offset < 0) return !1;
      var e = this.root;
      for (var t = 0; t < this.path.length - 1; t++) if (e = e.getChildAtOffset(this.path[t]), !e) return !1;
      return this.offset <= e.maxOffset;
    }
  }, {
    key: "compareWith",
    value: function compareWith(e) {
      if (this.root != e.root) return "different";
      var t = F(this.path, e.path);
      switch (t) {
        case "same":
          return "same";
        case "prefix":
          return "before";
        case "extension":
          return "after";
        default:
          return this.path[t] < e.path[t] ? "before" : "after";
      }
    }
  }, {
    key: "getLastMatchingPosition",
    value: function getLastMatchingPosition(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      t.startPosition = this;
      var n = new ie(t);
      return n.skip(e), n.position;
    }
  }, {
    key: "getParentPath",
    value: function getParentPath() {
      return this.path.slice(0, -1);
    }
  }, {
    key: "getAncestors",
    value: function getAncestors() {
      var e = this.parent;
      return e.is("documentFragment") ? [e] : e.getAncestors({
        includeSelf: !0
      });
    }
  }, {
    key: "findAncestor",
    value: function findAncestor(e) {
      var t = this.parent;
      return t.is("element") ? t.findAncestor(e, {
        includeSelf: !0
      }) : null;
    }
  }, {
    key: "getCommonPath",
    value: function getCommonPath(e) {
      if (this.root != e.root) return [];
      var t = F(this.path, e.path),
        n = typeof t == "string" ? Math.min(this.path.length, e.path.length) : t;
      return this.path.slice(0, n);
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(e) {
      var t = this.getAncestors(),
        n = e.getAncestors();
      var r = 0;
      for (; t[r] == n[r] && t[r];) r++;
      return r === 0 ? null : t[r - 1];
    }
  }, {
    key: "getShiftedBy",
    value: function getShiftedBy(e) {
      var t = this.clone(),
        n = t.offset + e;
      return t.offset = n < 0 ? 0 : n, t;
    }
  }, {
    key: "isAfter",
    value: function isAfter(e) {
      return this.compareWith(e) == "after";
    }
  }, {
    key: "isBefore",
    value: function isBefore(e) {
      return this.compareWith(e) == "before";
    }
  }, {
    key: "isEqual",
    value: function isEqual(e) {
      return this.compareWith(e) == "same";
    }
  }, {
    key: "isTouching",
    value: function isTouching(e) {
      if (this.root !== e.root) return !1;
      var t = Math.min(this.path.length, e.path.length);
      for (var n = 0; n < t; n++) {
        var r = this.path[n] - e.path[n];
        if (r < -1 || r > 1) return !1;
        if (r === 1) return wn(e, this, n);
        if (r === -1) return wn(this, e, n);
      }
      return this.path.length === e.path.length ? !0 : this.path.length > e.path.length ? Bt(this.path, t) : Bt(e.path, t);
    }
  }, {
    key: "hasSameParentAs",
    value: function hasSameParentAs(e) {
      if (this.root !== e.root) return !1;
      var t = this.getParentPath(),
        n = e.getParentPath();
      return F(t, n) == "same";
    }
  }, {
    key: "getTransformedByOperation",
    value: function getTransformedByOperation(e) {
      var t;
      switch (e.type) {
        case "insert":
          t = this._getTransformedByInsertOperation(e);
          break;
        case "move":
        case "remove":
        case "reinsert":
          t = this._getTransformedByMoveOperation(e);
          break;
        case "split":
          t = this._getTransformedBySplitOperation(e);
          break;
        case "merge":
          t = this._getTransformedByMergeOperation(e);
          break;
        default:
          t = m._createAt(this);
          break;
      }
      return t;
    }
  }, {
    key: "_getTransformedByInsertOperation",
    value: function _getTransformedByInsertOperation(e) {
      return this._getTransformedByInsertion(e.position, e.howMany);
    }
  }, {
    key: "_getTransformedByMoveOperation",
    value: function _getTransformedByMoveOperation(e) {
      return this._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
    }
  }, {
    key: "_getTransformedBySplitOperation",
    value: function _getTransformedBySplitOperation(e) {
      var t = e.movedRange;
      return t.containsPosition(this) || t.start.isEqual(this) && this.stickiness == "toNext" ? this._getCombined(e.splitPosition, e.moveTargetPosition) : e.graveyardPosition ? this._getTransformedByMove(e.graveyardPosition, e.insertionPosition, 1) : this._getTransformedByInsertion(e.insertionPosition, 1);
    }
  }, {
    key: "_getTransformedByMergeOperation",
    value: function _getTransformedByMergeOperation(e) {
      var t = e.movedRange,
        n = t.containsPosition(this) || t.start.isEqual(this);
      var r;
      return n ? (r = this._getCombined(e.sourcePosition, e.targetPosition), e.sourcePosition.isBefore(e.targetPosition) && (r = r._getTransformedByDeletion(e.deletionPosition, 1))) : this.isEqual(e.deletionPosition) ? r = m._createAt(e.deletionPosition) : r = this._getTransformedByMove(e.deletionPosition, e.graveyardPosition, 1), r;
    }
  }, {
    key: "_getTransformedByDeletion",
    value: function _getTransformedByDeletion(e, t) {
      var n = m._createAt(this);
      if (this.root != e.root) return n;
      if (F(e.getParentPath(), this.getParentPath()) == "same") {
        if (e.offset < this.offset) {
          if (e.offset + t > this.offset) return null;
          n.offset -= t;
        }
      } else if (F(e.getParentPath(), this.getParentPath()) == "prefix") {
        var r = e.path.length - 1;
        if (e.offset <= this.path[r]) {
          if (e.offset + t > this.path[r]) return null;
          n.path[r] -= t;
        }
      }
      return n;
    }
  }, {
    key: "_getTransformedByInsertion",
    value: function _getTransformedByInsertion(e, t) {
      var n = m._createAt(this);
      if (this.root != e.root) return n;
      if (F(e.getParentPath(), this.getParentPath()) == "same") (e.offset < this.offset || e.offset == this.offset && this.stickiness != "toPrevious") && (n.offset += t);else if (F(e.getParentPath(), this.getParentPath()) == "prefix") {
        var r = e.path.length - 1;
        e.offset <= this.path[r] && (n.path[r] += t);
      }
      return n;
    }
  }, {
    key: "_getTransformedByMove",
    value: function _getTransformedByMove(e, t, n) {
      if (t = t._getTransformedByDeletion(e, n), e.isEqual(t)) return m._createAt(this);
      var r = this._getTransformedByDeletion(e, n);
      return r === null || e.isEqual(this) && this.stickiness == "toNext" || e.getShiftedBy(n).isEqual(this) && this.stickiness == "toPrevious" ? this._getCombined(e, t) : r._getTransformedByInsertion(t, n);
    }
  }, {
    key: "_getCombined",
    value: function _getCombined(e, t) {
      var n = e.path.length - 1,
        r = m._createAt(t);
      return r.stickiness = this.stickiness, r.offset = r.offset + this.path[n] - e.offset, r.path = [].concat(_toConsumableArray(r.path), _toConsumableArray(this.path.slice(n + 1))), r;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        root: this.root.toJSON(),
        path: Array.from(this.path),
        stickiness: this.stickiness
      };
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.root, this.path, this.stickiness);
    }
  }], [{
    key: "_createAt",
    value: function _createAt(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
      if (e.is("model:position")) return new m(e.root, e.path, e.stickiness);
      {
        var r = e;
        if (t == "end") t = r.maxOffset;else {
          if (t == "before") return this._createBefore(r, n);
          if (t == "after") return this._createAfter(r, n);
          if (t !== 0 && !t) throw new f("model-createpositionat-offset-required", [this, e]);
        }
        if (!r.is("element") && !r.is("documentFragment")) throw new f("model-position-parent-incorrect", [this, e]);
        var i = r.getPath();
        return i.push(t), new this(r.root, i, n);
      }
    }
  }, {
    key: "_createAfter",
    value: function _createAfter(e, t) {
      if (!e.parent) throw new f("model-position-after-root", [this, e], {
        root: e
      });
      return this._createAt(e.parent, e.endOffset, t);
    }
  }, {
    key: "_createBefore",
    value: function _createBefore(e, t) {
      if (!e.parent) throw new f("model-position-before-root", e, {
        root: e
      });
      return this._createAt(e.parent, e.startOffset, t);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      if (e.root === "$graveyard") {
        var n = new m(t.graveyard, e.path);
        return n.stickiness = e.stickiness, n;
      }
      if (!t.getRoot(e.root)) throw new f("model-position-fromjson-no-root", t, {
        rootName: e.root
      });
      return new m(t.getRoot(e.root), e.path, e.stickiness);
    }
  }]);
}(he);
m.prototype.is = function (s) {
  return s === "position" || s === "model:position";
};
function qe(s, e) {
  var t = e.getChildAtOffset(s.offset);
  return t && t.is("$text") && t.startOffset < s.offset ? t : null;
}
function is(s, e, t) {
  return t !== null ? null : e.getChildAtOffset(s.offset);
}
function os(s, e, t) {
  return t !== null ? null : e.getChild(e.offsetToIndex(s.offset) - 1);
}
function wn(s, e, t) {
  return !(t + 1 === s.path.length || !Bt(e.path, t + 1) || !Kr(s, t + 1));
}
function Bt(s, e) {
  for (; e < s.length;) {
    if (s[e] !== 0) return !1;
    e++;
  }
  return !0;
}
function Kr(s, e) {
  var t = s.parent,
    n = s.path.length - 1,
    r = 0;
  for (; n >= e;) {
    if (s.path[n] + r !== t.maxOffset) return !1;
    r = 1, n--, t = t.parent;
  }
  return !0;
}
var u = /*#__PURE__*/function (_he3) {
  function u(e, t) {
    var _this42;
    _classCallCheck(this, u);
    _this42 = _callSuper(this, u), _defineProperty(_assertThisInitialized(_this42), "start", void 0), _defineProperty(_assertThisInitialized(_this42), "end", void 0), _this42.start = m._createAt(e), _this42.end = t ? m._createAt(t) : m._createAt(e), _this42.start.stickiness = _this42.isCollapsed ? "toNone" : "toNext", _this42.end.stickiness = _this42.isCollapsed ? "toNone" : "toPrevious";
    return _this42;
  }
  _inherits(u, _he3);
  return _createClass(u, [{
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      return _regeneratorRuntime().wrap(function value$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.delegateYield(new ie({
              boundaries: this,
              ignoreElementEnd: !0
            }), "t0", 1);
          case 1:
          case "end":
            return _context11.stop();
        }
      }, value, this);
    })
  }, {
    key: "isCollapsed",
    get: function get() {
      return this.start.isEqual(this.end);
    }
  }, {
    key: "isFlat",
    get: function get() {
      var e = this.start.getParentPath(),
        t = this.end.getParentPath();
      return F(e, t) == "same";
    }
  }, {
    key: "root",
    get: function get() {
      return this.start.root;
    }
  }, {
    key: "containsPosition",
    value: function containsPosition(e) {
      return e.isAfter(this.start) && e.isBefore(this.end);
    }
  }, {
    key: "containsRange",
    value: function containsRange(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      e.isCollapsed && (t = !1);
      var n = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
        r = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
      return n && r;
    }
  }, {
    key: "containsItem",
    value: function containsItem(e) {
      var t = m._createBefore(e);
      return this.containsPosition(t) || this.start.isEqual(t);
    }
  }, {
    key: "isEqual",
    value: function isEqual(e) {
      return this.start.isEqual(e.start) && this.end.isEqual(e.end);
    }
  }, {
    key: "isIntersecting",
    value: function isIntersecting(e) {
      return this.start.isBefore(e.end) && this.end.isAfter(e.start);
    }
  }, {
    key: "getDifference",
    value: function getDifference(e) {
      var t = [];
      return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new u(this.start, e.start)), this.containsPosition(e.end) && t.push(new u(e.end, this.end))) : t.push(new u(this.start, this.end)), t;
    }
  }, {
    key: "getIntersection",
    value: function getIntersection(e) {
      if (this.isIntersecting(e)) {
        var t = this.start,
          n = this.end;
        return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new u(t, n);
      }
      return null;
    }
  }, {
    key: "getJoined",
    value: function getJoined(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = this.isIntersecting(e);
      if (n || (this.start.isBefore(e.start) ? n = t ? this.end.isTouching(e.start) : this.end.isEqual(e.start) : n = t ? e.end.isTouching(this.start) : e.end.isEqual(this.start)), !n) return null;
      var r = this.start,
        i = this.end;
      return e.start.isBefore(r) && (r = e.start), e.end.isAfter(i) && (i = e.end), new u(r, i);
    }
  }, {
    key: "getMinimalFlatRanges",
    value: function getMinimalFlatRanges() {
      var e = [],
        t = this.start.getCommonPath(this.end).length,
        n = m._createAt(this.start);
      var r = n.parent;
      for (; n.path.length > t + 1;) {
        var i = r.maxOffset - n.offset;
        i !== 0 && e.push(new u(n, n.getShiftedBy(i))), n.path = n.path.slice(0, -1), n.offset++, r = r.parent;
      }
      for (; n.path.length <= this.end.path.length;) {
        var _i28 = this.end.path[n.path.length - 1],
          o = _i28 - n.offset;
        o !== 0 && e.push(new u(n, n.getShiftedBy(o))), n.offset = _i28, n.path.push(0);
      }
      return e;
    }
  }, {
    key: "getWalker",
    value: function getWalker() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return e.boundaries = this, new ie(e);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this43 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var t, _iterator114, _step114, n;
        return _regeneratorRuntime().wrap(function _callee5$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              e.boundaries = _this43, e.ignoreElementEnd = !0;
              t = new ie(e);
              _iterator114 = _createForOfIteratorHelper(t);
              _context12.prev = 3;
              _iterator114.s();
            case 5:
              if ((_step114 = _iterator114.n()).done) {
                _context12.next = 11;
                break;
              }
              n = _step114.value;
              _context12.next = 9;
              return n.item;
            case 9:
              _context12.next = 5;
              break;
            case 11:
              _context12.next = 16;
              break;
            case 13:
              _context12.prev = 13;
              _context12.t0 = _context12["catch"](3);
              _iterator114.e(_context12.t0);
            case 16:
              _context12.prev = 16;
              _iterator114.f();
              return _context12.finish(16);
            case 19:
            case "end":
              return _context12.stop();
          }
        }, _callee5, null, [[3, 13, 16, 19]]);
      })();
    }
  }, {
    key: "getPositions",
    value: function getPositions() {
      var _this44 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var t, _iterator115, _step115, n;
        return _regeneratorRuntime().wrap(function _callee6$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              e.boundaries = _this44;
              t = new ie(e);
              _context13.next = 4;
              return t.position;
            case 4:
              _iterator115 = _createForOfIteratorHelper(t);
              _context13.prev = 5;
              _iterator115.s();
            case 7:
              if ((_step115 = _iterator115.n()).done) {
                _context13.next = 13;
                break;
              }
              n = _step115.value;
              _context13.next = 11;
              return n.nextPosition;
            case 11:
              _context13.next = 7;
              break;
            case 13:
              _context13.next = 18;
              break;
            case 15:
              _context13.prev = 15;
              _context13.t0 = _context13["catch"](5);
              _iterator115.e(_context13.t0);
            case 18:
              _context13.prev = 18;
              _iterator115.f();
              return _context13.finish(18);
            case 21:
            case "end":
              return _context13.stop();
          }
        }, _callee6, null, [[5, 15, 18, 21]]);
      })();
    }
  }, {
    key: "getTransformedByOperation",
    value: function getTransformedByOperation(e) {
      switch (e.type) {
        case "insert":
          return this._getTransformedByInsertOperation(e);
        case "move":
        case "remove":
        case "reinsert":
          return this._getTransformedByMoveOperation(e);
        case "split":
          return [this._getTransformedBySplitOperation(e)];
        case "merge":
          return [this._getTransformedByMergeOperation(e)];
      }
      return [new u(this.start, this.end)];
    }
  }, {
    key: "getTransformedByOperations",
    value: function getTransformedByOperations(e) {
      var t = [new u(this.start, this.end)];
      var _iterator116 = _createForOfIteratorHelper(e),
        _step116;
      try {
        for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
          var _n12 = _step116.value;
          for (var _r1 = 0; _r1 < t.length; _r1++) {
            var _i29 = t[_r1].getTransformedByOperation(_n12);
            t.splice.apply(t, [_r1, 1].concat(_toConsumableArray(_i29))), _r1 += _i29.length - 1;
          }
        }
      } catch (err) {
        _iterator116.e(err);
      } finally {
        _iterator116.f();
      }
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        for (var i = n + 1; i < t.length; i++) {
          var o = t[i];
          (r.containsRange(o) || o.containsRange(r) || r.isEqual(o)) && t.splice(i, 1);
        }
      }
      return t;
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor() {
      return this.start.getCommonAncestor(this.end);
    }
  }, {
    key: "getContainedElement",
    value: function getContainedElement() {
      if (this.isCollapsed) return null;
      var e = this.start.nodeAfter,
        t = this.end.nodeBefore;
      return e && e.is("element") && e === t ? e : null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        start: this.start.toJSON(),
        end: this.end.toJSON()
      };
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.start, this.end);
    }
  }, {
    key: "_getTransformedByInsertOperation",
    value: function _getTransformedByInsertOperation(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return this._getTransformedByInsertion(e.position, e.howMany, t);
    }
  }, {
    key: "_getTransformedByMoveOperation",
    value: function _getTransformedByMoveOperation(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = e.sourcePosition,
        r = e.howMany,
        i = e.targetPosition;
      return this._getTransformedByMove(n, i, r, t);
    }
  }, {
    key: "_getTransformedBySplitOperation",
    value: function _getTransformedBySplitOperation(e) {
      var t = this.start._getTransformedBySplitOperation(e);
      var n = this.end._getTransformedBySplitOperation(e);
      return this.end.isEqual(e.insertionPosition) && (n = this.end.getShiftedBy(1)), t.root != n.root && (n = this.end.getShiftedBy(-1)), new u(t, n);
    }
  }, {
    key: "_getTransformedByMergeOperation",
    value: function _getTransformedByMergeOperation(e) {
      if (this.start.isEqual(e.targetPosition) && this.end.isEqual(e.deletionPosition)) return new u(this.start);
      var t = this.start._getTransformedByMergeOperation(e),
        n = this.end._getTransformedByMergeOperation(e);
      return t.root != n.root && (n = this.end.getShiftedBy(-1)), t.isAfter(n) ? (e.sourcePosition.isBefore(e.targetPosition) ? (t = m._createAt(n), t.offset = 0) : (e.deletionPosition.isEqual(t) || (n = e.deletionPosition), t = e.targetPosition), new u(t, n)) : new u(t, n);
    }
  }, {
    key: "_getTransformedByInsertion",
    value: function _getTransformedByInsertion(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      if (n && this.containsPosition(e)) return [new u(this.start, e), new u(e.getShiftedBy(t), this.end._getTransformedByInsertion(e, t))];
      {
        var r = new u(this.start, this.end);
        return r.start = r.start._getTransformedByInsertion(e, t), r.end = r.end._getTransformedByInsertion(e, t), [r];
      }
    }
  }, {
    key: "_getTransformedByMove",
    value: function _getTransformedByMove(e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      if (this.isCollapsed) {
        var d = this.start._getTransformedByMove(e, t, n);
        return [new u(d)];
      }
      var i = u._createFromPositionAndShift(e, n),
        o = t._getTransformedByDeletion(e, n);
      if (this.containsPosition(t) && !r && (i.containsPosition(this.start) || i.containsPosition(this.end))) {
        var _d4 = this.start._getTransformedByMove(e, t, n),
          p = this.end._getTransformedByMove(e, t, n);
        return [new u(_d4, p)];
      }
      var a;
      var l = this.getDifference(i);
      var c = null;
      var h = this.getIntersection(i);
      if (l.length == 1 ? c = new u(l[0].start._getTransformedByDeletion(e, n), l[0].end._getTransformedByDeletion(e, n)) : l.length == 2 && (c = new u(this.start, this.end._getTransformedByDeletion(e, n))), c ? a = c._getTransformedByInsertion(o, n, h !== null || r) : a = [], h) {
        var _d5 = new u(h.start._getCombined(i.start, o), h.end._getCombined(i.start, o));
        a.length == 2 ? a.splice(1, 0, _d5) : a.push(_d5);
      }
      return a;
    }
  }, {
    key: "_getTransformedByDeletion",
    value: function _getTransformedByDeletion(e, t) {
      var n = this.start._getTransformedByDeletion(e, t),
        r = this.end._getTransformedByDeletion(e, t);
      return n == null && r == null ? null : (n == null && (n = e), r == null && (r = e), new u(n, r));
    }
  }], [{
    key: "_createFromPositionAndShift",
    value: function _createFromPositionAndShift(e, t) {
      var n = e,
        r = e.getShiftedBy(t);
      return t > 0 ? new this(n, r) : new this(r, n);
    }
  }, {
    key: "_createIn",
    value: function _createIn(e) {
      return new this(m._createAt(e, 0), m._createAt(e, e.maxOffset));
    }
  }, {
    key: "_createOn",
    value: function _createOn(e) {
      return this._createFromPositionAndShift(m._createBefore(e), e.offsetSize);
    }
  }, {
    key: "_createFromRanges",
    value: function _createFromRanges(e) {
      if (e.length === 0) throw new f("range-create-from-ranges-empty-array", null);
      if (e.length == 1) return e[0].clone();
      var t = e[0];
      e.sort(function (i, o) {
        return i.start.isAfter(o.start) ? 1 : -1;
      });
      var n = e.indexOf(t),
        r = new this(t.start, t.end);
      for (var i = n - 1; i >= 0 && e[i].end.isEqual(r.start); i--) r.start = m._createAt(e[i].start);
      for (var _i30 = n + 1; _i30 < e.length && e[_i30].start.isEqual(r.end); _i30++) r.end = m._createAt(e[_i30].end);
      return r;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      return new this(m.fromJSON(e.start, t), m.fromJSON(e.end, t));
    }
  }]);
}(he);
u.prototype.is = function (s) {
  return s === "range" || s === "model:range";
};
var as = /*#__PURE__*/function (_N5) {
  function as() {
    var _this45;
    _classCallCheck(this, as);
    _this45 = _callSuper(this, as), _defineProperty(_assertThisInitialized(_this45), "_modelToViewMapping", new WeakMap()), _defineProperty(_assertThisInitialized(_this45), "_viewToModelMapping", new WeakMap()), _defineProperty(_assertThisInitialized(_this45), "_viewToModelLengthCallbacks", new Map()), _defineProperty(_assertThisInitialized(_this45), "_markerNameToElements", new Map()), _defineProperty(_assertThisInitialized(_this45), "_elementToMarkerNames", new Map()), _defineProperty(_assertThisInitialized(_this45), "_deferredBindingRemovals", new Map()), _defineProperty(_assertThisInitialized(_this45), "_unboundMarkerNames", new Set()), _defineProperty(_assertThisInitialized(_this45), "_cache", new Xr()), _this45.on("modelToViewPosition", function (e, t) {
      if (t.viewPosition) return;
      var n = _this45._modelToViewMapping.get(t.modelPosition.parent);
      if (!n) throw new f("mapping-model-position-view-parent-not-found", _assertThisInitialized(_this45), {
        modelPosition: t.modelPosition
      });
      t.viewPosition = _this45.findPositionIn(n, t.modelPosition.offset);
    }, {
      priority: "low"
    }), _this45.on("viewToModelPosition", function (e, t) {
      if (t.modelPosition) return;
      var n = _this45.findMappedViewAncestor(t.viewPosition),
        r = _this45._viewToModelMapping.get(n),
        i = _this45._toModelOffset(t.viewPosition.parent, t.viewPosition.offset, n);
      t.modelPosition = m._createAt(r, i);
    }, {
      priority: "low"
    });
    return _this45;
  }
  _inherits(as, _N5);
  return _createClass(as, [{
    key: "bindElements",
    value: function bindElements(e, t) {
      this._modelToViewMapping.set(e, t), this._viewToModelMapping.set(t, e);
    }
  }, {
    key: "unbindViewElement",
    value: function unbindViewElement(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = this.toModelElement(e);
      if (this._elementToMarkerNames.has(e)) {
        var _iterator117 = _createForOfIteratorHelper(this._elementToMarkerNames.get(e)),
          _step117;
        try {
          for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
            var r = _step117.value;
            this._unboundMarkerNames.add(r);
          }
        } catch (err) {
          _iterator117.e(err);
        } finally {
          _iterator117.f();
        }
      }
      t.defer ? this._deferredBindingRemovals.set(e, e.root) : (this._viewToModelMapping.delete(e) && this._cache.stopTracking(e), this._modelToViewMapping.get(n) == e && this._modelToViewMapping.delete(n));
    }
  }, {
    key: "unbindModelElement",
    value: function unbindModelElement(e) {
      var t = this.toViewElement(e);
      this._modelToViewMapping.delete(e), this._viewToModelMapping.get(t) == e && this._viewToModelMapping.delete(t) && this._cache.stopTracking(t);
    }
  }, {
    key: "bindElementToMarker",
    value: function bindElementToMarker(e, t) {
      var n = this._markerNameToElements.get(t) || new Set();
      n.add(e);
      var r = this._elementToMarkerNames.get(e) || new Set();
      r.add(t), this._markerNameToElements.set(t, n), this._elementToMarkerNames.set(e, r);
    }
  }, {
    key: "unbindElementFromMarkerName",
    value: function unbindElementFromMarkerName(e, t) {
      var n = this._markerNameToElements.get(t);
      n && (n.delete(e), n.size == 0 && this._markerNameToElements.delete(t));
      var r = this._elementToMarkerNames.get(e);
      r && (r.delete(t), r.size == 0 && this._elementToMarkerNames.delete(e));
    }
  }, {
    key: "flushUnboundMarkerNames",
    value: function flushUnboundMarkerNames() {
      var e = Array.from(this._unboundMarkerNames);
      return this._unboundMarkerNames.clear(), e;
    }
  }, {
    key: "flushDeferredBindings",
    value: function flushDeferredBindings() {
      var _iterator118 = _createForOfIteratorHelper(this._deferredBindingRemovals),
        _step118;
      try {
        for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
          var _ref59 = _step118.value;
          var _ref60 = _slicedToArray(_ref59, 2);
          var e = _ref60[0];
          var t = _ref60[1];
          e.root == t && this.unbindViewElement(e);
        }
      } catch (err) {
        _iterator118.e(err);
      } finally {
        _iterator118.f();
      }
      this._deferredBindingRemovals = new Map();
    }
  }, {
    key: "clearBindings",
    value: function clearBindings() {
      this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this._deferredBindingRemovals = new Map();
    }
  }, {
    key: "toModelElement",
    value: function toModelElement(e) {
      return this._viewToModelMapping.get(e);
    }
  }, {
    key: "toViewElement",
    value: function toViewElement(e) {
      return this._modelToViewMapping.get(e);
    }
  }, {
    key: "toModelRange",
    value: function toModelRange(e) {
      return new u(this.toModelPosition(e.start), this.toModelPosition(e.end));
    }
  }, {
    key: "toViewRange",
    value: function toViewRange(e) {
      return new w(this.toViewPosition(e.start), this.toViewPosition(e.end));
    }
  }, {
    key: "toModelPosition",
    value: function toModelPosition(e) {
      var t = {
        viewPosition: e,
        mapper: this
      };
      return this.fire("viewToModelPosition", t), t.modelPosition;
    }
  }, {
    key: "toViewPosition",
    value: function toViewPosition(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = {
        modelPosition: e,
        mapper: this,
        isPhantom: t.isPhantom
      };
      return this.fire("modelToViewPosition", n), n.viewPosition;
    }
  }, {
    key: "markerNameToElements",
    value: function markerNameToElements(e) {
      var t = this._markerNameToElements.get(e);
      if (!t) return null;
      var n = new Set();
      var _iterator119 = _createForOfIteratorHelper(t),
        _step119;
      try {
        for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
          var r = _step119.value;
          if (r.is("attributeElement")) {
            var _iterator120 = _createForOfIteratorHelper(r.getElementsWithSameId()),
              _step120;
            try {
              for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
                var i = _step120.value;
                n.add(i);
              }
            } catch (err) {
              _iterator120.e(err);
            } finally {
              _iterator120.f();
            }
          } else n.add(r);
        }
      } catch (err) {
        _iterator119.e(err);
      } finally {
        _iterator119.f();
      }
      return n;
    }
  }, {
    key: "registerViewToModelLength",
    value: function registerViewToModelLength(e, t) {
      this._viewToModelLengthCallbacks.set(e, t);
    }
  }, {
    key: "findMappedViewAncestor",
    value: function findMappedViewAncestor(e) {
      var t = e.parent;
      for (; !this._viewToModelMapping.has(t);) t = t.parent;
      return t;
    }
  }, {
    key: "_toModelOffset",
    value: function _toModelOffset(e, t, n) {
      if (n != e) {
        var i = this._toModelOffset(e.parent, e.index, n),
          o = this._toModelOffset(e, t, e);
        return i + o;
      }
      if (e.is("$text")) return t;
      var r = 0;
      for (var _i31 = 0; _i31 < t; _i31++) r += this.getModelLength(e.getChild(_i31));
      return r;
    }
  }, {
    key: "getModelLength",
    value: function getModelLength(e) {
      var t = [e];
      var n = 0;
      for (; t.length > 0;) {
        var r = t.pop(),
          i = r.name && this._viewToModelLengthCallbacks.size > 0 && this._viewToModelLengthCallbacks.get(r.name);
        if (i) n += i(r);else if (this._viewToModelMapping.has(r)) n += 1;else if (r.is("$text")) n += r.data.length;else {
          if (r.is("uiElement")) continue;
          var _iterator121 = _createForOfIteratorHelper(r.getChildren()),
            _step121;
          try {
            for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
              var o = _step121.value;
              t.push(o);
            }
          } catch (err) {
            _iterator121.e(err);
          } finally {
            _iterator121.f();
          }
        }
      }
      return n;
    }
  }, {
    key: "findPositionIn",
    value: function findPositionIn(e, t) {
      if (t === 0) return this._moveViewPositionToTextNode(new g(e, 0));
      if (this._viewToModelLengthCallbacks.size == 0 && this._viewToModelMapping.has(e)) {
        var r = this._cache.getClosest(e, t);
        return this._findPositionStartingFrom(r.viewPosition, r.modelOffset, t, e, !0);
      } else return this._findPositionStartingFrom(new g(e, 0), 0, t, e, !1);
    }
  }, {
    key: "_findPositionStartingFrom",
    value: function _findPositionStartingFrom(e, t, n, r, i) {
      var o = e.parent,
        a = e.offset;
      if (o.is("$text")) return new g(o, n - t);
      var l,
        c = t,
        h = 0;
      for (; c < n;) {
        if (l = o.getChild(a), !l) {
          if (o == r) throw new f("mapping-model-offset-not-found", this, {
            modelOffset: n,
            viewContainer: r
          });
          a = o.parent.getChildIndex(o) + 1, o = o.parent, i && this._cache.save(o, a, r, c);
          continue;
        }
        i ? h = this._getModelLengthAndCache(l, r, c) : h = this.getModelLength(l), c += h, a++;
      }
      var d = new g(o, a);
      if (i) for (; d.isAtEnd && d.parent !== r && d.parent.parent;) {
        var p = d.parent.parent,
          _ = p.getChildIndex(d.parent) + 1;
        this._cache.save(p, _, r, c), d = new g(p, _);
      }
      return c == n ? this._moveViewPositionToTextNode(d) : this._findPositionStartingFrom(new g(l, 0), c - h, n, r, i);
    }
  }, {
    key: "_getModelLengthAndCache",
    value: function _getModelLengthAndCache(e, t, n) {
      var r = 0;
      if (this._viewToModelMapping.has(e)) r = 1;else if (e.is("$text")) r = e.data.length;else if (!e.is("uiElement")) {
        var _iterator122 = _createForOfIteratorHelper(e.getChildren()),
          _step122;
        try {
          for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
            var i = _step122.value;
            r += this._getModelLengthAndCache(i, t, n + r);
          }
        } catch (err) {
          _iterator122.e(err);
        } finally {
          _iterator122.f();
        }
      }
      return this._cache.save(e.parent, e.index + 1, t, n + r), r;
    }
  }, {
    key: "_moveViewPositionToTextNode",
    value: function _moveViewPositionToTextNode(e) {
      var t = e.nodeBefore,
        n = e.nodeAfter;
      return t && t.is("view:$text") ? new g(t, t.data.length) : n && n.is("view:$text") ? new g(n, 0) : e;
    }
  }]);
}(N());
var Xr = /*#__PURE__*/function (_N6) {
  function Xr() {
    var _this46;
    _classCallCheck(this, Xr);
    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }
    _this46 = _callSuper(this, Xr, [].concat(args));
    _defineProperty(_this46, "_cachedMapping", new WeakMap());
    _defineProperty(_this46, "_nodeToCacheListIndex", new WeakMap());
    _defineProperty(_this46, "_invalidateOnChildrenChangeCallback", function (e, t, n) {
      _this46._clearCacheInsideParent(t, n.index);
    });
    _defineProperty(_this46, "_invalidateOnTextChangeCallback", function (e, t) {
      _this46._clearCacheAfter(t);
    });
    return _this46;
  }
  _inherits(Xr, _N6);
  return _createClass(Xr, [{
    key: "save",
    value: function save(e, t, n, r) {
      var i = this._cachedMapping.get(n),
        o = i.cacheMap.get(r);
      if (o) {
        var h = e.getChild(t - 1),
          d = o.viewPosition.nodeBefore ? this._nodeToCacheListIndex.get(o.viewPosition.nodeBefore) : 0;
        this._nodeToCacheListIndex.set(h, d);
        return;
      }
      var l = {
        viewPosition: new g(e, t),
        modelOffset: r
      };
      i.maxModelOffset = r > i.maxModelOffset ? r : i.maxModelOffset, i.cacheMap.set(r, l);
      var c = i.cacheList.length - 1;
      for (; c >= 0 && i.cacheList[c].modelOffset > r;) c--;
      if (i.cacheList.splice(c + 1, 0, l), t > 0) {
        var _h = e.getChild(t - 1);
        this._nodeToCacheListIndex.set(_h, c + 1);
      }
    }
  }, {
    key: "getClosest",
    value: function getClosest(e, t) {
      var n = this._cachedMapping.get(e);
      var r;
      if (n) {
        if (t > n.maxModelOffset) r = n.cacheList[n.cacheList.length - 1];else {
          var i = n.cacheMap.get(t);
          i ? r = i : r = this._findInCacheList(n.cacheList, t);
        }
      } else r = this.startTracking(e);
      return {
        modelOffset: r.modelOffset,
        viewPosition: r.viewPosition.clone()
      };
    }
  }, {
    key: "startTracking",
    value: function startTracking(e) {
      var n = {
          viewPosition: new g(e, 0),
          modelOffset: 0
        },
        r = {
          maxModelOffset: 0,
          cacheList: [n],
          cacheMap: new Map([[0, n]])
        };
      return this._cachedMapping.set(e, r), e.on("change:children", this._invalidateOnChildrenChangeCallback), e.on("change:text", this._invalidateOnTextChangeCallback), n;
    }
  }, {
    key: "stopTracking",
    value: function stopTracking(e) {
      e.off("change:children", this._invalidateOnChildrenChangeCallback), e.off("change:text", this._invalidateOnTextChangeCallback), this._cachedMapping.delete(e);
    }
  }, {
    key: "_clearCacheInsideParent",
    value: function _clearCacheInsideParent(e, t) {
      if (t == 0) this._cachedMapping.has(e) ? this._clearCacheAll(e) : this._clearCacheInsideParent(e.parent, e.index);else {
        var n = e.getChild(t - 1);
        this._clearCacheAfter(n);
      }
    }
  }, {
    key: "_clearCacheAll",
    value: function _clearCacheAll(e) {
      var t = this._cachedMapping.get(e);
      t.maxModelOffset > 0 && (t.maxModelOffset = 0, t.cacheList.length = 1, t.cacheMap.clear(), t.cacheMap.set(0, t.cacheList[0]));
    }
  }, {
    key: "_clearCacheAfter",
    value: function _clearCacheAfter(e) {
      var t = this._nodeToCacheListIndex.get(e);
      if (t === void 0) {
        var r = e.parent;
        this._cachedMapping.has(r) || this._clearCacheInsideParent(r.parent, r.index);
        return;
      }
      var n = e.parent;
      for (; !this._cachedMapping.has(n);) n = n.parent;
      this._clearCacheFromCacheIndex(n, t);
    }
  }, {
    key: "_clearCacheFromCacheIndex",
    value: function _clearCacheFromCacheIndex(e, t) {
      t === 0 && (t = 1);
      var n = this._cachedMapping.get(e),
        r = n.cacheList[t - 1];
      if (!r) return;
      n.maxModelOffset = r.modelOffset;
      var i = n.cacheList.splice(t);
      var _iterator123 = _createForOfIteratorHelper(i),
        _step123;
      try {
        for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
          var o = _step123.value;
          n.cacheMap.delete(o.modelOffset);
          var a = o.viewPosition.nodeBefore;
          this._nodeToCacheListIndex.delete(a);
        }
      } catch (err) {
        _iterator123.e(err);
      } finally {
        _iterator123.f();
      }
    }
  }, {
    key: "_findInCacheList",
    value: function _findInCacheList(e, t) {
      var n = 0,
        r = e.length - 1,
        i = r - n >> 1,
        o = e[i];
      for (; n < r;) o.modelOffset < t ? n = i + 1 : r = i - 1, i = n + (r - n >> 1), o = e[i];
      return o.modelOffset <= t ? o : e[i - 1];
    }
  }]);
}(N());
var Yr = /*#__PURE__*/function () {
  function Yr() {
    _classCallCheck(this, Yr);
    _defineProperty(this, "_consumable", new Map());
    _defineProperty(this, "_textProxyRegistry", new Map());
  }
  return _createClass(Yr, [{
    key: "add",
    value: function add(e, t) {
      t = nt(t), e instanceof j && (e = this._getSymbolForTextProxy(e)), this._consumable.has(e) || this._consumable.set(e, new Map()), this._consumable.get(e).set(t, !0);
    }
  }, {
    key: "consume",
    value: function consume(e, t) {
      return t = nt(t), e instanceof j && (e = this._getSymbolForTextProxy(e)), this.test(e, t) ? (this._consumable.get(e).set(t, !1), !0) : !1;
    }
  }, {
    key: "test",
    value: function test(e, t) {
      t = nt(t), e instanceof j && (e = this._getSymbolForTextProxy(e));
      var n = this._consumable.get(e);
      if (n === void 0) return null;
      var r = n.get(t);
      return r === void 0 ? null : r;
    }
  }, {
    key: "revert",
    value: function revert(e, t) {
      t = nt(t), e instanceof j && (e = this._getSymbolForTextProxy(e));
      var n = this.test(e, t);
      return n === !1 ? (this._consumable.get(e).set(t, !0), !0) : n === !0 ? !1 : null;
    }
  }, {
    key: "verifyAllConsumed",
    value: function verifyAllConsumed(e) {
      var t = [];
      var _iterator124 = _createForOfIteratorHelper(this._consumable),
        _step124;
      try {
        for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
          var _ref61 = _step124.value;
          var _ref62 = _slicedToArray(_ref61, 2);
          var n = _ref62[0];
          var r = _ref62[1];
          var _iterator125 = _createForOfIteratorHelper(r),
            _step125;
          try {
            for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
              var _ref63 = _step125.value;
              var _ref64 = _slicedToArray(_ref63, 2);
              var i = _ref64[0];
              var o = _ref64[1];
              var a = i.split(":")[0];
              o && e == a && t.push({
                event: i,
                item: n.name || n.description
              });
            }
          } catch (err) {
            _iterator125.e(err);
          } finally {
            _iterator125.f();
          }
        }
      } catch (err) {
        _iterator124.e(err);
      } finally {
        _iterator124.f();
      }
      if (t.length) throw new f("conversion-model-consumable-not-consumed", null, {
        items: t
      });
    }
  }, {
    key: "_getSymbolForTextProxy",
    value: function _getSymbolForTextProxy(e) {
      var t = null;
      var n = this._textProxyRegistry.get(e.startOffset);
      if (n) {
        var r = n.get(e.endOffset);
        r && (t = r.get(e.parent));
      }
      return t || (t = this._addSymbolForTextProxy(e)), t;
    }
  }, {
    key: "_addSymbolForTextProxy",
    value: function _addSymbolForTextProxy(e) {
      var t = e.startOffset,
        n = e.endOffset,
        r = e.parent,
        i = Symbol("$textProxy:" + e.data);
      var o, a;
      return o = this._textProxyRegistry.get(t), o || (o = new Map(), this._textProxyRegistry.set(t, o)), a = o.get(n), a || (a = new Map(), o.set(n, a)), a.set(r, i), i;
    }
  }]);
}();
function nt(s) {
  var e = s.split(":");
  return e[0] == "insert" ? e[0] : e[0] == "addMarker" || e[0] == "removeMarker" ? s : e.length > 1 ? e[0] + ":" + e[1] : e[0];
}
var ls = /*#__PURE__*/function (_N7) {
  function ls(e) {
    var _this47;
    _classCallCheck(this, ls);
    _this47 = _callSuper(this, ls), _defineProperty(_assertThisInitialized(_this47), "_conversionApi", void 0), _defineProperty(_assertThisInitialized(_this47), "_firedEventsMap", void 0), _this47._conversionApi = _objectSpread({
      dispatcher: _assertThisInitialized(_this47)
    }, e), _this47._firedEventsMap = new WeakMap();
    return _this47;
  }
  _inherits(ls, _N7);
  return _createClass(ls, [{
    key: "convertChanges",
    value: function convertChanges(e, t, n) {
      var r = this._createConversionApi(n, e.getRefreshedItems());
      var _iterator126 = _createForOfIteratorHelper(e.getMarkersToRemove()),
        _step126;
      try {
        for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
          var o = _step126.value;
          this._convertMarkerRemove(o.name, o.range, r);
        }
      } catch (err) {
        _iterator126.e(err);
      } finally {
        _iterator126.f();
      }
      var i = this._reduceChanges(e.getChanges());
      var _iterator127 = _createForOfIteratorHelper(i),
        _step127;
      try {
        for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
          var _o12 = _step127.value;
          _o12.type === "insert" ? this._convertInsert(u._createFromPositionAndShift(_o12.position, _o12.length), r) : _o12.type === "reinsert" ? this._convertReinsert(u._createFromPositionAndShift(_o12.position, _o12.length), r) : _o12.type === "remove" ? this._convertRemove(_o12.position, _o12.length, _o12.name, r) : this._convertAttribute(_o12.range, _o12.attributeKey, _o12.attributeOldValue, _o12.attributeNewValue, r);
        }
      } catch (err) {
        _iterator127.e(err);
      } finally {
        _iterator127.f();
      }
      r.mapper.flushDeferredBindings();
      var _iterator128 = _createForOfIteratorHelper(r.mapper.flushUnboundMarkerNames()),
        _step128;
      try {
        for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
          var _o13 = _step128.value;
          var a = t.get(_o13).getRange();
          this._convertMarkerRemove(_o13, a, r), this._convertMarkerAdd(_o13, a, r);
        }
      } catch (err) {
        _iterator128.e(err);
      } finally {
        _iterator128.f();
      }
      var _iterator129 = _createForOfIteratorHelper(e.getMarkersToAdd()),
        _step129;
      try {
        for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
          var _o14 = _step129.value;
          this._convertMarkerAdd(_o14.name, _o14.range, r);
        }
      } catch (err) {
        _iterator129.e(err);
      } finally {
        _iterator129.f();
      }
      r.consumable.verifyAllConsumed("insert");
    }
  }, {
    key: "convert",
    value: function convert(e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var i = this._createConversionApi(n, void 0, r);
      this._convertInsert(e, i);
      var _iterator130 = _createForOfIteratorHelper(t),
        _step130;
      try {
        for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
          var _ref65 = _step130.value;
          var _ref66 = _slicedToArray(_ref65, 2);
          var o = _ref66[0];
          var a = _ref66[1];
          this._convertMarkerAdd(o, a, i);
        }
      } catch (err) {
        _iterator130.e(err);
      } finally {
        _iterator130.f();
      }
      i.consumable.verifyAllConsumed("insert");
    }
  }, {
    key: "convertSelection",
    value: function convertSelection(e, t, n) {
      var r = this._createConversionApi(n);
      this.fire("cleanSelection", {
        selection: e
      }, r);
      var i = e.getFirstPosition().root;
      if (!r.mapper.toViewElement(i)) return;
      var o = Array.from(t.getMarkersAtPosition(e.getFirstPosition()));
      if (this._addConsumablesForSelection(r.consumable, e, o), this.fire("selection", {
        selection: e
      }, r), !!e.isCollapsed) {
        var _iterator131 = _createForOfIteratorHelper(o),
          _step131;
        try {
          for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
            var a = _step131.value;
            if (r.consumable.test(e, "addMarker:" + a.name)) {
              var l = a.getRange();
              if (!Qr(e.getFirstPosition(), a, r.mapper)) continue;
              var c = {
                item: e,
                markerName: a.name,
                markerRange: l
              };
              this.fire("addMarker:".concat(a.name), c, r);
            }
          }
        } catch (err) {
          _iterator131.e(err);
        } finally {
          _iterator131.f();
        }
        var _iterator132 = _createForOfIteratorHelper(e.getAttributeKeys()),
          _step132;
        try {
          for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
            var _a8 = _step132.value;
            if (r.consumable.test(e, "attribute:" + _a8)) {
              var _l6 = {
                item: e,
                range: e.getFirstRange(),
                attributeKey: _a8,
                attributeOldValue: null,
                attributeNewValue: e.getAttribute(_a8)
              };
              this.fire("attribute:".concat(_a8, ":$text"), _l6, r);
            }
          }
        } catch (err) {
          _iterator132.e(err);
        } finally {
          _iterator132.f();
        }
      }
    }
  }, {
    key: "_convertInsert",
    value: function _convertInsert(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      n.doNotAddConsumables || this._addConsumablesForInsert(t.consumable, e);
      var _iterator133 = _createForOfIteratorHelper(e.getWalker({
          shallow: !0
        })),
        _step133;
      try {
        for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
          var r = _step133.value;
          this._testAndFire("insert", bn(r), t);
        }
      } catch (err) {
        _iterator133.e(err);
      } finally {
        _iterator133.f();
      }
    }
  }, {
    key: "_convertRemove",
    value: function _convertRemove(e, t, n, r) {
      this.fire("remove:".concat(n), {
        position: e,
        length: t
      }, r);
    }
  }, {
    key: "_convertAttribute",
    value: function _convertAttribute(e, t, n, r, i) {
      this._addConsumablesForRange(i.consumable, e, "attribute:".concat(t));
      var _iterator134 = _createForOfIteratorHelper(e),
        _step134;
      try {
        for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
          var o = _step134.value;
          var a = {
            item: o.item,
            range: u._createFromPositionAndShift(o.previousPosition, o.length),
            attributeKey: t,
            attributeOldValue: n,
            attributeNewValue: r
          };
          this._testAndFire("attribute:".concat(t), a, i);
        }
      } catch (err) {
        _iterator134.e(err);
      } finally {
        _iterator134.f();
      }
    }
  }, {
    key: "_convertReinsert",
    value: function _convertReinsert(e, t) {
      var n = Array.from(e.getWalker({
        shallow: !0
      }));
      this._addConsumablesForInsert(t.consumable, n);
      var _iterator135 = _createForOfIteratorHelper(n.map(bn)),
        _step135;
      try {
        for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
          var r = _step135.value;
          this._testAndFire("insert", _objectSpread(_objectSpread({}, r), {}, {
            reconversion: !0
          }), t);
        }
      } catch (err) {
        _iterator135.e(err);
      } finally {
        _iterator135.f();
      }
    }
  }, {
    key: "_convertMarkerAdd",
    value: function _convertMarkerAdd(e, t, n) {
      if (t.root.rootName == "$graveyard") return;
      var r = "addMarker:".concat(e);
      if (n.consumable.add(t, r), this.fire(r, {
        markerName: e,
        markerRange: t
      }, n), !!n.consumable.consume(t, r)) {
        this._addConsumablesForRange(n.consumable, t, r);
        var _iterator136 = _createForOfIteratorHelper(t.getItems()),
          _step136;
        try {
          for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
            var i = _step136.value;
            if (!n.consumable.test(i, r)) continue;
            var o = {
              item: i,
              range: u._createOn(i),
              markerName: e,
              markerRange: t
            };
            this.fire(r, o, n);
          }
        } catch (err) {
          _iterator136.e(err);
        } finally {
          _iterator136.f();
        }
      }
    }
  }, {
    key: "_convertMarkerRemove",
    value: function _convertMarkerRemove(e, t, n) {
      t.root.rootName != "$graveyard" && this.fire("removeMarker:".concat(e), {
        markerName: e,
        markerRange: t
      }, n);
    }
  }, {
    key: "_reduceChanges",
    value: function _reduceChanges(e) {
      var t = {
        changes: e
      };
      return this.fire("reduceChanges", t), t.changes;
    }
  }, {
    key: "_addConsumablesForInsert",
    value: function _addConsumablesForInsert(e, t) {
      var _iterator137 = _createForOfIteratorHelper(t),
        _step137;
      try {
        for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
          var n = _step137.value;
          var r = n.item;
          if (e.test(r, "insert") === null) {
            e.add(r, "insert");
            var _iterator138 = _createForOfIteratorHelper(r.getAttributeKeys()),
              _step138;
            try {
              for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
                var i = _step138.value;
                e.add(r, "attribute:" + i);
              }
            } catch (err) {
              _iterator138.e(err);
            } finally {
              _iterator138.f();
            }
          }
        }
      } catch (err) {
        _iterator137.e(err);
      } finally {
        _iterator137.f();
      }
      return e;
    }
  }, {
    key: "_addConsumablesForRange",
    value: function _addConsumablesForRange(e, t, n) {
      var _iterator139 = _createForOfIteratorHelper(t.getItems()),
        _step139;
      try {
        for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
          var r = _step139.value;
          e.add(r, n);
        }
      } catch (err) {
        _iterator139.e(err);
      } finally {
        _iterator139.f();
      }
      return e;
    }
  }, {
    key: "_addConsumablesForSelection",
    value: function _addConsumablesForSelection(e, t, n) {
      e.add(t, "selection");
      var _iterator140 = _createForOfIteratorHelper(n),
        _step140;
      try {
        for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
          var r = _step140.value;
          e.add(t, "addMarker:" + r.name);
        }
      } catch (err) {
        _iterator140.e(err);
      } finally {
        _iterator140.f();
      }
      var _iterator141 = _createForOfIteratorHelper(t.getAttributeKeys()),
        _step141;
      try {
        for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
          var _r10 = _step141.value;
          e.add(t, "attribute:" + _r10);
        }
      } catch (err) {
        _iterator141.e(err);
      } finally {
        _iterator141.f();
      }
      return e;
    }
  }, {
    key: "_testAndFire",
    value: function _testAndFire(e, t, n) {
      var r = Zr(e, t),
        i = t.item.is("$textProxy") ? n.consumable._getSymbolForTextProxy(t.item) : t.item,
        o = this._firedEventsMap.get(n),
        a = o.get(i);
      if (!a) o.set(i, new Set([r]));else if (!a.has(r)) a.add(r);else return;
      this.fire(r, t, n);
    }
  }, {
    key: "_testAndFireAddAttributes",
    value: function _testAndFireAddAttributes(e, t) {
      var n = {
        item: e,
        range: u._createOn(e)
      };
      var _iterator142 = _createForOfIteratorHelper(n.item.getAttributeKeys()),
        _step142;
      try {
        for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
          var r = _step142.value;
          n.attributeKey = r, n.attributeOldValue = null, n.attributeNewValue = n.item.getAttribute(r), this._testAndFire("attribute:".concat(r), n, t);
        }
      } catch (err) {
        _iterator142.e(err);
      } finally {
        _iterator142.f();
      }
    }
  }, {
    key: "_createConversionApi",
    value: function _createConversionApi(e) {
      var _this48 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var r = _objectSpread(_objectSpread({}, this._conversionApi), {}, {
        consumable: new Yr(),
        writer: e,
        options: n,
        convertItem: function convertItem(i) {
          return _this48._convertInsert(u._createOn(i), r);
        },
        convertChildren: function convertChildren(i) {
          return _this48._convertInsert(u._createIn(i), r, {
            doNotAddConsumables: !0
          });
        },
        convertAttributes: function convertAttributes(i) {
          return _this48._testAndFireAddAttributes(i, r);
        },
        canReuseView: function canReuseView(i) {
          return !t.has(r.mapper.toModelElement(i));
        }
      });
      return this._firedEventsMap.set(r, new Map()), r;
    }
  }]);
}(N());
function Qr(s, e, t) {
  var n = e.getRange(),
    r = Array.from(s.getAncestors());
  return r.shift(), r.reverse(), !r.some(function (o) {
    if (n.containsItem(o)) return !!t.toViewElement(o).getCustomProperty("addHighlight");
  });
}
function Zr(s, e) {
  var t = e.item.is("element") ? e.item.name : "$text";
  return "".concat(s, ":").concat(t);
}
function bn(s) {
  return {
    item: s.item,
    range: u._createFromPositionAndShift(s.previousPosition, s.length)
  };
}
var ve = /*#__PURE__*/function (_he4) {
  function ve(e) {
    var _this49;
    _classCallCheck(this, ve);
    _this49 = _callSuper(this, ve), _defineProperty(_assertThisInitialized(_this49), "parent", null), _defineProperty(_assertThisInitialized(_this49), "_attrs", void 0), _defineProperty(_assertThisInitialized(_this49), "_index", null), _defineProperty(_assertThisInitialized(_this49), "_startOffset", null), _this49._attrs = pe(e);
    return _this49;
  }
  _inherits(ve, _he4);
  return _createClass(ve, [{
    key: "document",
    get: function get() {
      return null;
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    }
  }, {
    key: "startOffset",
    get: function get() {
      return this._startOffset;
    }
  }, {
    key: "offsetSize",
    get: function get() {
      return 1;
    }
  }, {
    key: "endOffset",
    get: function get() {
      return this.startOffset === null ? null : this.startOffset + this.offsetSize;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      var e = this.index;
      return e !== null && this.parent.getChild(e + 1) || null;
    }
  }, {
    key: "previousSibling",
    get: function get() {
      var e = this.index;
      return e !== null && this.parent.getChild(e - 1) || null;
    }
  }, {
    key: "root",
    get: function get() {
      var e = this;
      for (; e.parent;) e = e.parent;
      return e;
    }
  }, {
    key: "isAttached",
    value: function isAttached() {
      return this.parent === null ? !1 : this.root.isAttached();
    }
  }, {
    key: "getPath",
    value: function getPath() {
      var e = [];
      var t = this;
      for (; t.parent;) e.unshift(t.startOffset), t = t.parent;
      return e;
    }
  }, {
    key: "getAncestors",
    value: function getAncestors() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = [];
      var n = e.includeSelf ? this : this.parent;
      for (; n;) t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
      return t;
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = this.getAncestors(t),
        r = e.getAncestors(t);
      var i = 0;
      for (; n[i] == r[i] && n[i];) i++;
      return i === 0 ? null : n[i - 1];
    }
  }, {
    key: "isBefore",
    value: function isBefore(e) {
      if (this == e || this.root !== e.root) return !1;
      var t = this.getPath(),
        n = e.getPath(),
        r = F(t, n);
      switch (r) {
        case "prefix":
          return !0;
        case "extension":
          return !1;
        default:
          return t[r] < n[r];
      }
    }
  }, {
    key: "isAfter",
    value: function isAfter(e) {
      return this == e || this.root !== e.root ? !1 : !this.isBefore(e);
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(e) {
      return this._attrs.has(e);
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(e) {
      return this._attrs.get(e);
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this._attrs.entries();
    }
  }, {
    key: "getAttributeKeys",
    value: function getAttributeKeys() {
      return this._attrs.keys();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = {};
      return this._attrs.size && (e.attributes = Array.from(this._attrs).reduce(function (t, n) {
        return t[n[0]] = n[1], t;
      }, {})), e;
    }
  }, {
    key: "_clone",
    value: function _clone(e) {
      return new this.constructor(this._attrs);
    }
  }, {
    key: "_remove",
    value: function _remove() {
      this.parent._removeChildren(this.index);
    }
  }, {
    key: "_setAttribute",
    value: function _setAttribute(e, t) {
      this._attrs.set(e, t);
    }
  }, {
    key: "_setAttributesTo",
    value: function _setAttributesTo(e) {
      this._attrs = pe(e);
    }
  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(e) {
      return this._attrs.delete(e);
    }
  }, {
    key: "_clearAttributes",
    value: function _clearAttributes() {
      this._attrs.clear();
    }
  }]);
}(he);
ve.prototype.is = function (s) {
  return s === "node" || s === "model:node";
};
var $ = /*#__PURE__*/function (_N8) {
  function $() {
    var _this51;
    var _this50;
    _classCallCheck(this, $);
    _this50 = _callSuper(this, $), _defineProperty(_assertThisInitialized(_this50), "_lastRangeBackward", !1), _defineProperty(_assertThisInitialized(_this50), "_attrs", new Map()), _defineProperty(_assertThisInitialized(_this50), "_ranges", []), arguments.length && (_this51 = _this50).setTo.apply(_this51, arguments);
    return _this50;
  }
  _inherits($, _N8);
  return _createClass($, [{
    key: "anchor",
    get: function get() {
      if (this._ranges.length > 0) {
        var e = this._ranges[this._ranges.length - 1];
        return this._lastRangeBackward ? e.end : e.start;
      }
      return null;
    }
  }, {
    key: "focus",
    get: function get() {
      if (this._ranges.length > 0) {
        var e = this._ranges[this._ranges.length - 1];
        return this._lastRangeBackward ? e.start : e.end;
      }
      return null;
    }
  }, {
    key: "isCollapsed",
    get: function get() {
      return this._ranges.length === 1 ? this._ranges[0].isCollapsed : !1;
    }
  }, {
    key: "rangeCount",
    get: function get() {
      return this._ranges.length;
    }
  }, {
    key: "isBackward",
    get: function get() {
      return !this.isCollapsed && this._lastRangeBackward;
    }
  }, {
    key: "isEqual",
    value: function isEqual(e) {
      if (this.rangeCount != e.rangeCount) return !1;
      if (this.rangeCount === 0) return !0;
      if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
      var _iterator143 = _createForOfIteratorHelper(this._ranges),
        _step143;
      try {
        for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
          var t = _step143.value;
          var n = !1;
          var _iterator144 = _createForOfIteratorHelper(e._ranges),
            _step144;
          try {
            for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
              var r = _step144.value;
              if (t.isEqual(r)) {
                n = !0;
                break;
              }
            }
          } catch (err) {
            _iterator144.e(err);
          } finally {
            _iterator144.f();
          }
          if (!n) return !1;
        }
      } catch (err) {
        _iterator143.e(err);
      } finally {
        _iterator143.f();
      }
      return !0;
    }
  }, {
    key: "getRanges",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
      var _iterator145, _step145, e;
      return _regeneratorRuntime().wrap(function getRanges$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            _iterator145 = _createForOfIteratorHelper(this._ranges);
            _context14.prev = 1;
            _iterator145.s();
          case 3:
            if ((_step145 = _iterator145.n()).done) {
              _context14.next = 9;
              break;
            }
            e = _step145.value;
            _context14.next = 7;
            return new u(e.start, e.end);
          case 7:
            _context14.next = 3;
            break;
          case 9:
            _context14.next = 14;
            break;
          case 11:
            _context14.prev = 11;
            _context14.t0 = _context14["catch"](1);
            _iterator145.e(_context14.t0);
          case 14:
            _context14.prev = 14;
            _iterator145.f();
            return _context14.finish(14);
          case 17:
          case "end":
            return _context14.stop();
        }
      }, getRanges, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "getFirstRange",
    value: function getFirstRange() {
      var e = null;
      var _iterator146 = _createForOfIteratorHelper(this._ranges),
        _step146;
      try {
        for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
          var t = _step146.value;
          (!e || t.start.isBefore(e.start)) && (e = t);
        }
      } catch (err) {
        _iterator146.e(err);
      } finally {
        _iterator146.f();
      }
      return e ? new u(e.start, e.end) : null;
    }
  }, {
    key: "getLastRange",
    value: function getLastRange() {
      var e = null;
      var _iterator147 = _createForOfIteratorHelper(this._ranges),
        _step147;
      try {
        for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
          var t = _step147.value;
          (!e || t.end.isAfter(e.end)) && (e = t);
        }
      } catch (err) {
        _iterator147.e(err);
      } finally {
        _iterator147.f();
      }
      return e ? new u(e.start, e.end) : null;
    }
  }, {
    key: "getFirstPosition",
    value: function getFirstPosition() {
      var e = this.getFirstRange();
      return e ? e.start.clone() : null;
    }
  }, {
    key: "getLastPosition",
    value: function getLastPosition() {
      var e = this.getLastRange();
      return e ? e.end.clone() : null;
    }
  }, {
    key: "setTo",
    value: function setTo() {
      for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        e[_key14] = arguments[_key14];
      }
      var t = e[0],
        n = e[1],
        r = e[2];
      if (_typeof(n) == "object" && (r = n, n = void 0), t === null) this._setRanges([]);else if (t instanceof $) this._setRanges(t.getRanges(), t.isBackward);else if (t && typeof t.getRanges == "function") this._setRanges(t.getRanges(), t.isBackward);else if (t instanceof u) this._setRanges([t], !!r && !!r.backward);else if (t instanceof m) this._setRanges([new u(t)]);else if (t instanceof ve) {
        var i = !!r && !!r.backward;
        var o;
        if (n == "in") o = u._createIn(t);else if (n == "on") o = u._createOn(t);else if (n !== void 0) o = new u(m._createAt(t, n));else throw new f("model-selection-setto-required-second-parameter", [this, t]);
        this._setRanges([o], i);
      } else if (le(t)) this._setRanges(t, r && !!r.backward);else throw new f("model-selection-setto-not-selectable", [this, t]);
    }
  }, {
    key: "_setRanges",
    value: function _setRanges(e) {
      var _this52 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = Array.from(e),
        r = n.some(function (i) {
          if (!(i instanceof u)) throw new f("model-selection-set-ranges-not-range", [_this52, e]);
          return _this52._ranges.every(function (o) {
            return !o.isEqual(i);
          });
        });
      n.length === this._ranges.length && !r || (this._replaceAllRanges(n), this._lastRangeBackward = !!t, this.fire("change:range", {
        directChange: !0
      }));
    }
  }, {
    key: "setFocus",
    value: function setFocus(e, t) {
      if (this.anchor === null) throw new f("model-selection-setfocus-no-ranges", [this, e]);
      var n = m._createAt(e, t);
      if (n.compareWith(this.focus) == "same") return;
      var r = this.anchor;
      this._ranges.length && this._popRange(), n.compareWith(r) == "before" ? (this._pushRange(new u(n, r)), this._lastRangeBackward = !0) : (this._pushRange(new u(r, n)), this._lastRangeBackward = !1), this.fire("change:range", {
        directChange: !0
      });
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(e) {
      return this._attrs.get(e);
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this._attrs.entries();
    }
  }, {
    key: "getAttributeKeys",
    value: function getAttributeKeys() {
      return this._attrs.keys();
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(e) {
      return this._attrs.has(e);
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(e) {
      this.hasAttribute(e) && (this._attrs.delete(e), this.fire("change:attribute", {
        attributeKeys: [e],
        directChange: !0
      }));
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(e, t) {
      this.getAttribute(e) !== t && (this._attrs.set(e, t), this.fire("change:attribute", {
        attributeKeys: [e],
        directChange: !0
      }));
    }
  }, {
    key: "getSelectedElement",
    value: function getSelectedElement() {
      return this.rangeCount !== 1 ? null : this.getFirstRange().getContainedElement();
    }
  }, {
    key: "getSelectedBlocks",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getSelectedBlocks() {
      var e, _iterator148, _step148, t, n, r, _iterator149, _step149, o, a, i;
      return _regeneratorRuntime().wrap(function getSelectedBlocks$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            e = new WeakSet();
            _iterator148 = _createForOfIteratorHelper(this.getRanges());
            _context15.prev = 2;
            _iterator148.s();
          case 4:
            if ((_step148 = _iterator148.n()).done) {
              _context15.next = 41;
              break;
            }
            t = _step148.value;
            n = yn(t.start, e);
            _context15.t0 = ti(n, t);
            if (!_context15.t0) {
              _context15.next = 11;
              break;
            }
            _context15.next = 11;
            return n;
          case 11:
            r = t.getWalker();
            _iterator149 = _createForOfIteratorHelper(r);
            _context15.prev = 13;
            _iterator149.s();
          case 15:
            if ((_step149 = _iterator149.n()).done) {
              _context15.next = 26;
              break;
            }
            o = _step149.value;
            a = o.item;
            if (!(o.type == "elementEnd" && ei(a, e, t))) {
              _context15.next = 23;
              break;
            }
            _context15.next = 21;
            return a;
          case 21:
            _context15.next = 24;
            break;
          case 23:
            o.type == "elementStart" && a.is("model:element") && a.root.document.model.schema.isBlock(a) && r.jumpTo(m._createAt(a, "end"));
          case 24:
            _context15.next = 15;
            break;
          case 26:
            _context15.next = 31;
            break;
          case 28:
            _context15.prev = 28;
            _context15.t1 = _context15["catch"](13);
            _iterator149.e(_context15.t1);
          case 31:
            _context15.prev = 31;
            _iterator149.f();
            return _context15.finish(31);
          case 34:
            i = yn(t.end, e);
            _context15.t2 = ni(i, t);
            if (!_context15.t2) {
              _context15.next = 39;
              break;
            }
            _context15.next = 39;
            return i;
          case 39:
            _context15.next = 4;
            break;
          case 41:
            _context15.next = 46;
            break;
          case 43:
            _context15.prev = 43;
            _context15.t3 = _context15["catch"](2);
            _iterator148.e(_context15.t3);
          case 46:
            _context15.prev = 46;
            _iterator148.f();
            return _context15.finish(46);
          case 49:
          case "end":
            return _context15.stop();
        }
      }, getSelectedBlocks, this, [[2, 43, 46, 49], [13, 28, 31, 34]]);
    })
  }, {
    key: "containsEntireContent",
    value: function containsEntireContent() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;
      var t = m._createAt(e, 0),
        n = m._createAt(e, "end");
      return t.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
    }
  }, {
    key: "_pushRange",
    value: function _pushRange(e) {
      this._checkRange(e), this._ranges.push(new u(e.start, e.end));
    }
  }, {
    key: "_checkRange",
    value: function _checkRange(e) {
      for (var t = 0; t < this._ranges.length; t++) if (e.isIntersecting(this._ranges[t])) throw new f("model-selection-range-intersects", [this, e], {
        addedRange: e,
        intersectingRange: this._ranges[t]
      });
    }
  }, {
    key: "_replaceAllRanges",
    value: function _replaceAllRanges(e) {
      this._removeAllRanges();
      var _iterator150 = _createForOfIteratorHelper(e),
        _step150;
      try {
        for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
          var t = _step150.value;
          this._pushRange(t);
        }
      } catch (err) {
        _iterator150.e(err);
      } finally {
        _iterator150.f();
      }
    }
  }, {
    key: "_removeAllRanges",
    value: function _removeAllRanges() {
      for (; this._ranges.length > 0;) this._popRange();
    }
  }, {
    key: "_popRange",
    value: function _popRange() {
      this._ranges.pop();
    }
  }]);
}(N(he));
$.prototype.is = function (s) {
  return s === "selection" || s === "model:selection";
};
function cs(s, e) {
  return e.has(s) ? !1 : (e.add(s), s.root.document.model.schema.isBlock(s) && !!s.parent);
}
function ei(s, e, t) {
  return cs(s, e) && Gt(s, t);
}
function yn(s, e) {
  var n = s.parent.root.document.model.schema,
    r = s.parent.getAncestors({
      parentFirst: !0,
      includeSelf: !0
    });
  var i = !1;
  var o = r.find(function (a) {
    return i ? !1 : (i = n.isLimit(a), !i && cs(a, e));
  });
  return r.forEach(function (a) {
    return e.add(a);
  }), o;
}
function Gt(s, e) {
  var t = si(s);
  return t ? !e.containsRange(u._createOn(t), !0) : !0;
}
function ti(s, e) {
  return s ? e.isCollapsed || s.isEmpty ? !0 : e.start.isTouching(m._createAt(s, s.maxOffset)) ? !1 : Gt(s, e) : !1;
}
function ni(s, e) {
  return s ? e.isCollapsed || s.isEmpty ? !0 : e.end.isTouching(m._createAt(s, 0)) ? !1 : Gt(s, e) : !1;
}
function si(s) {
  var e = s.root.document.model.schema;
  var t = s.parent;
  for (; t;) {
    if (e.isBlock(t)) return t;
    t = t.parent;
  }
}
var _e = /*#__PURE__*/function (_N9) {
  function _e(e, t) {
    var _this53;
    _classCallCheck(this, _e);
    _this53 = _callSuper(this, _e, [e, t]), ri.call(_assertThisInitialized(_this53));
    return _this53;
  }
  _inherits(_e, _N9);
  return _createClass(_e, [{
    key: "detach",
    value: function detach() {
      this.stopListening();
    }
  }, {
    key: "toRange",
    value: function toRange() {
      return new u(this.start, this.end);
    }
  }], [{
    key: "fromRange",
    value: function fromRange(e) {
      return new _e(e.start, e.end);
    }
  }]);
}(N(u));
_e.prototype.is = function (s) {
  return s === "liveRange" || s === "model:liveRange" || s == "range" || s === "model:range";
};
function ri() {
  var _this54 = this;
  this.listenTo(this.root.document.model, "applyOperation", function (s, e) {
    var t = e[0];
    t.isDocumentOperation && ii.call(_this54, t);
  }, {
    priority: "low"
  });
}
function ii(s) {
  var e = this.getTransformedByOperation(s),
    t = u._createFromRanges(e),
    n = !t.isEqual(this),
    r = oi(this, s);
  var i = null;
  if (n) {
    t.root.rootName == "$graveyard" && (s.type == "remove" ? i = s.sourcePosition : i = s.deletionPosition);
    var o = this.toRange();
    this.start = t.start, this.end = t.end, this.fire("change:range", o, {
      deletionPosition: i
    });
  } else r && this.fire("change:content", this.toRange(), {
    deletionPosition: i
  });
}
function oi(s, e) {
  switch (e.type) {
    case "insert":
      return s.containsPosition(e.position);
    case "move":
    case "remove":
    case "reinsert":
    case "merge":
      return s.containsPosition(e.sourcePosition) || s.start.isEqual(e.sourcePosition) || s.containsPosition(e.targetPosition);
    case "split":
      return s.containsPosition(e.splitPosition) || s.containsPosition(e.insertionPosition);
  }
  return !1;
}
var k = /*#__PURE__*/function (_ve) {
  function k(e, t) {
    var _this55;
    _classCallCheck(this, k);
    _this55 = _callSuper(this, k, [t]), _defineProperty(_assertThisInitialized(_this55), "_data", void 0), _this55._data = e || "";
    return _this55;
  }
  _inherits(k, _ve);
  return _createClass(k, [{
    key: "offsetSize",
    get: function get() {
      return this.data.length;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(k, "toJSON", this, 3)([]);
      return e.data = this.data, e;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      return new k(this.data, this.getAttributes());
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(e) {
      return new k(e.data, e.attributes);
    }
  }]);
}(ve);
k.prototype.is = function (s) {
  return s === "$text" || s === "model:$text" || s === "text" || s === "model:text" || s === "node" || s === "model:node";
};
var Ke = "selection:";
var G = /*#__PURE__*/function (_N0) {
  function G(e) {
    var _this56;
    _classCallCheck(this, G);
    _this56 = _callSuper(this, G), _defineProperty(_assertThisInitialized(_this56), "_selection", void 0), _this56._selection = new ai(e), _this56._selection.delegate("change:range").to(_assertThisInitialized(_this56)), _this56._selection.delegate("change:attribute").to(_assertThisInitialized(_this56)), _this56._selection.delegate("change:marker").to(_assertThisInitialized(_this56));
    return _this56;
  }
  _inherits(G, _N0);
  return _createClass(G, [{
    key: "isCollapsed",
    get: function get() {
      return this._selection.isCollapsed;
    }
  }, {
    key: "anchor",
    get: function get() {
      return this._selection.anchor;
    }
  }, {
    key: "focus",
    get: function get() {
      return this._selection.focus;
    }
  }, {
    key: "rangeCount",
    get: function get() {
      return this._selection.rangeCount;
    }
  }, {
    key: "hasOwnRange",
    get: function get() {
      return this._selection.hasOwnRange;
    }
  }, {
    key: "isBackward",
    get: function get() {
      return this._selection.isBackward;
    }
  }, {
    key: "isGravityOverridden",
    get: function get() {
      return this._selection.isGravityOverridden;
    }
  }, {
    key: "markers",
    get: function get() {
      return this._selection.markers;
    }
  }, {
    key: "_ranges",
    get: function get() {
      return this._selection._ranges;
    }
  }, {
    key: "getRanges",
    value: function getRanges() {
      return this._selection.getRanges();
    }
  }, {
    key: "getFirstPosition",
    value: function getFirstPosition() {
      return this._selection.getFirstPosition();
    }
  }, {
    key: "getLastPosition",
    value: function getLastPosition() {
      return this._selection.getLastPosition();
    }
  }, {
    key: "getFirstRange",
    value: function getFirstRange() {
      return this._selection.getFirstRange();
    }
  }, {
    key: "getLastRange",
    value: function getLastRange() {
      return this._selection.getLastRange();
    }
  }, {
    key: "getSelectedBlocks",
    value: function getSelectedBlocks() {
      return this._selection.getSelectedBlocks();
    }
  }, {
    key: "getSelectedElement",
    value: function getSelectedElement() {
      return this._selection.getSelectedElement();
    }
  }, {
    key: "containsEntireContent",
    value: function containsEntireContent(e) {
      return this._selection.containsEntireContent(e);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._selection.destroy();
    }
  }, {
    key: "getAttributeKeys",
    value: function getAttributeKeys() {
      return this._selection.getAttributeKeys();
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this._selection.getAttributes();
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(e) {
      return this._selection.getAttribute(e);
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(e) {
      return this._selection.hasAttribute(e);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this._selection.updateMarkers(), this._selection._updateAttributes(!1);
    }
  }, {
    key: "observeMarkers",
    value: function observeMarkers(e) {
      this._selection.observeMarkers(e);
    }
  }, {
    key: "_setFocus",
    value: function _setFocus(e, t) {
      this._selection.setFocus(e, t);
    }
  }, {
    key: "_setTo",
    value: function _setTo() {
      var _this$_selection2;
      (_this$_selection2 = this._selection).setTo.apply(_this$_selection2, arguments);
    }
  }, {
    key: "_setAttribute",
    value: function _setAttribute(e, t) {
      this._selection.setAttribute(e, t);
    }
  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(e) {
      this._selection.removeAttribute(e);
    }
  }, {
    key: "_getStoredAttributes",
    value: function _getStoredAttributes() {
      return this._selection.getStoredAttributes();
    }
  }, {
    key: "_overrideGravity",
    value: function _overrideGravity() {
      return this._selection.overrideGravity();
    }
  }, {
    key: "_restoreGravity",
    value: function _restoreGravity(e) {
      this._selection.restoreGravity(e);
    }
  }], [{
    key: "_getStoreAttributeKey",
    value: function _getStoreAttributeKey(e) {
      return Ke + e;
    }
  }, {
    key: "_isStoreAttributeKey",
    value: function _isStoreAttributeKey(e) {
      return e.startsWith(Ke);
    }
  }]);
}(N(he));
G.prototype.is = function (s) {
  return s === "selection" || s == "model:selection" || s == "documentSelection" || s == "model:documentSelection";
};
var ai = /*#__PURE__*/function (_$2) {
  function ai(e) {
    var _this57;
    _classCallCheck(this, ai);
    _this57 = _callSuper(this, ai), _defineProperty(_assertThisInitialized(_this57), "markers", new Lt({
      idProperty: "name"
    })), _defineProperty(_assertThisInitialized(_this57), "_model", void 0), _defineProperty(_assertThisInitialized(_this57), "_document", void 0), _defineProperty(_assertThisInitialized(_this57), "_attributePriority", new Map()), _defineProperty(_assertThisInitialized(_this57), "_selectionRestorePosition", null), _defineProperty(_assertThisInitialized(_this57), "_hasChangedRange", !1), _defineProperty(_assertThisInitialized(_this57), "_overriddenGravityRegister", new Set()), _defineProperty(_assertThisInitialized(_this57), "_observedMarkers", new Set()), _this57._model = e.model, _this57._document = e, _this57.listenTo(_this57._model, "applyOperation", function (t, n) {
      var r = n[0];
      !r.isDocumentOperation || r.type == "marker" || r.type == "rename" || r.type == "noop" || (_this57._ranges.length == 0 && _this57._selectionRestorePosition && _this57._fixGraveyardSelection(_this57._selectionRestorePosition), _this57._selectionRestorePosition = null, _this57._hasChangedRange && (_this57._hasChangedRange = !1, _this57.fire("change:range", {
        directChange: !1
      })));
    }, {
      priority: "lowest"
    }), _this57.on("change:range", function () {
      _this57._validateSelectionRanges(_this57.getRanges());
    }), _this57.listenTo(_this57._model.markers, "update", function (t, n, r, i) {
      _this57._updateMarker(n, i);
    }), _this57.listenTo(_this57._document, "change", function (t, n) {
      li(_this57._model, n);
    });
    return _this57;
  }
  _inherits(ai, _$2);
  return _createClass(ai, [{
    key: "isCollapsed",
    get: function get() {
      return this._ranges.length === 0 ? this._document._getDefaultRange().isCollapsed : _superPropGet(ai, "isCollapsed", this, 1);
    }
  }, {
    key: "anchor",
    get: function get() {
      return _superPropGet(ai, "anchor", this, 1) || this._document._getDefaultRange().start;
    }
  }, {
    key: "focus",
    get: function get() {
      return _superPropGet(ai, "focus", this, 1) || this._document._getDefaultRange().end;
    }
  }, {
    key: "rangeCount",
    get: function get() {
      return this._ranges.length ? this._ranges.length : 1;
    }
  }, {
    key: "hasOwnRange",
    get: function get() {
      return this._ranges.length > 0;
    }
  }, {
    key: "isGravityOverridden",
    get: function get() {
      return !!this._overriddenGravityRegister.size;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var e = 0; e < this._ranges.length; e++) this._ranges[e].detach();
      this.stopListening();
    }
  }, {
    key: "getRanges",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
      return _regeneratorRuntime().wrap(function getRanges$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            if (!this._ranges.length) {
              _context16.next = 4;
              break;
            }
            return _context16.delegateYield(_superPropGet(ai, "getRanges", this, 3)([]), "t0", 2);
          case 2:
            _context16.next = 6;
            break;
          case 4:
            _context16.next = 6;
            return this._document._getDefaultRange();
          case 6:
          case "end":
            return _context16.stop();
        }
      }, getRanges, this);
    })
  }, {
    key: "getFirstRange",
    value: function getFirstRange() {
      return _superPropGet(ai, "getFirstRange", this, 3)([]) || this._document._getDefaultRange();
    }
  }, {
    key: "getLastRange",
    value: function getLastRange() {
      return _superPropGet(ai, "getLastRange", this, 3)([]) || this._document._getDefaultRange();
    }
  }, {
    key: "setTo",
    value: function setTo() {
      for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        e[_key15] = arguments[_key15];
      }
      _superPropGet(ai, "setTo", this, 3)(e), this._updateAttributes(!0), this.updateMarkers();
    }
  }, {
    key: "setFocus",
    value: function setFocus(e, t) {
      _superPropGet(ai, "setFocus", this, 3)([e, t]), this._updateAttributes(!0), this.updateMarkers();
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(e, t) {
      if (this._setAttribute(e, t)) {
        var n = [e];
        this.fire("change:attribute", {
          attributeKeys: n,
          directChange: !0
        });
      }
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(e) {
      if (this._removeAttribute(e)) {
        var t = [e];
        this.fire("change:attribute", {
          attributeKeys: t,
          directChange: !0
        });
      }
    }
  }, {
    key: "overrideGravity",
    value: function overrideGravity() {
      var e = Fs();
      return this._overriddenGravityRegister.add(e), this._overriddenGravityRegister.size === 1 && this._updateAttributes(!0), e;
    }
  }, {
    key: "restoreGravity",
    value: function restoreGravity(e) {
      if (!this._overriddenGravityRegister.has(e)) throw new f("document-selection-gravity-wrong-restore", this, {
        uid: e
      });
      this._overriddenGravityRegister.delete(e), this.isGravityOverridden || this._updateAttributes(!0);
    }
  }, {
    key: "observeMarkers",
    value: function observeMarkers(e) {
      this._observedMarkers.add(e), this.updateMarkers();
    }
  }, {
    key: "_replaceAllRanges",
    value: function _replaceAllRanges(e) {
      this._validateSelectionRanges(e), _superPropGet(ai, "_replaceAllRanges", this, 3)([e]);
    }
  }, {
    key: "_popRange",
    value: function _popRange() {
      this._ranges.pop().detach();
    }
  }, {
    key: "_pushRange",
    value: function _pushRange(e) {
      var t = this._prepareRange(e);
      t && this._ranges.push(t);
    }
  }, {
    key: "_validateSelectionRanges",
    value: function _validateSelectionRanges(e) {
      var _iterator151 = _createForOfIteratorHelper(e),
        _step151;
      try {
        for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
          var t = _step151.value;
          if (!this._document._validateSelectionRange(t)) throw new f("document-selection-wrong-position", this, {
            range: t
          });
        }
      } catch (err) {
        _iterator151.e(err);
      } finally {
        _iterator151.f();
      }
    }
  }, {
    key: "_prepareRange",
    value: function _prepareRange(e) {
      var _this58 = this;
      if (this._checkRange(e), e.root == this._document.graveyard) return;
      var t = _e.fromRange(e);
      return t.on("change:range", function (n, r, i) {
        if (_this58._hasChangedRange = !0, t.root == _this58._document.graveyard) {
          _this58._selectionRestorePosition = i.deletionPosition;
          var o = _this58._ranges.indexOf(t);
          _this58._ranges.splice(o, 1), t.detach();
        }
      }), t;
    }
  }, {
    key: "updateMarkers",
    value: function updateMarkers() {
      if (!this._observedMarkers.size) return;
      var e = [];
      var t = !1;
      var _iterator152 = _createForOfIteratorHelper(this._model.markers),
        _step152;
      try {
        for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
          var _r12 = _step152.value;
          var i = _r12.name.split(":", 1)[0];
          if (!this._observedMarkers.has(i)) continue;
          var o = _r12.getRange();
          var _iterator153 = _createForOfIteratorHelper(this.getRanges()),
            _step153;
          try {
            for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
              var a = _step153.value;
              o.containsRange(a, !a.isCollapsed) && e.push(_r12);
            }
          } catch (err) {
            _iterator153.e(err);
          } finally {
            _iterator153.f();
          }
        }
      } catch (err) {
        _iterator152.e(err);
      } finally {
        _iterator152.f();
      }
      var n = Array.from(this.markers);
      for (var _i32 = 0, _e7 = e; _i32 < _e7.length; _i32++) {
        var r = _e7[_i32];
        this.markers.has(r) || (this.markers.add(r), t = !0);
      }
      for (var _i33 = 0, _Array$from5 = Array.from(this.markers); _i33 < _Array$from5.length; _i33++) {
        var _r11 = _Array$from5[_i33];
        e.includes(_r11) || (this.markers.remove(_r11), t = !0);
      }
      t && this.fire("change:marker", {
        oldMarkers: n,
        directChange: !1
      });
    }
  }, {
    key: "_updateMarker",
    value: function _updateMarker(e, t) {
      var n = e.name.split(":", 1)[0];
      if (!this._observedMarkers.has(n)) return;
      var r = !1;
      var i = Array.from(this.markers),
        o = this.markers.has(e);
      if (!t) o && (this.markers.remove(e), r = !0);else {
        var a = !1;
        var _iterator154 = _createForOfIteratorHelper(this.getRanges()),
          _step154;
        try {
          for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
            var l = _step154.value;
            if (t.containsRange(l, !l.isCollapsed)) {
              a = !0;
              break;
            }
          }
        } catch (err) {
          _iterator154.e(err);
        } finally {
          _iterator154.f();
        }
        a && !o ? (this.markers.add(e), r = !0) : !a && o && (this.markers.remove(e), r = !0);
      }
      r && this.fire("change:marker", {
        oldMarkers: i,
        directChange: !1
      });
    }
  }, {
    key: "_updateAttributes",
    value: function _updateAttributes(e) {
      var t = pe(this._getSurroundingAttributes()),
        n = pe(this.getAttributes());
      if (e) this._attributePriority = new Map(), this._attrs = new Map();else {
        var _iterator155 = _createForOfIteratorHelper(this._attributePriority),
          _step155;
        try {
          for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
            var _ref67 = _step155.value;
            var _ref68 = _slicedToArray(_ref67, 2);
            var i = _ref68[0];
            var o = _ref68[1];
            o == "low" && (this._attrs.delete(i), this._attributePriority.delete(i));
          }
        } catch (err) {
          _iterator155.e(err);
        } finally {
          _iterator155.f();
        }
      }
      this._setAttributesTo(t);
      var r = [];
      var _iterator156 = _createForOfIteratorHelper(this.getAttributes()),
        _step156;
      try {
        for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
          var _ref69 = _step156.value;
          var _ref70 = _slicedToArray(_ref69, 2);
          var _i34 = _ref70[0];
          var _o15 = _ref70[1];
          (!n.has(_i34) || n.get(_i34) !== _o15) && r.push(_i34);
        }
      } catch (err) {
        _iterator156.e(err);
      } finally {
        _iterator156.f();
      }
      var _iterator157 = _createForOfIteratorHelper(n),
        _step157;
      try {
        for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
          var _ref71 = _step157.value;
          var _ref72 = _slicedToArray(_ref71, 1);
          var _i35 = _ref72[0];
          this.hasAttribute(_i35) || r.push(_i35);
        }
      } catch (err) {
        _iterator157.e(err);
      } finally {
        _iterator157.f();
      }
      r.length > 0 && this.fire("change:attribute", {
        attributeKeys: r,
        directChange: !1
      });
    }
  }, {
    key: "_setAttribute",
    value: function _setAttribute(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var r = n ? "normal" : "low";
      return r == "low" && this._attributePriority.get(e) == "normal" || _superPropGet(ai, "getAttribute", this, 3)([e]) === t ? !1 : (this._attrs.set(e, t), this._attributePriority.set(e, r), !0);
    }
  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var n = t ? "normal" : "low";
      return n == "low" && this._attributePriority.get(e) == "normal" || (this._attributePriority.set(e, n), !_superPropGet(ai, "hasAttribute", this, 3)([e])) ? !1 : (this._attrs.delete(e), !0);
    }
  }, {
    key: "_setAttributesTo",
    value: function _setAttributesTo(e) {
      var t = new Set();
      var _iterator158 = _createForOfIteratorHelper(this.getAttributes()),
        _step158;
      try {
        for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
          var _ref73 = _step158.value;
          var _ref74 = _slicedToArray(_ref73, 2);
          var n = _ref74[0];
          var r = _ref74[1];
          e.get(n) !== r && this._removeAttribute(n, !1);
        }
      } catch (err) {
        _iterator158.e(err);
      } finally {
        _iterator158.f();
      }
      var _iterator159 = _createForOfIteratorHelper(e),
        _step159;
      try {
        for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
          var _ref75 = _step159.value;
          var _ref76 = _slicedToArray(_ref75, 2);
          var _n13 = _ref76[0];
          var _r13 = _ref76[1];
          this._setAttribute(_n13, _r13, !1) && t.add(_n13);
        }
      } catch (err) {
        _iterator159.e(err);
      } finally {
        _iterator159.f();
      }
      return t;
    }
  }, {
    key: "getStoredAttributes",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getStoredAttributes() {
      var e, _iterator160, _step160, t;
      return _regeneratorRuntime().wrap(function getStoredAttributes$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            e = this.getFirstPosition().parent;
            if (!(this.isCollapsed && e.isEmpty)) {
              _context17.next = 21;
              break;
            }
            _iterator160 = _createForOfIteratorHelper(e.getAttributeKeys());
            _context17.prev = 3;
            _iterator160.s();
          case 5:
            if ((_step160 = _iterator160.n()).done) {
              _context17.next = 13;
              break;
            }
            t = _step160.value;
            _context17.t0 = t.startsWith(Ke);
            if (!_context17.t0) {
              _context17.next = 11;
              break;
            }
            _context17.next = 11;
            return [t.substr(Ke.length), e.getAttribute(t)];
          case 11:
            _context17.next = 5;
            break;
          case 13:
            _context17.next = 18;
            break;
          case 15:
            _context17.prev = 15;
            _context17.t1 = _context17["catch"](3);
            _iterator160.e(_context17.t1);
          case 18:
            _context17.prev = 18;
            _iterator160.f();
            return _context17.finish(18);
          case 21:
          case "end":
            return _context17.stop();
        }
      }, getStoredAttributes, this, [[3, 15, 18, 21]]);
    })
  }, {
    key: "_getSurroundingAttributes",
    value: function _getSurroundingAttributes() {
      var e = this.getFirstPosition(),
        t = this._model.schema;
      if (e.root.rootName == "$graveyard") return null;
      var n = null;
      if (this.isCollapsed) {
        var r = e.textNode ? e.textNode : e.nodeBefore,
          i = e.textNode ? e.textNode : e.nodeAfter;
        if (this.isGravityOverridden || (n = De(r, t)), n || (n = De(i, t)), !this.isGravityOverridden && !n) {
          var o = r;
          for (; o && !n;) o = o.previousSibling, n = De(o, t);
        }
        if (!n) {
          var _o16 = i;
          for (; _o16 && !n;) _o16 = _o16.nextSibling, n = De(_o16, t);
        }
        n || (n = this.getStoredAttributes());
      } else {
        var _r14 = this.getFirstRange();
        var _iterator161 = _createForOfIteratorHelper(_r14),
          _step161;
        try {
          for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
            var _i36 = _step161.value;
            if (_i36.item.is("element") && t.isObject(_i36.item)) {
              n = De(_i36.item, t);
              break;
            }
            if (_i36.type == "text") {
              n = _i36.item.getAttributes();
              break;
            }
          }
        } catch (err) {
          _iterator161.e(err);
        } finally {
          _iterator161.f();
        }
      }
      return n;
    }
  }, {
    key: "_fixGraveyardSelection",
    value: function _fixGraveyardSelection(e) {
      var t = this._model.schema.getNearestSelectionRange(e);
      t && this._pushRange(t);
    }
  }]);
}($);
function De(s, e) {
  if (!s) return null;
  if (s instanceof j || s instanceof k) return s.getAttributes();
  if (!e.isInline(s)) return null;
  if (!e.isObject(s)) return [];
  var t = [];
  var _iterator162 = _createForOfIteratorHelper(s.getAttributes()),
    _step162;
  try {
    for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
      var _ref77 = _step162.value;
      var _ref78 = _slicedToArray(_ref77, 2);
      var n = _ref78[0];
      var r = _ref78[1];
      e.checkAttribute("$text", n) && e.getAttributeProperties(n).copyFromObject !== !1 && t.push([n, r]);
    }
  } catch (err) {
    _iterator162.e(err);
  } finally {
    _iterator162.f();
  }
  return t;
}
function li(s, e) {
  var t = s.document.differ;
  var _iterator163 = _createForOfIteratorHelper(t.getChanges()),
    _step163;
  try {
    var _loop2 = function _loop2() {
      var n = _step163.value;
      if (n.type != "insert") return 1; // continue
      var r = n.position.parent;
      n.length === r.maxOffset && s.enqueueChange(e, function (o) {
        var a = Array.from(r.getAttributeKeys()).filter(function (l) {
          return l.startsWith(Ke);
        });
        var _iterator164 = _createForOfIteratorHelper(a),
          _step164;
        try {
          for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
            var l = _step164.value;
            o.removeAttribute(l, r);
          }
        } catch (err) {
          _iterator164.e(err);
        } finally {
          _iterator164.f();
        }
      });
    };
    for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
      if (_loop2()) continue;
    }
  } catch (err) {
    _iterator163.e(err);
  } finally {
    _iterator163.f();
  }
}
var ze = /*#__PURE__*/function () {
  function ze(e) {
    _classCallCheck(this, ze);
    _defineProperty(this, "_nodes", []);
    _defineProperty(this, "_offsetToNode", []);
    e && this._insertNodes(0, e);
  }
  return _createClass(ze, [{
    key: Symbol.iterator,
    value: function value() {
      return this._nodes[Symbol.iterator]();
    }
  }, {
    key: "length",
    get: function get() {
      return this._nodes.length;
    }
  }, {
    key: "maxOffset",
    get: function get() {
      return this._offsetToNode.length;
    }
  }, {
    key: "getNode",
    value: function getNode(e) {
      return this._nodes[e] || null;
    }
  }, {
    key: "getNodeAtOffset",
    value: function getNodeAtOffset(e) {
      return this._offsetToNode[e] || null;
    }
  }, {
    key: "getNodeIndex",
    value: function getNodeIndex(e) {
      return e.index;
    }
  }, {
    key: "getNodeStartOffset",
    value: function getNodeStartOffset(e) {
      return e.startOffset;
    }
  }, {
    key: "indexToOffset",
    value: function indexToOffset(e) {
      if (e == this._nodes.length) return this.maxOffset;
      var t = this._nodes[e];
      if (!t) throw new f("model-nodelist-index-out-of-bounds", this);
      return this.getNodeStartOffset(t);
    }
  }, {
    key: "offsetToIndex",
    value: function offsetToIndex(e) {
      if (e == this._offsetToNode.length) return this._nodes.length;
      var t = this._offsetToNode[e];
      if (!t) throw new f("model-nodelist-offset-out-of-bounds", this, {
        offset: e,
        nodeList: this
      });
      return this.getNodeIndex(t);
    }
  }, {
    key: "_insertNodes",
    value: function _insertNodes(e, t) {
      var n = [];
      var _iterator165 = _createForOfIteratorHelper(t),
        _step165;
      try {
        for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
          var _i37 = _step165.value;
          if (!(_i37 instanceof ve)) throw new f("model-nodelist-insertnodes-not-node", this);
          n.push(_i37);
        }
      } catch (err) {
        _iterator165.e(err);
      } finally {
        _iterator165.f();
      }
      var r = this.indexToOffset(e);
      en(this._nodes, n, e), en(this._offsetToNode, ci(n), r);
      for (var i = e; i < this._nodes.length; i++) this._nodes[i]._index = i, this._nodes[i]._startOffset = r, r += this._nodes[i].offsetSize;
    }
  }, {
    key: "_removeNodes",
    value: function _removeNodes(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (t == 0) return [];
      var n = this.indexToOffset(e);
      var r = this._nodes.splice(e, t),
        i = r[r.length - 1],
        o = i.startOffset + i.offsetSize - n;
      this._offsetToNode.splice(n, o);
      var _iterator166 = _createForOfIteratorHelper(r),
        _step166;
      try {
        for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
          var _a9 = _step166.value;
          _a9._index = null, _a9._startOffset = null;
        }
      } catch (err) {
        _iterator166.e(err);
      } finally {
        _iterator166.f();
      }
      for (var a = e; a < this._nodes.length; a++) this._nodes[a]._index = a, this._nodes[a]._startOffset = n, n += this._nodes[a].offsetSize;
      return r;
    }
  }, {
    key: "_removeNodesArray",
    value: function _removeNodesArray(e) {
      if (e.length == 0) return;
      var _iterator167 = _createForOfIteratorHelper(e),
        _step167;
      try {
        for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
          var _n14 = _step167.value;
          _n14._index = null, _n14._startOffset = null;
        }
      } catch (err) {
        _iterator167.e(err);
      } finally {
        _iterator167.f();
      }
      this._nodes = this._nodes.filter(function (n) {
        return n.index !== null;
      }), this._offsetToNode = this._offsetToNode.filter(function (n) {
        return n.index !== null;
      });
      var t = 0;
      for (var n = 0; n < this._nodes.length; n++) this._nodes[n]._index = n, this._nodes[n]._startOffset = t, t += this._nodes[n].offsetSize;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this._nodes.map(function (e) {
        return e.toJSON();
      });
    }
  }]);
}();
function ci(s) {
  var e = [];
  var t = 0;
  var _iterator168 = _createForOfIteratorHelper(s),
    _step168;
  try {
    for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
      var n = _step168.value;
      for (var r = 0; r < n.offsetSize; r++) e[t++] = n;
    }
  } catch (err) {
    _iterator168.e(err);
  } finally {
    _iterator168.f();
  }
  return e;
}
var C = /*#__PURE__*/function (_ve2) {
  function C(e, t, n) {
    var _this59;
    _classCallCheck(this, C);
    _this59 = _callSuper(this, C, [t]), _defineProperty(_assertThisInitialized(_this59), "name", void 0), _defineProperty(_assertThisInitialized(_this59), "_children", new ze()), _this59.name = e, n && _this59._insertChild(0, n);
    return _this59;
  }
  _inherits(C, _ve2);
  return _createClass(C, [{
    key: "childCount",
    get: function get() {
      return this._children.length;
    }
  }, {
    key: "maxOffset",
    get: function get() {
      return this._children.maxOffset;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.childCount === 0;
    }
  }, {
    key: "getChild",
    value: function getChild(e) {
      return this._children.getNode(e);
    }
  }, {
    key: "getChildAtOffset",
    value: function getChildAtOffset(e) {
      return this._children.getNodeAtOffset(e);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children[Symbol.iterator]();
    }
  }, {
    key: "getChildIndex",
    value: function getChildIndex(e) {
      return this._children.getNodeIndex(e);
    }
  }, {
    key: "getChildStartOffset",
    value: function getChildStartOffset(e) {
      return this._children.getNodeStartOffset(e);
    }
  }, {
    key: "offsetToIndex",
    value: function offsetToIndex(e) {
      return this._children.offsetToIndex(e);
    }
  }, {
    key: "getNodeByPath",
    value: function getNodeByPath(e) {
      var t = this;
      var _iterator169 = _createForOfIteratorHelper(e),
        _step169;
      try {
        for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
          var n = _step169.value;
          t = t.getChildAtOffset(n);
        }
      } catch (err) {
        _iterator169.e(err);
      } finally {
        _iterator169.f();
      }
      return t;
    }
  }, {
    key: "findAncestor",
    value: function findAncestor(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = t.includeSelf ? this : this.parent;
      for (; n;) {
        if (n.name === e) return n;
        n = n.parent;
      }
      return null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(C, "toJSON", this, 3)([]);
      if (e.name = this.name, this._children.length > 0) {
        e.children = [];
        var _iterator170 = _createForOfIteratorHelper(this._children),
          _step170;
        try {
          for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
            var t = _step170.value;
            e.children.push(t.toJSON());
          }
        } catch (err) {
          _iterator170.e(err);
        } finally {
          _iterator170.f();
        }
      }
      return e;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = e ? ui(this._children) : void 0;
      return new C(this.name, this.getAttributes(), t);
    }
  }, {
    key: "_appendChild",
    value: function _appendChild(e) {
      this._insertChild(this.childCount, e);
    }
  }, {
    key: "_insertChild",
    value: function _insertChild(e, t) {
      var n = hi(t);
      var _iterator171 = _createForOfIteratorHelper(n),
        _step171;
      try {
        for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
          var r = _step171.value;
          r.parent !== null && r._remove(), r.parent = this;
        }
      } catch (err) {
        _iterator171.e(err);
      } finally {
        _iterator171.f();
      }
      this._children._insertNodes(e, n);
    }
  }, {
    key: "_removeChildren",
    value: function _removeChildren(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = this._children._removeNodes(e, t);
      var _iterator172 = _createForOfIteratorHelper(n),
        _step172;
      try {
        for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
          var r = _step172.value;
          r.parent = null;
        }
      } catch (err) {
        _iterator172.e(err);
      } finally {
        _iterator172.f();
      }
      return n;
    }
  }, {
    key: "_removeChildrenArray",
    value: function _removeChildrenArray(e) {
      this._children._removeNodesArray(e);
      var _iterator173 = _createForOfIteratorHelper(e),
        _step173;
      try {
        for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
          var t = _step173.value;
          t.parent = null;
        }
      } catch (err) {
        _iterator173.e(err);
      } finally {
        _iterator173.f();
      }
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(e) {
      var t;
      if (e.children) {
        t = [];
        var _iterator174 = _createForOfIteratorHelper(e.children),
          _step174;
        try {
          for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
            var n = _step174.value;
            n.name ? t.push(C.fromJSON(n)) : t.push(k.fromJSON(n));
          }
        } catch (err) {
          _iterator174.e(err);
        } finally {
          _iterator174.f();
        }
      }
      return new C(e.name, e.attributes, t);
    }
  }]);
}(ve);
C.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "element" || s === "model:element") : s === "element" || s === "model:element" || s === "node" || s === "model:node";
};
function hi(s) {
  if (typeof s == "string") return [new k(s)];
  le(s) || (s = [s]);
  var e = [];
  var _iterator175 = _createForOfIteratorHelper(s),
    _step175;
  try {
    for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
      var t = _step175.value;
      typeof t == "string" ? e.push(new k(t)) : t instanceof j ? e.push(new k(t.data, t.getAttributes())) : e.push(t);
    }
  } catch (err) {
    _iterator175.e(err);
  } finally {
    _iterator175.f();
  }
  return e;
}
function ui(s) {
  var e = [];
  var _iterator176 = _createForOfIteratorHelper(s),
    _step176;
  try {
    for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
      var t = _step176.value;
      e.push(t._clone(!0));
    }
  } catch (err) {
    _iterator176.e(err);
  } finally {
    _iterator176.f();
  }
  return e;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var hs = /*#__PURE__*/function () {
  function hs(e) {
    _classCallCheck(this, hs);
    _defineProperty(this, "_dispatchers", void 0);
    this._dispatchers = e;
  }
  return _createClass(hs, [{
    key: "add",
    value: function add(e) {
      var _iterator177 = _createForOfIteratorHelper(this._dispatchers),
        _step177;
      try {
        for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
          var t = _step177.value;
          e(t);
        }
      } catch (err) {
        _iterator177.e(err);
      } finally {
        _iterator177.f();
      }
      return this;
    }
  }]);
}();
var fi = /*#__PURE__*/function (_hs2) {
  function fi() {
    _classCallCheck(this, fi);
    return _callSuper(this, fi, arguments);
  }
  _inherits(fi, _hs2);
  return _createClass(fi, [{
    key: "elementToElement",
    value: function elementToElement(e) {
      return this.add(Mi(e));
    }
  }, {
    key: "elementToStructure",
    value: function elementToStructure(e) {
      return this.add(xi(e));
    }
  }, {
    key: "attributeToElement",
    value: function attributeToElement(e) {
      return this.add(Ni(e));
    }
  }, {
    key: "attributeToAttribute",
    value: function attributeToAttribute(e) {
      return this.add(Oi(e));
    }
  }, {
    key: "markerToElement",
    value: function markerToElement(e) {
      return this.add(Ii(e));
    }
  }, {
    key: "markerToHighlight",
    value: function markerToHighlight(e) {
      return this.add(Di(e));
    }
  }, {
    key: "markerToData",
    value: function markerToData(e) {
      return this.add(Fi(e));
    }
  }]);
}(hs);
function us() {
  return function (s, e, t) {
    if (!t.consumable.consume(e.item, s.name)) return;
    var n = t.writer,
      r = t.mapper.toViewPosition(e.range.start),
      i = n.createText(e.item.data);
    n.insert(r, i);
  };
}
function fs() {
  return function (s, e, t) {
    t.convertAttributes(e.item), !e.reconversion && e.item.is("element") && !e.item.isEmpty && t.convertChildren(e.item);
  };
}
function di() {
  return function (s, e, t) {
    var n = t.mapper.toViewPosition(e.position),
      r = e.position.getShiftedBy(e.length),
      i = t.mapper.toViewPosition(r, {
        isPhantom: !0
      }),
      o = t.writer.createRange(n, i),
      a = t.writer.remove(o.getTrimmed());
    var _iterator178 = _createForOfIteratorHelper(t.writer.createRangeIn(a).getItems()),
      _step178;
    try {
      for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
        var l = _step178.value;
        t.mapper.unbindViewElement(l, {
          defer: !0
        });
      }
    } catch (err) {
      _iterator178.e(err);
    } finally {
      _iterator178.f();
    }
  };
}
function ds(s, e) {
  var t = s.createAttributeElement("span", e.attributes);
  return e.classes && t._addClass(e.classes), typeof e.priority == "number" && (t._priority = e.priority), t._id = e.id, t;
}
function mi() {
  return function (s, e, t) {
    var n = e.selection;
    if (n.isCollapsed || !t.consumable.consume(n, "selection")) return;
    var r = [];
    var _iterator179 = _createForOfIteratorHelper(n.getRanges()),
      _step179;
    try {
      for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
        var i = _step179.value;
        r.push(t.mapper.toViewRange(i));
      }
    } catch (err) {
      _iterator179.e(err);
    } finally {
      _iterator179.f();
    }
    t.writer.setSelection(r, {
      backward: n.isBackward
    });
  };
}
function gi() {
  return function (s, e, t) {
    var n = e.selection;
    if (!n.isCollapsed || !t.consumable.consume(n, "selection")) return;
    var r = t.writer,
      i = n.getFirstPosition(),
      o = t.mapper.toViewPosition(i),
      a = r.breakAttributes(o);
    r.setSelection(a);
  };
}
function pi() {
  return function (s, e, t) {
    var n = t.writer,
      r = n.document.selection;
    var _iterator180 = _createForOfIteratorHelper(r.getRanges()),
      _step180;
    try {
      for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
        var i = _step180.value;
        i.isCollapsed && i.end.parent.isAttached() && t.writer.mergeAttributes(i.start);
      }
    } catch (err) {
      _iterator180.e(err);
    } finally {
      _iterator180.f();
    }
    n.setSelection(null);
  };
}
function _i(s) {
  return function (e, t, n) {
    if (!n.consumable.test(t.item, e.name)) return;
    var r = s(t.attributeOldValue, n, t),
      i = s(t.attributeNewValue, n, t);
    if (!r && !i) return;
    n.consumable.consume(t.item, e.name);
    var o = n.writer,
      a = o.document.selection;
    if (t.item instanceof $ || t.item instanceof G) o.wrap(a.getFirstRange(), i);else {
      var l = n.mapper.toViewRange(t.range);
      t.attributeOldValue !== null && r && (l = o.unwrap(l, r)), t.attributeNewValue !== null && i && o.wrap(l, i);
    }
  };
}
function wi(s) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : zi;
  return function (t, n, r) {
    if (!e(n.item, r.consumable, {
      preflight: !0
    })) return;
    var i = s(n.item, r, n);
    if (!i) return;
    e(n.item, r.consumable);
    var o = r.mapper.toViewPosition(n.range.start);
    r.mapper.bindElements(n.item, i), r.writer.insert(o, i), r.convertAttributes(n.item), ws(i, n.item.getChildren(), r, {
      reconversion: n.reconversion
    });
  };
}
function bi(s, e) {
  return function (t, n, r) {
    if (!e(n.item, r.consumable, {
      preflight: !0
    })) return;
    var i = new Map();
    r.writer._registerSlotFactory($i(n.item, i, r));
    var o = s(n.item, r, n);
    if (r.writer._clearSlotFactory(), !o) return;
    Li(n.item, i, r), e(n.item, r.consumable);
    var a = r.mapper.toViewPosition(n.range.start);
    r.mapper.bindElements(n.item, o), r.writer.insert(a, o), r.convertAttributes(n.item), Wi(o, i, r, {
      reconversion: n.reconversion
    });
  };
}
function yi(s) {
  return function (e, t, n) {
    t.isOpening = !0;
    var r = s(t, n);
    t.isOpening = !1;
    var i = s(t, n);
    if (!r || !i) return;
    var o = t.markerRange;
    if (o.isCollapsed && !n.consumable.consume(o, e.name)) return;
    var _iterator181 = _createForOfIteratorHelper(o),
      _step181;
    try {
      for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
        var c = _step181.value;
        if (!n.consumable.consume(c.item, e.name)) return;
      }
    } catch (err) {
      _iterator181.e(err);
    } finally {
      _iterator181.f();
    }
    var a = n.mapper,
      l = n.writer;
    l.insert(a.toViewPosition(o.start), r), n.mapper.bindElementToMarker(r, t.markerName), o.isCollapsed || (l.insert(a.toViewPosition(o.end), i), n.mapper.bindElementToMarker(i, t.markerName)), e.stop();
  };
}
function vi() {
  return function (s, e, t) {
    var n = t.mapper.markerNameToElements(e.markerName);
    if (n) {
      var _iterator182 = _createForOfIteratorHelper(n),
        _step182;
      try {
        for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
          var r = _step182.value;
          t.mapper.unbindElementFromMarkerName(r, e.markerName), t.writer.clear(t.writer.createRangeOn(r), r);
        }
      } catch (err) {
        _iterator182.e(err);
      } finally {
        _iterator182.f();
      }
      t.writer.clearClonedElementsGroup(e.markerName), s.stop();
    }
  };
}
function Pi(s) {
  return function (e, t, n) {
    var r = s(t.markerName, n);
    if (!r) return;
    var i = t.markerRange;
    n.consumable.consume(i, e.name) && (vn(i, !1, n, t, r), vn(i, !0, n, t, r), e.stop());
  };
}
function vn(s, e, t, n, r) {
  var i = e ? s.start : s.end,
    o = i.nodeAfter && i.nodeAfter.is("element") ? i.nodeAfter : null,
    a = i.nodeBefore && i.nodeBefore.is("element") ? i.nodeBefore : null;
  if (o || a) {
    var c, h;
    e && o || !e && !a ? (c = o, h = !0) : (c = a, h = !1);
    var d = t.mapper.toViewElement(c);
    if (d) {
      Ci(d, e, h, t, n, r);
      return;
    }
  }
  var l = t.mapper.toViewPosition(i);
  ki(l, e, t, n, r);
}
function Ci(s, e, t, n, r, i) {
  var o = "data-".concat(i.group, "-").concat(e ? "start" : "end", "-").concat(t ? "before" : "after"),
    a = s.hasAttribute(o) ? s.getAttribute(o).split(",") : [];
  a.unshift(i.name), n.writer.setAttribute(o, a.join(","), s), n.mapper.bindElementToMarker(s, r.markerName);
}
function ki(s, e, t, n, r) {
  var i = "".concat(r.group, "-").concat(e ? "start" : "end"),
    o = r.name ? {
      name: r.name
    } : null,
    a = t.writer.createUIElement(i, o);
  t.writer.insert(s, a), t.mapper.bindElementToMarker(a, n.markerName);
}
function Ai(s) {
  return function (e, t, n) {
    var r = s(t.markerName, n);
    if (!r) return;
    var i = n.mapper.markerNameToElements(t.markerName);
    if (!i) return;
    var _iterator183 = _createForOfIteratorHelper(i),
      _step183;
    try {
      for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
        var a = _step183.value;
        n.mapper.unbindElementFromMarkerName(a, t.markerName), a.is("containerElement") ? (o("data-".concat(r.group, "-start-before"), a), o("data-".concat(r.group, "-start-after"), a), o("data-".concat(r.group, "-end-before"), a), o("data-".concat(r.group, "-end-after"), a)) : n.writer.clear(n.writer.createRangeOn(a), a);
      }
    } catch (err) {
      _iterator183.e(err);
    } finally {
      _iterator183.f();
    }
    n.writer.clearClonedElementsGroup(t.markerName), e.stop();
    function o(a, l) {
      if (l.hasAttribute(a)) {
        var c = new Set(l.getAttribute(a).split(","));
        c.delete(r.name), c.size == 0 ? n.writer.removeAttribute(a, l) : n.writer.setAttribute(a, Array.from(c).join(","), l);
      }
    }
  };
}
function Si(s) {
  return function (e, t, n) {
    if (!n.consumable.test(t.item, e.name)) return;
    var r = s(t.attributeOldValue, n, t),
      i = s(t.attributeNewValue, n, t);
    if (!r && !i) return;
    n.consumable.consume(t.item, e.name);
    var o = n.mapper.toViewElement(t.item),
      a = n.writer;
    if (!o) throw new f("conversion-attribute-to-attribute-on-text", n.dispatcher, t);
    if (t.attributeOldValue !== null && r) {
      var l = r.value;
      r.key == "style" && (typeof r.value == "string" ? l = new We(a.document.stylesProcessor).setTo(r.value).getStylesEntries().map(function (_ref79) {
        var _ref80 = _slicedToArray(_ref79, 1),
          c = _ref80[0];
        return c;
      }) : l = Object.keys(r.value)), a.removeAttribute(r.key, l, o);
    }
    if (t.attributeNewValue !== null && i) {
      var _l7 = i.value;
      i.key == "style" && typeof i.value == "string" && (_l7 = Object.fromEntries(new We(a.document.stylesProcessor).setTo(i.value).getStylesEntries())), a.setAttribute(i.key, _l7, !1, o);
    }
  };
}
function Ei(s) {
  return function (e, t, n) {
    if (!t.item || !(t.item instanceof $ || t.item instanceof G) && !t.item.is("$textProxy")) return;
    var r = Ht(s, t, n);
    if (!r || !n.consumable.consume(t.item, e.name)) return;
    var i = n.writer,
      o = ds(i, r),
      a = i.document.selection;
    if (t.item instanceof $ || t.item instanceof G) i.wrap(a.getFirstRange(), o);else {
      var l = n.mapper.toViewRange(t.range),
        c = i.wrap(l, o);
      var _iterator184 = _createForOfIteratorHelper(c.getItems()),
        _step184;
      try {
        for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
          var h = _step184.value;
          if (h.is("attributeElement") && h.isSimilar(o)) {
            n.mapper.bindElementToMarker(h, t.markerName);
            break;
          }
        }
      } catch (err) {
        _iterator184.e(err);
      } finally {
        _iterator184.f();
      }
    }
  };
}
function Ri(s) {
  return function (e, t, n) {
    if (!t.item || !(t.item instanceof C)) return;
    var r = Ht(s, t, n);
    if (!r || !n.consumable.test(t.item, e.name)) return;
    var i = n.mapper.toViewElement(t.item);
    if (i && i.getCustomProperty("addHighlight")) {
      n.consumable.consume(t.item, e.name);
      var _iterator185 = _createForOfIteratorHelper(u._createIn(t.item)),
        _step185;
      try {
        for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
          var a = _step185.value;
          n.consumable.consume(a.item, e.name);
        }
      } catch (err) {
        _iterator185.e(err);
      } finally {
        _iterator185.f();
      }
      i.getCustomProperty("addHighlight")(i, r, n.writer), n.mapper.bindElementToMarker(i, t.markerName);
    }
  };
}
function Ti(s) {
  return function (e, t, n) {
    if (t.markerRange.isCollapsed) return;
    var r = Ht(s, t, n);
    if (!r) return;
    var i = ds(n.writer, r),
      o = n.mapper.markerNameToElements(t.markerName);
    if (o) {
      var _iterator186 = _createForOfIteratorHelper(o),
        _step186;
      try {
        for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
          var a = _step186.value;
          n.mapper.unbindElementFromMarkerName(a, t.markerName), a.is("attributeElement") ? n.writer.unwrap(n.writer.createRangeOn(a), i) : a.getCustomProperty("removeHighlight")(a, r.id, n.writer);
        }
      } catch (err) {
        _iterator186.e(err);
      } finally {
        _iterator186.f();
      }
      n.writer.clearClonedElementsGroup(t.markerName), e.stop();
    }
  };
}
function Mi(s) {
  var e = ms(s.model),
    t = Xe(s.view, "container");
  return e.attributes.length && (e.children = !0), function (n) {
    n.on("insert:".concat(e.name), wi(t, _s(e)), {
      priority: s.converterPriority || "normal"
    }), (e.children || e.attributes.length) && n.on("reduceChanges", ps(e), {
      priority: "low"
    });
  };
}
function xi(s) {
  var e = ms(s.model),
    t = Xe(s.view, "container");
  return e.children = !0, function (n) {
    if (n._conversionApi.schema.checkChild(e.name, "$text")) throw new f("conversion-element-to-structure-disallowed-text", n, {
      elementName: e.name
    });
    n.on("insert:".concat(e.name), bi(t, _s(e)), {
      priority: s.converterPriority || "normal"
    }), n.on("reduceChanges", ps(e), {
      priority: "low"
    });
  };
}
function Ni(s) {
  s = ce(s);
  var e = s.model;
  typeof e == "string" && (e = {
    key: e
  });
  var t = "attribute:".concat(e.key);
  if (e.name && (t += ":" + e.name), e.values) {
    var _iterator187 = _createForOfIteratorHelper(e.values),
      _step187;
    try {
      for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
        var r = _step187.value;
        s.view[r] = Xe(s.view[r], "attribute");
      }
    } catch (err) {
      _iterator187.e(err);
    } finally {
      _iterator187.f();
    }
  } else s.view = Xe(s.view, "attribute");
  var n = gs(s);
  return function (r) {
    r.on(t, _i(n), {
      priority: s.converterPriority || "normal"
    });
  };
}
function Oi(s) {
  s = ce(s);
  var e = s.model;
  typeof e == "string" && (e = {
    key: e
  });
  var t = "attribute:".concat(e.key);
  if (e.name && (t += ":" + e.name), e.values) {
    var _iterator188 = _createForOfIteratorHelper(e.values),
      _step188;
    try {
      for (_iterator188.s(); !(_step188 = _iterator188.n()).done;) {
        var r = _step188.value;
        s.view[r] = Pn(s.view[r]);
      }
    } catch (err) {
      _iterator188.e(err);
    } finally {
      _iterator188.f();
    }
  } else s.view = Pn(s.view);
  var n = gs(s);
  return function (r) {
    r.on(t, Si(n), {
      priority: s.converterPriority || "normal"
    });
  };
}
function Ii(s) {
  var e = Xe(s.view, "ui");
  return function (t) {
    t.on("addMarker:".concat(s.model), yi(e), {
      priority: s.converterPriority || "normal"
    }), t.on("removeMarker:".concat(s.model), vi(), {
      priority: s.converterPriority || "normal"
    });
  };
}
function Fi(s) {
  s = ce(s);
  var e = s.model;
  var t = s.view;
  return t || (t = function t(n) {
    return {
      group: e,
      name: n.substr(s.model.length + 1)
    };
  }), function (n) {
    n.on("addMarker:".concat(e), Pi(t), {
      priority: s.converterPriority || "normal"
    }), n.on("removeMarker:".concat(e), Ai(t), {
      priority: s.converterPriority || "normal"
    });
  };
}
function Di(s) {
  return function (e) {
    e.on("addMarker:".concat(s.model), Ei(s.view), {
      priority: s.converterPriority || "normal"
    }), e.on("addMarker:".concat(s.model), Ri(s.view), {
      priority: s.converterPriority || "normal"
    }), e.on("removeMarker:".concat(s.model), Ti(s.view), {
      priority: s.converterPriority || "normal"
    });
  };
}
function ms(s) {
  return typeof s == "string" && (s = {
    name: s
  }), {
    name: s.name,
    attributes: s.attributes ? ae(s.attributes) : [],
    children: !!s.children
  };
}
function Xe(s, e) {
  return typeof s == "function" ? s : function (t, n) {
    return Bi(s, n, e);
  };
}
function Bi(s, e, t) {
  typeof s == "string" && (s = {
    name: s
  });
  var n;
  var r = e.writer,
    i = Object.assign({}, s.attributes);
  if (t == "container") n = r.createContainerElement(s.name, i);else if (t == "attribute") {
    var o = {
      priority: s.priority || Me.DEFAULT_PRIORITY
    };
    n = r.createAttributeElement(s.name, i, o);
  } else n = r.createUIElement(s.name, i);
  if (s.styles) {
    var _o17 = Object.keys(s.styles);
    for (var _i38 = 0, _o18 = _o17; _i38 < _o18.length; _i38++) {
      var a = _o18[_i38];
      r.setStyle(a, s.styles[a], n);
    }
  }
  if (s.classes) {
    var _o19 = s.classes;
    if (typeof _o19 == "string") r.addClass(_o19, n);else {
      var _iterator189 = _createForOfIteratorHelper(_o19),
        _step189;
      try {
        for (_iterator189.s(); !(_step189 = _iterator189.n()).done;) {
          var _a0 = _step189.value;
          r.addClass(_a0, n);
        }
      } catch (err) {
        _iterator189.e(err);
      } finally {
        _iterator189.f();
      }
    }
  }
  return n;
}
function gs(s) {
  return s.model.values ? function (e, t, n) {
    var r = s.view[e];
    return r ? r(e, t, n) : null;
  } : s.view;
}
function Pn(s) {
  return typeof s == "string" ? function (e) {
    return {
      key: s,
      value: e
    };
  } : _typeof(s) == "object" ? s.value ? function () {
    return s;
  } : function (e) {
    return {
      key: s.key,
      value: e
    };
  } : s;
}
function Ht(s, e, t) {
  var n = typeof s == "function" ? s(e, t) : s;
  return n ? (n.priority || (n.priority = 10), n.id || (n.id = e.markerName), n) : null;
}
function Vi(s) {
  return function (e, t) {
    if (!e.is("element", s.name)) return !1;
    if (t.type == "attribute") {
      if (s.attributes.includes(t.attributeKey)) return !0;
    } else {
      /* istanbul ignore else: This is always true because otherwise it would not register a reducer callback. -- @preserve */if (s.children) return !0;
    }
    return !1;
  };
}
function ps(s) {
  var e = Vi(s);
  return function (t, n) {
    var r = [];
    n.reconvertedElements || (n.reconvertedElements = new Set());
    var _iterator190 = _createForOfIteratorHelper(n.changes),
      _step190;
    try {
      for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
        var i = _step190.value;
        var o = i.type == "attribute" ? i.range.start.nodeAfter : i.position.parent;
        if (!o || !e(o, i)) {
          r.push(i);
          continue;
        }
        if (!n.reconvertedElements.has(o)) {
          n.reconvertedElements.add(o);
          var a = m._createBefore(o);
          var l = r.length;
          for (var c = r.length - 1; c >= 0; c--) {
            var h = r[c],
              p = (h.type == "attribute" ? h.range.start : h.position).compareWith(a);
            if (p == "before" || h.type == "remove" && p == "same") break;
            l = c;
          }
          r.splice(l, 0, {
            type: "remove",
            name: o.name,
            position: a,
            length: 1
          }, {
            type: "reinsert",
            name: o.name,
            position: a,
            length: 1
          });
        }
      }
    } catch (err) {
      _iterator190.e(err);
    } finally {
      _iterator190.f();
    }
    n.changes = r;
  };
}
function _s(s) {
  return function (e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var r = ["insert"];
    var _iterator191 = _createForOfIteratorHelper(s.attributes),
      _step191;
    try {
      for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
        var i = _step191.value;
        e.hasAttribute(i) && r.push("attribute:".concat(i));
      }
    } catch (err) {
      _iterator191.e(err);
    } finally {
      _iterator191.f();
    }
    return r.every(function (i) {
      return t.test(e, i);
    }) ? (n.preflight || r.forEach(function (i) {
      return t.consume(e, i);
    }), !0) : !1;
  };
}
function $i(s, e, t) {
  return function (n, r) {
    var i = n.createContainerElement("$slot");
    var o = null;
    if (r === "children") o = Array.from(s.getChildren());else if (typeof r == "function") o = Array.from(s.getChildren()).filter(function (a) {
      return r(a);
    });else throw new f("conversion-slot-mode-unknown", t.dispatcher, {
      modeOrFilter: r
    });
    return e.set(i, o), i;
  };
}
function Li(s, e, t) {
  var n = Array.from(e.values()).flat(),
    r = new Set(n);
  if (r.size != n.length) throw new f("conversion-slot-filter-overlap", t.dispatcher, {
    element: s
  });
  if (r.size != s.childCount) throw new f("conversion-slot-filter-incomplete", t.dispatcher, {
    element: s
  });
}
function Wi(s, e, t, n) {
  t.mapper.on("modelToViewPosition", o, {
    priority: "highest"
  });
  var r = null,
    i = null;
  var _iterator192 = _createForOfIteratorHelper(e),
    _step192;
  try {
    for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
      var _ref81 = _step192.value;
      var _ref82 = _ref81;
      var _ref83 = _slicedToArray(_ref82, 2);
      r = _ref83[0];
      i = _ref83[1];
      ws(s, i, t, n), t.writer.move(t.writer.createRangeIn(r), t.writer.createPositionBefore(r)), t.writer.remove(r);
    }
  } catch (err) {
    _iterator192.e(err);
  } finally {
    _iterator192.f();
  }
  t.mapper.off("modelToViewPosition", o);
  function o(a, l) {
    var c = l.modelPosition.nodeAfter,
      h = i.indexOf(c);
    h < 0 || (l.viewPosition = l.mapper.findPositionIn(r, h));
  }
}
function ws(s, e, t, n) {
  var _iterator193 = _createForOfIteratorHelper(e),
    _step193;
  try {
    for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
      var r = _step193.value;
      qi(s.root, r, t, n) || t.convertItem(r);
    }
  } catch (err) {
    _iterator193.e(err);
  } finally {
    _iterator193.f();
  }
}
function qi(s, e, t, n) {
  var r = t.writer,
    i = t.mapper;
  if (!n.reconversion) return !1;
  var o = i.toViewElement(e);
  return !o || o.root == s || !t.canReuseView(o) ? !1 : (r.move(r.createRangeOn(o), i.toViewPosition(m._createBefore(e))), !0);
}
function zi(s, e) {
  var _ref84 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    t = _ref84.preflight;
  return t ? e.test(s, "insert") : e.consume(s, "insert");
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function bs(s) {
  var _s$model = s.model,
    e = _s$model.schema,
    t = _s$model.document;
  var _iterator194 = _createForOfIteratorHelper(t.getRoots()),
    _step194;
  try {
    for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
      var n = _step194.value;
      if (n.isEmpty && !e.checkChild(n, "$text") && e.checkChild(n, "paragraph")) return s.insertElement("paragraph", n), !0;
    }
  } catch (err) {
    _iterator194.e(err);
  } finally {
    _iterator194.f();
  }
  return !1;
}
function ys(s, e, t) {
  var n = t.createContext(s);
  return !(!t.checkChild(n, "paragraph") || !t.checkChild(n.push("paragraph"), e));
}
function vs(s, e) {
  var t = e.createElement("paragraph");
  return e.insert(t, s), e.createPositionAt(t, 0);
}
var Ui = /*#__PURE__*/function (_hs3) {
  function Ui() {
    _classCallCheck(this, Ui);
    return _callSuper(this, Ui, arguments);
  }
  _inherits(Ui, _hs3);
  return _createClass(Ui, [{
    key: "elementToElement",
    value: function elementToElement(e) {
      return this.add(Ps(e));
    }
  }, {
    key: "elementToAttribute",
    value: function elementToAttribute(e) {
      return this.add(Gi(e));
    }
  }, {
    key: "attributeToAttribute",
    value: function attributeToAttribute(e) {
      return this.add(Hi(e));
    }
  }, {
    key: "elementToMarker",
    value: function elementToMarker(e) {
      return this.add(Ki(e));
    }
  }, {
    key: "dataToMarker",
    value: function dataToMarker(e) {
      return this.add(Xi(e));
    }
  }]);
}(hs);
function Cn() {
  return function (s, e, t) {
    if (!e.modelRange && t.consumable.consume(e.viewItem, {
      name: !0
    })) {
      var _t$convertChildren = t.convertChildren(e.viewItem, e.modelCursor),
        n = _t$convertChildren.modelRange,
        r = _t$convertChildren.modelCursor;
      e.modelRange = n, e.modelCursor = r;
    }
  };
}
function Ji() {
  return function (s, e, _ref85) {
    var t = _ref85.schema,
      n = _ref85.consumable,
      r = _ref85.writer;
    var i = e.modelCursor;
    if (!n.test(e.viewItem)) return;
    if (!t.checkChild(i, "$text")) {
      if (!ys(i, "$text", t) || e.viewItem.data.trim().length == 0) return;
      i = vs(i, r);
    }
    n.consume(e.viewItem);
    var o = r.createText(e.viewItem.data);
    r.insert(o, i), e.modelRange = r.createRange(i, i.getShiftedBy(o.offsetSize)), e.modelCursor = e.modelRange.end;
  };
}
function ji(s, e) {
  return function (t, n) {
    var r = n.newSelection,
      i = [];
    var _iterator195 = _createForOfIteratorHelper(r.getRanges()),
      _step195;
    try {
      for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
        var a = _step195.value;
        i.push(e.toModelRange(a));
      }
    } catch (err) {
      _iterator195.e(err);
    } finally {
      _iterator195.f();
    }
    var o = s.createSelection(i, {
      backward: r.isBackward
    });
    o.isEqual(s.document.selection) || s.change(function (a) {
      a.setSelection(o);
    });
  };
}
function Ps(s) {
  s = ce(s);
  var e = Vt(s),
    t = Kt(s.view),
    n = t ? "element:".concat(t) : "element";
  return function (r) {
    r.on(n, e, {
      priority: s.converterPriority || "normal"
    });
  };
}
function Gi(s) {
  s = ce(s), Cs(s);
  var e = ks(s, !1),
    t = Kt(s.view),
    n = t ? "element:".concat(t) : "element";
  return function (r) {
    r.on(n, e, {
      priority: s.converterPriority || "low"
    });
  };
}
function Hi(s) {
  s = ce(s);
  var e = null;
  (typeof s.view == "string" || s.view.key) && (e = Zi(s)), Cs(s, e);
  var t = ks(s, !0);
  return function (n) {
    n.on("element", t, {
      priority: s.converterPriority || "low"
    });
  };
}
function Ki(s) {
  var e = no(s.model);
  return Ps(_objectSpread(_objectSpread({}, s), {}, {
    model: e
  }));
}
function Xi(s) {
  s = ce(s), s.model || (s.model = function (r) {
    return r ? s.view + ":" + r : s.view;
  });
  var e = {
      view: s.view,
      model: s.model
    },
    t = Vt(kn(e, "start")),
    n = Vt(kn(e, "end"));
  return function (r) {
    r.on("element:".concat(s.view, "-start"), t, {
      priority: s.converterPriority || "normal"
    }), r.on("element:".concat(s.view, "-end"), n, {
      priority: s.converterPriority || "normal"
    });
    var i = pt.low,
      o = pt.highest,
      a = pt.get(s.converterPriority) / o;
    r.on("element", Yi(e), {
      priority: i + a
    });
  };
}
function Yi(s) {
  return function (e, t, n) {
    var r = "data-".concat(s.view);
    if (!n.consumable.test(t.viewItem, {
      attributes: r + "-end-after"
    }) && !n.consumable.test(t.viewItem, {
      attributes: r + "-start-after"
    }) && !n.consumable.test(t.viewItem, {
      attributes: r + "-end-before"
    }) && !n.consumable.test(t.viewItem, {
      attributes: r + "-start-before"
    })) return;
    t.modelRange || Object.assign(t, n.convertChildren(t.viewItem, t.modelCursor)), n.consumable.consume(t.viewItem, {
      attributes: r + "-end-after"
    }) && i(t.modelRange.end, t.viewItem.getAttribute(r + "-end-after").split(",")), n.consumable.consume(t.viewItem, {
      attributes: r + "-start-after"
    }) && i(t.modelRange.end, t.viewItem.getAttribute(r + "-start-after").split(",")), n.consumable.consume(t.viewItem, {
      attributes: r + "-end-before"
    }) && i(t.modelRange.start, t.viewItem.getAttribute(r + "-end-before").split(",")), n.consumable.consume(t.viewItem, {
      attributes: r + "-start-before"
    }) && i(t.modelRange.start, t.viewItem.getAttribute(r + "-start-before").split(","));
    function i(o, a) {
      var _iterator196 = _createForOfIteratorHelper(a),
        _step196;
      try {
        for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
          var l = _step196.value;
          var c = s.model(l, n),
            h = n.writer.createElement("$marker", {
              "data-name": c
            });
          n.writer.insert(h, o), t.modelCursor.isEqual(o) ? t.modelCursor = t.modelCursor.getShiftedBy(1) : t.modelCursor = t.modelCursor._getTransformedByInsertion(o, 1), t.modelRange = t.modelRange._getTransformedByInsertion(o, 1)[0];
        }
      } catch (err) {
        _iterator196.e(err);
      } finally {
        _iterator196.f();
      }
    }
  };
}
function Kt(s) {
  return typeof s == "string" ? s : _typeof(s) == "object" && typeof s.name == "string" ? s.name : null;
}
function Vt(s) {
  var e = new je(s.view);
  return function (t, n, r) {
    var i = e.match(n.viewItem);
    if (!i) return;
    var o = i.match;
    if (o.name = !0, !r.consumable.test(n.viewItem, o)) return;
    var a = Qi(s.model, n.viewItem, r);
    a && r.safeInsert(a, n.modelCursor) && (r.consumable.consume(n.viewItem, o), r.convertChildren(n.viewItem, a), r.updateConversionResult(a, n));
  };
}
function Qi(s, e, t) {
  return s instanceof Function ? s(e, t) : t.writer.createElement(s);
}
function Zi(s) {
  typeof s.view == "string" && (s.view = {
    key: s.view
  });
  var e = s.view.key,
    t = _typeof(s.view.value) > "u" ? /[\s\S]*/ : s.view.value;
  var n;
  return e == "class" || e == "style" ? n = _defineProperty({}, e == "class" ? "classes" : "styles", t) : n = {
    attributes: _defineProperty({}, e, t)
  }, s.view.name && (n.name = s.view.name), s.view = n, e;
}
function Cs(s) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var t = e === null ? !0 : function (i) {
      return i.getAttribute(e);
    },
    n = _typeof(s.model) != "object" ? s.model : s.model.key,
    r = _typeof(s.model) != "object" || _typeof(s.model.value) > "u" ? t : s.model.value;
  s.model = {
    key: n,
    value: r
  };
}
function ks(s, e) {
  var t = new je(s.view);
  return function (n, r, i) {
    if (!r.modelRange && e) return;
    var o = t.match(r.viewItem);
    if (!o || (eo(s.view, r.viewItem) ? o.match.name = !0 : delete o.match.name, !i.consumable.test(r.viewItem, o.match))) return;
    var a = s.model.key,
      l = typeof s.model.value == "function" ? s.model.value(r.viewItem, i, r) : s.model.value;
    if (l === null) return;
    r.modelRange || Object.assign(r, i.convertChildren(r.viewItem, r.modelCursor)), to(r.modelRange, {
      key: a,
      value: l
    }, e, i) && (i.consumable.test(r.viewItem, {
      name: !0
    }) && (o.match.name = !0), i.consumable.consume(r.viewItem, o.match));
  };
}
function eo(s, e) {
  var t = typeof s == "function" ? s(e) : s;
  return _typeof(t) == "object" && !Kt(t) ? !1 : !t.classes && !t.attributes && !t.styles;
}
function to(s, e, t, n) {
  var r = !1;
  for (var _i39 = 0, _Array$from6 = Array.from(s.getItems({
      shallow: t
    })); _i39 < _Array$from6.length; _i39++) {
    var i = _Array$from6[_i39];
    n.schema.checkAttribute(i, e.key) && (r = !0, !i.hasAttribute(e.key) && n.writer.setAttribute(e.key, e.value, i));
  }
  return r;
}
function no(s) {
  return function (e, t) {
    var n = typeof s == "string" ? s : s(e, t);
    return t.writer.createElement("$marker", {
      "data-name": n
    });
  };
}
function kn(s, e) {
  var t = function t(n, r) {
    var i = n.getAttribute("name"),
      o = s.model(i, r);
    return r.writer.createElement("$marker", {
      "data-name": o
    });
  };
  return {
    view: "".concat(s.view, "-").concat(e),
    model: t
  };
}
var _l = /*#__PURE__*/function (_U4) {
  function _l(e, t) {
    var _this60;
    _classCallCheck(this, _l);
    _this60 = _callSuper(this, _l), _defineProperty(_assertThisInitialized(_this60), "model", void 0), _defineProperty(_assertThisInitialized(_this60), "view", void 0), _defineProperty(_assertThisInitialized(_this60), "mapper", void 0), _defineProperty(_assertThisInitialized(_this60), "downcastDispatcher", void 0), _this60.model = e, _this60.view = new Hr(t), _this60.mapper = new as(), _this60.downcastDispatcher = new ls({
      mapper: _this60.mapper,
      schema: e.schema
    });
    var n = _this60.model.document,
      r = n.selection,
      i = _this60.model.markers;
    _this60.listenTo(_this60.model, "_beforeChanges", function () {
      _this60.view._disableRendering(!0);
    }, {
      priority: "highest"
    }), _this60.listenTo(_this60.model, "_afterChanges", function () {
      _this60.view._disableRendering(!1);
    }, {
      priority: "lowest"
    }), _this60.listenTo(n, "change", function () {
      _this60.view.change(function (o) {
        _this60.downcastDispatcher.convertChanges(n.differ, i, o), _this60.downcastDispatcher.convertSelection(r, i, o);
      });
    }, {
      priority: "low"
    }), _this60.listenTo(_this60.view.document, "selectionChange", ji(_this60.model, _this60.mapper)), _this60.downcastDispatcher.on("insert:$text", us(), {
      priority: "lowest"
    }), _this60.downcastDispatcher.on("insert", fs(), {
      priority: "lowest"
    }), _this60.downcastDispatcher.on("remove", di(), {
      priority: "low"
    }), _this60.downcastDispatcher.on("cleanSelection", pi()), _this60.downcastDispatcher.on("selection", mi(), {
      priority: "low"
    }), _this60.downcastDispatcher.on("selection", gi(), {
      priority: "low"
    }), _this60.view.document.roots.bindTo(_this60.model.document.roots).using(function (o) {
      if (o.rootName == "$graveyard") return null;
      var a = new Gn(_this60.view.document, o.name);
      return a.rootName = o.rootName, _this60.mapper.bindElements(o, a), a;
    });
    return _this60;
  }
  _inherits(_l, _U4);
  return _createClass(_l, [{
    key: "destroy",
    value: function destroy() {
      this.view.destroy(), this.stopListening();
    }
  }, {
    key: "reconvertMarker",
    value: function reconvertMarker(e) {
      var _this61 = this;
      var t = typeof e == "string" ? e : e.name,
        n = this.model.markers.get(t);
      if (!n) throw new f("editingcontroller-reconvertmarker-marker-not-exist", this, {
        markerName: t
      });
      this.model.change(function () {
        _this61.model.markers._refresh(n);
      });
    }
  }, {
    key: "reconvertItem",
    value: function reconvertItem(e) {
      var _this62 = this;
      this.model.change(function () {
        _this62.model.document.differ._refreshItem(e);
      });
    }
  }]);
}(U());
var so = /*#__PURE__*/function (_U5) {
  function so() {
    var _this63;
    _classCallCheck(this, so);
    _this63 = _callSuper(this, so), _defineProperty(_assertThisInitialized(_this63), "_sourceDefinitions", {}), _defineProperty(_assertThisInitialized(_this63), "_attributeProperties", Object.create(null)), _defineProperty(_assertThisInitialized(_this63), "_customChildChecks", new Map()), _defineProperty(_assertThisInitialized(_this63), "_customAttributeChecks", new Map()), _defineProperty(_assertThisInitialized(_this63), "_genericCheckSymbol", Symbol("$generic")), _defineProperty(_assertThisInitialized(_this63), "_compiledDefinitions", void 0), _this63.decorate("checkChild"), _this63.decorate("checkAttribute"), _this63.on("checkAttribute", function (e, t) {
      t[0] = new oe(t[0]);
    }, {
      priority: "highest"
    }), _this63.on("checkChild", function (e, t) {
      t[0] = new oe(t[0]), t[1] = _this63.getDefinition(t[1]);
    }, {
      priority: "highest"
    });
    return _this63;
  }
  _inherits(so, _U5);
  return _createClass(so, [{
    key: "register",
    value: function register(e, t) {
      if (this._sourceDefinitions[e]) throw new f("schema-cannot-register-item-twice", this, {
        itemName: e
      });
      this._sourceDefinitions[e] = [Object.assign({}, t)], this._clearCache();
    }
  }, {
    key: "extend",
    value: function extend(e, t) {
      if (!this._sourceDefinitions[e]) throw new f("schema-cannot-extend-missing-item", this, {
        itemName: e
      });
      this._sourceDefinitions[e].push(Object.assign({}, t)), this._clearCache();
    }
  }, {
    key: "getDefinitions",
    value: function getDefinitions() {
      return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
    }
  }, {
    key: "getDefinition",
    value: function getDefinition(e) {
      var t;
      return typeof e == "string" ? t = e : "is" in e && (e.is("$text") || e.is("$textProxy")) ? t = "$text" : t = e.name, this.getDefinitions()[t];
    }
  }, {
    key: "isRegistered",
    value: function isRegistered(e) {
      return !!this.getDefinition(e);
    }
  }, {
    key: "isBlock",
    value: function isBlock(e) {
      var t = this.getDefinition(e);
      return !!(t && t.isBlock);
    }
  }, {
    key: "isLimit",
    value: function isLimit(e) {
      var t = this.getDefinition(e);
      return t ? !!(t.isLimit || t.isObject) : !1;
    }
  }, {
    key: "isObject",
    value: function isObject(e) {
      var t = this.getDefinition(e);
      return t ? !!(t.isObject || t.isLimit && t.isSelectable && t.isContent) : !1;
    }
  }, {
    key: "isInline",
    value: function isInline(e) {
      var t = this.getDefinition(e);
      return !!(t && t.isInline);
    }
  }, {
    key: "isSelectable",
    value: function isSelectable(e) {
      var t = this.getDefinition(e);
      return t ? !!(t.isSelectable || t.isObject) : !1;
    }
  }, {
    key: "isContent",
    value: function isContent(e) {
      var t = this.getDefinition(e);
      return t ? !!(t.isContent || t.isObject) : !1;
    }
  }, {
    key: "checkChild",
    value: function checkChild(e, t) {
      return t ? this._checkContextMatch(e, t) : !1;
    }
  }, {
    key: "checkAttribute",
    value: function checkAttribute(e, t) {
      var n = this.getDefinition(e.last);
      if (!n) return !1;
      var r = this._evaluateAttributeChecks(e, t);
      return r !== void 0 ? r : n.allowAttributes.includes(t);
    }
  }, {
    key: "checkMerge",
    value: function checkMerge(e, t) {
      if (e instanceof m) {
        var n = e.nodeBefore,
          r = e.nodeAfter;
        if (!(n instanceof C)) throw new f("schema-check-merge-no-element-before", this);
        if (!(r instanceof C)) throw new f("schema-check-merge-no-element-after", this);
        return this.checkMerge(n, r);
      }
      if (this.isLimit(e) || this.isLimit(t)) return !1;
      var _iterator197 = _createForOfIteratorHelper(t.getChildren()),
        _step197;
      try {
        for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
          var _n16 = _step197.value;
          if (!this.checkChild(e, _n16)) return !1;
        }
      } catch (err) {
        _iterator197.e(err);
      } finally {
        _iterator197.f();
      }
      return !0;
    }
  }, {
    key: "addChildCheck",
    value: function addChildCheck(e, t) {
      var n = t !== void 0 ? t : this._genericCheckSymbol,
        r = this._customChildChecks.get(n) || [];
      r.push(e), this._customChildChecks.set(n, r);
    }
  }, {
    key: "addAttributeCheck",
    value: function addAttributeCheck(e, t) {
      var n = t !== void 0 ? t : this._genericCheckSymbol,
        r = this._customAttributeChecks.get(n) || [];
      r.push(e), this._customAttributeChecks.set(n, r);
    }
  }, {
    key: "setAttributeProperties",
    value: function setAttributeProperties(e, t) {
      this._attributeProperties[e] = Object.assign(this.getAttributeProperties(e), t);
    }
  }, {
    key: "getAttributeProperties",
    value: function getAttributeProperties(e) {
      return this._attributeProperties[e] || Object.create(null);
    }
  }, {
    key: "getLimitElement",
    value: function getLimitElement(e) {
      var t;
      for (e instanceof m ? t = e.parent : t = (e instanceof u ? [e] : Array.from(e.getRanges())).reduce(function (r, i) {
        var o = i.getCommonAncestor();
        return r ? r.getCommonAncestor(o, {
          includeSelf: !0
        }) : o;
      }, null); !this.isLimit(t) && t.parent;) t = t.parent;
      return t;
    }
  }, {
    key: "checkAttributeInSelection",
    value: function checkAttributeInSelection(e, t) {
      if (e.isCollapsed) {
        var r = [].concat(_toConsumableArray(e.getFirstPosition().getAncestors()), [new k("", e.getAttributes())]);
        return this.checkAttribute(r, t);
      } else {
        var n = e.getRanges();
        var _iterator198 = _createForOfIteratorHelper(n),
          _step198;
        try {
          for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
            var _r15 = _step198.value;
            var _iterator199 = _createForOfIteratorHelper(_r15),
              _step199;
            try {
              for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
                var i = _step199.value;
                if (this.checkAttribute(i.item, t)) return !0;
              }
            } catch (err) {
              _iterator199.e(err);
            } finally {
              _iterator199.f();
            }
          }
        } catch (err) {
          _iterator198.e(err);
        } finally {
          _iterator198.f();
        }
      }
      return !1;
    }
  }, {
    key: "getValidRanges",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getValidRanges(e, t) {
      var _iterator200, _step200, n;
      return _regeneratorRuntime().wrap(function getValidRanges$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            e = yo(e);
            _iterator200 = _createForOfIteratorHelper(e);
            _context18.prev = 2;
            _iterator200.s();
          case 4:
            if ((_step200 = _iterator200.n()).done) {
              _context18.next = 9;
              break;
            }
            n = _step200.value;
            return _context18.delegateYield(this._getValidRangesForRange(n, t), "t0", 7);
          case 7:
            _context18.next = 4;
            break;
          case 9:
            _context18.next = 14;
            break;
          case 11:
            _context18.prev = 11;
            _context18.t1 = _context18["catch"](2);
            _iterator200.e(_context18.t1);
          case 14:
            _context18.prev = 14;
            _iterator200.f();
            return _context18.finish(14);
          case 17:
          case "end":
            return _context18.stop();
        }
      }, getValidRanges, this, [[2, 11, 14, 17]]);
    })
  }, {
    key: "getNearestSelectionRange",
    value: function getNearestSelectionRange(e) {
      var _this64 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
      if (e.root.rootName == "$graveyard") return null;
      if (this.checkChild(e, "$text")) return new u(e);
      var n, r;
      var i = e.getAncestors().reverse().find(function (o) {
        return _this64.isLimit(o);
      }) || e.root;
      (t == "both" || t == "backward") && (n = new ie({
        boundaries: u._createIn(i),
        startPosition: e,
        direction: "backward"
      })), (t == "both" || t == "forward") && (r = new ie({
        boundaries: u._createIn(i),
        startPosition: e
      }));
      var _iterator201 = _createForOfIteratorHelper(bo(n, r)),
        _step201;
      try {
        for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
          var o = _step201.value;
          var a = o.walker == n ? "elementEnd" : "elementStart",
            l = o.value;
          if (l.type == a && this.isObject(l.item)) return u._createOn(l.item);
          if (this.checkChild(l.nextPosition, "$text")) return new u(l.nextPosition);
        }
      } catch (err) {
        _iterator201.e(err);
      } finally {
        _iterator201.f();
      }
      return null;
    }
  }, {
    key: "findAllowedParent",
    value: function findAllowedParent(e, t) {
      var n = e.parent;
      for (; n;) {
        if (this.checkChild(n, t)) return n;
        if (this.isLimit(n)) return null;
        n = n.parent;
      }
      return null;
    }
  }, {
    key: "setAllowedAttributes",
    value: function setAllowedAttributes(e, t, n) {
      var r = n.model;
      for (var _i40 = 0, _Object$entries2 = Object.entries(t); _i40 < _Object$entries2.length; _i40++) {
        var _ref86 = _Object$entries2[_i40];
        var _ref87 = _slicedToArray(_ref86, 2);
        var i = _ref87[0];
        var o = _ref87[1];
        r.schema.checkAttribute(e, i) && n.setAttribute(i, o, e);
      }
    }
  }, {
    key: "removeDisallowedAttributes",
    value: function removeDisallowedAttributes(e, t) {
      var _iterator202 = _createForOfIteratorHelper(e),
        _step202;
      try {
        for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
          var n = _step202.value;
          if (n.is("$text")) An(this, n, t);else {
            var i = u._createIn(n).getPositions();
            var _iterator203 = _createForOfIteratorHelper(i),
              _step203;
            try {
              for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
                var o = _step203.value;
                var a = o.nodeBefore || o.parent;
                An(this, a, t);
              }
            } catch (err) {
              _iterator203.e(err);
            } finally {
              _iterator203.f();
            }
          }
        }
      } catch (err) {
        _iterator202.e(err);
      } finally {
        _iterator202.f();
      }
    }
  }, {
    key: "getAttributesWithProperty",
    value: function getAttributesWithProperty(e, t, n) {
      var r = {};
      var _iterator204 = _createForOfIteratorHelper(e.getAttributes()),
        _step204;
      try {
        for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
          var _ref88 = _step204.value;
          var _ref89 = _slicedToArray(_ref88, 2);
          var i = _ref89[0];
          var o = _ref89[1];
          var a = this.getAttributeProperties(i);
          a[t] !== void 0 && (n === void 0 || n === a[t]) && (r[i] = o);
        }
      } catch (err) {
        _iterator204.e(err);
      } finally {
        _iterator204.f();
      }
      return r;
    }
  }, {
    key: "createContext",
    value: function createContext(e) {
      return new oe(e);
    }
  }, {
    key: "_clearCache",
    value: function _clearCache() {
      this._compiledDefinitions = null;
    }
  }, {
    key: "_compile",
    value: function _compile() {
      var e = {},
        t = this._sourceDefinitions,
        n = Object.keys(t);
      for (var _i41 = 0, _n17 = n; _i41 < _n17.length; _i41++) {
        var i = _n17[_i41];
        e[i] = ro(t[i], i);
      }
      var r = Object.values(e);
      for (var _i42 = 0, _r16 = r; _i42 < _r16.length; _i42++) {
        var _i43 = _r16[_i42];
        io(e, _i43), oo(e, _i43), ao(e, _i43), lo(e, _i43);
      }
      for (var _i44 = 0, _r17 = r; _i44 < _r17.length; _i44++) {
        var _i45 = _r17[_i44];
        co(e, _i45);
      }
      for (var _i46 = 0, _r18 = r; _i46 < _r18.length; _i46++) {
        var _i47 = _r18[_i46];
        ho(e, _i47);
      }
      for (var _i48 = 0, _r19 = r; _i48 < _r19.length; _i48++) {
        var _i49 = _r19[_i48];
        uo(e, _i49);
      }
      for (var _i50 = 0, _r20 = r; _i50 < _r20.length; _i50++) {
        var _i51 = _r20[_i50];
        mo(e, _i51);
      }
      for (var _i52 = 0, _r21 = r; _i52 < _r21.length; _i52++) {
        var _i53 = _r21[_i52];
        go(e, _i53);
      }
      this._compiledDefinitions = fo(e);
    }
  }, {
    key: "_checkContextMatch",
    value: function _checkContextMatch(e, t) {
      var n = e.last;
      var r = this._evaluateChildChecks(e, t);
      if (r = r !== void 0 ? r : t.allowIn.includes(n.name), !r) return !1;
      var i = this.getDefinition(n),
        o = e.trimLast();
      return i ? o.length == 0 ? !0 : this._checkContextMatch(o, i) : !1;
    }
  }, {
    key: "_evaluateChildChecks",
    value: function _evaluateChildChecks(e, t) {
      var n = this._customChildChecks.get(this._genericCheckSymbol) || [],
        r = this._customChildChecks.get(t.name) || [];
      for (var _i54 = 0, _arr = [].concat(_toConsumableArray(n), _toConsumableArray(r)); _i54 < _arr.length; _i54++) {
        var i = _arr[_i54];
        var o = i(e, t);
        if (o !== void 0) return o;
      }
    }
  }, {
    key: "_evaluateAttributeChecks",
    value: function _evaluateAttributeChecks(e, t) {
      var n = this._customAttributeChecks.get(this._genericCheckSymbol) || [],
        r = this._customAttributeChecks.get(t) || [];
      for (var _i55 = 0, _arr2 = [].concat(_toConsumableArray(n), _toConsumableArray(r)); _i55 < _arr2.length; _i55++) {
        var i = _arr2[_i55];
        var o = i(e, t);
        if (o !== void 0) return o;
      }
    }
  }, {
    key: "_getValidRangesForRange",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function _getValidRangesForRange(e, t) {
      var n, r, _iterator205, _step205, i;
      return _regeneratorRuntime().wrap(function _getValidRangesForRange$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            n = e.start, r = e.start;
            _iterator205 = _createForOfIteratorHelper(e.getItems({
              shallow: !0
            }));
            _context19.prev = 2;
            _iterator205.s();
          case 4:
            if ((_step205 = _iterator205.n()).done) {
              _context19.next = 19;
              break;
            }
            i = _step205.value;
            _context19.t0 = i.is("element");
            if (!_context19.t0) {
              _context19.next = 9;
              break;
            }
            return _context19.delegateYield(this._getValidRangesForRange(u._createIn(i), t), "t1", 9);
          case 9:
            _context19.t2 = this.checkAttribute(i, t);
            if (_context19.t2) {
              _context19.next = 16;
              break;
            }
            _context19.t3 = n.isEqual(r);
            if (_context19.t3) {
              _context19.next = 15;
              break;
            }
            _context19.next = 15;
            return new u(n, r);
          case 15:
            n = m._createAfter(i);
          case 16:
            r = m._createAfter(i);
          case 17:
            _context19.next = 4;
            break;
          case 19:
            _context19.next = 24;
            break;
          case 21:
            _context19.prev = 21;
            _context19.t4 = _context19["catch"](2);
            _iterator205.e(_context19.t4);
          case 24:
            _context19.prev = 24;
            _iterator205.f();
            return _context19.finish(24);
          case 27:
            _context19.t5 = n.isEqual(r);
            if (_context19.t5) {
              _context19.next = 31;
              break;
            }
            _context19.next = 31;
            return new u(n, r);
          case 31:
          case "end":
            return _context19.stop();
        }
      }, _getValidRangesForRange, this, [[2, 21, 24, 27]]);
    })
  }, {
    key: "findOptimalInsertionRange",
    value: function findOptimalInsertionRange(e, t) {
      var n = e.getSelectedElement();
      if (n && this.isObject(n) && !this.isInline(n)) return t == "before" || t == "after" ? new u(m._createAt(n, t)) : u._createOn(n);
      var r = Wt(e.getSelectedBlocks());
      if (!r) return new u(e.focus);
      if (r.isEmpty) return new u(m._createAt(r, 0));
      var i = m._createAfter(r);
      return e.focus.isTouching(i) ? new u(i) : new u(m._createBefore(r));
    }
  }]);
}(U());
var oe = /*#__PURE__*/function () {
  function oe(e) {
    _classCallCheck(this, oe);
    _defineProperty(this, "_items", void 0);
    if (e instanceof oe) return e;
    var t;
    typeof e == "string" ? t = [e] : Array.isArray(e) ? t = e : t = e.getAncestors({
      includeSelf: !0
    }), this._items = t.map(wo);
  }
  return _createClass(oe, [{
    key: "length",
    get: function get() {
      return this._items.length;
    }
  }, {
    key: "last",
    get: function get() {
      return this._items[this._items.length - 1];
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._items[Symbol.iterator]();
    }
  }, {
    key: "push",
    value: function push(e) {
      var t = new oe([e]);
      return t._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(t._items)), t;
    }
  }, {
    key: "trimLast",
    value: function trimLast() {
      var e = new oe([]);
      return e._items = this._items.slice(0, -1), e;
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      return this._items[e];
    }
  }, {
    key: "getNames",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getNames() {
      return _regeneratorRuntime().wrap(function getNames$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            return _context20.delegateYield(this._items.map(function (e) {
              return e.name;
            }), "t0", 1);
          case 1:
          case "end":
            return _context20.stop();
        }
      }, getNames, this);
    })
  }, {
    key: "endsWith",
    value: function endsWith(e) {
      return Array.from(this.getNames()).join(" ").endsWith(e);
    }
  }, {
    key: "startsWith",
    value: function startsWith(e) {
      return Array.from(this.getNames()).join(" ").startsWith(e);
    }
  }]);
}();
function ro(s, e) {
  var t = {
    name: e,
    allowIn: new Set(),
    allowChildren: new Set(),
    disallowIn: new Set(),
    disallowChildren: new Set(),
    allowContentOf: new Set(),
    allowWhere: new Set(),
    allowAttributes: new Set(),
    disallowAttributes: new Set(),
    allowAttributesOf: new Set(),
    inheritTypesFrom: new Set()
  };
  return po(s, t), H(s, t, "allowIn"), H(s, t, "allowChildren"), H(s, t, "disallowIn"), H(s, t, "disallowChildren"), H(s, t, "allowContentOf"), H(s, t, "allowWhere"), H(s, t, "allowAttributes"), H(s, t, "disallowAttributes"), H(s, t, "allowAttributesOf"), H(s, t, "inheritTypesFrom"), _o(s, t), t;
}
function io(s, e) {
  var _iterator206 = _createForOfIteratorHelper(e.allowIn),
    _step206;
  try {
    for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
      var t = _step206.value;
      var n = s[t];
      n ? n.allowChildren.add(e.name) : e.allowIn.delete(t);
    }
  } catch (err) {
    _iterator206.e(err);
  } finally {
    _iterator206.f();
  }
}
function oo(s, e) {
  var _iterator207 = _createForOfIteratorHelper(e.allowChildren),
    _step207;
  try {
    for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
      var t = _step207.value;
      var n = s[t];
      n ? n.allowIn.add(e.name) : e.allowChildren.delete(t);
    }
  } catch (err) {
    _iterator207.e(err);
  } finally {
    _iterator207.f();
  }
}
function ao(s, e) {
  var _iterator208 = _createForOfIteratorHelper(e.disallowIn),
    _step208;
  try {
    for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
      var t = _step208.value;
      var n = s[t];
      n ? n.disallowChildren.add(e.name) : e.disallowIn.delete(t);
    }
  } catch (err) {
    _iterator208.e(err);
  } finally {
    _iterator208.f();
  }
}
function lo(s, e) {
  var _iterator209 = _createForOfIteratorHelper(e.disallowChildren),
    _step209;
  try {
    for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
      var t = _step209.value;
      var n = s[t];
      n ? n.disallowIn.add(e.name) : e.disallowChildren.delete(t);
    }
  } catch (err) {
    _iterator209.e(err);
  } finally {
    _iterator209.f();
  }
}
function co(s, e) {
  var _iterator210 = _createForOfIteratorHelper(e.disallowChildren),
    _step210;
  try {
    for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
      var t = _step210.value;
      e.allowChildren.delete(t);
    }
  } catch (err) {
    _iterator210.e(err);
  } finally {
    _iterator210.f();
  }
  var _iterator211 = _createForOfIteratorHelper(e.disallowIn),
    _step211;
  try {
    for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
      var _t3 = _step211.value;
      e.allowIn.delete(_t3);
    }
  } catch (err) {
    _iterator211.e(err);
  } finally {
    _iterator211.f();
  }
  var _iterator212 = _createForOfIteratorHelper(e.disallowAttributes),
    _step212;
  try {
    for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
      var _t4 = _step212.value;
      e.allowAttributes.delete(_t4);
    }
  } catch (err) {
    _iterator212.e(err);
  } finally {
    _iterator212.f();
  }
}
function ho(s, e) {
  var _iterator213 = _createForOfIteratorHelper(e.allowContentOf),
    _step213;
  try {
    for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
      var t = _step213.value;
      var n = s[t];
      n && (n.disallowChildren.forEach(function (r) {
        e.allowChildren.has(r) || (e.disallowChildren.add(r), s[r].disallowIn.add(e.name));
      }), n.allowChildren.forEach(function (r) {
        e.disallowChildren.has(r) || (e.allowChildren.add(r), s[r].allowIn.add(e.name));
      }));
    }
  } catch (err) {
    _iterator213.e(err);
  } finally {
    _iterator213.f();
  }
}
function uo(s, e) {
  var _iterator214 = _createForOfIteratorHelper(e.allowWhere),
    _step214;
  try {
    for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
      var t = _step214.value;
      var n = s[t];
      n && (n.disallowIn.forEach(function (r) {
        e.allowIn.has(r) || (e.disallowIn.add(r), s[r].disallowChildren.add(e.name));
      }), n.allowIn.forEach(function (r) {
        e.disallowIn.has(r) || (e.allowIn.add(r), s[r].allowChildren.add(e.name));
      }));
    }
  } catch (err) {
    _iterator214.e(err);
  } finally {
    _iterator214.f();
  }
}
function fo(s) {
  var e = {};
  for (var _i56 = 0, _Object$values = Object.values(s); _i56 < _Object$values.length; _i56++) {
    var t = _Object$values[_i56];
    e[t.name] = {
      name: t.name,
      isBlock: !!t.isBlock,
      isContent: !!t.isContent,
      isInline: !!t.isInline,
      isLimit: !!t.isLimit,
      isObject: !!t.isObject,
      isSelectable: !!t.isSelectable,
      allowIn: Array.from(t.allowIn).filter(function (n) {
        return !!s[n];
      }),
      allowChildren: Array.from(t.allowChildren).filter(function (n) {
        return !!s[n];
      }),
      allowAttributes: Array.from(t.allowAttributes)
    };
  }
  return e;
}
function mo(s, e) {
  var _iterator215 = _createForOfIteratorHelper(e.allowAttributesOf),
    _step215;
  try {
    for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
      var t = _step215.value;
      var n = s[t];
      if (!n) return;
      n.allowAttributes.forEach(function (r) {
        e.disallowAttributes.has(r) || e.allowAttributes.add(r);
      });
    }
  } catch (err) {
    _iterator215.e(err);
  } finally {
    _iterator215.f();
  }
}
function go(s, e) {
  var _iterator216 = _createForOfIteratorHelper(e.inheritTypesFrom),
    _step216;
  try {
    for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
      var t = _step216.value;
      var n = s[t];
      if (n) {
        var r = Object.keys(n).filter(function (i) {
          return i.startsWith("is");
        });
        var _iterator217 = _createForOfIteratorHelper(r),
          _step217;
        try {
          for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
            var i = _step217.value;
            i in e || (e[i] = n[i]);
          }
        } catch (err) {
          _iterator217.e(err);
        } finally {
          _iterator217.f();
        }
      }
    }
  } catch (err) {
    _iterator216.e(err);
  } finally {
    _iterator216.f();
  }
}
function po(s, e) {
  var _iterator218 = _createForOfIteratorHelper(s),
    _step218;
  try {
    for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
      var t = _step218.value;
      var n = Object.keys(t).filter(function (r) {
        return r.startsWith("is");
      });
      var _iterator219 = _createForOfIteratorHelper(n),
        _step219;
      try {
        for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
          var r = _step219.value;
          e[r] = !!t[r];
        }
      } catch (err) {
        _iterator219.e(err);
      } finally {
        _iterator219.f();
      }
    }
  } catch (err) {
    _iterator218.e(err);
  } finally {
    _iterator218.f();
  }
}
function H(s, e, t) {
  var _iterator220 = _createForOfIteratorHelper(s),
    _step220;
  try {
    for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
      var n = _step220.value;
      var r = n[t];
      typeof r == "string" && (r = [r]), Array.isArray(r) && r.forEach(function (i) {
        return e[t].add(i);
      });
    }
  } catch (err) {
    _iterator220.e(err);
  } finally {
    _iterator220.f();
  }
}
function _o(s, e) {
  var _iterator221 = _createForOfIteratorHelper(s),
    _step221;
  try {
    for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
      var t = _step221.value;
      var n = t.inheritAllFrom;
      n && (e.allowContentOf.add(n), e.allowWhere.add(n), e.allowAttributesOf.add(n), e.inheritTypesFrom.add(n));
    }
  } catch (err) {
    _iterator221.e(err);
  } finally {
    _iterator221.f();
  }
}
function wo(s) {
  return typeof s == "string" || s.is("documentFragment") ? {
    name: typeof s == "string" ? s : "$documentFragment",
    getAttributeKeys: function getAttributeKeys() {
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
            case "end":
              return _context21.stop();
          }
        }, _callee7);
      })();
    },
    getAttribute: function getAttribute() {}
  } : {
    name: s.is("element") ? s.name : "$text",
    getAttributeKeys: function getAttributeKeys() {
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.delegateYield(s.getAttributeKeys(), "t0", 1);
            case 1:
            case "end":
              return _context22.stop();
          }
        }, _callee8);
      })();
    },
    getAttribute: function getAttribute(e) {
      return s.getAttribute(e);
    }
  };
}
function bo(s, e) {
  var t, n, _n18;
  return _regeneratorRuntime().wrap(function bo$(_context23) {
    while (1) switch (_context23.prev = _context23.next) {
      case 0:
        t = !1;
      case 1:
        if (t) {
          _context23.next = 18;
          break;
        }
        if (!(t = !0, s)) {
          _context23.next = 9;
          break;
        }
        n = s.next();
        _context23.t0 = n.done;
        if (_context23.t0) {
          _context23.next = 9;
          break;
        }
        t = !1;
        _context23.next = 9;
        return {
          walker: s,
          value: n.value
        };
      case 9:
        if (!e) {
          _context23.next = 16;
          break;
        }
        _n18 = e.next();
        _context23.t1 = _n18.done;
        if (_context23.t1) {
          _context23.next = 16;
          break;
        }
        t = !1;
        _context23.next = 16;
        return {
          walker: e,
          value: _n18.value
        };
      case 16:
        _context23.next = 1;
        break;
      case 18:
      case "end":
        return _context23.stop();
    }
  }, _marked);
}
function yo(s) {
  var _iterator222, _step222, e;
  return _regeneratorRuntime().wrap(function yo$(_context24) {
    while (1) switch (_context24.prev = _context24.next) {
      case 0:
        _iterator222 = _createForOfIteratorHelper(s);
        _context24.prev = 1;
        _iterator222.s();
      case 3:
        if ((_step222 = _iterator222.n()).done) {
          _context24.next = 8;
          break;
        }
        e = _step222.value;
        return _context24.delegateYield(e.getMinimalFlatRanges(), "t0", 6);
      case 6:
        _context24.next = 3;
        break;
      case 8:
        _context24.next = 13;
        break;
      case 10:
        _context24.prev = 10;
        _context24.t1 = _context24["catch"](1);
        _iterator222.e(_context24.t1);
      case 13:
        _context24.prev = 13;
        _iterator222.f();
        return _context24.finish(13);
      case 16:
      case "end":
        return _context24.stop();
    }
  }, _marked2, null, [[1, 10, 13, 16]]);
}
function An(s, e, t) {
  var _iterator223 = _createForOfIteratorHelper(e.getAttributeKeys()),
    _step223;
  try {
    for (_iterator223.s(); !(_step223 = _iterator223.n()).done;) {
      var n = _step223.value;
      s.checkAttribute(e, n) || t.removeAttribute(n, e);
    }
  } catch (err) {
    _iterator223.e(err);
  } finally {
    _iterator223.f();
  }
}
var vo = /*#__PURE__*/function (_N1) {
  function vo(e) {
    var _this65;
    _classCallCheck(this, vo);
    _this65 = _callSuper(this, vo), _defineProperty(_assertThisInitialized(_this65), "conversionApi", void 0), _defineProperty(_assertThisInitialized(_this65), "_splitParts", new Map()), _defineProperty(_assertThisInitialized(_this65), "_cursorParents", new Map()), _defineProperty(_assertThisInitialized(_this65), "_modelCursor", null), _defineProperty(_assertThisInitialized(_this65), "_emptyElementsToKeep", new Set()), _this65.conversionApi = _objectSpread(_objectSpread({}, e), {}, {
      consumable: null,
      writer: null,
      store: null,
      convertItem: function convertItem(t, n) {
        return _this65._convertItem(t, n);
      },
      convertChildren: function convertChildren(t, n) {
        return _this65._convertChildren(t, n);
      },
      safeInsert: function safeInsert(t, n) {
        return _this65._safeInsert(t, n);
      },
      updateConversionResult: function updateConversionResult(t, n) {
        return _this65._updateConversionResult(t, n);
      },
      splitToAllowedParent: function splitToAllowedParent(t, n) {
        return _this65._splitToAllowedParent(t, n);
      },
      getSplitParts: function getSplitParts(t) {
        return _this65._getSplitParts(t);
      },
      keepEmptyElement: function keepEmptyElement(t) {
        return _this65._keepEmptyElement(t);
      }
    });
    return _this65;
  }
  _inherits(vo, _N1);
  return _createClass(vo, [{
    key: "convert",
    value: function convert(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
      this.fire("viewCleanup", e), this._modelCursor = Co(n, t), this.conversionApi.writer = t, this.conversionApi.consumable = ct.createFrom(e), this.conversionApi.store = {};
      var _this$_convertItem = this._convertItem(e, this._modelCursor),
        r = _this$_convertItem.modelRange,
        i = t.createDocumentFragment();
      if (r) {
        this._removeEmptyElements();
        var o = this._modelCursor.parent,
          a = o._removeChildren(0, o.childCount);
        i._insertChild(0, a), i.markers = Po(i, t);
      }
      return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this._emptyElementsToKeep.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, i;
    }
  }, {
    key: "_convertItem",
    value: function _convertItem(e, t) {
      var n = {
        viewItem: e,
        modelCursor: t,
        modelRange: null
      };
      if (e.is("element") ? this.fire("element:".concat(e.name), n, this.conversionApi) : e.is("$text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof u)) throw new f("view-conversion-dispatcher-incorrect-result", this);
      return {
        modelRange: n.modelRange,
        modelCursor: n.modelCursor
      };
    }
  }, {
    key: "_convertChildren",
    value: function _convertChildren(e, t) {
      var n = t.is("position") ? t : m._createAt(t, 0);
      var r = new u(n);
      for (var _i57 = 0, _Array$from7 = Array.from(e.getChildren()); _i57 < _Array$from7.length; _i57++) {
        var i = _Array$from7[_i57];
        var o = this._convertItem(i, n);
        o.modelRange instanceof u && (r.end = o.modelRange.end, n = o.modelCursor);
      }
      return {
        modelRange: r,
        modelCursor: n
      };
    }
  }, {
    key: "_safeInsert",
    value: function _safeInsert(e, t) {
      var n = this._splitToAllowedParent(e, t);
      return n ? (this.conversionApi.writer.insert(e, n.position), !0) : !1;
    }
  }, {
    key: "_updateConversionResult",
    value: function _updateConversionResult(e, t) {
      var n = this._getSplitParts(e),
        r = this.conversionApi.writer;
      t.modelRange || (t.modelRange = r.createRange(r.createPositionBefore(e), r.createPositionAfter(n[n.length - 1])));
      var i = this._cursorParents.get(e);
      i ? t.modelCursor = r.createPositionAt(i, 0) : t.modelCursor = t.modelRange.end;
    }
  }, {
    key: "_splitToAllowedParent",
    value: function _splitToAllowedParent(e, t) {
      var _this$conversionApi = this.conversionApi,
        n = _this$conversionApi.schema,
        r = _this$conversionApi.writer;
      var i = n.findAllowedParent(t, e);
      if (i) {
        if (i === t.parent) return {
          position: t
        };
        this._modelCursor.parent.getAncestors().includes(i) && (i = null);
      }
      if (!i) return ys(t, e, n) ? {
        position: vs(t, r)
      } : null;
      var o = this.conversionApi.writer.split(t, i),
        a = [];
      var _iterator224 = _createForOfIteratorHelper(o.range.getWalker()),
        _step224;
      try {
        for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
          var c = _step224.value;
          if (c.type == "elementEnd") a.push(c.item);else {
            var h = a.pop(),
              d = c.item;
            this._registerSplitPair(h, d);
          }
        }
      } catch (err) {
        _iterator224.e(err);
      } finally {
        _iterator224.f();
      }
      var l = o.range.end.parent;
      return this._cursorParents.set(e, l), {
        position: o.position,
        cursorParent: l
      };
    }
  }, {
    key: "_registerSplitPair",
    value: function _registerSplitPair(e, t) {
      this._splitParts.has(e) || this._splitParts.set(e, [e]);
      var n = this._splitParts.get(e);
      this._splitParts.set(t, n), n.push(t);
    }
  }, {
    key: "_getSplitParts",
    value: function _getSplitParts(e) {
      var t;
      return this._splitParts.has(e) ? t = this._splitParts.get(e) : t = [e], t;
    }
  }, {
    key: "_keepEmptyElement",
    value: function _keepEmptyElement(e) {
      this._emptyElementsToKeep.add(e);
    }
  }, {
    key: "_removeEmptyElements",
    value: function _removeEmptyElements() {
      var e = new Map();
      var _iterator225 = _createForOfIteratorHelper(this._splitParts.keys()),
        _step225;
      try {
        for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
          var t = _step225.value;
          if (t.isEmpty && !this._emptyElementsToKeep.has(t)) {
            var n = e.get(t.parent) || [];
            n.push(t), this._splitParts.delete(t), e.set(t.parent, n);
          }
        }
      } catch (err) {
        _iterator225.e(err);
      } finally {
        _iterator225.f();
      }
      var _iterator226 = _createForOfIteratorHelper(e),
        _step226;
      try {
        for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
          var _ref90 = _step226.value;
          var _ref91 = _slicedToArray(_ref90, 2);
          var _t5 = _ref91[0];
          var _n19 = _ref91[1];
          _t5._removeChildrenArray(_n19);
        }
      } catch (err) {
        _iterator226.e(err);
      } finally {
        _iterator226.f();
      }
      e.size && this._removeEmptyElements();
    }
  }]);
}(N());
function Po(s, e) {
  var t = new Set(),
    n = new Map(),
    r = u._createIn(s).getItems();
  var _iterator227 = _createForOfIteratorHelper(r),
    _step227;
  try {
    for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
      var i = _step227.value;
      i.is("element", "$marker") && t.add(i);
    }
  } catch (err) {
    _iterator227.e(err);
  } finally {
    _iterator227.f();
  }
  var _iterator228 = _createForOfIteratorHelper(t),
    _step228;
  try {
    for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
      var _i58 = _step228.value;
      var o = _i58.getAttribute("data-name"),
        a = e.createPositionBefore(_i58);
      n.has(o) ? n.get(o).end = a.clone() : n.set(o, new u(a.clone())), e.remove(_i58);
    }
  } catch (err) {
    _iterator228.e(err);
  } finally {
    _iterator228.f();
  }
  return n;
}
function Co(s, e) {
  var t;
  var _iterator229 = _createForOfIteratorHelper(new oe(s)),
    _step229;
  try {
    for (_iterator229.s(); !(_step229 = _iterator229.n()).done;) {
      var n = _step229.value;
      var r = {};
      var _iterator230 = _createForOfIteratorHelper(n.getAttributeKeys()),
        _step230;
      try {
        for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
          var o = _step230.value;
          r[o] = n.getAttribute(o);
        }
      } catch (err) {
        _iterator230.e(err);
      } finally {
        _iterator230.f();
      }
      var i = e.createElement(n.name, r);
      t && e.insert(i, t), t = m._createAt(i, 0);
    }
  } catch (err) {
    _iterator229.e(err);
  } finally {
    _iterator229.f();
  }
  return t;
}
var ko = /*#__PURE__*/function () {
  function ko() {
    _classCallCheck(this, ko);
  }
  return _createClass(ko, [{
    key: "getHtml",
    value: function getHtml(e) {
      var n = re.document.implementation.createHTMLDocument("").createElement("div");
      return n.appendChild(e), n.innerHTML;
    }
  }]);
}();
var Ao = /*#__PURE__*/function () {
  function Ao(e) {
    _classCallCheck(this, Ao);
    _defineProperty(this, "domParser", void 0);
    _defineProperty(this, "domConverter", void 0);
    _defineProperty(this, "htmlWriter", void 0);
    _defineProperty(this, "skipComments", !0);
    this.domParser = new DOMParser(), this.domConverter = new ns(e, {
      renderingMode: "data"
    }), this.htmlWriter = new ko();
  }
  return _createClass(Ao, [{
    key: "toData",
    value: function toData(e) {
      var t = this.domConverter.viewToDom(e);
      return this.htmlWriter.getHtml(t);
    }
  }, {
    key: "toView",
    value: function toView(e) {
      var t = this._toDom(e);
      return this.domConverter.domToView(t, {
        skipComments: this.skipComments
      });
    }
  }, {
    key: "registerRawContentMatcher",
    value: function registerRawContentMatcher(e) {
      this.domConverter.registerRawContentMatcher(e);
    }
  }, {
    key: "useFillerType",
    value: function useFillerType(e) {
      this.domConverter.blockFillerMode = e == "marked" ? "markedNbsp" : "nbsp";
    }
  }, {
    key: "_toDom",
    value: function _toDom(e) {
      /<(?:html|body|head|meta)(?:\s[^>]*)?>/i.test(e.trim().slice(0, 1e4)) || (e = "<body>".concat(e, "</body>"));
      var t = this.domParser.parseFromString(e, "text/html"),
        n = t.createDocumentFragment(),
        r = t.body.childNodes;
      for (; r.length > 0;) n.appendChild(r[0]);
      return n;
    }
  }]);
}();
var wl = /*#__PURE__*/function (_N10) {
  function wl(e, t) {
    var _this66;
    _classCallCheck(this, wl);
    _this66 = _callSuper(this, wl), _defineProperty(_assertThisInitialized(_this66), "model", void 0), _defineProperty(_assertThisInitialized(_this66), "mapper", void 0), _defineProperty(_assertThisInitialized(_this66), "downcastDispatcher", void 0), _defineProperty(_assertThisInitialized(_this66), "upcastDispatcher", void 0), _defineProperty(_assertThisInitialized(_this66), "viewDocument", void 0), _defineProperty(_assertThisInitialized(_this66), "stylesProcessor", void 0), _defineProperty(_assertThisInitialized(_this66), "htmlProcessor", void 0), _defineProperty(_assertThisInitialized(_this66), "processor", void 0), _defineProperty(_assertThisInitialized(_this66), "_viewWriter", void 0), _this66.model = e, _this66.mapper = new as(), _this66.downcastDispatcher = new ls({
      mapper: _this66.mapper,
      schema: e.schema
    }), _this66.downcastDispatcher.on("insert:$text", us(), {
      priority: "lowest"
    }), _this66.downcastDispatcher.on("insert", fs(), {
      priority: "lowest"
    }), _this66.upcastDispatcher = new vo({
      schema: e.schema
    }), _this66.viewDocument = new Xn(t), _this66.stylesProcessor = t, _this66.htmlProcessor = new Ao(_this66.viewDocument), _this66.processor = _this66.htmlProcessor, _this66._viewWriter = new Yn(_this66.viewDocument), _this66.upcastDispatcher.on("text", Ji(), {
      priority: "lowest"
    }), _this66.upcastDispatcher.on("element", Cn(), {
      priority: "lowest"
    }), _this66.upcastDispatcher.on("documentFragment", Cn(), {
      priority: "lowest"
    }), U().prototype.decorate.call(_assertThisInitialized(_this66), "init"), U().prototype.decorate.call(_assertThisInitialized(_this66), "set"), U().prototype.decorate.call(_assertThisInitialized(_this66), "get"), U().prototype.decorate.call(_assertThisInitialized(_this66), "toView"), U().prototype.decorate.call(_assertThisInitialized(_this66), "toModel"), _this66.on("init", function () {
      _this66.fire("ready");
    }, {
      priority: "lowest"
    }), _this66.on("ready", function () {
      _this66.model.enqueueChange({
        isUndoable: !1
      }, bs);
    }, {
      priority: "lowest"
    });
    return _this66;
  }
  _inherits(wl, _N10);
  return _createClass(wl, [{
    key: "get",
    value: function get() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _e$rootName = e.rootName,
        t = _e$rootName === void 0 ? "main" : _e$rootName,
        _e$trim = e.trim,
        n = _e$trim === void 0 ? "empty" : _e$trim;
      if (!this._checkIfRootsExists([t])) throw new f("datacontroller-get-non-existent-root", this);
      var r = this.model.document.getRoot(t);
      return r.isAttached() || W("datacontroller-get-detached-root", this), n === "empty" && !this.model.hasContent(r, {
        ignoreWhitespaces: !0
      }) ? "" : this.stringify(r, e);
    }
  }, {
    key: "stringify",
    value: function stringify(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = this.toView(e, t);
      return this.processor.toData(n);
    }
  }, {
    key: "toView",
    value: function toView(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = this.viewDocument,
        r = this._viewWriter;
      this.mapper.clearBindings();
      var i = u._createIn(e),
        o = new ge(n);
      this.mapper.bindElements(e, o);
      var a = e.is("documentFragment") ? e.markers : So(e);
      return this.downcastDispatcher.convert(i, a, r, t), o;
    }
  }, {
    key: "init",
    value: function init(e) {
      var _this67 = this;
      if (this.model.document.version) throw new f("datacontroller-init-document-not-empty", this);
      var t = {};
      if (typeof e == "string" ? t.main = e : t = e, !this._checkIfRootsExists(Object.keys(t))) throw new f("datacontroller-init-non-existent-root", this);
      return this.model.enqueueChange({
        isUndoable: !1
      }, function (n) {
        for (var _i59 = 0, _Object$keys2 = Object.keys(t); _i59 < _Object$keys2.length; _i59++) {
          var r = _Object$keys2[_i59];
          var i = _this67.model.document.getRoot(r);
          n.insert(_this67.parse(t[r], i), i, 0);
        }
      }), Promise.resolve();
    }
  }, {
    key: "set",
    value: function set(e) {
      var _this68 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = {};
      if (typeof e == "string" ? n.main = e : n = e, !this._checkIfRootsExists(Object.keys(n))) throw new f("datacontroller-set-non-existent-root", this);
      this.model.enqueueChange(t.batchType || {}, function (r) {
        r.setSelection(null), r.removeSelectionAttribute(_this68.model.document.selection.getAttributeKeys());
        for (var _i60 = 0, _Object$keys3 = Object.keys(n); _i60 < _Object$keys3.length; _i60++) {
          var i = _Object$keys3[_i60];
          var o = _this68.model.document.getRoot(i);
          r.remove(r.createRangeIn(o)), r.insert(_this68.parse(n[i], o), o, 0);
        }
      });
    }
  }, {
    key: "parse",
    value: function parse(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
      var n = this.processor.toView(e);
      return this.toModel(n, t);
    }
  }, {
    key: "toModel",
    value: function toModel(e) {
      var _this69 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
      return this.model.change(function (n) {
        return _this69.upcastDispatcher.convert(e, n, t);
      });
    }
  }, {
    key: "addStyleProcessorRules",
    value: function addStyleProcessorRules(e) {
      e(this.stylesProcessor);
    }
  }, {
    key: "registerRawContentMatcher",
    value: function registerRawContentMatcher(e) {
      this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(e), this.htmlProcessor.registerRawContentMatcher(e);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
  }, {
    key: "_checkIfRootsExists",
    value: function _checkIfRootsExists(e) {
      var _iterator231 = _createForOfIteratorHelper(e),
        _step231;
      try {
        for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
          var t = _step231.value;
          if (!this.model.document.getRoot(t)) return !1;
        }
      } catch (err) {
        _iterator231.e(err);
      } finally {
        _iterator231.f();
      }
      return !0;
    }
  }]);
}(N());
function So(s) {
  var e = [],
    t = s.root.document;
  if (!t) return new Map();
  var n = u._createIn(s);
  var _iterator232 = _createForOfIteratorHelper(t.model.markers),
    _step232;
  try {
    for (_iterator232.s(); !(_step232 = _iterator232.n()).done;) {
      var r = _step232.value;
      var i = r.getRange(),
        o = i.isCollapsed,
        a = i.start.isEqual(n.start) || i.end.isEqual(n.end);
      if (o && a) e.push([r.name, i]);else {
        var l = n.getIntersection(i);
        l && e.push([r.name, l]);
      }
    }
  } catch (err) {
    _iterator232.e(err);
  } finally {
    _iterator232.f();
  }
  return e.sort(function (_ref92, _ref93) {
    var _ref94 = _slicedToArray(_ref92, 2),
      r = _ref94[0],
      i = _ref94[1];
    var _ref95 = _slicedToArray(_ref93, 2),
      o = _ref95[0],
      a = _ref95[1];
    if (i.end.compareWith(a.start) !== "after") return 1;
    if (i.start.compareWith(a.end) !== "before") return -1;
    switch (i.start.compareWith(a.start)) {
      case "before":
        return 1;
      case "after":
        return -1;
      default:
        switch (i.end.compareWith(a.end)) {
          case "before":
            return 1;
          case "after":
            return -1;
          default:
            return o.localeCompare(r);
        }
    }
  }), new Map(e);
}
var bl = /*#__PURE__*/function () {
  function bl(e, t) {
    _classCallCheck(this, bl);
    _defineProperty(this, "_helpers", new Map());
    _defineProperty(this, "_downcast", void 0);
    _defineProperty(this, "_upcast", void 0);
    this._downcast = ae(e), this._createConversionHelpers({
      name: "downcast",
      dispatchers: this._downcast,
      isDowncast: !0
    }), this._upcast = ae(t), this._createConversionHelpers({
      name: "upcast",
      dispatchers: this._upcast,
      isDowncast: !1
    });
  }
  return _createClass(bl, [{
    key: "addAlias",
    value: function addAlias(e, t) {
      var n = this._downcast.includes(t);
      if (!this._upcast.includes(t) && !n) throw new f("conversion-add-alias-dispatcher-not-registered", this);
      this._createConversionHelpers({
        name: e,
        dispatchers: [t],
        isDowncast: n
      });
    }
  }, {
    key: "for",
    value: function _for(e) {
      if (!this._helpers.has(e)) throw new f("conversion-for-unknown-group", this);
      return this._helpers.get(e);
    }
  }, {
    key: "elementToElement",
    value: function elementToElement(e) {
      this.for("downcast").elementToElement(e);
      var _iterator233 = _createForOfIteratorHelper(At(e)),
        _step233;
      try {
        for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
          var _ref96 = _step233.value;
          var t = _ref96.model;
          var n = _ref96.view;
          this.for("upcast").elementToElement({
            model: t,
            view: n,
            converterPriority: e.converterPriority
          });
        }
      } catch (err) {
        _iterator233.e(err);
      } finally {
        _iterator233.f();
      }
    }
  }, {
    key: "attributeToElement",
    value: function attributeToElement(e) {
      this.for("downcast").attributeToElement(e);
      var _iterator234 = _createForOfIteratorHelper(At(e)),
        _step234;
      try {
        for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
          var _ref97 = _step234.value;
          var t = _ref97.model;
          var n = _ref97.view;
          this.for("upcast").elementToAttribute({
            view: n,
            model: t,
            converterPriority: e.converterPriority
          });
        }
      } catch (err) {
        _iterator234.e(err);
      } finally {
        _iterator234.f();
      }
    }
  }, {
    key: "attributeToAttribute",
    value: function attributeToAttribute(e) {
      this.for("downcast").attributeToAttribute(e);
      var _iterator235 = _createForOfIteratorHelper(At(e)),
        _step235;
      try {
        for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
          var _ref98 = _step235.value;
          var t = _ref98.model;
          var n = _ref98.view;
          this.for("upcast").attributeToAttribute({
            view: n,
            model: t
          });
        }
      } catch (err) {
        _iterator235.e(err);
      } finally {
        _iterator235.f();
      }
    }
  }, {
    key: "_createConversionHelpers",
    value: function _createConversionHelpers(_ref99) {
      var e = _ref99.name,
        t = _ref99.dispatchers,
        n = _ref99.isDowncast;
      if (this._helpers.has(e)) throw new f("conversion-group-exists", this);
      var r = n ? new fi(t) : new Ui(t);
      this._helpers.set(e, r);
    }
  }]);
}();
function At(s) {
  var _iterator236, _step236, e, t, n, r;
  return _regeneratorRuntime().wrap(function At$(_context25) {
    while (1) switch (_context25.prev = _context25.next) {
      case 0:
        if (!s.model.values) {
          _context25.next = 20;
          break;
        }
        _iterator236 = _createForOfIteratorHelper(s.model.values);
        _context25.prev = 2;
        _iterator236.s();
      case 4:
        if ((_step236 = _iterator236.n()).done) {
          _context25.next = 10;
          break;
        }
        e = _step236.value;
        t = {
          key: s.model.key,
          value: e
        }, n = s.view[e], r = s.upcastAlso ? s.upcastAlso[e] : void 0;
        return _context25.delegateYield(Sn(t, n, r), "t0", 8);
      case 8:
        _context25.next = 4;
        break;
      case 10:
        _context25.next = 15;
        break;
      case 12:
        _context25.prev = 12;
        _context25.t1 = _context25["catch"](2);
        _iterator236.e(_context25.t1);
      case 15:
        _context25.prev = 15;
        _iterator236.f();
        return _context25.finish(15);
      case 18:
        _context25.next = 21;
        break;
      case 20:
        return _context25.delegateYield(Sn(s.model, s.view, s.upcastAlso), "t2", 21);
      case 21:
      case "end":
        return _context25.stop();
    }
  }, _marked3, null, [[2, 12, 15, 18]]);
}
function Sn(s, e, t) {
  var _iterator237, _step237, n;
  return _regeneratorRuntime().wrap(function Sn$(_context26) {
    while (1) switch (_context26.prev = _context26.next) {
      case 0:
        _context26.next = 2;
        return {
          model: s,
          view: e
        };
      case 2:
        if (!t) {
          _context26.next = 20;
          break;
        }
        _iterator237 = _createForOfIteratorHelper(ae(t));
        _context26.prev = 4;
        _iterator237.s();
      case 6:
        if ((_step237 = _iterator237.n()).done) {
          _context26.next = 12;
          break;
        }
        n = _step237.value;
        _context26.next = 10;
        return {
          model: s,
          view: n
        };
      case 10:
        _context26.next = 6;
        break;
      case 12:
        _context26.next = 17;
        break;
      case 14:
        _context26.prev = 14;
        _context26.t0 = _context26["catch"](4);
        _iterator237.e(_context26.t0);
      case 17:
        _context26.prev = 17;
        _iterator237.f();
        return _context26.finish(17);
      case 20:
      case "end":
        return _context26.stop();
    }
  }, _marked4, null, [[4, 14, 17, 20]]);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var q = /*#__PURE__*/function () {
  function q(e) {
    _classCallCheck(this, q);
    _defineProperty(this, "baseVersion", void 0);
    _defineProperty(this, "isDocumentOperation", void 0);
    _defineProperty(this, "batch", void 0);
    this.baseVersion = e, this.isDocumentOperation = this.baseVersion !== null, this.batch = null;
  }
  return _createClass(q, [{
    key: "_validate",
    value: function _validate() {}
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = Object.assign({}, this);
      return e.__className = this.constructor.className, delete e.batch, delete e.isDocumentOperation, e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "Operation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      return new this(e.baseVersion);
    }
  }]);
}();
function Xt(s, e) {
  var t = Ss(e),
    n = t.reduce(function (o, a) {
      return o + a.offsetSize;
    }, 0),
    r = s.parent;
  Ze(s);
  var i = s.index;
  return r._insertChild(i, t), Qe(r, i + t.length), Qe(r, i), new u(s, s.getShiftedBy(n));
}
function As(s) {
  if (!s.isFlat) throw new f("operation-utils-remove-range-not-flat", this);
  var e = s.start.parent;
  Ze(s.start), Ze(s.end);
  var t = e._removeChildren(s.start.index, s.end.index - s.start.index);
  return Qe(e, s.start.index), t;
}
function Ye(s, e) {
  if (!s.isFlat) throw new f("operation-utils-move-range-not-flat", this);
  var t = As(s);
  return e = e._getTransformedByDeletion(s.start, s.end.offset - s.start.offset), Xt(e, t);
}
function Eo(s, e, t) {
  Ze(s.start), Ze(s.end);
  var _iterator238 = _createForOfIteratorHelper(s.getItems({
      shallow: !0
    })),
    _step238;
  try {
    for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
      var n = _step238.value;
      var r = n.is("$textProxy") ? n.textNode : n;
      t !== null ? r._setAttribute(e, t) : r._removeAttribute(e), Qe(r.parent, r.index);
    }
  } catch (err) {
    _iterator238.e(err);
  } finally {
    _iterator238.f();
  }
  Qe(s.end.parent, s.end.index);
}
function Ss(s) {
  var e = [];
  function t(n) {
    if (typeof n == "string") e.push(new k(n));else if (n instanceof j) e.push(new k(n.data, n.getAttributes()));else if (n instanceof ve) e.push(n);else if (le(n)) {
      var _iterator239 = _createForOfIteratorHelper(n),
        _step239;
      try {
        for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
          var r = _step239.value;
          t(r);
        }
      } catch (err) {
        _iterator239.e(err);
      } finally {
        _iterator239.f();
      }
    }
  }
  t(s);
  for (var n = 1; n < e.length; n++) {
    var r = e[n],
      i = e[n - 1];
    r instanceof k && i instanceof k && Es(r, i) && (e.splice(n - 1, 2, new k(i.data + r.data, i.getAttributes())), n--);
  }
  return e;
}
function Qe(s, e) {
  var t = s.getChild(e - 1),
    n = s.getChild(e);
  if (t && n && t.is("$text") && n.is("$text") && Es(t, n)) {
    var r = new k(t.data + n.data, t.getAttributes());
    s._removeChildren(e - 1, 2), s._insertChild(e - 1, r);
  }
}
function Ze(s) {
  var e = s.textNode,
    t = s.parent;
  if (e) {
    var n = s.offset - e.startOffset,
      r = e.index;
    t._removeChildren(r, 1);
    var i = new k(e.data.substr(0, n), e.getAttributes()),
      o = new k(e.data.substr(n), e.getAttributes());
    t._insertChild(r, [i, o]);
  }
}
function Es(s, e) {
  var t = s.getAttributes(),
    n = e.getAttributes();
  var _iterator240 = _createForOfIteratorHelper(t),
    _step240;
  try {
    for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
      var r = _step240.value;
      if (r[1] !== e.getAttribute(r[0])) return !1;
      n.next();
    }
  } catch (err) {
    _iterator240.e(err);
  } finally {
    _iterator240.f();
  }
  return n.next().done;
}
var v = /*#__PURE__*/function (_q2) {
  function v(e, t, n, r) {
    var _this70;
    _classCallCheck(this, v);
    _this70 = _callSuper(this, v, [r]), _defineProperty(_assertThisInitialized(_this70), "sourcePosition", void 0), _defineProperty(_assertThisInitialized(_this70), "howMany", void 0), _defineProperty(_assertThisInitialized(_this70), "targetPosition", void 0), _this70.sourcePosition = e.clone(), _this70.sourcePosition.stickiness = "toNext", _this70.howMany = t, _this70.targetPosition = n.clone(), _this70.targetPosition.stickiness = "toNone";
    return _this70;
  }
  _inherits(v, _q2);
  return _createClass(v, [{
    key: "type",
    get: function get() {
      return this.targetPosition.root.rootName == "$graveyard" ? "remove" : this.sourcePosition.root.rootName == "$graveyard" ? "reinsert" : "move";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return [u._createFromPositionAndShift(this.sourcePosition, this.howMany), u._createFromPositionAndShift(this.targetPosition, 0)];
    }
  }, {
    key: "clone",
    value: function clone() {
      return new v(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
    }
  }, {
    key: "getMovedRangeStart",
    value: function getMovedRangeStart() {
      return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      var e = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
      return new v(this.getMovedRangeStart(), this.howMany, e, this.baseVersion + 1);
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var e = this.sourcePosition.parent,
        t = this.targetPosition.parent,
        n = this.sourcePosition.offset,
        r = this.targetPosition.offset;
      if (n + this.howMany > e.maxOffset) throw new f("move-operation-nodes-do-not-exist", this);
      if (e === t && n < r && r < n + this.howMany) throw new f("move-operation-range-into-itself", this);
      if (this.sourcePosition.root == this.targetPosition.root && F(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
        var i = this.sourcePosition.path.length - 1;
        if (this.targetPosition.path[i] >= n && this.targetPosition.path[i] < n + this.howMany) throw new f("move-operation-node-into-itself", this);
      }
    }
  }, {
    key: "_execute",
    value: function _execute() {
      Ye(u._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(v, "toJSON", this, 3)([]);
      return e.sourcePosition = this.sourcePosition.toJSON(), e.targetPosition = this.targetPosition.toJSON(), e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "MoveOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      var n = m.fromJSON(e.sourcePosition, t),
        r = m.fromJSON(e.targetPosition, t);
      return new this(n, e.howMany, r, e.baseVersion);
    }
  }]);
}(q);
var T = /*#__PURE__*/function (_q3) {
  function T(e, t, n) {
    var _this71;
    _classCallCheck(this, T);
    _this71 = _callSuper(this, T, [n]), _defineProperty(_assertThisInitialized(_this71), "position", void 0), _defineProperty(_assertThisInitialized(_this71), "nodes", void 0), _defineProperty(_assertThisInitialized(_this71), "shouldReceiveAttributes", void 0), _this71.position = e.clone(), _this71.position.stickiness = "toNone", _this71.nodes = new ze(Ss(t)), _this71.shouldReceiveAttributes = !1;
    return _this71;
  }
  _inherits(T, _q3);
  return _createClass(T, [{
    key: "type",
    get: function get() {
      return "insert";
    }
  }, {
    key: "howMany",
    get: function get() {
      return this.nodes.maxOffset;
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return this.position.clone();
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = new ze(_toConsumableArray(this.nodes).map(function (n) {
          return n._clone(!0);
        })),
        t = new T(this.position, e, this.baseVersion);
      return t.shouldReceiveAttributes = this.shouldReceiveAttributes, t;
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      var e = this.position.root.document.graveyard,
        t = new m(e, [0]);
      return new v(this.position, this.nodes.maxOffset, t, this.baseVersion + 1);
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var e = this.position.parent;
      if (!e || e.maxOffset < this.position.offset) throw new f("insert-operation-position-invalid", this);
    }
  }, {
    key: "_execute",
    value: function _execute() {
      var e = this.nodes;
      this.nodes = new ze(_toConsumableArray(e).map(function (t) {
        return t._clone(!0);
      })), Xt(this.position, e);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(T, "toJSON", this, 3)([]);
      return e.position = this.position.toJSON(), e.nodes = this.nodes.toJSON(), e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "InsertOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      var n = [];
      var _iterator241 = _createForOfIteratorHelper(e.nodes),
        _step241;
      try {
        for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
          var i = _step241.value;
          i.name ? n.push(C.fromJSON(i)) : n.push(k.fromJSON(i));
        }
      } catch (err) {
        _iterator241.e(err);
      } finally {
        _iterator241.f();
      }
      var r = new T(m.fromJSON(e.position, t), n, e.baseVersion);
      return r.shouldReceiveAttributes = e.shouldReceiveAttributes, r;
    }
  }]);
}(q);
var P = /*#__PURE__*/function (_q4) {
  function P(e, t, n, r, i) {
    var _this72;
    _classCallCheck(this, P);
    _this72 = _callSuper(this, P, [i]), _defineProperty(_assertThisInitialized(_this72), "splitPosition", void 0), _defineProperty(_assertThisInitialized(_this72), "howMany", void 0), _defineProperty(_assertThisInitialized(_this72), "insertionPosition", void 0), _defineProperty(_assertThisInitialized(_this72), "graveyardPosition", void 0), _this72.splitPosition = e.clone(), _this72.splitPosition.stickiness = "toNext", _this72.howMany = t, _this72.insertionPosition = n, _this72.graveyardPosition = r ? r.clone() : null, _this72.graveyardPosition && (_this72.graveyardPosition.stickiness = "toNext");
    return _this72;
  }
  _inherits(P, _q4);
  return _createClass(P, [{
    key: "type",
    get: function get() {
      return "split";
    }
  }, {
    key: "moveTargetPosition",
    get: function get() {
      var e = this.insertionPosition.path.slice();
      return e.push(0), new m(this.insertionPosition.root, e);
    }
  }, {
    key: "movedRange",
    get: function get() {
      var e = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
      return new u(this.splitPosition, e);
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      var e = [u._createFromPositionAndShift(this.splitPosition, 0), u._createFromPositionAndShift(this.insertionPosition, 0)];
      return this.graveyardPosition && e.push(u._createFromPositionAndShift(this.graveyardPosition, 0)), e;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new P(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      var e = this.splitPosition.root.document.graveyard,
        t = new m(e, [0]);
      return new A(this.moveTargetPosition, this.howMany, this.splitPosition, t, this.baseVersion + 1);
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var e = this.splitPosition.parent,
        t = this.splitPosition.offset;
      if (!e || e.maxOffset < t) throw new f("split-operation-position-invalid", this);
      if (e.parent) {
        if (this.howMany != e.maxOffset - this.splitPosition.offset) throw new f("split-operation-how-many-invalid", this);
        if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new f("split-operation-graveyard-position-invalid", this);
      } else throw new f("split-operation-split-in-root", this);
    }
  }, {
    key: "_execute",
    value: function _execute() {
      var e = this.splitPosition.parent;
      if (this.graveyardPosition) Ye(u._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
        var n = e._clone();
        Xt(this.insertionPosition, n);
      }
      var t = new u(m._createAt(e, this.splitPosition.offset), m._createAt(e, e.maxOffset));
      Ye(t, this.moveTargetPosition);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(P, "toJSON", this, 3)([]);
      return e.splitPosition = this.splitPosition.toJSON(), e.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (e.graveyardPosition = this.graveyardPosition.toJSON()), e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "SplitOperation";
    }
  }, {
    key: "getInsertionPosition",
    value: function getInsertionPosition(e) {
      var t = e.path.slice(0, -1);
      return t[t.length - 1]++, new m(e.root, t, "toPrevious");
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      var n = m.fromJSON(e.splitPosition, t),
        r = m.fromJSON(e.insertionPosition, t),
        i = e.graveyardPosition ? m.fromJSON(e.graveyardPosition, t) : null;
      return new this(n, e.howMany, r, i, e.baseVersion);
    }
  }]);
}(q);
var A = /*#__PURE__*/function (_q5) {
  function A(e, t, n, r, i) {
    var _this73;
    _classCallCheck(this, A);
    _this73 = _callSuper(this, A, [i]), _defineProperty(_assertThisInitialized(_this73), "sourcePosition", void 0), _defineProperty(_assertThisInitialized(_this73), "howMany", void 0), _defineProperty(_assertThisInitialized(_this73), "targetPosition", void 0), _defineProperty(_assertThisInitialized(_this73), "graveyardPosition", void 0), _this73.sourcePosition = e.clone(), _this73.sourcePosition.stickiness = "toPrevious", _this73.howMany = t, _this73.targetPosition = n.clone(), _this73.targetPosition.stickiness = "toNext", _this73.graveyardPosition = r.clone();
    return _this73;
  }
  _inherits(A, _q5);
  return _createClass(A, [{
    key: "type",
    get: function get() {
      return "merge";
    }
  }, {
    key: "deletionPosition",
    get: function get() {
      return new m(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
    }
  }, {
    key: "movedRange",
    get: function get() {
      var e = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
      return new u(this.sourcePosition, e);
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      var e = this.sourcePosition.parent;
      return [u._createOn(e), u._createFromPositionAndShift(this.targetPosition, 0), u._createFromPositionAndShift(this.graveyardPosition, 0)];
    }
  }, {
    key: "clone",
    value: function clone() {
      return new A(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      var e = this.targetPosition._getTransformedByMergeOperation(this),
        t = this.sourcePosition.path.slice(0, -1),
        n = new m(this.sourcePosition.root, t)._getTransformedByMergeOperation(this);
      return new P(e, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var e = this.sourcePosition.parent,
        t = this.targetPosition.parent;
      if (e.parent) {
        if (t.parent) {
          if (this.howMany != e.maxOffset) throw new f("merge-operation-how-many-invalid", this);
        } else throw new f("merge-operation-target-position-invalid", this);
      } else throw new f("merge-operation-source-position-invalid", this);
    }
  }, {
    key: "_execute",
    value: function _execute() {
      var e = this.sourcePosition.parent,
        t = u._createIn(e);
      Ye(t, this.targetPosition), Ye(u._createOn(e), this.graveyardPosition);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(A, "toJSON", this, 3)([]);
      return e.sourcePosition = e.sourcePosition.toJSON(), e.targetPosition = e.targetPosition.toJSON(), e.graveyardPosition = e.graveyardPosition.toJSON(), e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "MergeOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      var n = m.fromJSON(e.sourcePosition, t),
        r = m.fromJSON(e.targetPosition, t),
        i = m.fromJSON(e.graveyardPosition, t);
      return new this(n, e.howMany, r, i, e.baseVersion);
    }
  }]);
}(q);
var B = /*#__PURE__*/function (_q6) {
  function B(e, t, n, r, i, o) {
    var _this74;
    _classCallCheck(this, B);
    _this74 = _callSuper(this, B, [o]), _defineProperty(_assertThisInitialized(_this74), "name", void 0), _defineProperty(_assertThisInitialized(_this74), "oldRange", void 0), _defineProperty(_assertThisInitialized(_this74), "newRange", void 0), _defineProperty(_assertThisInitialized(_this74), "affectsData", void 0), _defineProperty(_assertThisInitialized(_this74), "_markers", void 0), _this74.name = e, _this74.oldRange = t ? t.clone() : null, _this74.newRange = n ? n.clone() : null, _this74.affectsData = i, _this74._markers = r;
    return _this74;
  }
  _inherits(B, _q6);
  return _createClass(B, [{
    key: "type",
    get: function get() {
      return "marker";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      var e = [];
      return this.oldRange && e.push(this.oldRange.clone()), this.newRange && (this.oldRange ? e.push.apply(e, _toConsumableArray(this.newRange.getDifference(this.oldRange))) : e.push(this.newRange.clone())), e;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new B(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      return new B(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
    }
  }, {
    key: "_execute",
    value: function _execute() {
      this.newRange ? this._markers._set(this.name, this.newRange, !0, this.affectsData) : this._markers._remove(this.name);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(B, "toJSON", this, 3)([]);
      return this.oldRange && (e.oldRange = this.oldRange.toJSON()), this.newRange && (e.newRange = this.newRange.toJSON()), delete e._markers, e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "MarkerOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      return new B(e.name, e.oldRange ? u.fromJSON(e.oldRange, t) : null, e.newRange ? u.fromJSON(e.newRange, t) : null, t.model.markers, e.affectsData, e.baseVersion);
    }
  }]);
}(q);
var S = /*#__PURE__*/function (_q7) {
  function S(e, t, n, r, i) {
    var _this75;
    _classCallCheck(this, S);
    _this75 = _callSuper(this, S, [i]), _defineProperty(_assertThisInitialized(_this75), "range", void 0), _defineProperty(_assertThisInitialized(_this75), "key", void 0), _defineProperty(_assertThisInitialized(_this75), "oldValue", void 0), _defineProperty(_assertThisInitialized(_this75), "newValue", void 0), _this75.range = e.clone(), _this75.key = t, _this75.oldValue = n === void 0 ? null : n, _this75.newValue = r === void 0 ? null : r;
    return _this75;
  }
  _inherits(S, _q7);
  return _createClass(S, [{
    key: "type",
    get: function get() {
      return this.oldValue === null ? "addAttribute" : this.newValue === null ? "removeAttribute" : "changeAttribute";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return this.range.clone();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new S(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      return new S(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(S, "toJSON", this, 3)([]);
      return e.range = this.range.toJSON(), e;
    }
  }, {
    key: "_validate",
    value: function _validate() {
      if (!this.range.isFlat) throw new f("attribute-operation-range-not-flat", this);
      var _iterator242 = _createForOfIteratorHelper(this.range.getItems({
          shallow: !0
        })),
        _step242;
      try {
        for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
          var e = _step242.value;
          if (this.oldValue !== null && !nn(e.getAttribute(this.key), this.oldValue)) throw new f("attribute-operation-wrong-old-value", this, {
            item: e,
            key: this.key,
            value: this.oldValue
          });
          if (this.oldValue === null && this.newValue !== null && e.hasAttribute(this.key)) throw new f("attribute-operation-attribute-exists", this, {
            node: e,
            key: this.key
          });
        }
      } catch (err) {
        _iterator242.e(err);
      } finally {
        _iterator242.f();
      }
    }
  }, {
    key: "_execute",
    value: function _execute() {
      nn(this.oldValue, this.newValue) || Eo(this.range, this.key, this.newValue);
    }
  }], [{
    key: "className",
    get: function get() {
      return "AttributeOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      return new S(u.fromJSON(e.range, t), e.key, e.oldValue, e.newValue, e.baseVersion);
    }
  }]);
}(q);
var R = /*#__PURE__*/function (_q8) {
  function R() {
    _classCallCheck(this, R);
    return _callSuper(this, R, arguments);
  }
  _inherits(R, _q8);
  return _createClass(R, [{
    key: "type",
    get: function get() {
      return "noop";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return null;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new R(this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      return new R(this.baseVersion + 1);
    }
  }, {
    key: "_execute",
    value: function _execute() {}
  }], [{
    key: "className",
    get: function get() {
      return "NoOperation";
    }
  }]);
}(q);
var V = /*#__PURE__*/function (_q9) {
  function V(e, t, n, r) {
    var _this76;
    _classCallCheck(this, V);
    _this76 = _callSuper(this, V, [r]), _defineProperty(_assertThisInitialized(_this76), "position", void 0), _defineProperty(_assertThisInitialized(_this76), "oldName", void 0), _defineProperty(_assertThisInitialized(_this76), "newName", void 0), _this76.position = e, _this76.position.stickiness = "toNext", _this76.oldName = t, _this76.newName = n;
    return _this76;
  }
  _inherits(V, _q9);
  return _createClass(V, [{
    key: "type",
    get: function get() {
      return "rename";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return this.position.nodeAfter;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new V(this.position.clone(), this.oldName, this.newName, this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      return new V(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var e = this.position.nodeAfter;
      if (e instanceof C) {
        if (e.name !== this.oldName) throw new f("rename-operation-wrong-name", this);
      } else throw new f("rename-operation-wrong-position", this);
    }
  }, {
    key: "_execute",
    value: function _execute() {
      var e = this.position.nodeAfter;
      e.name = this.newName;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(V, "toJSON", this, 3)([]);
      return e.position = this.position.toJSON(), e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "RenameOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      return new V(m.fromJSON(e.position, t), e.oldName, e.newName, e.baseVersion);
    }
  }]);
}(q);
var ee = /*#__PURE__*/function (_q0) {
  function ee(e, t, n, r, i) {
    var _this77;
    _classCallCheck(this, ee);
    _this77 = _callSuper(this, ee, [i]), _defineProperty(_assertThisInitialized(_this77), "root", void 0), _defineProperty(_assertThisInitialized(_this77), "key", void 0), _defineProperty(_assertThisInitialized(_this77), "oldValue", void 0), _defineProperty(_assertThisInitialized(_this77), "newValue", void 0), _this77.root = e, _this77.key = t, _this77.oldValue = n === void 0 ? null : n, _this77.newValue = r === void 0 ? null : r;
    return _this77;
  }
  _inherits(ee, _q0);
  return _createClass(ee, [{
    key: "type",
    get: function get() {
      return this.oldValue === null ? "addRootAttribute" : this.newValue === null ? "removeRootAttribute" : "changeRootAttribute";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return this.root;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ee(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      return new ee(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
    }
  }, {
    key: "_validate",
    value: function _validate() {
      if (this.root != this.root.root || this.root.is("documentFragment")) throw new f("rootattribute-operation-not-a-root", this, {
        root: this.root,
        key: this.key
      });
      if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue) throw new f("rootattribute-operation-wrong-old-value", this, {
        root: this.root,
        key: this.key
      });
      if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key)) throw new f("rootattribute-operation-attribute-exists", this, {
        root: this.root,
        key: this.key
      });
    }
  }, {
    key: "_execute",
    value: function _execute() {
      this.newValue !== null ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(ee, "toJSON", this, 3)([]);
      return e.root = this.root.toJSON(), e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "RootAttributeOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      if (!t.getRoot(e.root)) throw new f("rootattribute-operation-fromjson-no-root", this, {
        rootName: e.root
      });
      return new ee(t.getRoot(e.root), e.key, e.oldValue, e.newValue, e.baseVersion);
    }
  }]);
}(q);
var X = /*#__PURE__*/function (_q1) {
  function X(e, t, n, r, i) {
    var _this78;
    _classCallCheck(this, X);
    if (_this78 = _callSuper(this, X, [i]), _defineProperty(_assertThisInitialized(_this78), "rootName", void 0), _defineProperty(_assertThisInitialized(_this78), "elementName", void 0), _defineProperty(_assertThisInitialized(_this78), "isAdd", void 0), _defineProperty(_assertThisInitialized(_this78), "_document", void 0), _this78.rootName = e, _this78.elementName = t, _this78.isAdd = n, _this78._document = r, !_this78._document.getRoot(_this78.rootName)) {
      var o = _this78._document.createRoot(_this78.elementName, _this78.rootName);
      o._isAttached = !1;
    }
    return _assertThisInitialized(_this78);
  }
  _inherits(X, _q1);
  return _createClass(X, [{
    key: "type",
    get: function get() {
      return this.isAdd ? "addRoot" : "detachRoot";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return this._document.getRoot(this.rootName);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new X(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
    }
  }, {
    key: "getReversed",
    value: function getReversed() {
      return new X(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
    }
  }, {
    key: "_execute",
    value: function _execute() {
      this._document.getRoot(this.rootName)._isAttached = this.isAdd;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(X, "toJSON", this, 3)([]);
      return delete e._document, e;
    }
  }], [{
    key: "className",
    get: function get() {
      return "RootOperation";
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e, t) {
      return new X(e.rootName, e.elementName, e.isAdd, t, e.baseVersion);
    }
  }]);
}(q);
var J = {};
J[S.className] = S;
J[T.className] = T;
J[B.className] = B;
J[v.className] = v;
J[R.className] = R;
J[q.className] = q;
J[V.className] = V;
J[ee.className] = ee;
J[X.className] = X;
J[P.className] = P;
J[A.className] = A;
var Ro = /*#__PURE__*/function () {
  function Ro() {
    _classCallCheck(this, Ro);
  }
  return _createClass(Ro, null, [{
    key: "fromJSON",
    value: function fromJSON(e, t) {
      return J[e.__className].fromJSON(e, t);
    }
  }]);
}();
var $t = new Map();
function b(s, e, t) {
  var n = $t.get(s);
  n || (n = new Map(), $t.set(s, n)), n.set(e, t);
}
function To(s, e) {
  var t = $t.get(s);
  return t && t.has(e) ? t.get(e) : Mo;
}
function Mo(s) {
  return [s];
}
function En(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var n = To(s.constructor, e.constructor);
  try {
    return s = s.clone(), n(s, e, t);
  } catch (r) {
    throw r;
  }
}
function yl(s, e, t) {
  s = s.slice(), e = e.slice();
  var n = new xo(t.document, t.useRelations, t.forceWeakRemove);
  n.setOriginalOperations(s), n.setOriginalOperations(e);
  var r = n.originalOperations;
  if (s.length == 0 || e.length == 0) return {
    operationsA: s,
    operationsB: e,
    originalOperations: r
  };
  var i = new WeakMap();
  var _iterator243 = _createForOfIteratorHelper(s),
    _step243;
  try {
    for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
      var _l9 = _step243.value;
      i.set(_l9, 0);
    }
  } catch (err) {
    _iterator243.e(err);
  } finally {
    _iterator243.f();
  }
  var o = {
    nextBaseVersionA: s[s.length - 1].baseVersion + 1,
    nextBaseVersionB: e[e.length - 1].baseVersion + 1,
    originalOperationsACount: s.length,
    originalOperationsBCount: e.length
  };
  var a = 0;
  for (; a < s.length;) {
    var _s3, _e8;
    var l = s[a],
      c = i.get(l);
    if (c == e.length) {
      a++;
      continue;
    }
    var h = e[c],
      d = En(l, h, n.getContext(l, h, !0)),
      p = En(h, l, n.getContext(h, l, !1));
    n.updateRelation(l, h), n.setOriginalOperations(d, l), n.setOriginalOperations(p, h);
    var _iterator244 = _createForOfIteratorHelper(d),
      _step244;
    try {
      for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
        var _ = _step244.value;
        i.set(_, c + p.length);
      }
    } catch (err) {
      _iterator244.e(err);
    } finally {
      _iterator244.f();
    }
    (_s3 = s).splice.apply(_s3, [a, 1].concat(_toConsumableArray(d))), (_e8 = e).splice.apply(_e8, [c, 1].concat(_toConsumableArray(p)));
  }
  return Tn(s), Tn(e), Rn(s, o.nextBaseVersionB), Rn(e, o.nextBaseVersionA), {
    operationsA: s,
    operationsB: e,
    originalOperations: r
  };
}
var xo = /*#__PURE__*/function () {
  function xo(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    _classCallCheck(this, xo);
    _defineProperty(this, "originalOperations", void 0);
    _defineProperty(this, "_history", void 0);
    _defineProperty(this, "_useRelations", void 0);
    _defineProperty(this, "_forceWeakRemove", void 0);
    _defineProperty(this, "_relations", void 0);
    this.originalOperations = new Map(), this._history = e.history, this._useRelations = t, this._forceWeakRemove = !!n, this._relations = new Map();
  }
  return _createClass(xo, [{
    key: "setOriginalOperations",
    value: function setOriginalOperations(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = t ? this.originalOperations.get(t) : null;
      var _iterator245 = _createForOfIteratorHelper(e),
        _step245;
      try {
        for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
          var r = _step245.value;
          this.originalOperations.set(r, n || r);
        }
      } catch (err) {
        _iterator245.e(err);
      } finally {
        _iterator245.f();
      }
    }
  }, {
    key: "updateRelation",
    value: function updateRelation(e, t) {
      if (e instanceof v) t instanceof A ? e.targetPosition.isEqual(t.sourcePosition) || t.movedRange.containsPosition(e.targetPosition) ? this._setRelation(e, t, "insertAtSource") : e.targetPosition.isEqual(t.deletionPosition) ? this._setRelation(e, t, "insertBetween") : e.targetPosition.isAfter(t.sourcePosition) && this._setRelation(e, t, "moveTargetAfter") : t instanceof v && (e.targetPosition.isEqual(t.sourcePosition) || e.targetPosition.isBefore(t.sourcePosition) ? this._setRelation(e, t, "insertBefore") : this._setRelation(e, t, "insertAfter"));else if (e instanceof P) {
        if (t instanceof A) e.splitPosition.isBefore(t.sourcePosition) && this._setRelation(e, t, "splitBefore");else if (t instanceof v) if (e.splitPosition.isEqual(t.sourcePosition) || e.splitPosition.isBefore(t.sourcePosition)) this._setRelation(e, t, "splitBefore");else {
          var n = u._createFromPositionAndShift(t.sourcePosition, t.howMany);
          if (e.splitPosition.hasSameParentAs(t.sourcePosition) && n.containsPosition(e.splitPosition)) {
            var r = n.end.offset - e.splitPosition.offset,
              i = e.splitPosition.offset - n.start.offset;
            this._setRelation(e, t, {
              howMany: r,
              offset: i
            });
          }
        }
      } else if (e instanceof A) t instanceof A ? (e.targetPosition.isEqual(t.sourcePosition) || this._setRelation(e, t, "mergeTargetNotMoved"), e.sourcePosition.isEqual(t.targetPosition) && this._setRelation(e, t, "mergeSourceNotMoved"), e.sourcePosition.isEqual(t.sourcePosition) && this._setRelation(e, t, "mergeSameElement")) : t instanceof P ? e.sourcePosition.isEqual(t.splitPosition) && this._setRelation(e, t, "splitAtSource") : t instanceof v && t.howMany > 0 && (e.sourcePosition.isEqual(t.sourcePosition.getShiftedBy(t.howMany)) && this._setRelation(e, t, "mergeSourceAffected"), e.targetPosition.isEqual(t.sourcePosition) && this._setRelation(e, t, "mergeTargetWasBefore"));else if (e instanceof B) {
        var _n20 = e.newRange;
        if (!_n20) return;
        if (t instanceof A) {
          var _r22 = _n20.start.isEqual(t.targetPosition),
            _i61 = _n20.start.isEqual(t.deletionPosition),
            o = _n20.end.isEqual(t.deletionPosition),
            a = _n20.end.isEqual(t.sourcePosition);
          (_r22 || _i61 || o || a) && this._setRelation(e, t, {
            wasInLeftElement: _r22,
            wasStartBeforeMergedElement: _i61,
            wasEndBeforeMergedElement: o,
            wasInRightElement: a
          });
        }
      }
    }
  }, {
    key: "getContext",
    value: function getContext(e, t, n) {
      return {
        aIsStrong: n,
        aWasUndone: this._wasUndone(e),
        bWasUndone: this._wasUndone(t),
        abRelation: this._useRelations ? this._getRelation(e, t) : null,
        baRelation: this._useRelations ? this._getRelation(t, e) : null,
        forceWeakRemove: this._forceWeakRemove
      };
    }
  }, {
    key: "_wasUndone",
    value: function _wasUndone(e) {
      var t = this.originalOperations.get(e);
      return t.wasUndone || this._history.isUndoneOperation(t);
    }
  }, {
    key: "_getRelation",
    value: function _getRelation(e, t) {
      var n = this.originalOperations.get(t),
        r = this._history.getUndoneOperation(n);
      if (!r) return null;
      var i = this.originalOperations.get(e),
        o = this._relations.get(i);
      return o && o.get(r) || null;
    }
  }, {
    key: "_setRelation",
    value: function _setRelation(e, t, n) {
      var r = this.originalOperations.get(e),
        i = this.originalOperations.get(t);
      var o = this._relations.get(r);
      o || (o = new Map(), this._relations.set(r, o)), o.set(i, n);
    }
  }]);
}();
function Rn(s, e) {
  var _iterator246 = _createForOfIteratorHelper(s),
    _step246;
  try {
    for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
      var t = _step246.value;
      t.baseVersion = e++;
    }
  } catch (err) {
    _iterator246.e(err);
  } finally {
    _iterator246.f();
  }
}
function Tn(s) {
  var e = new Map();
  for (var t = 0; t < s.length; t++) {
    var n = s[t];
    n instanceof B && (n.baseVersion !== -1 ? e.set(n.name, {
      op: n,
      ranges: n.newRange ? [n.newRange] : []
    }) : (n.newRange && e.get(n.name).ranges.push(n.newRange), s.splice(t, 1), t--));
  }
  var _iterator247 = _createForOfIteratorHelper(e.values()),
    _step247;
  try {
    for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
      var _ref100 = _step247.value;
      var _t6 = _ref100.op;
      var _n21 = _ref100.ranges;
      _n21.length ? _t6.newRange = u._createFromRanges(_n21) : _t6.newRange = null;
    }
  } catch (err) {
    _iterator247.e(err);
  } finally {
    _iterator247.f();
  }
}
b(S, S, function (s, e, t) {
  if (s.key === e.key && s.range.start.hasSameParentAs(e.range.start)) {
    var n = s.range.getDifference(e.range).map(function (i) {
        return new S(i, s.key, s.oldValue, s.newValue, 0);
      }),
      r = s.range.getIntersection(e.range);
    return r && t.aIsStrong && n.push(new S(r, e.key, e.newValue, s.newValue, 0)), n.length == 0 ? [new R(0)] : n;
  } else return [s];
});
b(S, T, function (s, e) {
  if (s.range.start.hasSameParentAs(e.position) && s.range.containsPosition(e.position)) {
    var n = s.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(function (r) {
      return new S(r, s.key, s.oldValue, s.newValue, s.baseVersion);
    });
    if (e.shouldReceiveAttributes) {
      var r = Rs(e, s.key, s.oldValue);
      r && n.unshift(r);
    }
    return n;
  }
  return s.range = s.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [s];
});
function Rs(s, e, t) {
  var r = s.nodes.getNode(0).getAttribute(e);
  if (r == t) return null;
  var i = new u(s.position, s.position.getShiftedBy(s.howMany));
  return new S(i, e, r, t, 0);
}
b(S, A, function (s, e) {
  var t = [];
  s.range.start.hasSameParentAs(e.deletionPosition) && (s.range.containsPosition(e.deletionPosition) || s.range.start.isEqual(e.deletionPosition)) && t.push(u._createFromPositionAndShift(e.graveyardPosition, 1));
  var n = s.range._getTransformedByMergeOperation(e);
  return n.isCollapsed || t.push(n), t.map(function (r) {
    return new S(r, s.key, s.oldValue, s.newValue, s.baseVersion);
  });
});
b(S, v, function (s, e) {
  return No(s.range, e).map(function (n) {
    return new S(n, s.key, s.oldValue, s.newValue, s.baseVersion);
  });
});
function No(s, e) {
  var t = u._createFromPositionAndShift(e.sourcePosition, e.howMany);
  var n = null,
    r = [];
  t.containsRange(s, !0) ? n = s : s.start.hasSameParentAs(t.start) ? (r = s.getDifference(t), n = s.getIntersection(t)) : r = [s];
  var i = [];
  var _iterator248 = _createForOfIteratorHelper(r),
    _step248;
  try {
    for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
      var o = _step248.value;
      o = o._getTransformedByDeletion(e.sourcePosition, e.howMany);
      var a = e.getMovedRangeStart(),
        l = o.start.hasSameParentAs(a),
        c = o._getTransformedByInsertion(a, e.howMany, l);
      i.push.apply(i, _toConsumableArray(c));
    }
  } catch (err) {
    _iterator248.e(err);
  } finally {
    _iterator248.f();
  }
  return n && i.push(n._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]), i;
}
b(S, P, function (s, e) {
  if (s.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || s.range.end.offset++, [s];
  if (s.range.start.hasSameParentAs(e.splitPosition) && s.range.containsPosition(e.splitPosition)) {
    var t = s.clone();
    return t.range = new u(e.moveTargetPosition.clone(), s.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), s.range.end = e.splitPosition.clone(), s.range.end.stickiness = "toPrevious", [s, t];
  }
  return s.range = s.range._getTransformedBySplitOperation(e), [s];
});
b(T, S, function (s, e) {
  var t = [s];
  if (s.shouldReceiveAttributes && s.position.hasSameParentAs(e.range.start) && e.range.containsPosition(s.position)) {
    var n = Rs(s, e.key, e.newValue);
    n && t.push(n);
  }
  return t;
});
b(T, T, function (s, e, t) {
  return s.position.isEqual(e.position) && t.aIsStrong ? [s] : (s.position = s.position._getTransformedByInsertOperation(e), [s]);
});
b(T, v, function (s, e) {
  return s.position = s.position._getTransformedByMoveOperation(e), [s];
});
b(T, P, function (s, e) {
  return s.position = s.position._getTransformedBySplitOperation(e), [s];
});
b(T, A, function (s, e) {
  return s.position = s.position._getTransformedByMergeOperation(e), [s];
});
b(B, T, function (s, e) {
  return s.oldRange && (s.oldRange = s.oldRange._getTransformedByInsertOperation(e)[0]), s.newRange && (s.newRange = s.newRange._getTransformedByInsertOperation(e)[0]), [s];
});
b(B, B, function (s, e, t) {
  if (s.name == e.name) if (t.aIsStrong) s.oldRange = e.newRange ? e.newRange.clone() : null;else return [new R(0)];
  return [s];
});
b(B, A, function (s, e) {
  return s.oldRange && (s.oldRange = s.oldRange._getTransformedByMergeOperation(e)), s.newRange && (s.newRange = s.newRange._getTransformedByMergeOperation(e)), [s];
});
b(B, v, function (s, e) {
  var t = [s];
  if (s.oldRange && (s.oldRange = u._createFromRanges(s.oldRange._getTransformedByMoveOperation(e))), s.newRange) {
    var n = s.newRange._getTransformedByMoveOperation(e);
    s.newRange = n[0];
    for (var r = 1; r < n.length; r++) {
      var i = s.clone();
      i.oldRange = null, i.newRange = n[r], i.baseVersion = -1, t.push(i);
    }
  }
  return t;
});
b(B, P, function (s, e, t) {
  if (s.oldRange && (s.oldRange = s.oldRange._getTransformedBySplitOperation(e)), s.newRange) {
    if (t.abRelation) {
      var n = s.newRange._getTransformedBySplitOperation(e);
      return s.newRange.start.isEqual(e.splitPosition) ? t.abRelation.wasStartBeforeMergedElement ? s.newRange.start = m._createAt(e.insertionPosition) : t.abRelation.wasInLeftElement ? s.newRange.start = m._createAt(s.newRange.start) : s.newRange.start = m._createAt(e.moveTargetPosition) : s.newRange.start = n.start, s.newRange.end.isEqual(e.splitPosition) ? s.newRange.end.isEqual(e.splitPosition) && t.abRelation.wasEndBeforeMergedElement ? s.newRange.end = m._createAt(e.insertionPosition) : t.abRelation.wasInRightElement ? s.newRange.end = m._createAt(e.moveTargetPosition) : s.newRange.end = m._createAt(s.newRange.end) : s.newRange.end = n.end, [s];
    }
    s.newRange = s.newRange._getTransformedBySplitOperation(e);
  }
  return [s];
});
b(A, T, function (s, e) {
  return s.sourcePosition.hasSameParentAs(e.position) && (s.howMany += e.howMany), s.sourcePosition = s.sourcePosition._getTransformedByInsertOperation(e), s.targetPosition = s.targetPosition._getTransformedByInsertOperation(e), [s];
});
b(A, A, function (s, e, t) {
  if (s.sourcePosition.isEqual(e.sourcePosition) && s.targetPosition.isEqual(e.targetPosition)) if (t.bWasUndone) {
    var n = e.graveyardPosition.path.slice();
    return n.push(0), s.sourcePosition = new m(e.graveyardPosition.root, n), s.howMany = 0, [s];
  } else return [new R(0)];
  if (s.sourcePosition.isEqual(e.sourcePosition) && !s.targetPosition.isEqual(e.targetPosition) && !t.bWasUndone && t.abRelation != "splitAtSource") {
    var _n22 = s.targetPosition.root.rootName == "$graveyard",
      r = e.targetPosition.root.rootName == "$graveyard";
    if (r && !_n22 || !(_n22 && !r) && t.aIsStrong) {
      var l = e.targetPosition._getTransformedByMergeOperation(e),
        c = s.targetPosition._getTransformedByMergeOperation(e);
      return [new v(l, s.howMany, c, 0)];
    } else return [new R(0)];
  }
  return s.sourcePosition.hasSameParentAs(e.targetPosition) && (s.howMany += e.howMany), s.sourcePosition = s.sourcePosition._getTransformedByMergeOperation(e), s.targetPosition = s.targetPosition._getTransformedByMergeOperation(e), (!s.graveyardPosition.isEqual(e.graveyardPosition) || !t.aIsStrong) && (s.graveyardPosition = s.graveyardPosition._getTransformedByMergeOperation(e)), [s];
});
b(A, v, function (s, e, t) {
  var n = u._createFromPositionAndShift(e.sourcePosition, e.howMany);
  return e.type == "remove" && !t.bWasUndone && s.deletionPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(s.sourcePosition) ? [new R(0)] : (e.sourcePosition.getShiftedBy(e.howMany).isEqual(s.sourcePosition) ? s.sourcePosition.stickiness = "toNone" : e.targetPosition.isEqual(s.sourcePosition) && t.abRelation == "mergeSourceAffected" ? s.sourcePosition.stickiness = "toNext" : e.sourcePosition.isEqual(s.targetPosition) ? (s.targetPosition.stickiness = "toNone", s.howMany -= e.howMany) : e.targetPosition.isEqual(s.targetPosition) && t.abRelation == "mergeTargetWasBefore" ? (s.targetPosition.stickiness = "toPrevious", s.howMany += e.howMany) : (s.sourcePosition.hasSameParentAs(e.targetPosition) && (s.howMany += e.howMany), s.sourcePosition.hasSameParentAs(e.sourcePosition) && (s.howMany -= e.howMany)), s.sourcePosition = s.sourcePosition._getTransformedByMoveOperation(e), s.targetPosition = s.targetPosition._getTransformedByMoveOperation(e), s.sourcePosition.stickiness = "toPrevious", s.targetPosition.stickiness = "toNext", s.graveyardPosition.isEqual(e.targetPosition) || (s.graveyardPosition = s.graveyardPosition._getTransformedByMoveOperation(e)), [s]);
});
b(A, P, function (s, e, t) {
  if (e.graveyardPosition && (s.graveyardPosition = s.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), s.deletionPosition.isEqual(e.graveyardPosition) && (s.howMany = e.howMany)), s.targetPosition.isEqual(e.splitPosition) && (e.graveyardPosition && s.deletionPosition.isEqual(e.graveyardPosition) || t.abRelation == "mergeTargetNotMoved")) return s.sourcePosition = s.sourcePosition._getTransformedBySplitOperation(e), [s];
  if (s.sourcePosition.isEqual(e.splitPosition)) {
    if (t.abRelation == "mergeSourceNotMoved") return s.howMany = 0, s.targetPosition = s.targetPosition._getTransformedBySplitOperation(e), [s];
    if (t.abRelation == "mergeSameElement" || s.sourcePosition.offset > 0) return s.sourcePosition = e.moveTargetPosition.clone(), s.targetPosition = s.targetPosition._getTransformedBySplitOperation(e), [s];
  }
  return s.sourcePosition.hasSameParentAs(e.splitPosition) && (s.howMany = e.splitPosition.offset), s.sourcePosition = s.sourcePosition._getTransformedBySplitOperation(e), s.targetPosition = s.targetPosition._getTransformedBySplitOperation(e), [s];
});
b(v, T, function (s, e) {
  var n = u._createFromPositionAndShift(s.sourcePosition, s.howMany)._getTransformedByInsertOperation(e, !1)[0];
  return s.sourcePosition = n.start, s.howMany = n.end.offset - n.start.offset, s.targetPosition.isEqual(e.position) || (s.targetPosition = s.targetPosition._getTransformedByInsertOperation(e)), [s];
});
b(v, v, function (s, e, t) {
  var n = u._createFromPositionAndShift(s.sourcePosition, s.howMany),
    r = u._createFromPositionAndShift(e.sourcePosition, e.howMany);
  var i = t.aIsStrong,
    o = !t.aIsStrong;
  t.abRelation == "insertBefore" || t.baRelation == "insertAfter" ? o = !0 : (t.abRelation == "insertAfter" || t.baRelation == "insertBefore") && (o = !1);
  var a;
  if (s.targetPosition.isEqual(e.targetPosition) && o ? a = s.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : a = s.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Mn(s, e) && Mn(e, s)) return [e.getReversed()];
  if (n.containsPosition(e.targetPosition) && n.containsRange(r, !0)) return n.start = n.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), n.end = n.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Te([n], a);
  if (r.containsPosition(s.targetPosition) && r.containsRange(n, !0)) return n.start = n.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), n.end = n.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), Te([n], a);
  var h = F(s.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
  if (h == "prefix" || h == "extension") return n.start = n.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), n.end = n.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Te([n], a);
  s.type == "remove" && e.type != "remove" && !t.aWasUndone && !t.forceWeakRemove ? i = !0 : s.type != "remove" && e.type == "remove" && !t.bWasUndone && !t.forceWeakRemove && (i = !1);
  var d = [],
    p = n.getDifference(r);
  var _iterator249 = _createForOfIteratorHelper(p),
    _step249;
  try {
    for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
      var y = _step249.value;
      y.start = y.start._getTransformedByDeletion(e.sourcePosition, e.howMany), y.end = y.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
      var I = F(y.start.getParentPath(), e.getMovedRangeStart().getParentPath()) == "same",
        ue = y._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, I);
      d.push.apply(d, _toConsumableArray(ue));
    }
  } catch (err) {
    _iterator249.e(err);
  } finally {
    _iterator249.f();
  }
  var _ = n.getIntersection(r);
  return _ !== null && i && (_.start = _.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), _.end = _.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), d.length === 0 ? d.push(_) : d.length == 1 ? r.start.isBefore(n.start) || r.start.isEqual(n.start) ? d.unshift(_) : d.push(_) : d.splice(1, 0, _)), d.length === 0 ? [new R(s.baseVersion)] : Te(d, a);
});
b(v, P, function (s, e, t) {
  var n = s.targetPosition.clone();
  (!s.targetPosition.isEqual(e.insertionPosition) || !e.graveyardPosition || t.abRelation == "moveTargetAfter") && (n = s.targetPosition._getTransformedBySplitOperation(e));
  var r = u._createFromPositionAndShift(s.sourcePosition, s.howMany);
  if (r.end.isEqual(e.insertionPosition)) return e.graveyardPosition || s.howMany++, s.targetPosition = n, [s];
  if (r.start.hasSameParentAs(e.splitPosition) && r.containsPosition(e.splitPosition)) {
    var a = new u(e.splitPosition, r.end);
    a = a._getTransformedBySplitOperation(e);
    var l = [new u(r.start, e.splitPosition), a];
    return Te(l, n);
  }
  s.targetPosition.isEqual(e.splitPosition) && t.abRelation == "insertAtSource" && (n = e.moveTargetPosition), s.targetPosition.isEqual(e.insertionPosition) && t.abRelation == "insertBetween" && (n = s.targetPosition);
  var o = [r._getTransformedBySplitOperation(e)];
  if (e.graveyardPosition) {
    var _a1 = r.start.isEqual(e.graveyardPosition) || r.containsPosition(e.graveyardPosition);
    s.howMany > 1 && _a1 && !t.aWasUndone && o.push(u._createFromPositionAndShift(e.insertionPosition, 1));
  }
  return Te(o, n);
});
b(v, A, function (s, e, t) {
  var n = u._createFromPositionAndShift(s.sourcePosition, s.howMany);
  if (e.deletionPosition.hasSameParentAs(s.sourcePosition) && n.containsPosition(e.sourcePosition)) {
    if (s.type == "remove" && !t.forceWeakRemove) {
      if (!t.aWasUndone) {
        var o = [];
        var a = e.graveyardPosition.clone(),
          l = e.targetPosition._getTransformedByMergeOperation(e);
        var c = s.targetPosition.getTransformedByOperation(e);
        s.howMany > 1 && (o.push(new v(s.sourcePosition, s.howMany - 1, c, 0)), a = a._getTransformedByMove(s.sourcePosition, c, s.howMany - 1), l = l._getTransformedByMove(s.sourcePosition, c, s.howMany - 1));
        var h = e.deletionPosition._getCombined(s.sourcePosition, c),
          d = new v(a, 1, h, 0),
          p = d.getMovedRangeStart().path.slice();
        p.push(0);
        var _ = new m(d.targetPosition.root, p);
        l = l._getTransformedByMove(a, h, 1);
        var y = new v(l, e.howMany, _, 0);
        return o.push(d), o.push(y), o;
      }
    } else if (s.howMany == 1) return t.bWasUndone ? (s.sourcePosition = e.graveyardPosition.clone(), s.targetPosition = s.targetPosition._getTransformedByMergeOperation(e), [s]) : [new R(0)];
  }
  var i = u._createFromPositionAndShift(s.sourcePosition, s.howMany)._getTransformedByMergeOperation(e);
  return s.sourcePosition = i.start, s.howMany = i.end.offset - i.start.offset, s.targetPosition = s.targetPosition._getTransformedByMergeOperation(e), [s];
});
b(V, T, function (s, e) {
  return s.position = s.position._getTransformedByInsertOperation(e), [s];
});
b(V, A, function (s, e) {
  return s.position.isEqual(e.deletionPosition) ? (s.position = e.graveyardPosition.clone(), s.position.stickiness = "toNext", [s]) : (s.position = s.position._getTransformedByMergeOperation(e), [s]);
});
b(V, v, function (s, e) {
  return s.position = s.position._getTransformedByMoveOperation(e), [s];
});
b(V, V, function (s, e, t) {
  if (s.position.isEqual(e.position)) if (t.aIsStrong) s.oldName = e.newName;else return [new R(0)];
  return [s];
});
b(V, P, function (s, e) {
  var t = s.position.path,
    n = e.splitPosition.getParentPath();
  if (F(t, n) == "same" && !e.graveyardPosition) {
    var r = new V(s.position.getShiftedBy(1), s.oldName, s.newName, 0);
    return [s, r];
  }
  return s.position = s.position._getTransformedBySplitOperation(e), [s];
});
b(ee, ee, function (s, e, t) {
  if (s.root === e.root && s.key === e.key) {
    if (!t.aIsStrong || s.newValue === e.newValue) return [new R(0)];
    s.oldValue = e.newValue;
  }
  return [s];
});
b(X, X, function (s, e) {
  return s.rootName === e.rootName && s.isAdd === e.isAdd ? [new R(0)] : [s];
});
b(P, T, function (s, e) {
  return s.splitPosition.hasSameParentAs(e.position) && s.splitPosition.offset < e.position.offset && (s.howMany += e.howMany), s.splitPosition = s.splitPosition._getTransformedByInsertOperation(e), s.insertionPosition = s.insertionPosition._getTransformedByInsertOperation(e), [s];
});
b(P, A, function (s, e, t) {
  if (!s.graveyardPosition && !t.bWasUndone && s.splitPosition.hasSameParentAs(e.sourcePosition)) {
    var n = e.graveyardPosition.path.slice();
    n.push(0);
    var r = new m(e.graveyardPosition.root, n),
      i = P.getInsertionPosition(new m(e.graveyardPosition.root, n)),
      o = new P(r, 0, i, null, 0);
    return s.splitPosition = s.splitPosition._getTransformedByMergeOperation(e), s.insertionPosition = P.getInsertionPosition(s.splitPosition), s.graveyardPosition = o.insertionPosition.clone(), s.graveyardPosition.stickiness = "toNext", [o, s];
  }
  return s.splitPosition.hasSameParentAs(e.deletionPosition) && !s.splitPosition.isAfter(e.deletionPosition) && s.howMany--, s.splitPosition.hasSameParentAs(e.targetPosition) && (s.howMany += e.howMany), s.splitPosition = s.splitPosition._getTransformedByMergeOperation(e), s.insertionPosition = P.getInsertionPosition(s.splitPosition), s.graveyardPosition && (s.graveyardPosition = s.graveyardPosition._getTransformedByMergeOperation(e)), [s];
});
b(P, v, function (s, e, t) {
  var n = u._createFromPositionAndShift(e.sourcePosition, e.howMany);
  if (s.graveyardPosition) {
    var i = n.start.isEqual(s.graveyardPosition) || n.containsPosition(s.graveyardPosition);
    if (!t.bWasUndone && i) {
      var o = s.splitPosition._getTransformedByMoveOperation(e),
        a = s.graveyardPosition._getTransformedByMoveOperation(e),
        l = a.path.slice();
      l.push(0);
      var c = new m(a.root, l);
      return [new v(o, s.howMany, c, 0)];
    }
    s.graveyardPosition = s.graveyardPosition._getTransformedByMoveOperation(e);
  }
  var r = s.splitPosition.isEqual(e.targetPosition);
  if (r && (t.baRelation == "insertAtSource" || t.abRelation == "splitBefore")) return s.howMany += e.howMany, s.splitPosition = s.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), s.insertionPosition = P.getInsertionPosition(s.splitPosition), [s];
  if (r && t.abRelation && t.abRelation.howMany) {
    var _t$abRelation = t.abRelation,
      _i62 = _t$abRelation.howMany,
      _o20 = _t$abRelation.offset;
    return s.howMany += _i62, s.splitPosition = s.splitPosition.getShiftedBy(_o20), [s];
  }
  if (s.splitPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(s.splitPosition)) {
    var _i63 = e.howMany - (s.splitPosition.offset - e.sourcePosition.offset);
    return s.howMany -= _i63, s.splitPosition.hasSameParentAs(e.targetPosition) && s.splitPosition.offset < e.targetPosition.offset && (s.howMany += e.howMany), s.splitPosition = e.sourcePosition.clone(), s.insertionPosition = P.getInsertionPosition(s.splitPosition), [s];
  }
  return e.sourcePosition.isEqual(e.targetPosition) || (s.splitPosition.hasSameParentAs(e.sourcePosition) && s.splitPosition.offset <= e.sourcePosition.offset && (s.howMany -= e.howMany), s.splitPosition.hasSameParentAs(e.targetPosition) && s.splitPosition.offset < e.targetPosition.offset && (s.howMany += e.howMany)), s.splitPosition.stickiness = "toNone", s.splitPosition = s.splitPosition._getTransformedByMoveOperation(e), s.splitPosition.stickiness = "toNext", s.graveyardPosition ? s.insertionPosition = s.insertionPosition._getTransformedByMoveOperation(e) : s.insertionPosition = P.getInsertionPosition(s.splitPosition), [s];
});
b(P, P, function (s, e, t) {
  if (s.splitPosition.isEqual(e.splitPosition)) {
    if (!s.graveyardPosition && !e.graveyardPosition) return [new R(0)];
    if (s.graveyardPosition && e.graveyardPosition && s.graveyardPosition.isEqual(e.graveyardPosition)) return [new R(0)];
    if (t.abRelation == "splitBefore") return s.howMany = 0, s.graveyardPosition = s.graveyardPosition._getTransformedBySplitOperation(e), [s];
  }
  if (s.graveyardPosition && e.graveyardPosition && s.graveyardPosition.isEqual(e.graveyardPosition)) {
    var n = s.splitPosition.root.rootName == "$graveyard",
      r = e.splitPosition.root.rootName == "$graveyard";
    if (r && !n || !(n && !r) && t.aIsStrong) {
      var l = [];
      return e.howMany && l.push(new v(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), s.howMany && l.push(new v(s.splitPosition, s.howMany, s.moveTargetPosition, 0)), l;
    } else return [new R(0)];
  }
  if (s.graveyardPosition && (s.graveyardPosition = s.graveyardPosition._getTransformedBySplitOperation(e)), s.splitPosition.isEqual(e.insertionPosition) && t.abRelation == "splitBefore") return s.howMany++, [s];
  if (e.splitPosition.isEqual(s.insertionPosition) && t.baRelation == "splitBefore") {
    var _n23 = e.insertionPosition.path.slice();
    _n23.push(0);
    var _r23 = new m(e.insertionPosition.root, _n23),
      i = new v(s.insertionPosition, 1, _r23, 0);
    return [s, i];
  }
  return s.splitPosition.hasSameParentAs(e.splitPosition) && s.splitPosition.offset < e.splitPosition.offset && (s.howMany -= e.howMany), s.splitPosition = s.splitPosition._getTransformedBySplitOperation(e), s.insertionPosition = P.getInsertionPosition(s.splitPosition), [s];
});
function Mn(s, e) {
  return s.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) === null;
}
function Te(s, e) {
  var t = [];
  for (var n = 0; n < s.length; n++) {
    var r = s[n],
      i = new v(r.start, r.end.offset - r.start.offset, e, 0);
    t.push(i);
    for (var o = n + 1; o < s.length; o++) s[o] = s[o]._getTransformedByMove(i.sourcePosition, i.targetPosition, i.howMany)[0];
    e = e._getTransformedByMove(i.sourcePosition, i.targetPosition, i.howMany);
  }
  return t;
}
var O = /*#__PURE__*/function (_N11) {
  function O(e, t) {
    var _this79;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
    _classCallCheck(this, O);
    if (_this79 = _callSuper(this, O, [e, t, n]), !_this79.root.is("rootElement")) throw new f("model-liveposition-root-not-rootelement", e);
    Oo.call(_assertThisInitialized(_this79));
    return _assertThisInitialized(_this79);
  }
  _inherits(O, _N11);
  return _createClass(O, [{
    key: "detach",
    value: function detach() {
      this.stopListening();
    }
  }, {
    key: "toPosition",
    value: function toPosition() {
      return new m(this.root, this.path.slice(), this.stickiness);
    }
  }], [{
    key: "fromPosition",
    value: function fromPosition(e, t) {
      return new this(e.root, e.path.slice(), t || e.stickiness);
    }
  }]);
}(N(m));
O.prototype.is = function (s) {
  return s === "livePosition" || s === "model:livePosition" || s == "position" || s === "model:position";
};
function Oo() {
  var _this80 = this;
  this.listenTo(this.root.document.model, "applyOperation", function (s, e) {
    var t = e[0];
    t.isDocumentOperation && Io.call(_this80, t);
  }, {
    priority: "low"
  });
}
function Io(s) {
  var e = this.getTransformedByOperation(s);
  if (!this.isEqual(e)) {
    var t = this.toPosition();
    this.path = e.path, this.root = e.root, this.fire("change", t);
  }
}
var ke = /*#__PURE__*/function () {
  function ke() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ke);
    _defineProperty(this, "operations", void 0);
    _defineProperty(this, "isUndoable", void 0);
    _defineProperty(this, "isLocal", void 0);
    _defineProperty(this, "isUndo", void 0);
    _defineProperty(this, "isTyping", void 0);
    typeof e == "string" && (e = e === "transparent" ? {
      isUndoable: !1
    } : {}, W("batch-constructor-deprecated-string-type"));
    var _e9 = e,
      _e9$isUndoable = _e9.isUndoable,
      t = _e9$isUndoable === void 0 ? !0 : _e9$isUndoable,
      _e9$isLocal = _e9.isLocal,
      n = _e9$isLocal === void 0 ? !0 : _e9$isLocal,
      _e9$isUndo = _e9.isUndo,
      r = _e9$isUndo === void 0 ? !1 : _e9$isUndo,
      _e9$isTyping = _e9.isTyping,
      i = _e9$isTyping === void 0 ? !1 : _e9$isTyping;
    this.operations = [], this.isUndoable = t, this.isLocal = n, this.isUndo = r, this.isTyping = i;
  }
  return _createClass(ke, [{
    key: "type",
    get: function get() {
      return W("batch-type-deprecated"), "default";
    }
  }, {
    key: "baseVersion",
    get: function get() {
      var _iterator250 = _createForOfIteratorHelper(this.operations),
        _step250;
      try {
        for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
          var e = _step250.value;
          if (e.baseVersion !== null) return e.baseVersion;
        }
      } catch (err) {
        _iterator250.e(err);
      } finally {
        _iterator250.f();
      }
      return null;
    }
  }, {
    key: "addOperation",
    value: function addOperation(e) {
      return e.isDocumentOperation && (e.batch = this, this.operations.push(e)), e;
    }
  }]);
}();
var ut = /*#__PURE__*/function () {
  function ut(e) {
    _classCallCheck(this, ut);
    _defineProperty(this, "_markerCollection", void 0);
    _defineProperty(this, "_changesInElement", new Map());
    _defineProperty(this, "_elementsSnapshots", new Map());
    _defineProperty(this, "_elementChildrenSnapshots", new Map());
    _defineProperty(this, "_elementState", new Map());
    _defineProperty(this, "_changedMarkers", new Map());
    _defineProperty(this, "_changedRoots", new Map());
    _defineProperty(this, "_changeCount", 0);
    _defineProperty(this, "_cachedChanges", null);
    _defineProperty(this, "_cachedChangesWithGraveyard", null);
    _defineProperty(this, "_refreshedItems", new Set());
    this._markerCollection = e;
  }
  return _createClass(ut, [{
    key: "isEmpty",
    get: function get() {
      return this._changesInElement.size == 0 && this._changedMarkers.size == 0 && this._changedRoots.size == 0;
    }
  }, {
    key: "bufferOperation",
    value: function bufferOperation(e) {
      var t = e;
      switch (t.type) {
        case "insert":
          {
            if (this._isInInsertedElement(t.position.parent)) return;
            this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);
            break;
          }
        case "addAttribute":
        case "removeAttribute":
        case "changeAttribute":
          {
            var _iterator251 = _createForOfIteratorHelper(t.range.getItems({
                shallow: !0
              })),
              _step251;
            try {
              for (_iterator251.s(); !(_step251 = _iterator251.n()).done;) {
                var n = _step251.value;
                this._isInInsertedElement(n.parent) || this._markAttribute(n);
              }
            } catch (err) {
              _iterator251.e(err);
            } finally {
              _iterator251.f();
            }
            break;
          }
        case "remove":
        case "move":
        case "reinsert":
          {
            if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) return;
            var _n24 = this._isInInsertedElement(t.sourcePosition.parent),
              r = this._isInInsertedElement(t.targetPosition.parent);
            _n24 || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), r || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
            var i = u._createFromPositionAndShift(t.sourcePosition, t.howMany);
            var _iterator252 = _createForOfIteratorHelper(i.getItems({
                shallow: !0
              })),
              _step252;
            try {
              for (_iterator252.s(); !(_step252 = _iterator252.n()).done;) {
                var o = _step252.value;
                this._setElementState(o, "move");
              }
            } catch (err) {
              _iterator252.e(err);
            } finally {
              _iterator252.f();
            }
            break;
          }
        case "rename":
          {
            if (this._isInInsertedElement(t.position.parent)) return;
            this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);
            var _n25 = u._createFromPositionAndShift(t.position, 1);
            var _iterator253 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(_n25)),
              _step253;
            try {
              for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
                var _r24 = _step253.value;
                var _i64 = _r24.getData();
                this.bufferMarkerChange(_r24.name, _i64, _i64);
              }
            } catch (err) {
              _iterator253.e(err);
            } finally {
              _iterator253.f();
            }
            this._setElementState(t.position.nodeAfter, "rename");
            break;
          }
        case "split":
          {
            var _n26 = t.splitPosition.parent;
            if (!this._isInInsertedElement(_n26)) {
              this._markRemove(_n26, t.splitPosition.offset, t.howMany);
              var _r25 = u._createFromPositionAndShift(t.splitPosition, t.howMany);
              var _iterator254 = _createForOfIteratorHelper(_r25.getItems({
                  shallow: !0
                })),
                _step254;
              try {
                for (_iterator254.s(); !(_step254 = _iterator254.n()).done;) {
                  var _i65 = _step254.value;
                  this._setElementState(_i65, "move");
                }
              } catch (err) {
                _iterator254.e(err);
              } finally {
                _iterator254.f();
              }
            }
            this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && (this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1), this._setElementState(t.graveyardPosition.nodeAfter, "move"));
            break;
          }
        case "merge":
          {
            var _n27 = t.sourcePosition.parent;
            this._isInInsertedElement(_n27.parent) || this._markRemove(_n27.parent, _n27.startOffset, 1);
            var _r26 = t.graveyardPosition.parent;
            this._markInsert(_r26, t.graveyardPosition.offset, 1), this._setElementState(_n27, "move");
            var _i66 = t.targetPosition.parent;
            if (!this._isInInsertedElement(_i66)) {
              this._markInsert(_i66, t.targetPosition.offset, _n27.maxOffset);
              var _o21 = u._createFromPositionAndShift(t.sourcePosition, t.howMany);
              var _iterator255 = _createForOfIteratorHelper(_o21.getItems({
                  shallow: !0
                })),
                _step255;
              try {
                for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
                  var a = _step255.value;
                  this._setElementState(a, "move");
                }
              } catch (err) {
                _iterator255.e(err);
              } finally {
                _iterator255.f();
              }
            }
            break;
          }
        case "detachRoot":
        case "addRoot":
          {
            var _n28 = t.affectedSelectable;
            if (!_n28._isLoaded || _n28.isAttached() == t.isAdd) return;
            this._bufferRootStateChange(t.rootName, t.isAdd);
            break;
          }
        case "addRootAttribute":
        case "removeRootAttribute":
        case "changeRootAttribute":
          {
            if (!t.root._isLoaded) return;
            var _n29 = t.root.rootName;
            this._bufferRootAttributeChange(_n29, t.key, t.oldValue, t.newValue);
            break;
          }
      }
      this._cachedChanges = null;
    }
  }, {
    key: "bufferMarkerChange",
    value: function bufferMarkerChange(e, t, n) {
      t.range && t.range.root.is("rootElement") && !t.range.root._isLoaded && (t.range = null), n.range && n.range.root.is("rootElement") && !n.range.root._isLoaded && (n.range = null);
      var r = this._changedMarkers.get(e);
      r ? r.newMarkerData = n : (r = {
        newMarkerData: n,
        oldMarkerData: t
      }, this._changedMarkers.set(e, r)), r.oldMarkerData.range == null && n.range == null && this._changedMarkers.delete(e);
    }
  }, {
    key: "getMarkersToRemove",
    value: function getMarkersToRemove() {
      var e = [];
      var _iterator256 = _createForOfIteratorHelper(this._changedMarkers),
        _step256;
      try {
        for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
          var _ref101 = _step256.value;
          var _ref102 = _slicedToArray(_ref101, 2);
          var t = _ref102[0];
          var n = _ref102[1];
          n.oldMarkerData.range != null && e.push({
            name: t,
            range: n.oldMarkerData.range
          });
        }
      } catch (err) {
        _iterator256.e(err);
      } finally {
        _iterator256.f();
      }
      return e;
    }
  }, {
    key: "getMarkersToAdd",
    value: function getMarkersToAdd() {
      var e = [];
      var _iterator257 = _createForOfIteratorHelper(this._changedMarkers),
        _step257;
      try {
        for (_iterator257.s(); !(_step257 = _iterator257.n()).done;) {
          var _ref103 = _step257.value;
          var _ref104 = _slicedToArray(_ref103, 2);
          var t = _ref104[0];
          var n = _ref104[1];
          n.newMarkerData.range != null && e.push({
            name: t,
            range: n.newMarkerData.range
          });
        }
      } catch (err) {
        _iterator257.e(err);
      } finally {
        _iterator257.f();
      }
      return e;
    }
  }, {
    key: "getChangedMarkers",
    value: function getChangedMarkers() {
      return Array.from(this._changedMarkers).map(function (_ref105) {
        var _ref106 = _slicedToArray(_ref105, 2),
          e = _ref106[0],
          t = _ref106[1];
        return {
          name: e,
          data: {
            oldRange: t.oldMarkerData.range,
            newRange: t.newMarkerData.range
          }
        };
      });
    }
  }, {
    key: "hasDataChanges",
    value: function hasDataChanges() {
      if (this.getChanges().length || this._changedRoots.size > 0) return !0;
      var _iterator258 = _createForOfIteratorHelper(this._changedMarkers.values()),
        _step258;
      try {
        for (_iterator258.s(); !(_step258 = _iterator258.n()).done;) {
          var _ref107 = _step258.value;
          var e = _ref107.newMarkerData;
          var t = _ref107.oldMarkerData;
          if (e.affectsData !== t.affectsData) return !0;
          if (e.affectsData) {
            var n = e.range && !t.range,
              r = !e.range && t.range,
              i = e.range && t.range && !e.range.isEqual(t.range);
            if (n || r || i) return !0;
          }
        }
      } catch (err) {
        _iterator258.e(err);
      } finally {
        _iterator258.f();
      }
      return !1;
    }
  }, {
    key: "getChanges",
    value: function getChanges() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this._cachedChanges) return e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
      var t = [];
      var _iterator259 = _createForOfIteratorHelper(this._changesInElement.keys()),
        _step259;
      try {
        for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
          var _n30 = _step259.value;
          var _r27 = this._changesInElement.get(_n30).sort(function (h, d) {
              return h.offset === d.offset ? h.type != d.type ? h.type == "remove" ? -1 : 1 : 0 : h.offset < d.offset ? -1 : 1;
            }),
            _i67 = this._elementChildrenSnapshots.get(_n30),
            _o22 = Nn(_n30.getChildren()),
            _a10 = Fo(_i67.length, _r27);
          var _l0 = 0,
            _c = 0;
          var _iterator261 = _createForOfIteratorHelper(_a10),
            _step261;
          try {
            for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
              var h = _step261.value;
              if (h === "i") {
                var d = this._getDiffActionForNode(_o22[_l0].node, "insert"),
                  p = this._elementsSnapshots.get(_o22[_l0].node),
                  _ = this._getInsertDiff(_n30, _l0, d, _o22[_l0], p);
                t.push(_), _l0++;
              } else if (h === "r") {
                var _d6 = this._getDiffActionForNode(_i67[_c].node, "remove"),
                  _p = this._getRemoveDiff(_n30, _l0, _d6, _i67[_c]);
                t.push(_p), _c++;
              } else if (h === "a") {
                var _t7;
                var _d7 = _i67[_c].attributes,
                  _p2 = _o22[_l0].attributes;
                var _2 = void 0;
                if (_o22[_l0].name == "$text") _2 = new u(m._createAt(_n30, _l0), m._createAt(_n30, _l0 + 1));else {
                  var I = _n30.offsetToIndex(_l0);
                  _2 = new u(m._createAt(_n30, _l0), m._createAt(_n30.getChild(I), 0));
                }
                var y = this._getAttributesDiff(_2, _d7, _p2);
                (_t7 = t).push.apply(_t7, _toConsumableArray(y)), _l0++, _c++;
              } else _l0++, _c++;
            }
          } catch (err) {
            _iterator261.e(err);
          } finally {
            _iterator261.f();
          }
        }
      } catch (err) {
        _iterator259.e(err);
      } finally {
        _iterator259.f();
      }
      t.sort(function (n, r) {
        return n.position.root != r.position.root ? n.position.root.rootName < r.position.root.rootName ? -1 : 1 : n.position.isEqual(r.position) ? n.changeCount - r.changeCount : n.position.isBefore(r.position) ? -1 : 1;
      });
      for (var n = 1, r = 0; n < t.length; n++) {
        var i = t[r],
          o = t[n],
          a = i.type == "remove" && o.type == "remove" && i.name == "$text" && o.name == "$text" && i.position.isEqual(o.position),
          l = i.type == "insert" && o.type == "insert" && i.name == "$text" && o.name == "$text" && i.position.parent == o.position.parent && i.position.offset + i.length == o.position.offset,
          c = i.type == "attribute" && o.type == "attribute" && i.position.parent == o.position.parent && i.range.isFlat && o.range.isFlat && i.position.offset + i.length == o.position.offset && i.attributeKey == o.attributeKey && i.attributeOldValue == o.attributeOldValue && i.attributeNewValue == o.attributeNewValue;
        a || l || c ? (i.length++, c && (i.range.end = i.range.end.getShiftedBy(1)), t[n] = null) : r = n;
      }
      t = t.filter(function (n) {
        return n;
      });
      var _iterator260 = _createForOfIteratorHelper(t),
        _step260;
      try {
        for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
          var _n31 = _step260.value;
          delete _n31.changeCount, _n31.type == "attribute" && (delete _n31.position, delete _n31.length);
        }
      } catch (err) {
        _iterator260.e(err);
      } finally {
        _iterator260.f();
      }
      return this._changeCount = 0, this._cachedChangesWithGraveyard = t, this._cachedChanges = t.filter(Do), e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
    }
  }, {
    key: "getChangedRoots",
    value: function getChangedRoots() {
      return Array.from(this._changedRoots.values()).map(function (e) {
        var t = _objectSpread({}, e);
        return t.state !== void 0 && delete t.attributes, t;
      });
    }
  }, {
    key: "getRefreshedItems",
    value: function getRefreshedItems() {
      return new Set(this._refreshedItems);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._changesInElement.clear(), this._elementChildrenSnapshots.clear(), this._elementsSnapshots.clear(), this._elementState.clear(), this._changedMarkers.clear(), this._changedRoots.clear(), this._refreshedItems.clear(), this._cachedChanges = null;
    }
  }, {
    key: "_refreshItem",
    value: function _refreshItem(e) {
      if (this._isInInsertedElement(e.parent)) return;
      this._markRemove(e.parent, e.startOffset, e.offsetSize), this._markInsert(e.parent, e.startOffset, e.offsetSize), this._refreshedItems.add(e), this._setElementState(e, "refresh");
      var t = u._createOn(e);
      var _iterator262 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(t)),
        _step262;
      try {
        for (_iterator262.s(); !(_step262 = _iterator262.n()).done;) {
          var n = _step262.value;
          var r = n.getData();
          this.bufferMarkerChange(n.name, r, r);
        }
      } catch (err) {
        _iterator262.e(err);
      } finally {
        _iterator262.f();
      }
      this._cachedChanges = null;
    }
  }, {
    key: "_bufferRootLoad",
    value: function _bufferRootLoad(e) {
      if (e.isAttached()) {
        this._bufferRootStateChange(e.rootName, !0), this._markInsert(e, 0, e.maxOffset);
        var _iterator263 = _createForOfIteratorHelper(e.getAttributeKeys()),
          _step263;
        try {
          for (_iterator263.s(); !(_step263 = _iterator263.n()).done;) {
            var t = _step263.value;
            this._bufferRootAttributeChange(e.rootName, t, null, e.getAttribute(t));
          }
        } catch (err) {
          _iterator263.e(err);
        } finally {
          _iterator263.f();
        }
        var _iterator264 = _createForOfIteratorHelper(this._markerCollection),
          _step264;
        try {
          for (_iterator264.s(); !(_step264 = _iterator264.n()).done;) {
            var _t8 = _step264.value;
            if (_t8.getRange().root == e) {
              var n = _t8.getData();
              this.bufferMarkerChange(_t8.name, _objectSpread(_objectSpread({}, n), {}, {
                range: null
              }), n);
            }
          }
        } catch (err) {
          _iterator264.e(err);
        } finally {
          _iterator264.f();
        }
      }
    }
  }, {
    key: "_bufferRootStateChange",
    value: function _bufferRootStateChange(e, t) {
      if (!this._changedRoots.has(e)) {
        this._changedRoots.set(e, {
          name: e,
          state: t ? "attached" : "detached"
        });
        return;
      }
      var n = this._changedRoots.get(e);
      n.state !== void 0 ? (delete n.state, n.attributes === void 0 && this._changedRoots.delete(e)) : n.state = t ? "attached" : "detached";
    }
  }, {
    key: "_bufferRootAttributeChange",
    value: function _bufferRootAttributeChange(e, t, n, r) {
      var i = this._changedRoots.get(e) || {
          name: e
        },
        o = i.attributes || {};
      if (o[t]) {
        var a = o[t];
        r === a.oldValue ? delete o[t] : a.newValue = r;
      } else o[t] = {
        oldValue: n,
        newValue: r
      };
      Object.entries(o).length === 0 ? (delete i.attributes, i.state === void 0 && this._changedRoots.delete(e)) : (i.attributes = o, this._changedRoots.set(e, i));
    }
  }, {
    key: "_markInsert",
    value: function _markInsert(e, t, n) {
      if (e.root.is("rootElement") && !e.root._isLoaded) return;
      var r = {
        type: "insert",
        offset: t,
        howMany: n,
        count: this._changeCount++
      };
      this._markChange(e, r);
    }
  }, {
    key: "_markRemove",
    value: function _markRemove(e, t, n) {
      if (e.root.is("rootElement") && !e.root._isLoaded) return;
      var r = {
        type: "remove",
        offset: t,
        howMany: n,
        count: this._changeCount++
      };
      this._markChange(e, r), this._removeAllNestedChanges(e, t, n);
    }
  }, {
    key: "_markAttribute",
    value: function _markAttribute(e) {
      if (e.root.is("rootElement") && !e.root._isLoaded) return;
      var t = {
        type: "attribute",
        offset: e.startOffset,
        howMany: e.offsetSize,
        count: this._changeCount++
      };
      this._markChange(e.parent, t);
    }
  }, {
    key: "_markChange",
    value: function _markChange(e, t) {
      this._makeSnapshots(e);
      var n = this._getChangesForElement(e);
      this._handleChange(t, n), n.push(t);
      for (var r = 0; r < n.length; r++) n[r].howMany < 1 && (n.splice(r, 1), r--);
    }
  }, {
    key: "_setElementState",
    value: function _setElementState(e, t) {
      if (!e.is("element")) return;
      var n = ut._statesPriority.indexOf(this._elementState.get(e));
      ut._statesPriority.indexOf(t) > n && this._elementState.set(e, t);
    }
  }, {
    key: "_getDiffActionForNode",
    value: function _getDiffActionForNode(e, t) {
      if (!e.is("element") || !this._elementsSnapshots.has(e)) return t;
      var n = this._elementState.get(e);
      return !n || n == "move" ? t : n;
    }
  }, {
    key: "_getChangesForElement",
    value: function _getChangesForElement(e) {
      var t;
      return this._changesInElement.has(e) ? t = this._changesInElement.get(e) : (t = [], this._changesInElement.set(e, t)), t;
    }
  }, {
    key: "_makeSnapshots",
    value: function _makeSnapshots(e) {
      if (this._elementChildrenSnapshots.has(e)) return;
      var t = Nn(e.getChildren());
      this._elementChildrenSnapshots.set(e, t);
      var _iterator265 = _createForOfIteratorHelper(t),
        _step265;
      try {
        for (_iterator265.s(); !(_step265 = _iterator265.n()).done;) {
          var n = _step265.value;
          this._elementsSnapshots.set(n.node, n);
        }
      } catch (err) {
        _iterator265.e(err);
      } finally {
        _iterator265.f();
      }
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e, t) {
      e.nodesToHandle = e.howMany;
      var _iterator266 = _createForOfIteratorHelper(t),
        _step266;
      try {
        for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
          var n = _step266.value;
          var r = e.offset + e.howMany,
            i = n.offset + n.howMany;
          if (e.type == "insert" && (n.type == "insert" && (e.offset <= n.offset ? n.offset += e.howMany : e.offset < i && (n.howMany += e.nodesToHandle, e.nodesToHandle = 0)), n.type == "remove" && e.offset < n.offset && (n.offset += e.howMany), n.type == "attribute")) {
            if (e.offset <= n.offset) n.offset += e.howMany;else if (e.offset < i) {
              var o = n.howMany;
              n.howMany = e.offset - n.offset, t.unshift({
                type: "attribute",
                offset: r,
                howMany: o - n.howMany,
                count: this._changeCount++
              });
            }
          }
          if (e.type == "remove") {
            if (n.type == "insert") {
              if (r <= n.offset) n.offset -= e.howMany;else if (r <= i) {
                if (e.offset < n.offset) {
                  var _o23 = r - n.offset;
                  n.offset = e.offset, n.howMany -= _o23, e.nodesToHandle -= _o23;
                } else n.howMany -= e.nodesToHandle, e.nodesToHandle = 0;
              } else if (e.offset <= n.offset) e.nodesToHandle -= n.howMany, n.howMany = 0;else if (e.offset < i) {
                var _o24 = i - e.offset;
                n.howMany -= _o24, e.nodesToHandle -= _o24;
              }
            }
            if (n.type == "remove" && (r <= n.offset ? n.offset -= e.howMany : e.offset < n.offset && (e.nodesToHandle += n.howMany, n.howMany = 0)), n.type == "attribute") {
              if (r <= n.offset) n.offset -= e.howMany;else if (e.offset < n.offset) {
                var _o25 = r - n.offset;
                n.offset = e.offset, n.howMany -= _o25;
              } else if (e.offset < i) if (r <= i) {
                var _o26 = n.howMany;
                n.howMany = e.offset - n.offset;
                var a = _o26 - n.howMany - e.nodesToHandle;
                t.unshift({
                  type: "attribute",
                  offset: e.offset,
                  howMany: a,
                  count: this._changeCount++
                });
              } else n.howMany -= i - e.offset;
            }
          }
          if (e.type == "attribute") {
            if (n.type == "insert") if (e.offset < n.offset && r > n.offset) {
              if (r > i) {
                var _o27 = {
                  type: "attribute",
                  offset: i,
                  howMany: r - i,
                  count: this._changeCount++
                };
                this._handleChange(_o27, t), t.push(_o27);
              }
              e.nodesToHandle = n.offset - e.offset, e.howMany = e.nodesToHandle;
            } else e.offset >= n.offset && e.offset < i && (r > i ? (e.nodesToHandle = r - i, e.offset = i) : e.nodesToHandle = 0);
            if (n.type == "remove" && e.offset < n.offset && r > n.offset) {
              var _o28 = {
                type: "attribute",
                offset: n.offset,
                howMany: r - n.offset,
                count: this._changeCount++
              };
              this._handleChange(_o28, t), t.push(_o28), e.nodesToHandle = n.offset - e.offset, e.howMany = e.nodesToHandle;
            }
            n.type == "attribute" && (e.offset >= n.offset && r <= i ? (e.nodesToHandle = 0, e.howMany = 0, e.offset = 0) : e.offset <= n.offset && r >= i && (n.howMany = 0));
          }
        }
      } catch (err) {
        _iterator266.e(err);
      } finally {
        _iterator266.f();
      }
      e.howMany = e.nodesToHandle, delete e.nodesToHandle;
    }
  }, {
    key: "_getInsertDiff",
    value: function _getInsertDiff(e, t, n, r, i) {
      var o = {
        type: "insert",
        position: m._createAt(e, t),
        name: r.name,
        attributes: new Map(r.attributes),
        length: 1,
        changeCount: this._changeCount++,
        action: n
      };
      return n != "insert" && i && (o.before = {
        name: i.name,
        attributes: new Map(i.attributes)
      }), o;
    }
  }, {
    key: "_getRemoveDiff",
    value: function _getRemoveDiff(e, t, n, r) {
      return {
        type: "remove",
        action: n,
        position: m._createAt(e, t),
        name: r.name,
        attributes: new Map(r.attributes),
        length: 1,
        changeCount: this._changeCount++
      };
    }
  }, {
    key: "_getAttributesDiff",
    value: function _getAttributesDiff(e, t, n) {
      var r = [];
      n = new Map(n);
      var _iterator267 = _createForOfIteratorHelper(t),
        _step267;
      try {
        for (_iterator267.s(); !(_step267 = _iterator267.n()).done;) {
          var _ref108 = _step267.value;
          var _ref109 = _slicedToArray(_ref108, 2);
          var i = _ref109[0];
          var o = _ref109[1];
          var a = n.has(i) ? n.get(i) : null;
          a !== o && r.push({
            type: "attribute",
            position: e.start,
            range: e.clone(),
            length: 1,
            attributeKey: i,
            attributeOldValue: o,
            attributeNewValue: a,
            changeCount: this._changeCount++
          }), n.delete(i);
        }
      } catch (err) {
        _iterator267.e(err);
      } finally {
        _iterator267.f();
      }
      var _iterator268 = _createForOfIteratorHelper(n),
        _step268;
      try {
        for (_iterator268.s(); !(_step268 = _iterator268.n()).done;) {
          var _ref110 = _step268.value;
          var _ref111 = _slicedToArray(_ref110, 2);
          var _i68 = _ref111[0];
          var _o29 = _ref111[1];
          r.push({
            type: "attribute",
            position: e.start,
            range: e.clone(),
            length: 1,
            attributeKey: _i68,
            attributeOldValue: null,
            attributeNewValue: _o29,
            changeCount: this._changeCount++
          });
        }
      } catch (err) {
        _iterator268.e(err);
      } finally {
        _iterator268.f();
      }
      return r;
    }
  }, {
    key: "_isInInsertedElement",
    value: function _isInInsertedElement(e) {
      var t = e.parent;
      if (!t) return !1;
      var n = this._changesInElement.get(t),
        r = e.startOffset;
      if (n) {
        var _iterator269 = _createForOfIteratorHelper(n),
          _step269;
        try {
          for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
            var i = _step269.value;
            if (i.type == "insert" && r >= i.offset && r < i.offset + i.howMany) return !0;
          }
        } catch (err) {
          _iterator269.e(err);
        } finally {
          _iterator269.f();
        }
      }
      return this._isInInsertedElement(t);
    }
  }, {
    key: "_removeAllNestedChanges",
    value: function _removeAllNestedChanges(e, t, n) {
      var r = new u(m._createAt(e, t), m._createAt(e, t + n));
      var _iterator270 = _createForOfIteratorHelper(r.getItems({
          shallow: !0
        })),
        _step270;
      try {
        for (_iterator270.s(); !(_step270 = _iterator270.n()).done;) {
          var i = _step270.value;
          i.is("element") && (this._changesInElement.delete(i), this._removeAllNestedChanges(i, 0, i.maxOffset));
        }
      } catch (err) {
        _iterator270.e(err);
      } finally {
        _iterator270.f();
      }
    }
  }]);
}();
_defineProperty(ut, "_statesPriority", [void 0, "refresh", "rename", "move"]);
function xn(s) {
  return {
    node: s,
    name: s.is("$text") ? "$text" : s.name,
    attributes: new Map(s.getAttributes())
  };
}
function Nn(s) {
  var e = [];
  var _iterator271 = _createForOfIteratorHelper(s),
    _step271;
  try {
    for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
      var t = _step271.value;
      if (t.is("$text")) for (var n = 0; n < t.data.length; ++n) e.push(xn(t));else e.push(xn(t));
    }
  } catch (err) {
    _iterator271.e(err);
  } finally {
    _iterator271.f();
  }
  return e;
}
function Fo(s, e) {
  var t = [];
  var n = 0,
    r = 0;
  var _iterator272 = _createForOfIteratorHelper(e),
    _step272;
  try {
    for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
      var _i69 = _step272.value;
      if (_i69.offset > n) {
        for (var o = 0; o < _i69.offset - n; o++) t.push("e");
        r += _i69.offset - n;
      }
      if (_i69.type == "insert") {
        for (var _o30 = 0; _o30 < _i69.howMany; _o30++) t.push("i");
        n = _i69.offset + _i69.howMany;
      } else if (_i69.type == "remove") {
        for (var _o31 = 0; _o31 < _i69.howMany; _o31++) t.push("r");
        n = _i69.offset, r += _i69.howMany;
      } else {
        if (_i69.howMany > 1500) for (var _o32 = 0; _o32 < _i69.howMany; _o32++) t.push("a");else t.push.apply(t, _toConsumableArray("a".repeat(_i69.howMany).split("")));
        n = _i69.offset + _i69.howMany, r += _i69.howMany;
      }
    }
  } catch (err) {
    _iterator272.e(err);
  } finally {
    _iterator272.f();
  }
  if (r < s) for (var i = 0; i < s - r - n; i++) t.push("e");
  return t;
}
function Do(s) {
  var e = "position" in s && s.position.root.rootName == "$graveyard",
    t = "range" in s && s.range.root.rootName == "$graveyard";
  return !e && !t;
}
var Bo = /*#__PURE__*/function () {
  function Bo() {
    _classCallCheck(this, Bo);
    _defineProperty(this, "_operations", []);
    _defineProperty(this, "_undoPairs", new Map());
    _defineProperty(this, "_undoneOperations", new Set());
    _defineProperty(this, "_baseVersionToOperationIndex", new Map());
    _defineProperty(this, "_version", 0);
    _defineProperty(this, "_gaps", new Map());
  }
  return _createClass(Bo, [{
    key: "version",
    get: function get() {
      return this._version;
    },
    set: function set(e) {
      this._operations.length && e > this._version + 1 && this._gaps.set(this._version, e), this._version = e;
    }
  }, {
    key: "lastOperation",
    get: function get() {
      return this._operations[this._operations.length - 1];
    }
  }, {
    key: "addOperation",
    value: function addOperation(e) {
      if (e.baseVersion !== this.version) throw new f("model-document-history-addoperation-incorrect-version", this, {
        operation: e,
        historyVersion: this.version
      });
      this._operations.push(e), this._version++, this._baseVersionToOperationIndex.set(e.baseVersion, this._operations.length - 1);
    }
  }, {
    key: "getOperations",
    value: function getOperations(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.version;
      if (!this._operations.length) return [];
      var n = this._operations[0];
      e === void 0 && (e = n.baseVersion);
      var r = t - 1;
      var _iterator273 = _createForOfIteratorHelper(this._gaps),
        _step273;
      try {
        for (_iterator273.s(); !(_step273 = _iterator273.n()).done;) {
          var _ref112 = _step273.value;
          var _ref113 = _slicedToArray(_ref112, 2);
          var a = _ref113[0];
          var l = _ref113[1];
          e > a && e < l && (e = l), r > a && r < l && (r = a - 1);
        }
      } catch (err) {
        _iterator273.e(err);
      } finally {
        _iterator273.f();
      }
      if (r < n.baseVersion || e > this.lastOperation.baseVersion) return [];
      var i = this._baseVersionToOperationIndex.get(e);
      i === void 0 && (i = 0);
      var o = this._baseVersionToOperationIndex.get(r);
      return o === void 0 && (o = this._operations.length - 1), this._operations.slice(i, o + 1);
    }
  }, {
    key: "getOperation",
    value: function getOperation(e) {
      var t = this._baseVersionToOperationIndex.get(e);
      if (t !== void 0) return this._operations[t];
    }
  }, {
    key: "setOperationAsUndone",
    value: function setOperationAsUndone(e, t) {
      this._undoPairs.set(t, e), this._undoneOperations.add(e);
    }
  }, {
    key: "isUndoingOperation",
    value: function isUndoingOperation(e) {
      return this._undoPairs.has(e);
    }
  }, {
    key: "isUndoneOperation",
    value: function isUndoneOperation(e) {
      return this._undoneOperations.has(e);
    }
  }, {
    key: "getUndoneOperation",
    value: function getUndoneOperation(e) {
      return this._undoPairs.get(e);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._version = 0, this._undoPairs = new Map(), this._operations = [], this._undoneOperations = new Set(), this._gaps = new Map(), this._baseVersionToOperationIndex = new Map();
    }
  }]);
}();
var ft = /*#__PURE__*/function (_C2) {
  function ft(e, t) {
    var _this81;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";
    _classCallCheck(this, ft);
    _this81 = _callSuper(this, ft, [t]), _defineProperty(_assertThisInitialized(_this81), "rootName", void 0), _defineProperty(_assertThisInitialized(_this81), "_document", void 0), _defineProperty(_assertThisInitialized(_this81), "_isAttached", !0), _defineProperty(_assertThisInitialized(_this81), "_isLoaded", !0), _this81._document = e, _this81.rootName = n;
    return _this81;
  }
  _inherits(ft, _C2);
  return _createClass(ft, [{
    key: "document",
    get: function get() {
      return this._document;
    }
  }, {
    key: "isAttached",
    value: function isAttached() {
      return this._isAttached;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.rootName;
    }
  }]);
}(C);
ft.prototype.is = function (s, e) {
  return e ? e === this.name && (s === "rootElement" || s === "model:rootElement" || s === "element" || s === "model:element") : s === "rootElement" || s === "model:rootElement" || s === "element" || s === "model:element" || s === "node" || s === "model:node";
};
var On = "$graveyard";
var Vo = /*#__PURE__*/function (_N12) {
  function Vo(e) {
    var _this82;
    _classCallCheck(this, Vo);
    _this82 = _callSuper(this, Vo), _defineProperty(_assertThisInitialized(_this82), "model", void 0), _defineProperty(_assertThisInitialized(_this82), "history", void 0), _defineProperty(_assertThisInitialized(_this82), "selection", void 0), _defineProperty(_assertThisInitialized(_this82), "roots", void 0), _defineProperty(_assertThisInitialized(_this82), "differ", void 0), _defineProperty(_assertThisInitialized(_this82), "isReadOnly", void 0), _defineProperty(_assertThisInitialized(_this82), "_postFixers", void 0), _defineProperty(_assertThisInitialized(_this82), "_hasSelectionChangedFromTheLastChangeBlock", void 0), _this82.model = e, _this82.history = new Bo(), _this82.selection = new G(_assertThisInitialized(_this82)), _this82.roots = new Lt({
      idProperty: "rootName"
    }), _this82.differ = new ut(e.markers), _this82.isReadOnly = !1, _this82._postFixers = new Set(), _this82._hasSelectionChangedFromTheLastChangeBlock = !1, _this82.createRoot("$root", On), _this82.listenTo(e, "applyOperation", function (t, n) {
      var r = n[0];
      r.isDocumentOperation && _this82.differ.bufferOperation(r);
    }, {
      priority: "high"
    }), _this82.listenTo(e, "applyOperation", function (t, n) {
      var r = n[0];
      r.isDocumentOperation && _this82.history.addOperation(r);
    }, {
      priority: "low"
    }), _this82.listenTo(_this82.selection, "change", function () {
      _this82._hasSelectionChangedFromTheLastChangeBlock = !0;
    }), _this82.listenTo(e.markers, "update", function (t, n, r, i, o) {
      var a = _objectSpread(_objectSpread({}, n.getData()), {}, {
        range: i
      });
      _this82.differ.bufferMarkerChange(n.name, o, a), r === null && n.on("change", function (l, c) {
        var h = n.getData();
        _this82.differ.bufferMarkerChange(n.name, _objectSpread(_objectSpread({}, h), {}, {
          range: c
        }), h);
      });
    }), _this82.registerPostFixer(function (t) {
      var n = !1;
      var _iterator274 = _createForOfIteratorHelper(_this82.roots),
        _step274;
      try {
        for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
          var r = _step274.value;
          !r.isAttached() && !r.isEmpty && (t.remove(t.createRangeIn(r)), n = !0);
        }
      } catch (err) {
        _iterator274.e(err);
      } finally {
        _iterator274.f();
      }
      var _iterator275 = _createForOfIteratorHelper(_this82.model.markers),
        _step275;
      try {
        for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
          var _r28 = _step275.value;
          _r28.getRange().root.isAttached() || (t.removeMarker(_r28), n = !0);
        }
      } catch (err) {
        _iterator275.e(err);
      } finally {
        _iterator275.f();
      }
      return n;
    });
    return _this82;
  }
  _inherits(Vo, _N12);
  return _createClass(Vo, [{
    key: "version",
    get: function get() {
      return this.history.version;
    },
    set: function set(e) {
      this.history.version = e;
    }
  }, {
    key: "graveyard",
    get: function get() {
      return this.getRoot(On);
    }
  }, {
    key: "createRoot",
    value: function createRoot() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
      if (this.roots.get(t)) throw new f("model-document-createroot-name-exists", this, {
        name: t
      });
      var n = new ft(this, e, t);
      return this.roots.add(n), n;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.selection.destroy(), this.stopListening();
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
      return this.roots.get(e);
    }
  }, {
    key: "getRootNames",
    value: function getRootNames() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this.getRoots(e).map(function (t) {
        return t.rootName;
      });
    }
  }, {
    key: "getRoots",
    value: function getRoots() {
      var _this83 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this.roots.filter(function (t) {
        return t != _this83.graveyard && (e || t.isAttached()) && t._isLoaded;
      });
    }
  }, {
    key: "registerPostFixer",
    value: function registerPostFixer(e) {
      this._postFixers.add(e);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = Un(this);
      return e.selection = "[engine.model.DocumentSelection]", e.model = "[engine.model.Model]", e;
    }
  }, {
    key: "_handleChangeBlock",
    value: function _handleChangeBlock(e) {
      this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(e), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", e.batch) : this.fire("change", e.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
    }
  }, {
    key: "_hasDocumentChangedFromTheLastChangeBlock",
    value: function _hasDocumentChangedFromTheLastChangeBlock() {
      return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
    }
  }, {
    key: "_getDefaultRoot",
    value: function _getDefaultRoot() {
      var e = this.getRoots();
      return e.length ? e[0] : this.graveyard;
    }
  }, {
    key: "_getDefaultRange",
    value: function _getDefaultRange() {
      var e = this._getDefaultRoot(),
        t = this.model,
        n = t.schema,
        r = t.createPositionFromPath(e, [0]);
      return n.getNearestSelectionRange(r) || t.createRange(r);
    }
  }, {
    key: "_validateSelectionRange",
    value: function _validateSelectionRange(e) {
      return e.start.isValid() && e.end.isValid() && In(e.start) && In(e.end);
    }
  }, {
    key: "_callPostFixers",
    value: function _callPostFixers(e) {
      var t = !1;
      do {
        var _iterator276 = _createForOfIteratorHelper(this._postFixers),
          _step276;
        try {
          for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
            var n = _step276.value;
            if (this.selection.refresh(), t = n(e), t) break;
          }
        } catch (err) {
          _iterator276.e(err);
        } finally {
          _iterator276.f();
        }
      } while (t);
    }
  }]);
}(N());
function In(s) {
  var e = s.textNode;
  if (e) {
    var t = e.data,
      n = s.offset - e.startOffset;
    return !Wn(t, n) && !qn(t, n);
  }
  return !0;
}
var $o = /*#__PURE__*/function (_N13) {
  function $o() {
    var _this84;
    _classCallCheck(this, $o);
    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }
    _this84 = _callSuper(this, $o, [].concat(args));
    _defineProperty(_this84, "_markers", new Map());
    return _this84;
  }
  _inherits($o, _N13);
  return _createClass($o, [{
    key: Symbol.iterator,
    value: function value() {
      return this._markers.values();
    }
  }, {
    key: "has",
    value: function has(e) {
      var t = e instanceof Ae ? e.name : e;
      return this._markers.has(t);
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._markers.get(e) || null;
    }
  }, {
    key: "_set",
    value: function _set(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var i = e instanceof Ae ? e.name : e;
      if (i.includes(",")) throw new f("markercollection-incorrect-marker-name", this);
      var o = this._markers.get(i);
      if (o) {
        var c = o.getData(),
          h = o.getRange();
        var d = !1;
        return h.isEqual(t) || (o._attachLiveRange(_e.fromRange(t)), d = !0), n != o.managedUsingOperations && (o._managedUsingOperations = n, d = !0), typeof r == "boolean" && r != o.affectsData && (o._affectsData = r, d = !0), d && this.fire("update:".concat(i), o, h, t, c), o;
      }
      var a = _e.fromRange(t),
        l = new Ae(i, a, n, r);
      return this._markers.set(i, l), this.fire("update:".concat(i), l, null, t, _objectSpread(_objectSpread({}, l.getData()), {}, {
        range: null
      })), l;
    }
  }, {
    key: "_remove",
    value: function _remove(e) {
      var t = e instanceof Ae ? e.name : e,
        n = this._markers.get(t);
      return n ? (this._markers.delete(t), this.fire("update:".concat(t), n, n.getRange(), null, n.getData()), this._destroyMarker(n), !0) : !1;
    }
  }, {
    key: "_refresh",
    value: function _refresh(e) {
      var t = e instanceof Ae ? e.name : e,
        n = this._markers.get(t);
      if (!n) throw new f("markercollection-refresh-marker-not-exists", this);
      var r = n.getRange();
      this.fire("update:".concat(t), n, r, r, n.getData());
    }
  }, {
    key: "getMarkersAtPosition",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersAtPosition(e) {
      var _iterator277, _step277, t;
      return _regeneratorRuntime().wrap(function getMarkersAtPosition$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            _iterator277 = _createForOfIteratorHelper(this);
            _context27.prev = 1;
            _iterator277.s();
          case 3:
            if ((_step277 = _iterator277.n()).done) {
              _context27.next = 11;
              break;
            }
            t = _step277.value;
            _context27.t0 = t.getRange().containsPosition(e);
            if (!_context27.t0) {
              _context27.next = 9;
              break;
            }
            _context27.next = 9;
            return t;
          case 9:
            _context27.next = 3;
            break;
          case 11:
            _context27.next = 16;
            break;
          case 13:
            _context27.prev = 13;
            _context27.t1 = _context27["catch"](1);
            _iterator277.e(_context27.t1);
          case 16:
            _context27.prev = 16;
            _iterator277.f();
            return _context27.finish(16);
          case 19:
          case "end":
            return _context27.stop();
        }
      }, getMarkersAtPosition, this, [[1, 13, 16, 19]]);
    })
  }, {
    key: "getMarkersIntersectingRange",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersIntersectingRange(e) {
      var _iterator278, _step278, t;
      return _regeneratorRuntime().wrap(function getMarkersIntersectingRange$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            _iterator278 = _createForOfIteratorHelper(this);
            _context28.prev = 1;
            _iterator278.s();
          case 3:
            if ((_step278 = _iterator278.n()).done) {
              _context28.next = 11;
              break;
            }
            t = _step278.value;
            _context28.t0 = t.getRange().getIntersection(e) !== null;
            if (!_context28.t0) {
              _context28.next = 9;
              break;
            }
            _context28.next = 9;
            return t;
          case 9:
            _context28.next = 3;
            break;
          case 11:
            _context28.next = 16;
            break;
          case 13:
            _context28.prev = 13;
            _context28.t1 = _context28["catch"](1);
            _iterator278.e(_context28.t1);
          case 16:
            _context28.prev = 16;
            _iterator278.f();
            return _context28.finish(16);
          case 19:
          case "end":
            return _context28.stop();
        }
      }, getMarkersIntersectingRange, this, [[1, 13, 16, 19]]);
    })
  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator279 = _createForOfIteratorHelper(this._markers.values()),
        _step279;
      try {
        for (_iterator279.s(); !(_step279 = _iterator279.n()).done;) {
          var e = _step279.value;
          this._destroyMarker(e);
        }
      } catch (err) {
        _iterator279.e(err);
      } finally {
        _iterator279.f();
      }
      this._markers = null, this.stopListening();
    }
  }, {
    key: "getMarkersGroup",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersGroup(e) {
      var _iterator280, _step280, t;
      return _regeneratorRuntime().wrap(function getMarkersGroup$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            _iterator280 = _createForOfIteratorHelper(this._markers.values());
            _context29.prev = 1;
            _iterator280.s();
          case 3:
            if ((_step280 = _iterator280.n()).done) {
              _context29.next = 11;
              break;
            }
            t = _step280.value;
            _context29.t0 = t.name.startsWith(e + ":");
            if (!_context29.t0) {
              _context29.next = 9;
              break;
            }
            _context29.next = 9;
            return t;
          case 9:
            _context29.next = 3;
            break;
          case 11:
            _context29.next = 16;
            break;
          case 13:
            _context29.prev = 13;
            _context29.t1 = _context29["catch"](1);
            _iterator280.e(_context29.t1);
          case 16:
            _context29.prev = 16;
            _iterator280.f();
            return _context29.finish(16);
          case 19:
          case "end":
            return _context29.stop();
        }
      }, getMarkersGroup, this, [[1, 13, 16, 19]]);
    })
  }, {
    key: "_destroyMarker",
    value: function _destroyMarker(e) {
      e.stopListening(), e._detachLiveRange();
    }
  }]);
}(N());
var Ae = /*#__PURE__*/function (_N14) {
  function Ae(e, t, n, r) {
    var _this85;
    _classCallCheck(this, Ae);
    _this85 = _callSuper(this, Ae), _defineProperty(_assertThisInitialized(_this85), "name", void 0), _defineProperty(_assertThisInitialized(_this85), "_managedUsingOperations", void 0), _defineProperty(_assertThisInitialized(_this85), "_affectsData", void 0), _defineProperty(_assertThisInitialized(_this85), "_liveRange", void 0), _this85.name = e, _this85._liveRange = _this85._attachLiveRange(t), _this85._managedUsingOperations = n, _this85._affectsData = r;
    return _this85;
  }
  _inherits(Ae, _N14);
  return _createClass(Ae, [{
    key: "managedUsingOperations",
    get: function get() {
      if (!this._liveRange) throw new f("marker-destroyed", this);
      return this._managedUsingOperations;
    }
  }, {
    key: "affectsData",
    get: function get() {
      if (!this._liveRange) throw new f("marker-destroyed", this);
      return this._affectsData;
    }
  }, {
    key: "getData",
    value: function getData() {
      return {
        range: this.getRange(),
        affectsData: this.affectsData,
        managedUsingOperations: this.managedUsingOperations
      };
    }
  }, {
    key: "getStart",
    value: function getStart() {
      if (!this._liveRange) throw new f("marker-destroyed", this);
      return this._liveRange.start.clone();
    }
  }, {
    key: "getEnd",
    value: function getEnd() {
      if (!this._liveRange) throw new f("marker-destroyed", this);
      return this._liveRange.end.clone();
    }
  }, {
    key: "getRange",
    value: function getRange() {
      if (!this._liveRange) throw new f("marker-destroyed", this);
      return this._liveRange.toRange();
    }
  }, {
    key: "_attachLiveRange",
    value: function _attachLiveRange(e) {
      return this._liveRange && this._detachLiveRange(), e.delegate("change:range").to(this), e.delegate("change:content").to(this), this._liveRange = e, e;
    }
  }, {
    key: "_detachLiveRange",
    value: function _detachLiveRange() {
      this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
    }
  }]);
}(N(he));
Ae.prototype.is = function (s) {
  return s === "marker" || s === "model:marker";
};
var Lo = /*#__PURE__*/function (_q10) {
  function Lo(e, t) {
    var _this86;
    _classCallCheck(this, Lo);
    _this86 = _callSuper(this, Lo, [null]), _defineProperty(_assertThisInitialized(_this86), "sourcePosition", void 0), _defineProperty(_assertThisInitialized(_this86), "howMany", void 0), _this86.sourcePosition = e.clone(), _this86.howMany = t;
    return _this86;
  }
  _inherits(Lo, _q10);
  return _createClass(Lo, [{
    key: "type",
    get: function get() {
      return "detach";
    }
  }, {
    key: "affectedSelectable",
    get: function get() {
      return null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = _superPropGet(Lo, "toJSON", this, 3)([]);
      return e.sourcePosition = this.sourcePosition.toJSON(), e;
    }
  }, {
    key: "_validate",
    value: function _validate() {
      if (this.sourcePosition.root.document) throw new f("detach-operation-on-document-node", this);
    }
  }, {
    key: "_execute",
    value: function _execute() {
      As(u._createFromPositionAndShift(this.sourcePosition, this.howMany));
    }
  }], [{
    key: "className",
    get: function get() {
      return "DetachOperation";
    }
  }]);
}(q);
var K = /*#__PURE__*/function (_he5) {
  function K(e) {
    var _this87;
    _classCallCheck(this, K);
    _this87 = _callSuper(this, K), _defineProperty(_assertThisInitialized(_this87), "markers", new Map()), _defineProperty(_assertThisInitialized(_this87), "_children", new ze()), e && _this87._insertChild(0, e);
    return _this87;
  }
  _inherits(K, _he5);
  return _createClass(K, [{
    key: Symbol.iterator,
    value: function value() {
      return this.getChildren();
    }
  }, {
    key: "childCount",
    get: function get() {
      return this._children.length;
    }
  }, {
    key: "maxOffset",
    get: function get() {
      return this._children.maxOffset;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.childCount === 0;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return null;
    }
  }, {
    key: "previousSibling",
    get: function get() {
      return null;
    }
  }, {
    key: "root",
    get: function get() {
      return this;
    }
  }, {
    key: "parent",
    get: function get() {
      return null;
    }
  }, {
    key: "document",
    get: function get() {
      return null;
    }
  }, {
    key: "isAttached",
    value: function isAttached() {
      return !1;
    }
  }, {
    key: "getAncestors",
    value: function getAncestors() {
      return [];
    }
  }, {
    key: "getChild",
    value: function getChild(e) {
      return this._children.getNode(e);
    }
  }, {
    key: "getChildAtOffset",
    value: function getChildAtOffset(e) {
      return this._children.getNodeAtOffset(e);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children[Symbol.iterator]();
    }
  }, {
    key: "getChildIndex",
    value: function getChildIndex(e) {
      return this._children.getNodeIndex(e);
    }
  }, {
    key: "getChildStartOffset",
    value: function getChildStartOffset(e) {
      return this._children.getNodeStartOffset(e);
    }
  }, {
    key: "getPath",
    value: function getPath() {
      return [];
    }
  }, {
    key: "getNodeByPath",
    value: function getNodeByPath(e) {
      var t = this;
      var _iterator281 = _createForOfIteratorHelper(e),
        _step281;
      try {
        for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
          var n = _step281.value;
          t = t.getChildAtOffset(n);
        }
      } catch (err) {
        _iterator281.e(err);
      } finally {
        _iterator281.f();
      }
      return t;
    }
  }, {
    key: "offsetToIndex",
    value: function offsetToIndex(e) {
      return this._children.offsetToIndex(e);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = [];
      var _iterator282 = _createForOfIteratorHelper(this._children),
        _step282;
      try {
        for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
          var t = _step282.value;
          e.push(t.toJSON());
        }
      } catch (err) {
        _iterator282.e(err);
      } finally {
        _iterator282.f();
      }
      return e;
    }
  }, {
    key: "_appendChild",
    value: function _appendChild(e) {
      this._insertChild(this.childCount, e);
    }
  }, {
    key: "_insertChild",
    value: function _insertChild(e, t) {
      var n = Wo(t);
      var _iterator283 = _createForOfIteratorHelper(n),
        _step283;
      try {
        for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
          var r = _step283.value;
          r.parent !== null && r._remove(), r.parent = this;
        }
      } catch (err) {
        _iterator283.e(err);
      } finally {
        _iterator283.f();
      }
      this._children._insertNodes(e, n);
    }
  }, {
    key: "_removeChildren",
    value: function _removeChildren(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = this._children._removeNodes(e, t);
      var _iterator284 = _createForOfIteratorHelper(n),
        _step284;
      try {
        for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
          var r = _step284.value;
          r.parent = null;
        }
      } catch (err) {
        _iterator284.e(err);
      } finally {
        _iterator284.f();
      }
      return n;
    }
  }, {
    key: "_removeChildrenArray",
    value: function _removeChildrenArray(e) {
      this._children._removeNodesArray(e);
      var _iterator285 = _createForOfIteratorHelper(e),
        _step285;
      try {
        for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
          var t = _step285.value;
          t.parent = null;
        }
      } catch (err) {
        _iterator285.e(err);
      } finally {
        _iterator285.f();
      }
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(e) {
      var t = [];
      var _iterator286 = _createForOfIteratorHelper(e),
        _step286;
      try {
        for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
          var n = _step286.value;
          n.name ? t.push(C.fromJSON(n)) : t.push(k.fromJSON(n));
        }
      } catch (err) {
        _iterator286.e(err);
      } finally {
        _iterator286.f();
      }
      return new K(t);
    }
  }]);
}(he);
K.prototype.is = function (s) {
  return s === "documentFragment" || s === "model:documentFragment";
};
function Wo(s) {
  return typeof s == "string" ? [new k(s)] : (le(s) || (s = [s]), Array.from(s).map(function (e) {
    return typeof e == "string" ? new k(e) : e instanceof j ? new k(e.data, e.getAttributes()) : e;
  }));
}
var qo = /*#__PURE__*/function () {
  function qo(e, t) {
    _classCallCheck(this, qo);
    _defineProperty(this, "model", void 0);
    _defineProperty(this, "batch", void 0);
    this.model = e, this.batch = t;
  }
  return _createClass(qo, [{
    key: "createText",
    value: function createText(e, t) {
      return new k(e, t);
    }
  }, {
    key: "createElement",
    value: function createElement(e, t) {
      return new C(e, t);
    }
  }, {
    key: "createDocumentFragment",
    value: function createDocumentFragment() {
      return new K();
    }
  }, {
    key: "cloneElement",
    value: function cloneElement(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return e._clone(t);
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (this._assertWriterUsedCorrectly(), e instanceof k && e.data == "") return;
      var r = m._createAt(t, n);
      if (e.parent) if (Bn(e.root, r.root)) {
        this.move(u._createOn(e), r);
        return;
      } else {
        if (e.root.document) throw new f("model-writer-insert-forbidden-move", this);
        this.remove(e);
      }
      var i = r.root.document ? r.root.document.version : null,
        o = e instanceof K ? e._removeChildren(0, e.childCount) : e,
        a = new T(r, o, i);
      if (e instanceof k && (a.shouldReceiveAttributes = !0), this.batch.addOperation(a), this.model.applyOperation(a), e instanceof K) {
        var _iterator287 = _createForOfIteratorHelper(e.markers),
          _step287;
        try {
          for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
            var _ref114 = _step287.value;
            var _ref115 = _slicedToArray(_ref114, 2);
            var l = _ref115[0];
            var c = _ref115[1];
            var h = m._createAt(c.root, 0),
              p = {
                range: new u(c.start._getCombined(h, r), c.end._getCombined(h, r)),
                usingOperation: !0,
                affectsData: !0
              };
            this.model.markers.has(l) ? this.updateMarker(l, p) : this.addMarker(l, p);
          }
        } catch (err) {
          _iterator287.e(err);
        } finally {
          _iterator287.f();
        }
      }
    }
  }, {
    key: "insertText",
    value: function insertText(e, t, n, r) {
      t instanceof K || t instanceof C || t instanceof m ? this.insert(this.createText(e), t, n) : this.insert(this.createText(e, t), n, r);
    }
  }, {
    key: "insertElement",
    value: function insertElement(e, t, n, r) {
      t instanceof K || t instanceof C || t instanceof m ? this.insert(this.createElement(e), t, n) : this.insert(this.createElement(e, t), n, r);
    }
  }, {
    key: "append",
    value: function append(e, t) {
      this.insert(e, t, "end");
    }
  }, {
    key: "appendText",
    value: function appendText(e, t, n) {
      t instanceof K || t instanceof C ? this.insert(this.createText(e), t, "end") : this.insert(this.createText(e, t), n, "end");
    }
  }, {
    key: "appendElement",
    value: function appendElement(e, t, n) {
      t instanceof K || t instanceof C ? this.insert(this.createElement(e), t, "end") : this.insert(this.createElement(e, t), n, "end");
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(e, t, n) {
      if (this._assertWriterUsedCorrectly(), n instanceof u) {
        var r = n.getMinimalFlatRanges();
        var _iterator288 = _createForOfIteratorHelper(r),
          _step288;
        try {
          for (_iterator288.s(); !(_step288 = _iterator288.n()).done;) {
            var i = _step288.value;
            Fn(this, e, t, i);
          }
        } catch (err) {
          _iterator288.e(err);
        } finally {
          _iterator288.f();
        }
      } else Dn(this, e, t, n);
    }
  }, {
    key: "setAttributes",
    value: function setAttributes(e, t) {
      var _iterator289 = _createForOfIteratorHelper(pe(e)),
        _step289;
      try {
        for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
          var _ref116 = _step289.value;
          var _ref117 = _slicedToArray(_ref116, 2);
          var n = _ref117[0];
          var r = _ref117[1];
          this.setAttribute(n, r, t);
        }
      } catch (err) {
        _iterator289.e(err);
      } finally {
        _iterator289.f();
      }
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(e, t) {
      if (this._assertWriterUsedCorrectly(), t instanceof u) {
        var n = t.getMinimalFlatRanges();
        var _iterator290 = _createForOfIteratorHelper(n),
          _step290;
        try {
          for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
            var r = _step290.value;
            Fn(this, e, null, r);
          }
        } catch (err) {
          _iterator290.e(err);
        } finally {
          _iterator290.f();
        }
      } else Dn(this, e, null, t);
    }
  }, {
    key: "clearAttributes",
    value: function clearAttributes(e) {
      var _this88 = this;
      this._assertWriterUsedCorrectly();
      var t = function t(n) {
        var _iterator291 = _createForOfIteratorHelper(n.getAttributeKeys()),
          _step291;
        try {
          for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
            var r = _step291.value;
            _this88.removeAttribute(r, n);
          }
        } catch (err) {
          _iterator291.e(err);
        } finally {
          _iterator291.f();
        }
      };
      if (!(e instanceof u)) t(e);else {
        var _iterator292 = _createForOfIteratorHelper(e.getItems()),
          _step292;
        try {
          for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
            var n = _step292.value;
            t(n);
          }
        } catch (err) {
          _iterator292.e(err);
        } finally {
          _iterator292.f();
        }
      }
    }
  }, {
    key: "move",
    value: function move(e, t, n) {
      if (this._assertWriterUsedCorrectly(), !(e instanceof u)) throw new f("writer-move-invalid-range", this);
      if (!e.isFlat) throw new f("writer-move-range-not-flat", this);
      var r = m._createAt(t, n);
      if (r.isEqual(e.start)) return;
      if (this._addOperationForAffectedMarkers("move", e), !Bn(e.root, r.root)) throw new f("writer-move-different-document", this);
      var i = e.root.document ? e.root.document.version : null,
        o = new v(e.start, e.end.offset - e.start.offset, r, i);
      this.batch.addOperation(o), this.model.applyOperation(o);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      this._assertWriterUsedCorrectly();
      var n = (e instanceof u ? e : u._createOn(e)).getMinimalFlatRanges().reverse();
      var _iterator293 = _createForOfIteratorHelper(n),
        _step293;
      try {
        for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
          var r = _step293.value;
          this._addOperationForAffectedMarkers("move", r), zo(r.start, r.end.offset - r.start.offset, this.batch, this.model);
        }
      } catch (err) {
        _iterator293.e(err);
      } finally {
        _iterator293.f();
      }
    }
  }, {
    key: "merge",
    value: function merge(e) {
      this._assertWriterUsedCorrectly();
      var t = e.nodeBefore,
        n = e.nodeAfter;
      if (this._addOperationForAffectedMarkers("merge", e), !(t instanceof C)) throw new f("writer-merge-no-element-before", this);
      if (!(n instanceof C)) throw new f("writer-merge-no-element-after", this);
      e.root.document ? this._merge(e) : this._mergeDetached(e);
    }
  }, {
    key: "createPositionFromPath",
    value: function createPositionFromPath(e, t, n) {
      return this.model.createPositionFromPath(e, t, n);
    }
  }, {
    key: "createPositionAt",
    value: function createPositionAt(e, t) {
      return this.model.createPositionAt(e, t);
    }
  }, {
    key: "createPositionAfter",
    value: function createPositionAfter(e) {
      return this.model.createPositionAfter(e);
    }
  }, {
    key: "createPositionBefore",
    value: function createPositionBefore(e) {
      return this.model.createPositionBefore(e);
    }
  }, {
    key: "createRange",
    value: function createRange(e, t) {
      return this.model.createRange(e, t);
    }
  }, {
    key: "createRangeIn",
    value: function createRangeIn(e) {
      return this.model.createRangeIn(e);
    }
  }, {
    key: "createRangeOn",
    value: function createRangeOn(e) {
      return this.model.createRangeOn(e);
    }
  }, {
    key: "createSelection",
    value: function createSelection() {
      var _this$model;
      return (_this$model = this.model).createSelection.apply(_this$model, arguments);
    }
  }, {
    key: "_mergeDetached",
    value: function _mergeDetached(e) {
      var t = e.nodeBefore,
        n = e.nodeAfter;
      this.move(u._createIn(n), m._createAt(t, "end")), this.remove(n);
    }
  }, {
    key: "_merge",
    value: function _merge(e) {
      var t = m._createAt(e.nodeBefore, "end"),
        n = m._createAt(e.nodeAfter, 0),
        r = e.root.document.graveyard,
        i = new m(r, [0]),
        o = e.root.document.version,
        a = new A(n, e.nodeAfter.maxOffset, t, i, o);
      this.batch.addOperation(a), this.model.applyOperation(a);
    }
  }, {
    key: "rename",
    value: function rename(e, t) {
      if (this._assertWriterUsedCorrectly(), !(e instanceof C)) throw new f("writer-rename-not-element-instance", this);
      var n = e.root.document ? e.root.document.version : null,
        r = new V(m._createBefore(e), e.name, t, n);
      this.batch.addOperation(r), this.model.applyOperation(r);
    }
  }, {
    key: "split",
    value: function split(e, t) {
      this._assertWriterUsedCorrectly();
      var n = e.parent;
      if (!n.parent) throw new f("writer-split-element-no-parent", this);
      if (t || (t = n.parent), !e.parent.getAncestors({
        includeSelf: !0
      }).includes(t)) throw new f("writer-split-invalid-limit-element", this);
      var r, i;
      do {
        var o = n.root.document ? n.root.document.version : null,
          a = n.maxOffset - e.offset,
          l = P.getInsertionPosition(e),
          c = new P(e, a, l, null, o);
        this.batch.addOperation(c), this.model.applyOperation(c), !r && !i && (r = n, i = e.parent.nextSibling), e = this.createPositionAfter(e.parent), n = e.parent;
      } while (n !== t);
      return {
        position: e,
        range: new u(m._createAt(r, "end"), m._createAt(i, 0))
      };
    }
  }, {
    key: "wrap",
    value: function wrap(e, t) {
      if (this._assertWriterUsedCorrectly(), !e.isFlat) throw new f("writer-wrap-range-not-flat", this);
      var n = t instanceof C ? t : new C(t);
      if (n.childCount > 0) throw new f("writer-wrap-element-not-empty", this);
      if (n.parent !== null) throw new f("writer-wrap-element-attached", this);
      this.insert(n, e.start);
      var r = new u(e.start.getShiftedBy(1), e.end.getShiftedBy(1));
      this.move(r, m._createAt(n, 0));
    }
  }, {
    key: "unwrap",
    value: function unwrap(e) {
      if (this._assertWriterUsedCorrectly(), e.parent === null) throw new f("writer-unwrap-element-no-parent", this);
      this.move(u._createIn(e), this.createPositionAfter(e)), this.remove(e);
    }
  }, {
    key: "addMarker",
    value: function addMarker(e, t) {
      if (this._assertWriterUsedCorrectly(), !t || typeof t.usingOperation != "boolean") throw new f("writer-addmarker-no-usingoperation", this);
      var n = t.usingOperation,
        r = t.range,
        i = t.affectsData === void 0 ? !1 : t.affectsData;
      if (this.model.markers.has(e)) throw new f("writer-addmarker-marker-exists", this);
      if (!r) throw new f("writer-addmarker-no-range", this);
      return n ? (Be(this, e, null, r, i), this.model.markers.get(e)) : this.model.markers._set(e, r, n, i);
    }
  }, {
    key: "updateMarker",
    value: function updateMarker(e, t) {
      this._assertWriterUsedCorrectly();
      var n = typeof e == "string" ? e : e.name,
        r = this.model.markers.get(n);
      if (!r) throw new f("writer-updatemarker-marker-not-exists", this);
      if (!t) {
        W("writer-updatemarker-reconvert-using-editingcontroller", {
          markerName: n
        }), this.model.markers._refresh(r);
        return;
      }
      var i = typeof t.usingOperation == "boolean",
        o = typeof t.affectsData == "boolean",
        a = o ? t.affectsData : r.affectsData;
      if (!i && !t.range && !o) throw new f("writer-updatemarker-wrong-options", this);
      var l = r.getRange(),
        c = t.range ? t.range : l;
      if (i && t.usingOperation !== r.managedUsingOperations) {
        t.usingOperation ? Be(this, n, null, c, a) : (Be(this, n, l, null, a), this.model.markers._set(n, c, void 0, a));
        return;
      }
      r.managedUsingOperations ? Be(this, n, l, c, a) : this.model.markers._set(n, c, void 0, a);
    }
  }, {
    key: "removeMarker",
    value: function removeMarker(e) {
      this._assertWriterUsedCorrectly();
      var t = typeof e == "string" ? e : e.name;
      if (!this.model.markers.has(t)) throw new f("writer-removemarker-no-marker", this);
      var n = this.model.markers.get(t);
      if (!n.managedUsingOperations) {
        this.model.markers._remove(t);
        return;
      }
      var r = n.getRange();
      Be(this, t, r, null, n.affectsData);
    }
  }, {
    key: "addRoot",
    value: function addRoot(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
      this._assertWriterUsedCorrectly();
      var n = this.model.document.getRoot(e);
      if (n && n.isAttached()) throw new f("writer-addroot-root-exists", this);
      var r = this.model.document,
        i = new X(e, t, !0, r, r.version);
      return this.batch.addOperation(i), this.model.applyOperation(i), this.model.document.getRoot(e);
    }
  }, {
    key: "detachRoot",
    value: function detachRoot(e) {
      this._assertWriterUsedCorrectly();
      var t = typeof e == "string" ? this.model.document.getRoot(e) : e;
      if (!t || !t.isAttached()) throw new f("writer-detachroot-no-root", this);
      var _iterator294 = _createForOfIteratorHelper(this.model.markers),
        _step294;
      try {
        for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
          var i = _step294.value;
          i.getRange().root === t && this.removeMarker(i);
        }
      } catch (err) {
        _iterator294.e(err);
      } finally {
        _iterator294.f();
      }
      var _iterator295 = _createForOfIteratorHelper(t.getAttributeKeys()),
        _step295;
      try {
        for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
          var _i70 = _step295.value;
          this.removeAttribute(_i70, t);
        }
      } catch (err) {
        _iterator295.e(err);
      } finally {
        _iterator295.f();
      }
      this.remove(this.createRangeIn(t));
      var n = this.model.document,
        r = new X(t.rootName, t.name, !1, n, n.version);
      this.batch.addOperation(r), this.model.applyOperation(r);
    }
  }, {
    key: "setSelection",
    value: function setSelection() {
      var _this$model$document$;
      this._assertWriterUsedCorrectly(), (_this$model$document$ = this.model.document.selection)._setTo.apply(_this$model$document$, arguments);
    }
  }, {
    key: "setSelectionFocus",
    value: function setSelectionFocus(e, t) {
      this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(e, t);
    }
  }, {
    key: "setSelectionAttribute",
    value: function setSelectionAttribute(e, t) {
      if (this._assertWriterUsedCorrectly(), typeof e == "string") this._setSelectionAttribute(e, t);else {
        var _iterator296 = _createForOfIteratorHelper(pe(e)),
          _step296;
        try {
          for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
            var _ref118 = _step296.value;
            var _ref119 = _slicedToArray(_ref118, 2);
            var n = _ref119[0];
            var r = _ref119[1];
            this._setSelectionAttribute(n, r);
          }
        } catch (err) {
          _iterator296.e(err);
        } finally {
          _iterator296.f();
        }
      }
    }
  }, {
    key: "removeSelectionAttribute",
    value: function removeSelectionAttribute(e) {
      if (this._assertWriterUsedCorrectly(), typeof e == "string") this._removeSelectionAttribute(e);else {
        var _iterator297 = _createForOfIteratorHelper(e),
          _step297;
        try {
          for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
            var t = _step297.value;
            this._removeSelectionAttribute(t);
          }
        } catch (err) {
          _iterator297.e(err);
        } finally {
          _iterator297.f();
        }
      }
    }
  }, {
    key: "overrideSelectionGravity",
    value: function overrideSelectionGravity() {
      return this.model.document.selection._overrideGravity();
    }
  }, {
    key: "restoreSelectionGravity",
    value: function restoreSelectionGravity(e) {
      this.model.document.selection._restoreGravity(e);
    }
  }, {
    key: "_setSelectionAttribute",
    value: function _setSelectionAttribute(e, t) {
      var n = this.model.document.selection;
      if (n.isCollapsed && n.anchor.parent.isEmpty) {
        var r = G._getStoreAttributeKey(e);
        this.setAttribute(r, t, n.anchor.parent);
      }
      n._setAttribute(e, t);
    }
  }, {
    key: "_removeSelectionAttribute",
    value: function _removeSelectionAttribute(e) {
      var t = this.model.document.selection;
      if (t.isCollapsed && t.anchor.parent.isEmpty) {
        var n = G._getStoreAttributeKey(e);
        this.removeAttribute(n, t.anchor.parent);
      }
      t._removeAttribute(e);
    }
  }, {
    key: "_assertWriterUsedCorrectly",
    value: function _assertWriterUsedCorrectly() {
      if (this.model._currentWriter !== this) throw new f("writer-incorrect-use", this);
    }
  }, {
    key: "_addOperationForAffectedMarkers",
    value: function _addOperationForAffectedMarkers(e, t) {
      var _iterator298 = _createForOfIteratorHelper(this.model.markers),
        _step298;
      try {
        for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
          var n = _step298.value;
          if (!n.managedUsingOperations) continue;
          var r = n.getRange();
          var i = !1;
          if (e === "move") {
            var o = t;
            i = o.containsPosition(r.start) || o.start.isEqual(r.start) || o.containsPosition(r.end) || o.end.isEqual(r.end);
          } else {
            var _o33 = t,
              a = _o33.nodeBefore,
              l = _o33.nodeAfter,
              c = r.start.parent == a && r.start.isAtEnd,
              h = r.end.parent == l && r.end.offset == 0,
              d = r.end.nodeAfter == l,
              p = r.start.nodeAfter == l;
            i = c || h || d || p;
          }
          i && this.updateMarker(n.name, {
            range: r
          });
        }
      } catch (err) {
        _iterator298.e(err);
      } finally {
        _iterator298.f();
      }
    }
  }]);
}();
function Fn(s, e, t, n) {
  var r = s.model,
    i = r.document;
  var o = n.start,
    a,
    l,
    c;
  var _iterator299 = _createForOfIteratorHelper(n.getWalker({
      shallow: !0
    })),
    _step299;
  try {
    for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
      var d = _step299.value;
      c = d.item.getAttribute(e), a && l != c && (l != t && h(), o = a), a = d.nextPosition, l = c;
    }
  } catch (err) {
    _iterator299.e(err);
  } finally {
    _iterator299.f();
  }
  a instanceof m && a != o && l != t && h();
  function h() {
    var d = new u(o, a),
      p = d.root.document ? i.version : null,
      _ = new S(d, e, l, t, p);
    s.batch.addOperation(_), r.applyOperation(_);
  }
}
function Dn(s, e, t, n) {
  var r = s.model,
    i = r.document,
    o = n.getAttribute(e);
  var a, l;
  if (o != t) {
    if (n.root === n) {
      var h = n.document ? i.version : null;
      l = new ee(n, e, o, t, h);
    } else {
      a = new u(m._createBefore(n), s.createPositionAfter(n));
      var _h2 = a.root.document ? i.version : null;
      l = new S(a, e, o, t, _h2);
    }
    s.batch.addOperation(l), r.applyOperation(l);
  }
}
function Be(s, e, t, n, r) {
  var i = s.model,
    o = i.document,
    a = new B(e, t, n, i.markers, !!r, o.version);
  s.batch.addOperation(a), i.applyOperation(a);
}
function zo(s, e, t, n) {
  var r;
  if (s.root.document) {
    var i = n.document,
      o = new m(i.graveyard, [0]);
    r = new v(s, e, o, i.version);
  } else r = new Lo(s, e);
  t.addOperation(r), n.applyOperation(r);
}
function Bn(s, e) {
  return s === e || s instanceof ft && e instanceof ft;
}
function Uo(s) {
  s.document.registerPostFixer(function (e) {
    return Jo(e, s);
  });
}
function Jo(s, e) {
  var t = e.document.selection,
    n = e.schema,
    r = [];
  var i = !1;
  var _iterator300 = _createForOfIteratorHelper(t.getRanges()),
    _step300;
  try {
    for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
      var o = _step300.value;
      var a = jo(o, n);
      a && !a.isEqual(o) ? (r.push(a), i = !0) : r.push(o);
    }
  } catch (err) {
    _iterator300.e(err);
  } finally {
    _iterator300.f();
  }
  return i && s.setSelection(Xo(r), {
    backward: t.isBackward
  }), !1;
}
function jo(s, e) {
  return s.isCollapsed ? Go(s, e) : Ho(s, e);
}
function Go(s, e) {
  var t = s.start,
    n = e.getNearestSelectionRange(t);
  if (!n) {
    var i = t.getAncestors().reverse().find(function (o) {
      return e.isObject(o);
    });
    return i ? u._createOn(i) : null;
  }
  if (!n.isCollapsed) return n;
  var r = n.start;
  return t.isEqual(r) ? null : new u(r);
}
function Ho(s, e) {
  var t = s.start,
    n = s.end,
    r = e.checkChild(t, "$text"),
    i = e.checkChild(n, "$text"),
    o = e.getLimitElement(t),
    a = e.getLimitElement(n);
  if (o === a) {
    if (r && i) return null;
    if (Ko(t, n, e)) {
      var d = t.nodeAfter && e.isSelectable(t.nodeAfter) ? null : e.getNearestSelectionRange(t, "forward"),
        _ = n.nodeBefore && e.isSelectable(n.nodeBefore) ? null : e.getNearestSelectionRange(n, "backward"),
        y = d ? d.start : t,
        I = _ ? _.end : n;
      return new u(y, I);
    }
  }
  var l = o && !o.is("rootElement"),
    c = a && !a.is("rootElement");
  if (l || c) {
    var h = t.nodeAfter && n.nodeBefore && t.nodeAfter.parent === n.nodeBefore.parent,
      _d8 = l && (!h || !$n(t.nodeAfter, e)),
      p = c && (!h || !$n(n.nodeBefore, e));
    var _3 = t,
      _y = n;
    return _d8 && (_3 = m._createBefore(Vn(o, e))), p && (_y = m._createAfter(Vn(a, e))), new u(_3, _y);
  }
  return null;
}
function Vn(s, e) {
  var t = s,
    n = t;
  for (; e.isLimit(n) && n.parent;) t = n, n = n.parent;
  return t;
}
function Ko(s, e, t) {
  var n = s.nodeAfter && !t.isLimit(s.nodeAfter) || t.checkChild(s, "$text"),
    r = e.nodeBefore && !t.isLimit(e.nodeBefore) || t.checkChild(e, "$text");
  return n || r;
}
function Xo(s) {
  var e = _toConsumableArray(s),
    t = new Set();
  var n = 1;
  for (; n < e.length;) {
    var i = e[n],
      o = e.slice(0, n);
    var _iterator301 = _createForOfIteratorHelper(o.entries()),
      _step301;
    try {
      for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
        var _ref120 = _step301.value;
        var _ref121 = _slicedToArray(_ref120, 2);
        var a = _ref121[0];
        var l = _ref121[1];
        if (!t.has(a)) {
          if (i.isEqual(l)) t.add(a);else if (i.isIntersecting(l)) {
            t.add(a), t.add(n);
            var c = i.getJoined(l);
            e.push(c);
          }
        }
      }
    } catch (err) {
      _iterator301.e(err);
    } finally {
      _iterator301.f();
    }
    n++;
  }
  return e.filter(function (i, o) {
    return !t.has(o);
  });
}
function $n(s, e) {
  return s && e.isSelectable(s);
}
function Yo(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (e.isCollapsed) return;
  var n = e.getFirstRange();
  if (n.root.rootName == "$graveyard") return;
  var r = s.schema;
  s.change(function (i) {
    var _Qo, _Qo2;
    if (!t.doNotResetEntireContent && oa(r, e)) {
      ia(i, e);
      return;
    }
    var o = {};
    if (!t.doNotAutoparagraph) {
      var c = e.getSelectedElement();
      c && Object.assign(o, r.getAttributesWithProperty(c, "copyOnReplace", !0));
    }
    var a, l;
    t.doNotFixSelection ? (a = O.fromPosition(n.start, "toPrevious"), l = O.fromPosition(n.end, "toNext")) : (_Qo = Qo(n), _Qo2 = _slicedToArray(_Qo, 2), a = _Qo2[0], l = _Qo2[1], _Qo), a.isTouching(l) || i.remove(i.createRange(a, l)), t.leaveUnmerged || (ea(i, a, l), r.removeDisallowedAttributes(a.parent.getChildren(), i)), Ns(i, e, a), !t.doNotAutoparagraph && sa(r, a) && xs(i, a, e, o), a.detach(), l.detach();
  });
}
function Qo(s) {
  var e = s.root.document.model,
    t = s.start;
  var n = s.end;
  if (e.hasContent(s, {
    ignoreMarkers: !0
  })) {
    var r = Zo(n);
    if (r && n.isTouching(e.createPositionAt(r, 0))) {
      var i = e.createSelection(s);
      e.modifySelection(i, {
        direction: "backward"
      });
      var o = i.getLastPosition(),
        a = e.createRange(o, n);
      e.hasContent(a, {
        ignoreMarkers: !0
      }) || (n = o);
    }
  }
  return [O.fromPosition(t, "toPrevious"), O.fromPosition(n, "toNext")];
}
function Zo(s) {
  var e = s.parent,
    t = e.root.document.model.schema,
    n = e.getAncestors({
      parentFirst: !0,
      includeSelf: !0
    });
  var _iterator302 = _createForOfIteratorHelper(n),
    _step302;
  try {
    for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
      var r = _step302.value;
      if (t.isLimit(r)) return null;
      if (t.isBlock(r)) return r;
    }
  } catch (err) {
    _iterator302.e(err);
  } finally {
    _iterator302.f();
  }
}
function ea(s, e, t) {
  var n = s.model;
  if (!Yt(s.model.schema, e, t)) return;
  var _na = na(e, t),
    _na2 = _slicedToArray(_na, 2),
    r = _na2[0],
    i = _na2[1];
  !r || !i || (!n.hasContent(r, {
    ignoreMarkers: !0
  }) && n.hasContent(i, {
    ignoreMarkers: !0
  }) ? Ms(s, e, t, r.parent) : Ts(s, e, t, r.parent));
}
function Ts(s, e, t, n) {
  var r = e.parent,
    i = t.parent;
  if (!(r == n || i == n)) {
    for (e = s.createPositionAfter(r), t = s.createPositionBefore(i), t.isEqual(e) || s.insert(i, e), s.merge(e); t.parent.isEmpty;) {
      var o = t.parent;
      t = s.createPositionBefore(o), s.remove(o);
    }
    Yt(s.model.schema, e, t) && Ts(s, e, t, n);
  }
}
function Ms(s, e, t, n) {
  var r = e.parent,
    i = t.parent;
  if (!(r == n || i == n)) {
    for (e = s.createPositionAfter(r), t = s.createPositionBefore(i), t.isEqual(e) || s.insert(r, t); e.parent.isEmpty;) {
      var o = e.parent;
      e = s.createPositionBefore(o), s.remove(o);
    }
    t = s.createPositionBefore(i), ta(s, t), Yt(s.model.schema, e, t) && Ms(s, e, t, n);
  }
}
function ta(s, e) {
  var t = e.nodeBefore,
    n = e.nodeAfter;
  t.name != n.name && s.rename(t, n.name), s.clearAttributes(t), s.setAttributes(Object.fromEntries(n.getAttributes()), t), s.merge(e);
}
function Yt(s, e, t) {
  var n = e.parent,
    r = t.parent;
  return n == r || s.isLimit(n) || s.isLimit(r) ? !1 : ra(e, t, s);
}
function na(s, e) {
  var t = s.getAncestors(),
    n = e.getAncestors();
  var r = 0;
  for (; t[r] && t[r] == n[r];) r++;
  return [t[r], n[r]];
}
function sa(s, e) {
  var t = s.checkChild(e, "$text"),
    n = s.checkChild(e, "paragraph");
  return !t && n;
}
function ra(s, e, t) {
  var n = new u(s, e);
  var _iterator303 = _createForOfIteratorHelper(n.getWalker()),
    _step303;
  try {
    for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
      var r = _step303.value;
      if (t.isLimit(r.item)) return !1;
    }
  } catch (err) {
    _iterator303.e(err);
  } finally {
    _iterator303.f();
  }
  return !0;
}
function xs(s, e, t) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var r = s.createElement("paragraph");
  s.model.schema.setAllowedAttributes(r, n, s), s.insert(r, e), Ns(s, t, s.createPositionAt(r, 0));
}
function ia(s, e) {
  var t = s.model.schema.getLimitElement(e);
  s.remove(s.createRangeIn(t)), xs(s, s.createPositionAt(t, 0), e);
}
function oa(s, e) {
  var t = s.getLimitElement(e);
  if (!e.containsEntireContent(t)) return !1;
  var n = e.getFirstRange();
  return n.start.parent == n.end.parent ? !1 : s.checkChild(t, "paragraph");
}
function Ns(s, e, t) {
  e instanceof G ? s.setSelection(t) : e.setTo(t);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function aa(s, e) {
  return s.change(function (t) {
    var n = t.createDocumentFragment(),
      r = e.getFirstRange();
    if (!r || r.isCollapsed) return n;
    var i = r.start.root,
      o = r.start.getCommonPath(r.end),
      a = i.getNodeByPath(o);
    var l;
    r.start.parent == r.end.parent ? l = r : l = t.createRange(t.createPositionAt(a, r.start.path[o.length]), t.createPositionAt(a, r.end.path[o.length] + 1));
    var c = l.end.offset - l.start.offset;
    var _iterator304 = _createForOfIteratorHelper(l.getItems({
        shallow: !0
      })),
      _step304;
    try {
      for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
        var _h3 = _step304.value;
        _h3.is("$textProxy") ? t.appendText(_h3.data, _h3.getAttributes(), n) : t.append(t.cloneElement(_h3, !0), n);
      }
    } catch (err) {
      _iterator304.e(err);
    } finally {
      _iterator304.f();
    }
    if (l != r) {
      var h = r._getTransformedByMove(l.start, t.createPositionAt(n, 0), c)[0],
        d = t.createRange(t.createPositionAt(n, 0), h.start),
        p = t.createRange(h.end, t.createPositionAt(n, "end"));
      Ln(p, t), Ln(d, t);
    }
    return n;
  });
}
function Ln(s, e) {
  var t = [];
  Array.from(s.getItems({
    direction: "backward"
  })).map(function (n) {
    return e.createRangeOn(n);
  }).filter(function (n) {
    return (n.start.isAfter(s.start) || n.start.isEqual(s.start)) && (n.end.isBefore(s.end) || n.end.isEqual(s.end));
  }).forEach(function (n) {
    t.push(n.start.parent), e.remove(n);
  }), t.forEach(function (n) {
    var r = n;
    for (; r.parent && r.isEmpty;) {
      var i = e.createRangeOn(r);
      r = r.parent, e.remove(i);
    }
  });
}
function la(s, e, t) {
  return s.change(function (n) {
    var r = t || s.document.selection;
    r.isCollapsed || s.deleteContent(r, {
      doNotAutoparagraph: !0
    });
    var i = new ca(s, n, r.anchor),
      o = [];
    var a;
    if (e.is("documentFragment")) {
      if (e.markers.size) {
        var h = [];
        var _iterator305 = _createForOfIteratorHelper(e.markers),
          _step305;
        try {
          for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
            var _ref122 = _step305.value;
            var _ref123 = _slicedToArray(_ref122, 2);
            var _d9 = _ref123[0];
            var _p3 = _ref123[1];
            var _4 = _p3.start,
              _y2 = _p3.end,
              _I = _4.isEqual(_y2);
            h.push({
              position: _4,
              name: _d9,
              isCollapsed: _I
            }, {
              position: _y2,
              name: _d9,
              isCollapsed: _I
            });
          }
        } catch (err) {
          _iterator305.e(err);
        } finally {
          _iterator305.f();
        }
        h.sort(function (_ref124, _ref125) {
          var d = _ref124.position;
          var p = _ref125.position;
          return d.isBefore(p) ? 1 : -1;
        });
        for (var _i71 = 0, _h4 = h; _i71 < _h4.length; _i71++) {
          var _ref126 = _h4[_i71];
          var d = _ref126.position;
          var p = _ref126.name;
          var _ = _ref126.isCollapsed;
          var y = null,
            I = null;
          var ue = d.parent === e && d.isAtStart,
            ne = d.parent === e && d.isAtEnd;
          !ue && !ne ? (y = n.createElement("$marker"), n.insert(y, d)) : _ && (I = ue ? "start" : "end"), o.push({
            name: p,
            element: y,
            collapsed: I
          });
        }
      }
      a = e.getChildren();
    } else a = [e];
    i.handleNodes(a);
    var l = i.getSelectionRange();
    if (e.is("documentFragment") && o.length) {
      var _h5 = l ? _e.fromRange(l) : null,
        _d0 = {};
      for (var _p4 = o.length - 1; _p4 >= 0; _p4--) {
        var _o$_p = o[_p4],
          _5 = _o$_p.name,
          _y3 = _o$_p.element,
          _I2 = _o$_p.collapsed,
          _ue = !_d0[_5];
        if (_ue && (_d0[_5] = []), _y3) {
          var _ne = n.createPositionAt(_y3, "before");
          _d0[_5].push(_ne), n.remove(_y3);
        } else {
          var _ne2 = i.getAffectedRange();
          if (!_ne2) {
            _I2 && _d0[_5].push(i.position);
            continue;
          }
          _I2 ? _d0[_5].push(_ne2[_I2]) : _d0[_5].push(_ue ? _ne2.start : _ne2.end);
        }
      }
      for (var _i72 = 0, _Object$entries3 = Object.entries(_d0); _i72 < _Object$entries3.length; _i72++) {
        var _ref127 = _Object$entries3[_i72];
        var _ref128 = _slicedToArray(_ref127, 2);
        var _p5 = _ref128[0];
        var _ref128$ = _slicedToArray(_ref128[1], 2);
        var _6 = _ref128$[0];
        var _y4 = _ref128$[1];
        _6 && _y4 && _6.root === _y4.root && _6.root.document && !n.model.markers.has(_p5) && n.addMarker(_p5, {
          usingOperation: !0,
          affectsData: !0,
          range: new u(_6, _y4)
        });
      }
      _h5 && (l = _h5.toRange(), _h5.detach());
    } /* istanbul ignore else -- @preserve */
    l && (r instanceof G ? n.setSelection(l) : r.setTo(l));
    var c = i.getAffectedRange() || s.createRange(r.anchor);
    return i.destroy(), c;
  });
}
var ca = /*#__PURE__*/function () {
  function ca(e, t, n) {
    _classCallCheck(this, ca);
    _defineProperty(this, "model", void 0);
    _defineProperty(this, "writer", void 0);
    _defineProperty(this, "position", void 0);
    _defineProperty(this, "canMergeWith", void 0);
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "_documentFragment", void 0);
    _defineProperty(this, "_documentFragmentPosition", void 0);
    _defineProperty(this, "_firstNode", null);
    _defineProperty(this, "_lastNode", null);
    _defineProperty(this, "_lastAutoParagraph", null);
    _defineProperty(this, "_filterAttributesOf", []);
    _defineProperty(this, "_affectedStart", null);
    _defineProperty(this, "_affectedEnd", null);
    _defineProperty(this, "_nodeToSelect", null);
    this.model = e, this.writer = t, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = e.schema, this._documentFragment = t.createDocumentFragment(), this._documentFragmentPosition = t.createPositionAt(this._documentFragment, 0);
  }
  return _createClass(ca, [{
    key: "handleNodes",
    value: function handleNodes(e) {
      for (var _i73 = 0, _Array$from8 = Array.from(e); _i73 < _Array$from8.length; _i73++) {
        var t = _Array$from8[_i73];
        this._handleNode(t);
      }
      this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
    }
  }, {
    key: "_updateLastNodeFromAutoParagraph",
    value: function _updateLastNodeFromAutoParagraph(e) {
      var t = this.writer.createPositionAfter(this._lastNode),
        n = this.writer.createPositionAfter(e);
      if (n.isAfter(t)) {
        this._lastNode = e; /* istanbul ignore if -- @preserve */
        if (this.position.parent != e || !this.position.isAtEnd) throw new f("insertcontent-invalid-insertion-position", this);
        this.position = n, this._setAffectedBoundaries(this.position);
      }
    }
  }, {
    key: "getSelectionRange",
    value: function getSelectionRange() {
      return this._nodeToSelect ? u._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
    }
  }, {
    key: "getAffectedRange",
    value: function getAffectedRange() {
      return this._affectedStart ? new u(this._affectedStart, this._affectedEnd) : null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
    }
  }, {
    key: "_handleNode",
    value: function _handleNode(e) {
      if (!this._checkAndSplitToAllowedPosition(e)) {
        this.schema.isObject(e) || this._handleDisallowedNode(e);
        return;
      }
      this._appendToFragment(e), this._firstNode || (this._firstNode = e), this._lastNode = e;
    }
  }, {
    key: "_insertPartialFragment",
    value: function _insertPartialFragment() {
      if (this._documentFragment.isEmpty) return;
      var e = O.fromPosition(this.position, "toNext");
      this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = e.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = e.toPosition(), e.detach();
    }
  }, {
    key: "_handleDisallowedNode",
    value: function _handleDisallowedNode(e) {
      e.is("element") && this.handleNodes(e.getChildren());
    }
  }, {
    key: "_appendToFragment",
    value: function _appendToFragment(e) {
      /* istanbul ignore if -- @preserve */if (!this.schema.checkChild(this.position, e)) throw new f("insertcontent-wrong-position", this, {
        node: e,
        position: this.position
      });
      this.writer.insert(e, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(e.offsetSize), this.schema.isObject(e) && !this.schema.checkChild(this.position, "$text") ? this._nodeToSelect = e : this._nodeToSelect = null, this._filterAttributesOf.push(e);
    }
  }, {
    key: "_setAffectedBoundaries",
    value: function _setAffectedBoundaries(e) {
      this._affectedStart || (this._affectedStart = O.fromPosition(e, "toPrevious")), (!this._affectedEnd || this._affectedEnd.isBefore(e)) && (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = O.fromPosition(e, "toNext"));
    }
  }, {
    key: "_mergeOnLeft",
    value: function _mergeOnLeft() {
      var e = this._firstNode;
      if (!(e instanceof C) || !this._canMergeLeft(e)) return;
      var t = O._createBefore(e);
      t.stickiness = "toNext";
      var n = O.fromPosition(this.position, "toNext");
      this._affectedStart.isEqual(t) && (this._affectedStart.detach(), this._affectedStart = O._createAt(t.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = O._createAt(t.nodeBefore, "end", "toNext")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
    }
  }, {
    key: "_mergeOnRight",
    value: function _mergeOnRight() {
      var e = this._lastNode;
      if (!(e instanceof C) || !this._canMergeRight(e)) return;
      var t = O._createAfter(e);
      t.stickiness = "toNext"; /* istanbul ignore if -- @preserve */
      if (!this.position.isEqual(t)) throw new f("insertcontent-invalid-insertion-position", this);
      this.position = m._createAt(t.nodeBefore, "end");
      var n = O.fromPosition(this.position, "toPrevious");
      this._affectedEnd.isEqual(t) && (this._affectedEnd.detach(), this._affectedEnd = O._createAt(t.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = O._createAt(t.nodeBefore, 0, "toPrevious")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
    }
  }, {
    key: "_canMergeLeft",
    value: function _canMergeLeft(e) {
      var t = e.previousSibling;
      return t instanceof C && this.canMergeWith.has(t) && this.model.schema.checkMerge(t, e);
    }
  }, {
    key: "_canMergeRight",
    value: function _canMergeRight(e) {
      var t = e.nextSibling;
      return t instanceof C && this.canMergeWith.has(t) && this.model.schema.checkMerge(e, t);
    }
  }, {
    key: "_insertAutoParagraph",
    value: function _insertAutoParagraph() {
      this._insertPartialFragment();
      var e = this.writer.createElement("paragraph");
      this.writer.insert(e, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = e, this.position = this.writer.createPositionAt(e, 0);
    }
  }, {
    key: "_checkAndSplitToAllowedPosition",
    value: function _checkAndSplitToAllowedPosition(e) {
      var t = this._getAllowedIn(this.position.parent, e);
      if (!t) return !1;
      for (t != this.position.parent && this._insertPartialFragment(); t != this.position.parent;) if (this.position.isAtStart) {
        var n = this.position.parent;
        this.position = this.writer.createPositionBefore(n), n.isEmpty && n.parent === t && this.writer.remove(n);
      } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
        var _n32 = this.writer.createPositionAfter(this.position.parent);
        this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _n32, this.canMergeWith.add(this.position.nodeAfter);
      }
      return this.schema.checkChild(this.position.parent, e) || this._insertAutoParagraph(), !0;
    }
  }, {
    key: "_getAllowedIn",
    value: function _getAllowedIn(e, t) {
      return this.schema.checkChild(e, t) || this.schema.checkChild(e, "paragraph") && this.schema.checkChild("paragraph", t) ? e : this.schema.isLimit(e) ? null : this._getAllowedIn(e.parent, t);
    }
  }]);
}();
function ha(s, e, t) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (!s.schema.isObject(e)) throw new f("insertobject-element-not-an-object", s, {
    object: e
  });
  var r = t || s.document.selection;
  var i = r;
  n.findOptimalPosition && s.schema.isBlock(e) && (i = s.createSelection(s.schema.findOptimalInsertionRange(r, n.findOptimalPosition)));
  var o = Wt(r.getSelectedBlocks()),
    a = {};
  return o && Object.assign(a, s.schema.getAttributesWithProperty(o, "copyOnReplace", !0)), s.change(function (l) {
    i.isCollapsed || s.deleteContent(i, {
      doNotAutoparagraph: !0
    });
    var c = e;
    var h = i.anchor.parent;
    !s.schema.checkChild(h, e) && s.schema.checkChild(h, "paragraph") && s.schema.checkChild("paragraph", e) && (c = l.createElement("paragraph"), l.insert(e, c)), s.schema.setAllowedAttributes(c, a, l);
    var d = s.insertContent(c, i);
    return d.isCollapsed || n.setSelection && ua(l, e, n.setSelection, a), d;
  });
}
function ua(s, e, t, n) {
  var r = s.model;
  if (t == "on") {
    s.setSelection(e, "on");
    return;
  }
  if (t != "after") throw new f("insertobject-invalid-place-parameter-value", r);
  var i = e.nextSibling;
  if (r.schema.isInline(e)) {
    s.setSelection(e, "after");
    return;
  }
  !(i && r.schema.checkChild(i, "$text")) && r.schema.checkChild(e.parent, "paragraph") && (i = s.createElement("paragraph"), r.schema.setAllowedAttributes(i, n, s), r.insertContent(i, s.createPositionAfter(e))), i && s.setSelection(i, 0);
}
var fa = ' ,.?!:;"-()';
function da(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var n = s.schema,
    r = t.direction != "backward",
    i = t.unit ? t.unit : "character",
    o = !!t.treatEmojiAsSingleUnit,
    a = e.focus,
    l = new ie({
      boundaries: _a(a, r),
      singleCharacters: !0,
      direction: r ? "forward" : "backward"
    }),
    c = {
      walker: l,
      schema: n,
      isForward: r,
      unit: i,
      treatEmojiAsSingleUnit: o
    };
  var h;
  var _loop3 = function _loop3() {
      if (h.done) return {
        v: void 0
      };
      var d = ma(c, h.value);
      if (d) {
        e instanceof G ? s.change(function (p) {
          p.setSelectionFocus(d);
        }) : e.setFocus(d);
        return {
          v: void 0
        };
      }
    },
    _ret;
  for (; h = l.next();) {
    _ret = _loop3();
    if (_ret) return _ret.v;
  }
}
function ma(s, e) {
  var t = s.isForward,
    n = s.walker,
    r = s.unit,
    i = s.schema,
    o = s.treatEmojiAsSingleUnit,
    a = e.type,
    l = e.item,
    c = e.nextPosition;
  if (a == "text") return s.unit === "word" ? pa(n, t) : ga(n, r, o);
  if (a == (t ? "elementStart" : "elementEnd")) {
    if (i.isSelectable(l)) return m._createAt(l, t ? "after" : "before");
    if (i.checkChild(c, "$text")) return c;
  } else {
    if (i.isLimit(l)) {
      n.skip(function () {
        return !0;
      });
      return;
    }
    if (i.checkChild(c, "$text")) return c;
  }
}
function ga(s, e, t) {
  var n = s.position.textNode;
  if (n) {
    var r = n.data;
    var i = s.position.offset - n.startOffset;
    for (; Wn(r, i) || e == "character" && qn(r, i) || t && qs(r, i);) s.next(), i = s.position.offset - n.startOffset;
  }
  return s.position;
}
function pa(s, e) {
  var t = s.position.textNode;
  for (t || (t = e ? s.position.nodeAfter : s.position.nodeBefore); t && t.is("$text");) {
    var n = s.position.offset - t.startOffset;
    if (ba(t, n, e)) t = e ? s.position.nodeAfter : s.position.nodeBefore;else {
      if (wa(t.data, n, e)) break;
      s.next();
    }
  }
  return s.position;
}
function _a(s, e) {
  var t = s.root,
    n = m._createAt(t, e ? "end" : 0);
  return e ? new u(s, n) : new u(n, s);
}
function wa(s, e, t) {
  var n = e + (t ? 0 : -1);
  return fa.includes(s.charAt(n));
}
function ba(s, e, t) {
  return e === (t ? s.offsetSize : 0);
}
var vl = /*#__PURE__*/function (_U6) {
  function vl() {
    var _this89;
    _classCallCheck(this, vl);
    _this89 = _callSuper(this, vl), _defineProperty(_assertThisInitialized(_this89), "markers", void 0), _defineProperty(_assertThisInitialized(_this89), "document", void 0), _defineProperty(_assertThisInitialized(_this89), "schema", void 0), _defineProperty(_assertThisInitialized(_this89), "_pendingChanges", void 0), _defineProperty(_assertThisInitialized(_this89), "_currentWriter", void 0), _this89.markers = new $o(), _this89.document = new Vo(_assertThisInitialized(_this89)), _this89.schema = new so(), _this89._pendingChanges = [], _this89._currentWriter = null, ["deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (e) {
      return _this89.decorate(e);
    }), _this89.on("applyOperation", function (e, t) {
      t[0]._validate();
    }, {
      priority: "highest"
    }), _this89.schema.register("$root", {
      isLimit: !0
    }), _this89.schema.register("$container", {
      allowIn: ["$root", "$container"]
    }), _this89.schema.register("$block", {
      allowIn: ["$root", "$container"],
      isBlock: !0
    }), _this89.schema.register("$blockObject", {
      allowWhere: "$block",
      isBlock: !0,
      isObject: !0
    }), _this89.schema.register("$inlineObject", {
      allowWhere: "$text",
      allowAttributesOf: "$text",
      isInline: !0,
      isObject: !0
    }), _this89.schema.register("$text", {
      allowIn: "$block",
      isInline: !0,
      isContent: !0
    }), _this89.schema.register("$clipboardHolder", {
      allowContentOf: "$root",
      allowChildren: "$text",
      isLimit: !0
    }), _this89.schema.register("$documentFragment", {
      allowContentOf: "$root",
      allowChildren: "$text",
      isLimit: !0
    }), _this89.schema.register("$marker"), _this89.schema.addChildCheck(function () {
      return !0;
    }, "$marker"), Uo(_assertThisInitialized(_this89)), _this89.document.registerPostFixer(bs), _this89.on("insertContent", function (e, _ref129) {
      var _ref130 = _slicedToArray(_ref129, 2),
        t = _ref130[0],
        n = _ref130[1];
      e.return = la(_assertThisInitialized(_this89), t, n);
    }), _this89.on("insertObject", function (e, _ref131) {
      var _ref132 = _slicedToArray(_ref131, 3),
        t = _ref132[0],
        n = _ref132[1],
        r = _ref132[2];
      e.return = ha(_assertThisInitialized(_this89), t, n, r);
    }), _this89.on("canEditAt", function (e) {
      var t = !_this89.document.isReadOnly;
      e.return = t, t || e.stop();
    });
    return _this89;
  }
  _inherits(vl, _U6);
  return _createClass(vl, [{
    key: "change",
    value: function change(e) {
      try {
        return this._pendingChanges.length === 0 ? (this._pendingChanges.push({
          batch: new ke(),
          callback: e
        }), this._runPendingChanges()[0]) : e(this._currentWriter);
      } catch (t) {
        /* istanbul ignore next -- @preserve */f.rethrowUnexpectedError(t, this);
      }
    }
  }, {
    key: "enqueueChange",
    value: function enqueueChange(e, t) {
      try {
        e ? typeof e == "function" ? (t = e, e = new ke()) : e instanceof ke || (e = new ke(e)) : e = new ke(), this._pendingChanges.push({
          batch: e,
          callback: t
        }), this._pendingChanges.length == 1 && this._runPendingChanges();
      } catch (n) {
        /* istanbul ignore next -- @preserve */f.rethrowUnexpectedError(n, this);
      }
    }
  }, {
    key: "applyOperation",
    value: function applyOperation(e) {
      e._execute();
    }
  }, {
    key: "insertContent",
    value: function insertContent(e, t, n) {
      var i = St(t, n);
      for (var _len17 = arguments.length, r = new Array(_len17 > 3 ? _len17 - 3 : 0), _key17 = 3; _key17 < _len17; _key17++) {
        r[_key17 - 3] = arguments[_key17];
      }
      return this.fire("insertContent", [e, i, n].concat(r));
    }
  }, {
    key: "insertObject",
    value: function insertObject(e, t, n, r) {
      var o = St(t, n);
      for (var _len18 = arguments.length, i = new Array(_len18 > 4 ? _len18 - 4 : 0), _key18 = 4; _key18 < _len18; _key18++) {
        i[_key18 - 4] = arguments[_key18];
      }
      return this.fire("insertObject", [e, o, r, r].concat(i));
    }
  }, {
    key: "deleteContent",
    value: function deleteContent(e, t) {
      Yo(this, e, t);
    }
  }, {
    key: "modifySelection",
    value: function modifySelection(e, t) {
      da(this, e, t);
    }
  }, {
    key: "getSelectedContent",
    value: function getSelectedContent(e) {
      return aa(this, e);
    }
  }, {
    key: "hasContent",
    value: function hasContent(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = e instanceof u ? e : u._createIn(e);
      if (n.isCollapsed) return !1;
      var _t$ignoreWhitespaces = t.ignoreWhitespaces,
        r = _t$ignoreWhitespaces === void 0 ? !1 : _t$ignoreWhitespaces,
        _t$ignoreMarkers = t.ignoreMarkers,
        i = _t$ignoreMarkers === void 0 ? !1 : _t$ignoreMarkers;
      if (!i) {
        var _iterator306 = _createForOfIteratorHelper(this.markers.getMarkersIntersectingRange(n)),
          _step306;
        try {
          for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
            var o = _step306.value;
            if (o.affectsData) return !0;
          }
        } catch (err) {
          _iterator306.e(err);
        } finally {
          _iterator306.f();
        }
      }
      var _iterator307 = _createForOfIteratorHelper(n.getItems()),
        _step307;
      try {
        for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
          var _o34 = _step307.value;
          if (this.schema.isContent(_o34)) if (_o34.is("$textProxy")) {
            if (r) {
              if (_o34.data.search(/\S/) !== -1) return !0;
            } else return !0;
          } else return !0;
        }
      } catch (err) {
        _iterator307.e(err);
      } finally {
        _iterator307.f();
      }
      return !1;
    }
  }, {
    key: "canEditAt",
    value: function canEditAt(e) {
      var t = St(e);
      return this.fire("canEditAt", [t]);
    }
  }, {
    key: "createPositionFromPath",
    value: function createPositionFromPath(e, t, n) {
      return new m(e, t, n);
    }
  }, {
    key: "createPositionAt",
    value: function createPositionAt(e, t) {
      return m._createAt(e, t);
    }
  }, {
    key: "createPositionAfter",
    value: function createPositionAfter(e) {
      return m._createAfter(e);
    }
  }, {
    key: "createPositionBefore",
    value: function createPositionBefore(e) {
      return m._createBefore(e);
    }
  }, {
    key: "createRange",
    value: function createRange(e, t) {
      return new u(e, t);
    }
  }, {
    key: "createRangeIn",
    value: function createRangeIn(e) {
      return u._createIn(e);
    }
  }, {
    key: "createRangeOn",
    value: function createRangeOn(e) {
      return u._createOn(e);
    }
  }, {
    key: "createSelection",
    value: function createSelection() {
      for (var _len19 = arguments.length, e = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
        e[_key19] = arguments[_key19];
      }
      return _construct($, e);
    }
  }, {
    key: "createBatch",
    value: function createBatch(e) {
      return new ke(e);
    }
  }, {
    key: "createOperationFromJSON",
    value: function createOperationFromJSON(e) {
      return Ro.fromJSON(e, this.document);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.document.destroy(), this.stopListening();
    }
  }, {
    key: "_runPendingChanges",
    value: function _runPendingChanges() {
      var e = [];
      this.fire("_beforeChanges");
      try {
        for (; this._pendingChanges.length;) {
          var t = this._pendingChanges[0].batch;
          this._currentWriter = new qo(this, t);
          var n = this._pendingChanges[0].callback(this._currentWriter);
          e.push(n), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
        }
      } finally {
        this._pendingChanges.length = 0, this._currentWriter = null, this.fire("_afterChanges");
      }
      return e;
    }
  }]);
}(U());
function St(s, e) {
  if (s) return s instanceof $ || s instanceof G ? s : s instanceof ve ? e || e === 0 ? new $(s, e) : s.is("rootElement") ? new $(s, "in") : new $(s, "on") : new $(s);
}
var Pl = /*#__PURE__*/function (_ye6) {
  function Pl() {
    var _this90;
    _classCallCheck(this, Pl);
    for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      args[_key20] = arguments[_key20];
    }
    _this90 = _callSuper(this, Pl, [].concat(args));
    _defineProperty(_this90, "domEventType", "click");
    return _this90;
  }
  _inherits(Pl, _ye6);
  return _createClass(Pl, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      this.fire(e.type, e);
    }
  }]);
}(ye);
var Cl = /*#__PURE__*/function (_ye7) {
  function Cl() {
    var _this91;
    _classCallCheck(this, Cl);
    for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      args[_key21] = arguments[_key21];
    }
    _this91 = _callSuper(this, Cl, [].concat(args));
    _defineProperty(_this91, "domEventType", ["mousedown", "mouseup", "mouseover", "mouseout"]);
    return _this91;
  }
  _inherits(Cl, _ye7);
  return _createClass(Cl, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      this.fire(e.type, e);
    }
  }]);
}(ye);
var kl = /*#__PURE__*/function (_ye8) {
  function kl() {
    var _this92;
    _classCallCheck(this, kl);
    for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      args[_key22] = arguments[_key22];
    }
    _this92 = _callSuper(this, kl, [].concat(args));
    _defineProperty(_this92, "domEventType", ["touchstart", "touchend", "touchmove"]);
    return _this92;
  }
  _inherits(kl, _ye8);
  return _createClass(kl, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      this.fire(e.type, e);
    }
  }]);
}(ye);
var Al = /*#__PURE__*/function () {
  function Al(e) {
    _classCallCheck(this, Al);
    _defineProperty(this, "document", void 0);
    this.document = e;
  }
  return _createClass(Al, [{
    key: "createDocumentFragment",
    value: function createDocumentFragment(e) {
      return new ge(this.document, e);
    }
  }, {
    key: "createElement",
    value: function createElement(e, t, n) {
      return new te(this.document, e, t, n);
    }
  }, {
    key: "createText",
    value: function createText(e) {
      return new x(this.document, e);
    }
  }, {
    key: "clone",
    value: function clone(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return e._clone(t);
    }
  }, {
    key: "appendChild",
    value: function appendChild(e, t) {
      return t._appendChild(e);
    }
  }, {
    key: "insertChild",
    value: function insertChild(e, t, n) {
      return n._insertChild(e, t);
    }
  }, {
    key: "removeChildren",
    value: function removeChildren(e, t, n) {
      return n._removeChildren(e, t);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = e.parent;
      return t ? this.removeChildren(t.getChildIndex(e), 1, t) : [];
    }
  }, {
    key: "replace",
    value: function replace(e, t) {
      var n = e.parent;
      if (n) {
        var r = n.getChildIndex(e);
        return this.removeChildren(r, 1, n), this.insertChild(r, t, n), !0;
      }
      return !1;
    }
  }, {
    key: "unwrapElement",
    value: function unwrapElement(e) {
      var t = e.parent;
      if (t) {
        var n = t.getChildIndex(e);
        this.remove(e), this.insertChild(n, e.getChildren(), t);
      }
    }
  }, {
    key: "rename",
    value: function rename(e, t) {
      var n = new te(this.document, e, t.getAttributes(), t.getChildren());
      return this.replace(t, n) ? n : null;
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(e, t, n) {
      n._setAttribute(e, t);
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(e, t) {
      t._removeAttribute(e);
    }
  }, {
    key: "addClass",
    value: function addClass(e, t) {
      t._addClass(e);
    }
  }, {
    key: "removeClass",
    value: function removeClass(e, t) {
      t._removeClass(e);
    }
  }, {
    key: "setStyle",
    value: function setStyle(e, t, n) {
      Tt(e) && n === void 0 ? t._setStyle(e) : n._setStyle(e, t);
    }
  }, {
    key: "removeStyle",
    value: function removeStyle(e, t) {
      t._removeStyle(e);
    }
  }, {
    key: "setCustomProperty",
    value: function setCustomProperty(e, t, n) {
      n._setCustomProperty(e, t);
    }
  }, {
    key: "removeCustomProperty",
    value: function removeCustomProperty(e, t) {
      return t._removeCustomProperty(e);
    }
  }, {
    key: "createPositionAt",
    value: function createPositionAt(e, t) {
      return g._createAt(e, t);
    }
  }, {
    key: "createPositionAfter",
    value: function createPositionAfter(e) {
      return g._createAfter(e);
    }
  }, {
    key: "createPositionBefore",
    value: function createPositionBefore(e) {
      return g._createBefore(e);
    }
  }, {
    key: "createRange",
    value: function createRange(e, t) {
      return new w(e, t);
    }
  }, {
    key: "createRangeOn",
    value: function createRangeOn(e) {
      return w._createOn(e);
    }
  }, {
    key: "createRangeIn",
    value: function createRangeIn(e) {
      return w._createIn(e);
    }
  }, {
    key: "createSelection",
    value: function createSelection() {
      for (var _len23 = arguments.length, e = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
        e[_key23] = arguments[_key23];
      }
      return _construct(Z, e);
    }
  }]);
}();
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
var ya = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i,
  va = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i,
  Pa = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
  Ca = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i,
  ka = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
  Aa = /\w+\((?:[^()]|\([^()]*\))*\)|\S+/gi,
  Sa = new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "activeborder", "activecaption", "appworkspace", "background", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "captiontext", "graytext", "highlight", "highlighttext", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infobackground", "infotext", "menu", "menutext", "scrollbar", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "window", "windowframe", "windowtext", "rebeccapurple", "currentcolor", "transparent"]);
function Ea(s) {
  return s.startsWith("#") ? ya.test(s) : s.startsWith("rgb") ? va.test(s) || Pa.test(s) : s.startsWith("hsl") ? Ca.test(s) || ka.test(s) : Sa.has(s.toLowerCase());
}
var Ra = ["none", "hidden", "dotted", "dashed", "solid", "double", "groove", "ridge", "inset", "outset"];
function Ta(s) {
  return Ra.includes(s);
}
var Ma = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
function xa(s) {
  return Ma.test(s);
}
var Na = /^[+-]?[0-9]*([.][0-9]+)?%$/;
function Sl(s) {
  return Na.test(s);
}
var Oa = ["repeat-x", "repeat-y", "repeat", "space", "round", "no-repeat"];
function Ia(s) {
  return Oa.includes(s);
}
var Fa = ["center", "top", "bottom", "left", "right"];
function Da(s) {
  return Fa.includes(s);
}
var Ba = ["fixed", "scroll", "local"];
function Va(s) {
  return Ba.includes(s);
}
var $a = /^url\(/;
function La(s) {
  return $a.test(s);
}
function Ue() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (s === "") return {
    top: void 0,
    right: void 0,
    bottom: void 0,
    left: void 0
  };
  var e = Qt(s),
    t = e[0],
    n = e[2] || t,
    r = e[1] || t,
    i = e[3] || r;
  return {
    top: t,
    bottom: n,
    right: r,
    left: i
  };
}
function Je(s) {
  return function (e) {
    var t = e.top,
      n = e.right,
      r = e.bottom,
      i = e.left,
      o = [];
    return [t, n, i, r].every(function (a) {
      return !!a;
    }) ? o.push([s, Wa(e)]) : (t && o.push([s + "-top", t]), n && o.push([s + "-right", n]), r && o.push([s + "-bottom", r]), i && o.push([s + "-left", i])), o;
  };
}
function Wa(_ref133) {
  var s = _ref133.top,
    e = _ref133.right,
    t = _ref133.bottom,
    n = _ref133.left;
  var r = [];
  return n !== e ? r.push(s, e, t, n) : t !== s ? r.push(s, e, t) : e !== s ? r.push(s, e) : r.push(s), r.join(" ");
}
function Os(s) {
  return function (e) {
    return {
      path: s,
      value: Ue(e)
    };
  };
}
function Qt(s) {
  var e = s.trim().slice(0, 1500).matchAll(Aa);
  return Array.from(e).map(function (t) {
    return t[0];
  });
}
function El(s) {
  s.setNormalizer("background", qa()), s.setNormalizer("background-color", za()), s.setReducer("background", Ua()), s.setStyleRelation("background", ["background-color"]);
}
function qa() {
  return function (s) {
    var e = {},
      t = Qt(s);
    var _iterator308 = _createForOfIteratorHelper(t),
      _step308;
    try {
      for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
        var n = _step308.value;
        Ia(n) ? (e.repeat = e.repeat || [], e.repeat.push(n)) : Da(n) ? (e.position = e.position || [], e.position.push(n)) : Va(n) ? e.attachment = n : Ea(n) ? e.color = n : La(n) && (e.image = n);
      }
    } catch (err) {
      _iterator308.e(err);
    } finally {
      _iterator308.f();
    }
    return {
      path: "background",
      value: e
    };
  };
}
function za() {
  return function (s) {
    return {
      path: "background.color",
      value: s
    };
  };
}
function Ua() {
  return function (s) {
    var e = [];
    return e.push(["background-color", s.color]), e;
  };
}
function Rl(s) {
  s.setNormalizer("border", Ja()), s.setNormalizer("border-top", st("top")), s.setNormalizer("border-right", st("right")), s.setNormalizer("border-bottom", st("bottom")), s.setNormalizer("border-left", st("left")), s.setNormalizer("border-color", Et("color")), s.setNormalizer("border-width", Et("width")), s.setNormalizer("border-style", Et("style")), s.setNormalizer("border-top-color", z("color", "top")), s.setNormalizer("border-top-style", z("style", "top")), s.setNormalizer("border-top-width", z("width", "top")), s.setNormalizer("border-right-color", z("color", "right")), s.setNormalizer("border-right-style", z("style", "right")), s.setNormalizer("border-right-width", z("width", "right")), s.setNormalizer("border-bottom-color", z("color", "bottom")), s.setNormalizer("border-bottom-style", z("style", "bottom")), s.setNormalizer("border-bottom-width", z("width", "bottom")), s.setNormalizer("border-left-color", z("color", "left")), s.setNormalizer("border-left-style", z("style", "left")), s.setNormalizer("border-left-width", z("width", "left")), s.setExtractor("border-top", rt("top")), s.setExtractor("border-right", rt("right")), s.setExtractor("border-bottom", rt("bottom")), s.setExtractor("border-left", rt("left")), s.setExtractor("border-top-color", "border.color.top"), s.setExtractor("border-right-color", "border.color.right"), s.setExtractor("border-bottom-color", "border.color.bottom"), s.setExtractor("border-left-color", "border.color.left"), s.setExtractor("border-top-width", "border.width.top"), s.setExtractor("border-right-width", "border.width.right"), s.setExtractor("border-bottom-width", "border.width.bottom"), s.setExtractor("border-left-width", "border.width.left"), s.setExtractor("border-top-style", "border.style.top"), s.setExtractor("border-right-style", "border.style.right"), s.setExtractor("border-bottom-style", "border.style.bottom"), s.setExtractor("border-left-style", "border.style.left"), s.setReducer("border-color", Je("border-color")), s.setReducer("border-style", Je("border-style")), s.setReducer("border-width", Je("border-width")), s.setReducer("border-top", it("top")), s.setReducer("border-right", it("right")), s.setReducer("border-bottom", it("bottom")), s.setReducer("border-left", it("left")), s.setReducer("border", Ga()), s.setStyleRelation("border", ["border-color", "border-style", "border-width", "border-top", "border-right", "border-bottom", "border-left", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), s.setStyleRelation("border-color", ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"]), s.setStyleRelation("border-style", ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"]), s.setStyleRelation("border-width", ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), s.setStyleRelation("border-top", ["border-top-color", "border-top-style", "border-top-width"]), s.setStyleRelation("border-right", ["border-right-color", "border-right-style", "border-right-width"]), s.setStyleRelation("border-bottom", ["border-bottom-color", "border-bottom-style", "border-bottom-width"]), s.setStyleRelation("border-left", ["border-left-color", "border-left-style", "border-left-width"]);
}
function Ja() {
  return function (s) {
    var _Is = Is(s),
      e = _Is.color,
      t = _Is.style,
      n = _Is.width;
    return {
      path: "border",
      value: {
        color: Ue(e),
        style: Ue(t),
        width: Ue(n)
      }
    };
  };
}
function st(s) {
  return function (e) {
    var _Is2 = Is(e),
      t = _Is2.color,
      n = _Is2.style,
      r = _Is2.width,
      i = {};
    return t !== void 0 && (i.color = _defineProperty({}, s, t)), n !== void 0 && (i.style = _defineProperty({}, s, n)), r !== void 0 && (i.width = _defineProperty({}, s, r)), {
      path: "border",
      value: i
    };
  };
}
function Et(s) {
  return function (e) {
    return {
      path: "border",
      value: ja(e, s)
    };
  };
}
function ja(s, e) {
  return _defineProperty({}, e, Ue(s));
}
function z(s, e) {
  return function (t) {
    return {
      path: "border",
      value: _defineProperty({}, s, _defineProperty({}, e, t))
    };
  };
}
function rt(s) {
  return function (e, t) {
    if (t.border) return $e(t.border, s);
  };
}
function $e(s, e) {
  var t = {};
  return s.width && s.width[e] && (t.width = s.width[e]), s.style && s.style[e] && (t.style = s.style[e]), s.color && s.color[e] && (t.color = s.color[e]), t;
}
function Is(s) {
  var e = {},
    t = Qt(s);
  var _iterator309 = _createForOfIteratorHelper(t),
    _step309;
  try {
    for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
      var n = _step309.value;
      xa(n) || /thin|medium|thick/.test(n) ? e.width = n : Ta(n) ? e.style = n : e.color = n;
    }
  } catch (err) {
    _iterator309.e(err);
  } finally {
    _iterator309.f();
  }
  return e;
}
function Ga() {
  return function (e) {
    var t = $e(e, "top"),
      n = $e(e, "right"),
      r = $e(e, "bottom"),
      i = $e(e, "left"),
      o = [t, n, r, i],
      a = {
        width: s(o, "width"),
        style: s(o, "style"),
        color: s(o, "color")
      },
      l = Se(a, "all");
    return l.length ? l : [].concat(_toConsumableArray(Object.entries(a).reduce(function (h, _ref135) {
      var _ref136 = _slicedToArray(_ref135, 2),
        d = _ref136[0],
        p = _ref136[1];
      return p && (h.push(["border-".concat(d), p]), o.forEach(function (_) {
        return delete _[d];
      })), h;
    }, [])), _toConsumableArray(Se(t, "top")), _toConsumableArray(Se(n, "right")), _toConsumableArray(Se(r, "bottom")), _toConsumableArray(Se(i, "left")));
  };
  function s(e, t) {
    return e.map(function (n) {
      return n[t];
    }).reduce(function (n, r) {
      return n == r ? n : null;
    });
  }
}
function it(s) {
  return function (e) {
    return Se(e, s);
  };
}
function Se(s, e) {
  var t = [];
  if (s && s.width && t.push("width"), s && s.style && t.push("style"), s && s.color && t.push("color"), t.length == 3) {
    var n = t.map(function (r) {
      return s[r];
    }).join(" ");
    return [e == "all" ? ["border", n] : ["border-".concat(e), n]];
  }
  return e == "all" ? [] : t.map(function (n) {
    return ["border-".concat(e, "-").concat(n), s[n]];
  });
}
function Tl(s) {
  s.setNormalizer("margin", Os("margin")), s.setNormalizer("margin-top", function (e) {
    return {
      path: "margin.top",
      value: e
    };
  }), s.setNormalizer("margin-right", function (e) {
    return {
      path: "margin.right",
      value: e
    };
  }), s.setNormalizer("margin-bottom", function (e) {
    return {
      path: "margin.bottom",
      value: e
    };
  }), s.setNormalizer("margin-left", function (e) {
    return {
      path: "margin.left",
      value: e
    };
  }), s.setReducer("margin", Je("margin")), s.setStyleRelation("margin", ["margin-top", "margin-right", "margin-bottom", "margin-left"]);
}
function Ml(s) {
  s.setNormalizer("padding", Os("padding")), s.setNormalizer("padding-top", function (e) {
    return {
      path: "padding.top",
      value: e
    };
  }), s.setNormalizer("padding-right", function (e) {
    return {
      path: "padding.right",
      value: e
    };
  }), s.setNormalizer("padding-bottom", function (e) {
    return {
      path: "padding.bottom",
      value: e
    };
  }), s.setNormalizer("padding-left", function (e) {
    return {
      path: "padding.left",
      value: e
    };
  }), s.setReducer("padding", Je("padding")), s.setStyleRelation("padding", ["padding-top", "padding-right", "padding-bottom", "padding-left"]);
}
export { Me as AttributeElement, S as AttributeOperation, Ut as BubblingEventInfo, Pl as ClickObserver, bl as Conversion, wl as DataController, zr as DataTransfer, K as DocumentFragment, G as DocumentSelection, ns as DomConverter, Br as DomEventData, ye as DomEventObserver, Yn as DowncastWriter, _l as EditingController, Hr as EditingView, C as Element, Dt as FocusObserver, Bo as History, Ao as HtmlDataProcessor, T as InsertOperation, O as LivePosition, _e as LiveRange, B as MarkerOperation, je as Matcher, A as MergeOperation, vl as Model, Cl as MouseObserver, v as MoveOperation, R as NoOperation, xe as Observer, Ro as OperationFactory, m as Position, u as Range, V as RenameOperation, vr as Renderer, ee as RootAttributeOperation, X as RootOperation, oe as SchemaContext, P as SplitOperation, We as StylesMap, ul as StylesProcessor, Gr as TabObserver, k as Text, j as TextProxy, kl as TouchObserver, ie as TreeWalker, Al as UpcastWriter, Me as ViewAttributeElement, Ge as ViewContainerElement, Xn as ViewDocument, ge as ViewDocumentFragment, dt as ViewEditableElement, te as ViewElement, Jt as ViewEmptyElement, jt as ViewRawElement, Gn as ViewRootEditableElement, x as ViewText, me as ViewTreeWalker, mt as ViewUIElement, jo as _tryFixingModelRange, El as addBackgroundRules, Rl as addBorderRules, Tl as addMarginRules, Ml as addPaddingRules, bs as autoParagraphEmptyRoots, al as enablePlaceholder, Wa as getBoxSidesShorthandValue, Je as getBoxSidesValueReducer, Ue as getBoxSidesValues, ar as getFillerOffset, Os as getPositionShorthandNormalizer, Qt as getShorthandValues, Ks as hidePlaceholder, Va as isAttachment, Ea as isColor, xa as isLength, Ta as isLineStyle, ys as isParagraphable, Sl as isPercentage, Da as isPosition, Ia as isRepeat, La as isURL, Xs as needsPlaceholder, Hs as showPlaceholder, yl as transformSets, vs as wrapInParagraph };